var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ACCOUNT_COMPANY_CREATION_TYPE: () => ACCOUNT_COMPANY_CREATION_TYPE,
  ACCOUNT_COMPANY_VAT_HANDLING: () => ACCOUNT_COMPANY_VAT_HANDLING,
  ActionBadge: () => ActionBadge_default,
  ActiveFilterDisplay: () => ActiveFilterDisplay_default,
  ActiveFilters: () => ActiveFilters_default,
  Address: () => Address_default,
  AttributeBoolean: () => AttributeBoolean_default,
  AttributeChat: () => AttributeChat_default,
  AttributeChecklist: () => AttributeChecklist_default,
  AttributeDate: () => AttributeDate_default,
  AttributeFile: () => AttributeFile_default,
  AttributeFileItem: () => AttributeFileItem_default,
  AttributeHtml: () => AttributeHtml_default,
  AttributeLabel: () => AttributeLabel_default,
  AttributeList: () => AttributeList_default,
  AttributeNumber: () => AttributeNumber_default,
  AttributeText: () => AttributeText_default,
  AuraDatePicker: () => AuraDatePicker_default,
  AuraDrawer: () => AuraDrawer,
  AuraDrawerBody: () => AuraDrawerBody,
  AuraDrawerCloseButton: () => AuraDrawerCloseButton,
  AuraDrawerContent: () => AuraDrawerContent,
  AuraDrawerFooter: () => AuraDrawerFooter,
  AuraDrawerHeader: () => AuraDrawerHeader,
  AuraDrawerOverlay: () => AuraDrawerOverlay,
  AuraDropdownMenu: () => AuraDropdownMenu_default,
  AuraFormLabel: () => AuraFormLabel_default,
  AuraInput: () => AuraInput_default,
  AuraMenuItem: () => AuraMenuItem_default,
  AuraModal: () => AuraModal,
  AuraModalBody: () => AuraModalBody,
  AuraModalCloseButton: () => AuraModalCloseButton,
  AuraModalContent: () => AuraModalContent,
  AuraModalFooter: () => AuraModalFooter,
  AuraModalHeader: () => AuraModalHeader,
  AuraModalOverlay: () => AuraModalOverlay,
  AuraSelect: () => AuraSelect_default,
  AuraSpinner: () => AuraSpinner_default,
  AuraTabs: () => AuraTabs_default,
  AuthContext: () => AuthContext,
  AuthContextProvider: () => AuthContextProvider,
  AvailabilityFilter: () => AvailabilityFilter_default,
  BackwardNavigation: () => BackwardNavigation_default,
  BasketContext: () => BasketContext,
  BasketContextProvider: () => BasketContextProvider,
  BlockedDisabledInfo: () => BlockedDisabledInfo_default,
  BooleanFilter: () => BooleanFilter_default,
  BoxCollapse: () => BoxCollapse,
  BoxCollapseButton: () => BoxCollapseButton,
  BoxCollapseContent: () => BoxCollapseContent,
  BoxCollapseItem: () => BoxCollapseItem,
  BoxIcon: () => BoxIcon,
  Breadcrumbs: () => Breadcrumbs_default,
  ButtonAction: () => ButtonAction_default,
  CSSReset: () => CSSReset,
  CellWrapper: () => CellWrapper_default,
  ColorPicker: () => ColorPicker_default,
  ConnectedCampaignOpportunity: () => ConnectedCampaignOpportunity_default,
  ConnectedDocument: () => ConnectedDocument_default,
  ConnectedProcess: () => ConnectedProcess_default,
  ConnectedServicedProduct: () => ConnectedServicedProduct_default,
  ConnectedTaskAndEvent: () => ConnectedTaskAndEvent_default,
  ContentBox: () => ContentBox_default,
  CookieNotice: () => CookieNotice_default,
  CreatorUserCell: () => CreatorUserCell_default,
  CredentialsCompact: () => CredentialsCompact_default,
  CustomCSSReset: () => CustomCSSReset_default,
  CustomMultiValueContainer: () => CustomMultiValueContainer,
  CustomProductOption: () => CustomProductOption_default,
  CustomSelectOption: () => CustomSelectOption_default,
  CustomizeColumns: () => CustomizeColumns_default,
  CustomizeColumnsModal: () => CustomizeColumnsModal_default,
  CustomizerContext: () => CustomizerContext,
  CustomizerContextProvider: () => CustomizerContext_default,
  CustomizerInit: () => CustomizerInit_default,
  DATETIME_FORMAT_DOTS: () => DATETIME_FORMAT_DOTS,
  DATE_FORMAT_DOTS: () => DATE_FORMAT_DOTS,
  DEFAULT_LIMIT_AVAILABLE_PRODUCTS: () => DEFAULT_LIMIT_AVAILABLE_PRODUCTS,
  DataSelector: () => DataSelector_default,
  DataSelectorFilter: () => DataSelectorFilter_default,
  DateInput: () => DateInput_default,
  DatetimeFilter: () => DatetimeFilter_default,
  DefaultEventDates: () => DefaultEventDates,
  DocumentSummary: () => DocumentSummary_default,
  EmptyFilters: () => EmptyFilters_default,
  EmptyList: () => EmptyList_default,
  EmptyState: () => EmptyState_default,
  ExternalMarkerContainer: () => ExternalMarkerContainer_default,
  ExternalMarkerFilter: () => ExternalMarkerFilter_default,
  ExternalMarkerLabel: () => ExternalMarkerLabel_default,
  ExternalMarkersContext: () => ExternalMarkersContext,
  ExternalMarkersProvider: () => ExternalMarkersContext_default,
  FileDetails: () => FileDetails_default,
  FilePreview: () => FilePreview,
  FilterFormLabel: () => FilterFormLabel_default,
  FilterInputSeparator: () => FilterInputSeparator_default,
  FilterName: () => FilterName,
  FilterTextInput: () => FilterTextInput_default,
  FiltersDisplayItem: () => FiltersDisplayItem_default,
  GalleryItem: () => GalleryItem_default,
  Header: () => Header_default,
  InBasketInfo: () => InBasketInfo_default,
  InBasketText: () => InBasketText_default,
  Information: () => Information_default,
  LANGUAGES: () => LANGUAGES,
  LanguageContext: () => LanguageContext,
  LanguageProvider: () => LanguageProvider,
  LinkContext: () => LinkContext,
  LinkContextProvider: () => LinkContextProvider,
  Linkify: () => Linkify_default,
  List: () => List_default,
  ListFilter: () => ListFilter_default,
  ListFilters: () => ListFilters_default,
  ListFiltersContext: () => ListFiltersContext,
  ListFiltersContextProvider: () => ListFiltersContext_default,
  LoadingOverlay: () => LoadingOverlay_default,
  MODULE_MAP: () => MODULE_MAP,
  MainHeader: () => MainHeader,
  MessageBreadcrumbs: () => MessageBreadcrumbs_default,
  MessageItem: () => MessageItem_default,
  Modal: () => Modal_default,
  ModalServicedProduct: () => ModalServicedProduct_default,
  ModalVisibilityProvider: () => ModalVisibilityProvider,
  ModuleLink: () => ModuleLink,
  MoreIconButton: () => MoreIconButton_default,
  MultiFilter: () => MultiFilter_default,
  NameDisplay: () => NameDisplay_default,
  NotificationBar: () => NotificationBar,
  NumberBox: () => NumberBox,
  NumericFilter: () => NumericFilter_default,
  ObjectsPerPageSelect: () => ObjectsPerPageSelect,
  Pagination: () => Pagination_default,
  PanelHeading: () => PanelHeading_default,
  PerPage: () => PerPage_default,
  PersonInfo: () => PersonInfo_default,
  PersonItem: () => PersonItem_default,
  PersonList: () => PersonList_default,
  PriceDisplay: () => PriceDisplay_default,
  PriceWithCurrency: () => PriceWithCurrency,
  ProductAvailability: () => ProductAvailability_default,
  ProductAvailabilityIcon: () => ProductAvailabilityIcon_default,
  ProductEAN: () => ProductEAN_default,
  ProductImage: () => ProductImage_default,
  ProductQuantitySelector: () => ProductQuantitySelector_default,
  ProductSlider: () => ProductSlider_default,
  ProfileSaveConfigModal: () => ProfileSaveConfigModal_default,
  QAvatar: () => QAvatar_default,
  QuantitySelector: () => QuantitySelector_default,
  RepositoryFile: () => RepositoryFile_default,
  RepositoryFileList: () => RepositoryFileList_default,
  ResultsPagination: () => ResultsPagination_default,
  ResultsPerPage: () => ResultsPerPage_default,
  RoundIcon: () => RoundIcon_default,
  STable: () => Table,
  STableContainer: () => TableContainer,
  STbody: () => Tbody,
  STd: () => Td,
  STfoot: () => Tfoot,
  STh: () => Th,
  SThead: () => Thead,
  STr: () => Tr,
  SecondaryHeader: () => SecondaryHeader,
  SelectCheckbox: () => SelectCheckbox_default,
  SettingsContext: () => SettingsContext,
  SettingsProvider: () => SettingsProvider,
  SmallTag: () => SmallTag_default,
  SortingIndicator: () => SortingIndicator_default,
  SubordinatesCheckbox: () => SubordinatesCheckbox_default,
  Table: () => Table_default,
  TagButton: () => TagButton,
  TagDisplay: () => TagDisplay,
  TagFilter: () => TagFilter_default,
  TaskItem: () => TaskItem_default,
  TaskList: () => TaskList_default,
  Tbody: () => Tbody_default,
  Td: () => Td_default,
  TextFilter: () => TextFilter_default,
  TextScroll: () => TextScroll_default,
  Th: () => Th_default,
  Thead: () => Thead_default,
  TileItem: () => TileItem_default,
  TileItemList: () => TileItemList_default,
  TileList: () => TileList_default,
  Timeline: () => Timeline_default,
  TimelineItem: () => TimelineItem_default,
  Tr: () => Tr_default,
  UNRESET_SCSS: () => UNRESET_SCSS,
  USED_SETTINGS: () => USED_SETTINGS,
  UsedMaterials: () => UsedMaterials_default,
  UserFilter: () => UserFilter_default,
  UserTypes: () => UserTypes,
  Widget: () => Widget_default,
  WidgetBody: () => WidgetBody_default,
  WidgetControls: () => WidgetControls_default,
  WidgetHeader: () => WidgetHeader_default,
  WidgetName: () => WidgetName_default,
  WidgetSettingsModal: () => WidgetSettingsModal_default,
  auraSelectFilterConfig: () => auraSelectFilterConfig,
  baseApi: () => api_default,
  buildOptions: () => buildOptions,
  disableSortingColumns: () => disableSortingColumns,
  documentStatusPositions: () => documentStatusPositions,
  downloadXlsxDocument: () => downloadXlsxDocument,
  formatAttributeCell: () => formatAttributeCell,
  formatAttributeHeader: () => formatAttributeHeader,
  formatDateForApi: () => formatDateForApi,
  formatFieldCell: () => formatFieldCell,
  formatHeader: () => formatHeader,
  formatPlaceField: () => formatPlaceField,
  formatRelationFieldCell: () => formatRelationFieldCell,
  formatRelationHeader: () => formatRelationHeader,
  formatValue: () => formatValue,
  getActiveMarkers: () => getActiveMarkers,
  getAttributeTagTypeForModule: () => getAttributeTagTypeForModule,
  getBasePriceFilter: () => getBasePriceFilter,
  getCommonI18nConfig: () => getCommonI18nConfig,
  getDocumentRelationName: () => getDocumentRelationName,
  getImageUrl: () => getImageUrl,
  getListFiltersConfig: () => getListFiltersConfig,
  getModuleHref: () => getModuleHref,
  getPriceFilterForUserUserLevel: () => getPriceFilterForUserUserLevel,
  getUserPrice: () => getUserPrice,
  getVisibleColumnsParams: () => getVisibleColumnsParams,
  imageSizeValue: () => imageSizeValue,
  initModal: () => initModal,
  inputValueReducer: () => inputValueReducer,
  isFile: () => isFile,
  isImage: () => isImage,
  isOptionsGrouped: () => isOptionsGrouped,
  isOptionsWithAvatar: () => isOptionsWithAvatar,
  log: () => logger_default,
  normalizeSettings: () => normalizeSettings,
  parseFiltersForApi: () => parseFiltersForApi,
  parseMetaToColumns: () => parseMetaToColumns,
  parseUrlParams: () => parseUrlParams,
  priceFormatter: () => priceFormatter,
  sortTasks: () => sortTasks,
  splitPriceParts: () => splitPriceParts,
  statusCampaignOpportunity: () => statusCampaignOpportunity,
  stripHtmlTags: () => stripHtmlTags,
  theme: () => customTheme,
  transformApiResponse: () => transformApiResponse,
  transformTasksForTasklist: () => transformTasksForTasklist,
  useBasketContent: () => useBasketContent,
  useCustomScript: () => useCustomScript_default,
  useExternalMarkers: () => useExternalMarkers,
  useLanguage: () => useLanguage,
  useLink: () => useLink,
  useListColumnsOrdering: () => useListColumnsOrdering_default,
  useListColumnsVisibility: () => useListColumnsVisibility_default,
  useListFilters: () => useListFilters,
  useListFiltersVisibility: () => useListFiltersVisibility_default,
  useListPagination: () => useListPagination_default,
  useListSorting: () => useListSorting_default,
  useMinimalAutoselect: () => useMinimalAutoselect_default,
  useModalVisibilityContext: () => useModalVisibilityContext,
  usePersistedState: () => usePersistedState_default,
  useProductPrice: () => useProductPrice_default,
  useQueryParams: () => useQueryParams_default,
  useResponsive: () => useResponsive_default,
  useSetting: () => useSetting_default,
  useSettings: () => useSettings_default,
  useTemplates: () => useTemplates_default,
  useUserProfiles: () => useUserProfiles_default,
  useUserSettingsWithFallback: () => useUserSettingsWithFallback_default,
  validateAttribute: () => validateAttribute
});
module.exports = __toCommonJS(src_exports);

// src/components/ActionBadge/ActionBadge.tsx
var import_react = require("@chakra-ui/react");
var import_react2 = require("@emotion/react");
var import_react3 = require("react");
var import_fa = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var ActionBadge = (0, import_react3.forwardRef)(
  ({ isError, isSuccess, isLoading, noAnimation, ...props }, ref) => {
    if (!isError && !isSuccess && !isLoading)
      return null;
    const getIcon = () => {
      if (isSuccess)
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa.FaCheckCircle, {});
      if (isError)
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa.FaTimesCircle, {});
    };
    return isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Spinner, {
      size: "sm"
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Box, {
      ref,
      color: !isError ? "green.400" : "red.400",
      animation: noAnimation ? "" : `${fadeInOut} 0.5s ease-in-out`,
      "aria-label": !isError ? "success" : "error",
      ...props,
      children: getIcon()
    });
  }
);
var fadeInOut = import_react2.keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
var ActionBadge_default = ActionBadge;

// src/components/ActiveFilterDisplay/ActiveFilterDisplay.tsx
var import_react13 = require("@chakra-ui/react");
var import_isEmpty2 = __toESM(require("lodash/isEmpty"));
var import_isNil3 = __toESM(require("lodash/isNil"));
var import_react_i18next3 = require("react-i18next");

// src/components/ActiveFilterDisplay/FiltersDisplayItem/FiltersDisplayItem.tsx
var import_react9 = require("@chakra-ui/react");
var import_date_fns3 = require("date-fns");
var import_isNil2 = __toESM(require("lodash/isNil"));
var import_react_i18next2 = require("react-i18next");
var import_js = require("@mdi/js");

// src/utils/logger.ts
var logLevel = require("loglevel");
var loglevelPrefix = require("loglevel-plugin-prefix");
loglevelPrefix.reg(logLevel);
loglevelPrefix.apply(logLevel);
if (process.env.NODE_ENV === "development") {
  logLevel.enableAll();
}
var logger = logLevel.getLogger("logger");
var logger_default = logger;

// src/utils/misc.ts
var import_dompurify = __toESM(require("dompurify"));
var getImageUrl = (dbName, size, fileName) => {
  if (!dbName || typeof dbName !== "string") {
    return null;
  }
  let params = `${dbName}/`;
  if (size === "thmb" || size === "md") {
    params += `type/${size}/`;
  }
  if (fileName) {
    params += encodeURI(fileName);
  }
  return `/file/show/file/${params}`;
};
var buildOptions = (data, labelField, valueField = "id", includedFields) => {
  if (!data) {
    return [];
  }
  if (typeof data === "string") {
    return [];
  }
  return data.map((item) => {
    const optionLabel = labelField ? item[labelField] : item;
    const fields = {};
    includedFields == null ? void 0 : includedFields.forEach((field) => {
      if (item[field]) {
        fields[field] = item[field];
      }
    });
    return {
      value: valueField ? item[valueField] : item,
      label: optionLabel,
      ...item.additionalName ? { additionalName: item.additionalName } : {},
      ...fields
    };
  });
};
var isImage = (mimetype) => {
  return (mimetype == null ? void 0 : mimetype.startsWith("image/")) ?? false;
};
var stripHtmlTags = (text) => {
  return import_dompurify.default.sanitize(text == null ? void 0 : text.replace(/&nbsp;/g, " "), {
    ALLOWED_TAGS: ["#text"]
  }).trim().replace(/^\s*[\r\n]/gm, "");
};

// src/types/index.ts
var PriceNames = /* @__PURE__ */ ((PriceNames2) => {
  PriceNames2["brutto"] = "priceBrutto";
  PriceNames2["netto"] = "priceNetto";
  return PriceNames2;
})(PriceNames || {});
var DefaultEventDates = /* @__PURE__ */ ((DefaultEventDates2) => {
  DefaultEventDates2[DefaultEventDates2["Now"] = 1] = "Now";
  DefaultEventDates2[DefaultEventDates2["FromTask"] = 2] = "FromTask";
  return DefaultEventDates2;
})(DefaultEventDates || {});

// src/utils/productUtils.ts
var getActiveMarkers = (externalMarkers) => {
  return externalMarkers == null ? void 0 : externalMarkers.filter((marker) => marker.isActive);
};
var priceFormatter = (value, currencyCode = "PLN", { formatToParts = false } = {}, numberDigits = -1) => {
  const options = { useGrouping: true };
  if (currencyCode.trim() !== "" && currencyCode.trim() !== "none") {
    options["style"] = "currency";
    options["currency"] = currencyCode;
    options["currencyDisplay"] = "symbol";
  }
  if (numberDigits > -1) {
    options["maximumFractionDigits"] = numberDigits;
    options["minimumFractionDigits"] = numberDigits;
  }
  const formatter = new Intl.NumberFormat("pl-PL", options);
  const priceInParts = formatter.formatToParts(value).map(({ type, value: value2 }) => {
    switch (type) {
      case "integer":
        return addPriceSpace(value2);
      default:
        return value2;
    }
  });
  if (formatToParts) {
    return priceInParts;
  }
  const price = priceInParts.join("");
  return price;
};
var addPriceSpace = (formattedPrice) => {
  if (formattedPrice.length === 4) {
    const stringArray = Array.from(formattedPrice);
    stringArray.splice(1, 0, "\xA0");
    return stringArray.join("");
  }
  return formattedPrice;
};
var getBasePriceFilter = ({
  priceLevel,
  priceType,
  filterType
}) => {
  return `filter[prices][${priceLevel}.${PriceNames[priceType]}][${filterType}]`;
};
var getPriceFilterForUserUserLevel = ({
  priceType,
  filterType,
  isUserUser
}) => {
  return getBasePriceFilter({
    priceType,
    filterType,
    priceLevel: isUserUser ? "srp" : "purchase"
  });
};
var splitPriceParts = (priceParts) => {
  const priceValue = Array.isArray(priceParts) ? priceParts.slice(0, -1).join("") : "?";
  const priceCurrency = Array.isArray(priceParts) ? priceParts.slice(-1).toString() : "?";
  return {
    priceValue,
    priceCurrency
  };
};
var getUserPrice = (prices) => {
  const priceIndividual = prices == null ? void 0 : prices.find(
    (price) => price.priceLevel === "purchase"
  );
  if (priceIndividual) {
    return priceIndividual;
  }
  return prices == null ? void 0 : prices[0];
};

// src/utils/i18n.ts
var getCommonI18nConfig = (language, i18nVersion) => {
  return {
    lng: language || "pl",
    fallbackLng: "pl",
    ns: ["messages", "messagesCustom"],
    defaultNS: "messagesCustom",
    fallbackNS: "messages",
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
    backend: {
      loadPath: "/assets/{{ns}}.json?lang={{lng}}",
      allowMultiLoading: true,
      queryStringParams: {
        v: i18nVersion ?? ""
      }
    }
  };
};

// src/utils/listUtils.tsx
var import_react6 = require("@chakra-ui/react");
var import_date_fns = require("date-fns");
var import_isNil = __toESM(require("lodash/isNil"));
var import_partition = __toESM(require("lodash/partition"));
var import_uniq = __toESM(require("lodash/uniq"));
var import_xor = __toESM(require("lodash/xor"));
var import_react7 = __toESM(require("react"));
var import_react_i18next = require("react-i18next");
var import_fa2 = require("react-icons/fa");

// src/components/FilterFields/CellWrapper.tsx
var import_react4 = __toESM(require("react"));
var import_react5 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var CellWrapper = import_react4.default.memo(({ children, ...props }) => {
  const [isTruncated, setIsTruncated] = (0, import_react4.useState)(false);
  const textRef = import_react4.default.useRef(null);
  const handleResize = () => {
    if (textRef.current.offsetWidth < textRef.current.scrollWidth) {
      setIsTruncated(true);
    } else {
      setIsTruncated(false);
    }
  };
  (0, import_react4.useEffect)(() => {
    handleResize();
    const observer = new MutationObserver(handleResize);
    const parentNode = textRef.current.offsetParent;
    if (parentNode && textRef) {
      observer.observe(parentNode, { attributes: true });
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: isTruncated ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react5.Tooltip, {
      hasArrow: true,
      px: "12px",
      py: "8px",
      placement: "bottom-start",
      label: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react5.Text, {
        noOfLines: 10,
        children
      }),
      rounded: "4px",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react5.Text, {
        ref: textRef,
        className: "table-cell-wrapper",
        as: "span",
        display: "inline-block",
        w: "full",
        isTruncated: true,
        ...props,
        children
      })
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react5.Text, {
      ref: textRef,
      className: "table-cell-wrapper",
      as: "span",
      display: "inline-block",
      w: "full",
      isTruncated: true,
      ...props,
      children
    })
  });
});
var CellWrapper_default = CellWrapper;

// src/api.ts
var import_merge = __toESM(require("lodash/merge"));
var import_nookies = require("nookies");
var handleModuleAccessErrors = (response, responseBody, context) => {
  var _a2;
  if (response.status === 403) {
    if (/User has no permission on aura module: product/.test(
      (_a2 = responseBody.errors) == null ? void 0 : _a2.generalMessage
    )) {
      return context.res.redirect(307, "/");
    }
  }
};
var getBaseUrl = (context) => {
  return context ? context.req.apiUrl : document.location.origin + "/api";
};
var getAuthHeader = (apiToken) => {
  if (!apiToken) {
    return {};
  }
  return { Authorization: `Bearer ${apiToken}` };
};
var API = {
  get: async (apiUrl, options, context) => {
    const baseURL = getBaseUrl(context);
    const cookies = (0, import_nookies.parseCookies)(context);
    const apiToken = cookies["api_token"];
    const { params } = options;
    const urlSearchParams = new URLSearchParams(params);
    const fullUrl = `${baseURL}${apiUrl}?${urlSearchParams}`;
    logger_default.debug(`GET ${fullUrl}`);
    let res;
    try {
      res = await fetch(fullUrl, {
        method: "GET",
        headers: {
          ...getAuthHeader(apiToken)
        }
      });
    } catch (error) {
      console.error(error.message);
    }
    const jsonResponse = await res.json();
    handleModuleAccessErrors(res, jsonResponse, context);
    return jsonResponse;
  },
  post: async (apiUrl, payload, options, context) => {
    const baseURL = getBaseUrl(context);
    const cookies = (0, import_nookies.parseCookies)(context);
    const apiToken = cookies["api_token"];
    const { params } = options;
    const urlSearchParams = new URLSearchParams(params);
    const isFormData = payload instanceof FormData;
    const res = await fetch(`${baseURL}${apiUrl}?${urlSearchParams}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        ...!isFormData ? { "Content-Type": "application/json" } : {},
        ...getAuthHeader(apiToken)
      },
      body: isFormData ? payload : JSON.stringify(payload)
    });
    const jsonResponse = await res.json();
    return jsonResponse;
  },
  patch: async (apiUrl, payload, options = { params: {} }, context) => {
    const baseURL = getBaseUrl(context);
    const cookies = (0, import_nookies.parseCookies)(context);
    const apiToken = cookies["api_token"];
    const { params } = options;
    const urlSearchParams = new URLSearchParams(params);
    const data = { data: payload };
    const res = await fetch(`${baseURL}${apiUrl}?${urlSearchParams}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeader(apiToken)
      },
      body: JSON.stringify(data)
    });
    if (res.status === 401) {
      context.res.writeHead(301, {
        Location: "/"
      });
      context.res.end();
      return;
    }
    const jsonResponse = await res.json();
    return jsonResponse;
  },
  delete: async (apiUrl, options = { params: {} }, context) => {
    const baseURL = getBaseUrl(context);
    const { params } = options;
    const urlSearchParams = new URLSearchParams(params);
    const res = await fetch(`${baseURL}${apiUrl}?${urlSearchParams}`, {
      method: "DELETE"
    });
    const jsonResponse = await res.json();
    return jsonResponse;
  }
};
var api_default = {
  getMe: (context) => API.get("/me", {}, context),
  getAutoselect: (endpoint, options = {}) => API.get(`/${endpoint}/autoselect`, options),
  getList: (endpoint, options = {}) => API.get(`/${endpoint}`, options),
  getSetting: (settingKey, options = {}) => API.get(
    `/settings/${settingKey}`,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  ),
  getUserSetting: (settingKey, options = {}) => API.get(`/user_settings/${settingKey}`, options),
  getProfileSetting: (settingKey, options = {}) => API.get(`/profile_settings/${settingKey}`, options),
  getSelectedProfileSetting: (options = {}) => API.get(`/profile_settings`, options),
  updateUserSetting: (settingKey, payload) => API.patch(`/user_settings/${settingKey}`, payload),
  updateProfileSetting: (settingKey, profileId, payload, options = {}) => API.post(
    `/profile_settings`,
    (0, import_merge.default)(
      {
        data: {
          name: settingKey,
          userProfile: profileId
        }
      },
      payload
    ),
    options
  ),
  removeUserSetting: (settingKey) => API.delete(`/user_settings/${settingKey}`),
  getBasket: async ({ options }) => API.get("/basket_contents", {
    ...options,
    params: {
      "setting[with_relations]": true,
      "page[limit]": -1
    }
  }),
  updateBasket: async ({ payload, options = {} }) => API.post(
    "/basket_contents",
    { data: payload },
    {
      ...options,
      params: {
        "setting[with_relations]": true,
        "page[limit]": -1
      }
    }
  ),
  updateLanguage: async ({ language, options = {} }) => API.patch(
    "/user_settings/systemLanguage",
    {
      value: [language]
    },
    options
  ),
  getMeta: async (endpoint, options = {}) => API.get(`/${endpoint}/meta`, options),
  getTemplates: async (options = {}) => API.get("/product_templates", options),
  uploadFile: (files, options) => API.post(
    "/files/upload",
    files,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  ),
  getEndpoint: (endpoint, options) => API.get(`/${endpoint}`, options),
  getEndpointById: (endpoint, id, options) => API.get(
    `/${endpoint}/${id}`,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  )
};

// src/hooks/useMinimalAutoselect.ts
var import_react_query = require("react-query");
var import_get = __toESM(require("lodash/get"));
var useMinimalAutoselect = ({
  endpoint,
  labelField,
  valueField = "id",
  fields,
  labelFieldCreator,
  extraFields,
  enabled = true,
  filters,
  settings,
  additionalOptionField
}) => {
  return (0, import_react_query.useQuery)(
    ["positions", endpoint, extraFields, filters],
    () => api_default.getAutoselect(endpoint, {
      params: {
        fields: [
          ...Array.isArray(labelField) ? labelField : [labelField],
          valueField,
          ...fields ?? []
        ].filter((v) => v).join(","),
        "page[limit]": -1,
        ...extraFields && { extra_fields: extraFields.join(",") },
        ...filters,
        ...settings
      }
    }),
    {
      select: (response) => {
        var _a2;
        return ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((item) => {
          const additionalFields = {};
          if (additionalOptionField) {
            additionalOptionField.forEach((aof) => {
              additionalFields[aof.field] = (0, import_get.default)(item, aof.source);
            });
          }
          return {
            id: item[valueField],
            value: labelFieldCreator && Array.isArray(labelField) ? labelFieldCreator(item) : item[labelField],
            ...additionalFields
          };
        })) ?? [];
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: enabled && !!endpoint,
      retry: false,
      keepPreviousData: true
    }
  );
};
var useMinimalAutoselect_default = useMinimalAutoselect;

// src/components/List/PriceTypeDisplay/PriceTypeDisplay.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var PriceTypeDisplay = ({ value }) => {
  const { data } = useMinimalAutoselect_default({
    endpoint: "price_types",
    labelField: "fullName"
  });
  if (!data) {
    return null;
  }
  const priceType = data == null ? void 0 : data.find((priceType2) => priceType2.id === value - 1);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
    children: priceType == null ? void 0 : priceType.value
  });
};
var PriceTypeDisplay_default = PriceTypeDisplay;

// src/consts.ts
var USED_SETTINGS = [
  "cookie_notice",
  "sell_by_price",
  "shop_title",
  "database_version",
  "enable_multilingualism",
  "inventory_thumbnail_height",
  "inventory_thumbnail_width",
  "company_search_for_user_user",
  "searchbar_account_user"
];
var UNRESET_SCSS = `
/**
 * Unreset CSS
 *
 * Copyright (C) 2016 Kite (ixkaito@gmail.com)
 * License MIT
 * Version 1.0.0
 *
 * Unreset CSS restores browsers' default element styles which are reset by
 * Eric Meyer's Reset CSS, YUI 3 Reset CSS, HTML5 Reset Stylesheet of HTML5
 * Doctor, or Tim Murtaugh's HTML5 Reset.
 */

/**
 * 
 * html {
 *   box-sizing: content-box;
 * }
 * 
 * body {
 *   margin: 8px;
 *   line-height: normal;
 * }
 * 
 */

p {
	margin: 1em 0;
}

blockquote,
figure {
	margin: 1em 40px;
}

q {
	quotes: "\u201C" "\u201D" "\u2018" "\u2019";

	&:before {
		content: open-quote;
	}

	&:after {
		content: close-quote;
	}
}

hr {
	border: 1px inset;
	box-sizing: border-box;
	margin: 0.5em auto;
}

h1 {
	font-size: 2em;
	font-weight: bold;
	margin: 0.67em 0;
}

h2 {
	font-size: 1.5em;
	font-weight: bold;
	margin: 0.83em 0;
}

h3 {
	font-size: 1.17em;
	font-weight: bold;
	margin: 1em 0;
}

h4 {
	font-size: 1.00em;
	font-weight: bold;
	margin: 1.33em 0;
}

h5 {
	font-size: 0.83em;
	font-weight: bold;
	margin: 1.67em 0;
}

h6 {
	font-size: 0.67em;
	font-weight: bold;
	margin: 2.33em 0;
}

article, aside, nav, section {

	h1 {
		font-size: 1.5em;
		font-weight: bold;
		margin: 0.83em 0;
	}

	article, aside, nav, section {

		h1 {
			font-size: 1.17em;
			font-weight: bold;
			margin: 1em 0;
		}

		article, aside, nav, section {

			h1 {
				font-size: 1.00em;
				font-weight: bold;
				margin: 1.33em 0;
			}

			article, aside, nav, section {

				h1 {
					font-size: 0.83em;
					font-weight: bold;
					margin: 1.67em 0;
				}

				article, aside, nav, section {

					h1 {
						font-size: 0.67em;
						font-weight: bold;
						margin: 2.33em 0;
					}
				}
			}
		}
	}
}

table {
	border-collapse: separate;
	border-spacing: 2px;
	border-color: gray;
}

thead,
tbody,
tfoot,
tr {
	border-color: inherit;
	vertical-align: middle;
}

td, th {
	padding: 1px;
	vertical-align: inherit;
}

th {
	font-weight: bold
}

caption {
	text-align: center;
}

ul, menu {
	list-style-type: disc;
	margin: 1em 0;
	padding: 0 0 0 40px;
}

ol {
	list-style-type: decimal;
	margin: 1em 0;
	padding: 0 0 0 40px;
}

ul, ol {

	ul {
		list-style-type: circle;
	}

	ul, ol {

		ul {
			list-style-type: square;
		}
	}
}

dd {
	margin: 0 0 0 40px;
}

dl {
	margin: 1em 0;
}

ul, ol, menu, dl {

	ul, ol, menu, dl {
		margin: 0;
	}
}

legend {
	padding: 0 2px;
}

fieldset {
	border-style: groove;
	border-width: 2px;
	border: 2px groove ThreeDFace;
	margin: 0 2px;
	padding: 0 2px 3px;
	-webkit-padding-before: 0.35em;
	-webkit-padding-start: 0.75em;
	-webkit-padding-end: 0.75em;
	-webkit-padding-after: 0.625em;
}

ins {
	background-color: transparent;
	font-weight: inherit;
	text-decoration: underline;
}

b, strong {
	font-weight: bold;
}

i, cite, em, var, address, dfn {
	font-style: italic;
	font-weight: inherit;
}

abbr[title], dfn[title] {
	border-bottom: 0;
	cursor: default;
	font-weight: inherit;
}

tt, code, kbd, samp {
	font-family: monospace;
	font-weight: inherit;
}

pre {
	font-family: monospace;
	margin: 1em 0;
	white-space: pre;
}

mark {
	background-color: yellow;
	color: black;
	font-style: normal;
	font-weight: inherit;
}

big {
	font-size: larger;
	font-weight: inherit;
}

small {
	font-size: smaller;
	font-weight: inherit;
}

sub, sup {
	font-weight: inherit;
	line-height: inherit;
	position: static;
}

sub {
	font-size: smaller;
	bottom: 0;
	vertical-align: sub;
}

sup {
	font-size: smaller;
	top: 0;
	vertical-align: super;
}

ruby {

	> rt {
		font-size: 50%;
	}
}

iframe {
	border: 2px inset;
}
`;
var DATE_FORMAT_DOTS = "dd.MM.yyyy";
var DATETIME_FORMAT_DOTS = "dd.MM.yyyy HH:mm";
var DEFAULT_LIMIT_AVAILABLE_PRODUCTS = 1e8;
var ACCOUNT_COMPANY_CREATION_TYPE = /* @__PURE__ */ ((ACCOUNT_COMPANY_CREATION_TYPE2) => {
  ACCOUNT_COMPANY_CREATION_TYPE2[ACCOUNT_COMPANY_CREATION_TYPE2["DatasourceImport"] = 1] = "DatasourceImport";
  ACCOUNT_COMPANY_CREATION_TYPE2[ACCOUNT_COMPANY_CREATION_TYPE2["RegistrationForm"] = 2] = "RegistrationForm";
  ACCOUNT_COMPANY_CREATION_TYPE2[ACCOUNT_COMPANY_CREATION_TYPE2["Manual"] = 3] = "Manual";
  return ACCOUNT_COMPANY_CREATION_TYPE2;
})(ACCOUNT_COMPANY_CREATION_TYPE || {});
var ACCOUNT_COMPANY_VAT_HANDLING = /* @__PURE__ */ ((ACCOUNT_COMPANY_VAT_HANDLING2) => {
  ACCOUNT_COMPANY_VAT_HANDLING2["Standard"] = "STANDARD";
  ACCOUNT_COMPANY_VAT_HANDLING2["NotApplied"] = "NOT_APPLIED";
  return ACCOUNT_COMPANY_VAT_HANDLING2;
})(ACCOUNT_COMPANY_VAT_HANDLING || {});
var MODULE_MAP = /* @__PURE__ */ ((MODULE_MAP2) => {
  MODULE_MAP2[MODULE_MAP2["commissions"] = 5] = "commissions";
  return MODULE_MAP2;
})(MODULE_MAP || {});
var LANGUAGES = /* @__PURE__ */ ((LANGUAGES2) => {
  LANGUAGES2["PL"] = "pl";
  LANGUAGES2["EN"] = "en";
  LANGUAGES2["DE"] = "de";
  LANGUAGES2["RU"] = "ru";
  return LANGUAGES2;
})(LANGUAGES || {});

// src/utils/listUtils.tsx
var import_axios = __toESM(require("axios"));
var import_isEmpty = __toESM(require("lodash/isEmpty"));
var import_jsx_runtime = require("react/jsx-runtime");
var placeFieldFormatter = (place) => {
  return `${place.streetAddress ? place.streetAddress + " " : ""}${place.streetNumber ? place.streetNumber : ""}${place.localNumber ? "/" + place.localNumber : ""}`;
};
var formatPlaceField = (placeField) => {
  return Array.isArray(placeField) ? placeField.map((place) => placeFieldFormatter(place)).join(", ") : placeFieldFormatter(placeField);
};
var getPrefixedName = (name, prefix) => {
  return prefix ? `${prefix}${name}` : name;
};
var getListFiltersConfig = (moduleMeta, namePrefix, options) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h;
  if (!moduleMeta) {
    return null;
  }
  if ((options == null ? void 0 : options.includedFields) && (options == null ? void 0 : options.excludedFields)) {
    throw new Error(
      "Cannot use both includedFields and excludedFields in getListFiltersConfig"
    );
  }
  const fields = Object.entries(moduleMeta == null ? void 0 : moduleMeta.fields).filter((field) => {
    var _a3, _b2;
    if (options == null ? void 0 : options.excludedFields) {
      return !((_a3 = options == null ? void 0 : options.excludedFields) == null ? void 0 : _a3.includes(field[0]));
    } else if (options == null ? void 0 : options.includedFields) {
      return (_b2 = options == null ? void 0 : options.includedFields) == null ? void 0 : _b2.includes(field[0]);
    } else {
      return true;
    }
  }).map((field) => {
    var _a3, _b2;
    const fieldName = field[0];
    const fieldConfig = field[1];
    const prefixedName = getPrefixedName(fieldName, namePrefix);
    if (!(0, import_isEmpty.default)((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[fieldName]) == null ? void 0 : _b2.filter)) {
      return options.fieldOverrides[fieldName].filter;
    }
    if (fieldName === "creationType") {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: [
            {
              id: 1 /* DatasourceImport */,
              value: "LIST_AC_CT_DATASOURCE_IMPORT",
              ordering: 1
            },
            {
              id: 2 /* RegistrationForm */,
              value: "LIST_AC_CT_REGISTRATION_FORM",
              ordering: 2
            },
            {
              id: 3 /* Manual */,
              value: "LIST_AC_CT_MANUAL",
              ordering: 3
            }
          ]
        }
      };
    }
    if (fieldName === "defaultPriceType") {
      return {
        id: fieldName,
        name: prefixedName,
        type: "defaultPriceType",
        additionalData: {
          additionalProps: {
            endpoint: "price_types",
            labelField: ["fullName"],
            valueField: "indexUpper",
            filters: { "filter[active]": true }
          }
        }
      };
    }
    if (["documentStatusByAu", "documentStatus"].includes(fieldName)) {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: documentStatusPositions
        }
      };
    }
    if (fieldName === "vatHandling") {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: [
            {
              id: "STANDARD" /* Standard */,
              value: "LIST_AC_VH_STANDARD",
              ordering: 1
            },
            {
              id: "NOT_APPLIED" /* NotApplied */,
              value: "LIST_AC_VH_NOT_APPLIED",
              ordering: 2
            }
          ]
        }
      };
    }
    if (fieldName === "currencyCode") {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: [
            {
              id: "PLN",
              value: "PLN"
            },
            {
              id: "GBP",
              value: "GBP"
            },
            {
              id: "USD",
              value: "USD"
            },
            {
              id: "EUR",
              value: "EUR"
            },
            {
              id: "CHF",
              value: "CHF"
            },
            {
              id: "RUB",
              value: "RUB"
            }
          ]
        }
      };
    }
    if (fieldName === "documentSeriesDefinition" && (options == null ? void 0 : options.endpoint) !== null) {
      return {
        id: fieldName,
        name: prefixedName,
        type: fieldConfig.type,
        relatedModule: fieldConfig.relatedModule,
        additionalData: {
          filter: {
            "filter[documentType][eq]": MODULE_MAP[options == null ? void 0 : options.endpoint]
          }
        }
      };
    }
    return {
      id: fieldName,
      name: prefixedName,
      type: fieldConfig.type,
      relatedModule: fieldConfig.relatedModule
    };
  });
  const extraFields = Object.entries((moduleMeta == null ? void 0 : moduleMeta.extra_fields) ?? {}).filter((field) => {
    var _a3, _b2;
    if (options == null ? void 0 : options.excludedFields) {
      return !((_a3 = options == null ? void 0 : options.excludedFields) == null ? void 0 : _a3.includes(field[0]));
    } else if (options == null ? void 0 : options.includedFields) {
      return (_b2 = options == null ? void 0 : options.includedFields) == null ? void 0 : _b2.includes(field[0]);
    } else {
      return true;
    }
  }).map((field) => {
    var _a3, _b2;
    const fieldName = field[0];
    const fieldConfig = field[1];
    const prefixedName = getPrefixedName(fieldName, namePrefix);
    if (!(0, import_isEmpty.default)((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[fieldName]) == null ? void 0 : _b2.filter)) {
      return options.fieldOverrides[fieldName].filter;
    }
    return {
      id: fieldName,
      name: prefixedName,
      type: fieldConfig.type,
      relatedModule: fieldConfig.relatedModule
    };
  });
  const extraFieldRelations = ((_b = (_a2 = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _a2.relations) == null ? void 0 : _b.properties) && !Array.isArray((_d = (_c = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _c.relations) == null ? void 0 : _d.properties) ? Object.keys((_f = (_e = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _e.relations) == null ? void 0 : _f.properties).filter(
    (relation) => {
      var _a3;
      return (_a3 = options.includedExtraFieldRelations) == null ? void 0 : _a3.includes(relation);
    }
  ).map((relation) => ({
    id: relation,
    name: getPrefixedName(relation, namePrefix),
    type: "relation",
    relatedModule: relation
  })) : [];
  const attributeFields = Array.isArray(moduleMeta == null ? void 0 : moduleMeta.extra_fields) ? [] : ((_h = (_g = moduleMeta.extra_fields) == null ? void 0 : _g.attributes) == null ? void 0 : _h.items.filter((attr) => {
    var _a3;
    return !((_a3 = options == null ? void 0 : options.excludedAttributeTypes) == null ? void 0 : _a3.includes(attr.type));
  }).sort(attributeSorting).map((attr) => {
    var _a3, _b2;
    return {
      id: String(attr.id),
      name: attr.name,
      type: attr.type,
      relatedModule: "attributes",
      additionalData: {
        displayName: attr.name,
        ...(attr == null ? void 0 : attr.positions) ? { positions: attr.positions } : {},
        ...(attr == null ? void 0 : attr.options) ? { options: attr.options } : {},
        ...getAttributeAdditionalProps(attr.type),
        ...((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[`attribute.${attr.type}`]) == null ? void 0 : _b2.filter) ?? {}
      }
    };
  })) ?? [];
  return [
    ...fields,
    ...extraFields,
    ...(options == null ? void 0 : options.customFilters) ?? [],
    ...extraFieldRelations,
    ...attributeFields
  ];
};
var attributeSorting = (attribute1, attribute2) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h;
  if (((_a2 = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _a2.displayPriority) !== ((_b = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _b.displayPriority)) {
    return ((_c = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _c.displayPriority) - ((_d = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _d.displayPriority);
  }
  if (((_e = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _e.ordering) !== ((_f = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _f.ordering)) {
    return ((_g = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _g.ordering) - ((_h = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _h.ordering);
  }
  return attribute1 == null ? void 0 : attribute1.name.localeCompare(attribute2 == null ? void 0 : attribute2.name);
};
var getAttributeAdditionalProps = (type) => {
  switch (type) {
    case "company":
      return {
        endpoint: "account_companies",
        labelField: "displayName",
        extraFields: ["displayName"]
      };
    default:
      return {};
  }
};
var getModuleHref = (module2, id) => {
  switch (module2) {
    case "accountCompany":
      return `/accountCompany/show/company_id/${id}`;
    case "accountUser":
      return `/accountUser/show/user_id/${id}`;
    case "campaign":
      return `/campaign/show/campaign_id/${id}`;
    case "campaignOpportunity":
      return `/campaignOpportunity/show/opportunity_id/${id}`;
    case "commission":
      return `/commission/show/commission_id/${id}`;
    case "product":
      return `/product/show/productid/${id}`;
    case "productList":
      return `/product/show/productid/${id}`;
    case "servicedProduct":
      return `/servicedProduct/show/serviced_product_id/${id}`;
    case "userUser":
      return `/userUser/show/userid/${id}`;
    case "documentOrder":
      return `/documentOrder/listProcess/document_id/${id}`;
    case "documentOfferQuestion":
      return `/documentOfferQuestion/listProcess/document_id/${id}`;
    case "documentStore":
      return `/documentStorePosition/list/document_id/${id}`;
    case "internalDocumentOrder":
      return `/internalDocumentOrder/listProcess/document_id/${id}`;
    case "documentInvoice":
      return `/documentInvoicePosition/list/document_id/${id}`;
    default:
      return "#";
  }
};
var getAttributeTagTypeForModule = (module2) => {
  switch (module2) {
    case "commission":
      return 1;
    case "accountCompany":
      return 2;
    case "accountUser":
      return 3;
    case "userForm":
      return 4;
    case "campaignOpportunity":
      return 5;
    default:
      return 1;
  }
};
var ModuleLink = ({ module: module2, id, children, isTooltip = true }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: isTooltip ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Tooltip, {
      hasArrow: true,
      px: "12px",
      py: "8px",
      label: children,
      openDelay: 500,
      placement: "bottom-start",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Link, {
        textDecoration: "none",
        color: "#3182CE",
        isExternal: true,
        href: getModuleHref(module2, id),
        children
      })
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Link, {
      textDecoration: "none",
      color: "#3182CE",
      isExternal: true,
      href: getModuleHref(module2, id),
      children
    })
  });
};
var checkTitleCell = (value, row, fieldName, fieldConfig, moduleName) => {
  if (fieldConfig.type === "string" && fieldName === "title") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: "campaignOpportunity",
      id: row.original.id,
      children: value
    });
  }
  if ((fieldConfig.type === "string" || fieldConfig.type === "text") && fieldName === "documentHeader") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: moduleName,
      id: row.original.id,
      children: value
    });
  }
  if (fieldConfig.type === "string" && fieldName === "commissionNumber") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: "commission",
      id: row.original.id,
      children: value
    });
  }
  if (fieldConfig.type === "string" && fieldName === "serialCode") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: "servicedProduct",
      id: row.original.id,
      children: value
    });
  }
  if (moduleName === "productList" && ["name", "code"].includes(fieldName)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: "productList",
      id: row.original.id,
      children: value
    });
  }
  if (fieldConfig.type === "text" && fieldName === "name" || fieldConfig.type === "string" && fieldName === "shortName" || (fieldConfig.type === "string" || fieldConfig.type === "text") && fieldName === "displayName") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: "accountCompany",
      id: row.original.id,
      children: value
    });
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "campaign") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: "campaign",
      id: value.id,
      children: value.name
    });
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "product") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: "product",
      id: value.id,
      children: value.name
    });
  }
  let tooltipLabelContent = [];
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "accountCompany") {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const companies = newValue.map((ac, index) => {
        tooltipLabelContent.push(ac.displayName);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react7.default.Fragment, {
          children: [
            index !== 0 && ",\xA0",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: "accountCompany",
              id: ac.id,
              isTooltip: false,
              children: ac.displayName
            })
          ]
        }, ac.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Tooltip, {
        hasArrow: true,
        px: "12px",
        py: "8px",
        label: tooltipLabelContent.join(", "),
        openDelay: 500,
        placement: "bottom-start",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
          as: "span",
          children: companies
        })
      });
    }
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "userUser") {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const users = newValue.map((uu, index) => {
        tooltipLabelContent.push(`${uu.firstName} ${uu.lastName}`);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react7.default.Fragment, {
          children: [
            index !== 0 && ",\xA0",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: "userUser",
              id: uu.id,
              isTooltip: false,
              children: `${uu.firstName} ${uu.lastName}`
            })
          ]
        }, uu.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Tooltip, {
        hasArrow: true,
        px: "12px",
        py: "8px",
        label: tooltipLabelContent.join(", "),
        openDelay: 500,
        placement: "bottom-start",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
          as: "span",
          children: users
        })
      });
    }
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "accountUser") {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const users = newValue.map((au, index) => {
        tooltipLabelContent.push(`${au.firstName} ${au.lastName}`);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react7.default.Fragment, {
          children: [
            index !== 0 && ",\xA0",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: "accountUser",
              id: au.id,
              isTooltip: false,
              children: `${au.firstName} ${au.lastName}`
            })
          ]
        }, au.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Tooltip, {
        hasArrow: true,
        px: "12px",
        py: "8px",
        label: tooltipLabelContent.join(", "),
        openDelay: 500,
        placement: "bottom-start",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
          as: "span",
          children: users
        })
      });
    }
  }
  return null;
};
var formatFieldCell = (value, row, fieldName, fieldConfig, moduleName) => {
  if ((0, import_isNil.default)(value)) {
    return "";
  }
  const titleCell = checkTitleCell(
    value,
    row,
    fieldName,
    fieldConfig,
    moduleName
  );
  if (titleCell) {
    return titleCell;
  }
  if (fieldConfig.type === "integer" && fieldName === "creationType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(CellWrapper_default, {
        children: [
          value === 1 /* DatasourceImport */ && t("LIST_AC_CT_DATASOURCE_IMPORT"),
          value === 2 /* RegistrationForm */ && t("LIST_AC_CT_REGISTRATION_FORM"),
          value === 3 /* Manual */ && t("LIST_AC_CT_MANUAL")
        ]
      })
    });
  }
  if (fieldConfig.type === "string" && fieldName === "vatHandling") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(CellWrapper_default, {
        children: [
          value === "STANDARD" /* Standard */ && t("LIST_AC_VH_STANDARD"),
          value === "NOT_APPLIED" /* NotApplied */ && t("LIST_AC_VH_NOT_APPLIED")
        ]
      })
    });
  }
  if (fieldConfig.type === "integer" && fieldName === "defaultPriceType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceTypeDisplay_default, {
      value
    });
  }
  if (["datetime", "datetimetz"].includes(fieldConfig.type)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: (0, import_date_fns.format)(new Date(value), DATETIME_FORMAT_DOTS)
    });
  }
  if ([
    "value",
    "valueNetto",
    "valueBrutto",
    "valueVat",
    "paymentToPay",
    "paymentPayed",
    "valueNettoBeforeDiscount"
  ].includes(fieldName)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: priceFormatter(value, "none", {}, 2)
    });
  }
  if (["documentStatusByAu", "documentStatus"].includes(fieldName)) {
    const foundObject = documentStatusPositions.find((obj) => obj.id === value);
    const preparedValue = foundObject.value ?? null;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: t(preparedValue)
      })
    });
  }
  if (fieldConfig.type === "date") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: (0, import_date_fns.format)(new Date(value), DATE_FORMAT_DOTS)
    });
  }
  if (fieldConfig.type === "boolean") {
    if (fieldName == "isActive") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Box, {
          mx: "auto",
          color: "green.500",
          as: import_fa2.FaCheck
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Box, {
          mx: "auto",
          color: "red.500",
          as: import_fa2.FaTimes
        })
      });
    } else {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
        children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          textAlign: "center",
          children: value ? t("YES") : t("NO")
        })
      });
    }
  }
  if (["integer", "bigint", "decimal", "float"].includes(fieldConfig.type)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: value
    });
  }
  if (["string", "text"].includes(fieldConfig.type)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: stripHtmlTags(value)
    });
  }
  if (fieldConfig.type === "relation") {
    switch (fieldConfig.relatedModule) {
      case "userUser":
      case "accountUser":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          children: Array.isArray(value) ? value.map((user) => `${user.firstName} ${user.lastName}`).join(", ") : `${value.firstName} ${value.lastName}`
        });
      case "documentSeriesDefinition":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.name)
          })
        });
      case "places": {
        const formattedPlaces = formatPlaceField(value);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          isTruncated: true,
          maxW: "500px",
          title: formattedPlaces,
          children: formattedPlaces
        });
      }
      case "paymentType":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.name)
          })
        });
      case "deliveryType":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.name)
          })
        });
      case "campaignPhase":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.name)
          })
        });
      case "commissionPhase":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.phaseName)
          })
        });
      case "taskType":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.typeName)
          })
        });
      case "priceCompanyGroup":
      default:
        logger_default.warn(
          `Cannot format cell for ${fieldName} from module ${fieldConfig.relatedModule}`
        );
        return null;
    }
  }
  logger_default.warn(`Cannot format cell for ${fieldName} of type ${fieldConfig.type}`);
  return null;
};
var formatAttributeCell = (value, attributeConfig) => {
  if ((0, import_isNil.default)(value)) {
    return null;
  }
  switch (attributeConfig.type) {
    case "text":
    case "phone":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: stripHtmlTags(value)
      });
    case "date":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: (0, import_date_fns.format)(new Date(value), DATE_FORMAT_DOTS)
      });
    case "datetime":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: (0, import_date_fns.format)(new Date(value), DATETIME_FORMAT_DOTS)
      });
    case "tags":
    case "email":
      return value.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value.join(", ")
      }) : null;
    case "bool":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Box, {
          mx: "auto",
          color: "green.500",
          as: import_fa2.FaCheck
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Box, {
          mx: "auto",
          color: "red.500",
          as: import_fa2.FaTimes
        })
      });
    case "numeric":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: value
      });
    case "file":
      return null;
    case "list": {
      const listValue = value == null ? void 0 : value.find((opt) => opt.selected);
      if (!listValue) {
        return null;
      }
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
        children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          children: t(listValue.value)
        })
      });
    }
    case "listMulti": {
      const listValue = value.filter((opt) => opt.selected);
      if (listValue.length < 1) {
        return null;
      }
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
        children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          children: listValue.map((val) => t(val.value)).join(", ")
        })
      });
    }
    case "company": {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value.map((ac, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react7.default.Fragment, {
          children: [
            index !== 0 && ",\xA0",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Link, {
              textDecoration: "none",
              color: "crmBlue",
              isExternal: true,
              href: getModuleHref("accountCompany", ac.id),
              children: ac.value
            })
          ]
        }, ac.id))
      });
    }
    case "accountUser": {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value.map((au, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react7.default.Fragment, {
          children: [
            index !== 0 && ",\xA0",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Link, {
              textDecoration: "none",
              color: "crmBlue",
              isExternal: true,
              href: getModuleHref("accountUser", au.id),
              children: au.name
            })
          ]
        }, au.id))
      });
    }
    default:
      logger_default.warn(
        `Cannot format attribute cell for attribute ${attributeConfig.name} of type ${attributeConfig.type}`
      );
      return null;
  }
};
var relationFieldCellMap = {
  accountCompanies: {
    module: "accountCompany",
    value: (elem) => elem.value
  },
  accountUsers: {
    module: "accountUser",
    value: (elem) => `${elem.firstName} ${elem.lastName}`
  },
  products: {
    module: "product",
    value: (elem) => elem.fullName
  },
  servicedProducts: {
    module: "servicedProduct",
    value: (elem) => elem.fullName
  }
};
var formatRelationFieldCell = (value, row, relation) => {
  if ((0, import_isNil.default)(value)) {
    return "";
  }
  if (relationFieldCellMap[relation]) {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const relationFieldNames = [];
      const relationFields = newValue.map((elem, index) => {
        relationFieldNames.push(relationFieldCellMap[relation].value(elem));
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react7.default.Fragment, {
          children: [
            index !== 0 && ",\xA0",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: elem.type || relationFieldCellMap[relation].module,
              id: elem.id,
              isTooltip: false,
              children: relationFieldCellMap[relation].value(elem)
            })
          ]
        }, elem.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Tooltip, {
        hasArrow: true,
        px: "12px",
        py: "8px",
        label: relationFieldNames.join(", "),
        openDelay: 500,
        placement: "bottom-start",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
          isTruncated: true,
          as: "span",
          children: relationFields
        })
      });
    }
  }
  logger_default.warn(`Cannot format relation field cell for relation ${relation}`);
  return null;
};
var formatHeader = (fieldName, fieldConfig, {
  alignment,
  prefix = "LIST_COLUMN_"
} = {
  alignment: "left"
}) => {
  if (["datetime", "date", "datetimetz", "integer", "bigint", "decimal"].includes(
    fieldConfig == null ? void 0 : fieldConfig.type
  )) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
        w: "full",
        as: "span",
        display: "block",
        textAlign: "right",
        children: t(`${prefix}${fieldName}`)
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
    children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
      w: "full",
      as: "span",
      display: "block",
      textAlign: alignment,
      children: t(`${prefix}${fieldName}`)
    })
  });
};
var formatRelationHeader = (relationName, {
  alignment
} = {
  alignment: "left"
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
    children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
      textAlign: alignment,
      children: t(`LIST_COLUMN_${relationName}`)
    })
  });
};
var formatAttributeHeader = (attribute, {
  alignment
} = {}) => {
  if (["datetime", "date", "integer", "bigint", "decimal", "numeric"].includes(
    attribute == null ? void 0 : attribute.type
  )) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
        as: "span",
        display: "block",
        float: "right",
        children: t(`${attribute.name}`)
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_i18next.Translation, {
    children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react6.Text, {
      textAlign: alignment,
      children: t(`${attribute.name}`)
    })
  });
};
var getProductFieldsAccessor = (fieldName) => {
  switch (fieldName) {
    case "name":
    case "code":
    case "description":
      return `translations.${fieldName}`;
    case "priceBrutto":
    case "priceNetto":
      return "prices";
    default:
      return fieldName;
  }
};
var parseMetaToColumns = (moduleMeta, options, moduleName) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  if (!moduleMeta) {
    return null;
  }
  const baseFieldsColumns = Object.keys(
    moduleMeta.fields
  ).filter((field) => !(options == null ? void 0 : options.excludedFields.includes(field))).map((field) => {
    var _a3, _b2;
    if ((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[field]) == null ? void 0 : _b2.column) {
      return options.fieldOverrides[field].column;
    }
    return {
      id: field,
      Header: (options2) => {
        return formatHeader(field, moduleMeta.fields[field], options2);
      },
      accessor: moduleName === "productList" ? getProductFieldsAccessor(field) : field,
      Cell: ({ value, row }) => {
        return formatFieldCell(
          value,
          row,
          field,
          moduleMeta.fields[field],
          moduleName
        );
      }
    };
  });
  const baseExtraFieldsColumns = Object.keys(
    (moduleMeta == null ? void 0 : moduleMeta.extra_fields) ?? {}
  ).filter((extraField) => extraField !== "attributes").filter((extraField) => !(options == null ? void 0 : options.excludedFields.includes(extraField))).map((extraField) => {
    var _a3, _b2;
    if ((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[extraField]) == null ? void 0 : _b2.column) {
      return options.fieldOverrides[extraField].column;
    }
    return {
      id: extraField,
      Header: (options2) => {
        return formatHeader(
          extraField,
          moduleMeta.extra_fields[extraField],
          options2
        );
      },
      accessor: extraField,
      Cell: ({ value, row }) => {
        return formatFieldCell(
          value,
          row,
          extraField,
          moduleMeta.extra_fields[extraField],
          moduleName
        );
      }
    };
  });
  const extraFieldRelations = ((_b = (_a2 = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _a2.relations) == null ? void 0 : _b.properties) && !Array.isArray((_d = (_c = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _c.relations) == null ? void 0 : _d.properties) ? Object.keys((_f = (_e = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _e.relations) == null ? void 0 : _f.properties).filter(
    (relation) => {
      var _a3;
      return (_a3 = options.includedExtraFieldRelations) == null ? void 0 : _a3.includes(relation);
    }
  ).map((relation) => ({
    id: relation,
    Header: () => formatRelationHeader(relation),
    fieldType: "relation",
    fieldName: relation,
    accessor: (originalRow) => {
      var _a3;
      return (_a3 = originalRow.relations) == null ? void 0 : _a3[relation];
    },
    Cell: ({ value, row }) => {
      return formatRelationFieldCell(value, row, relation);
    }
  })) : [];
  const attributesColumns = !Array.isArray((_g = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _g.attributes) && ((_j = (_i = (_h = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _h.attributes) == null ? void 0 : _i.items) == null ? void 0 : _j.length) ? (_m = (_l = (_k = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _k.attributes) == null ? void 0 : _l.items) == null ? void 0 : _m.filter(
    (attribute) => {
      var _a3;
      return !((_a3 = options == null ? void 0 : options.excludedAttributeTypes) == null ? void 0 : _a3.includes(attribute.type));
    }
  ).map((attribute) => ({
    id: `attribute.${attribute.id}`,
    Header: () => {
      return formatAttributeHeader(attribute);
    },
    fieldType: "attribute",
    fieldName: attribute.name,
    accessor: (originalRow) => {
      var _a3;
      const accessedAttribute = (_a3 = originalRow == null ? void 0 : originalRow.attributes) == null ? void 0 : _a3.find(
        (attr) => attr.id === attribute.id
      );
      return accessedAttribute == null ? void 0 : accessedAttribute.value;
    },
    Cell: ({ value, row }) => {
      var _a3;
      return formatAttributeCell(
        value,
        !Array.isArray(moduleMeta.extra_fields) ? (_a3 = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _a3.attributes.items.find(
          (attr) => attr.id === attribute.id
        ) : null
      );
    }
  })) : [];
  return [
    ...baseFieldsColumns,
    ...baseExtraFieldsColumns,
    ...extraFieldRelations,
    ...attributesColumns
  ];
};
var getVisibleColumnsParams = (columns, hiddenColumns, activeFilters, initialParams) => {
  if (!columns || (columns == null ? void 0 : columns.length) < 1) {
    return null;
  }
  let activeFilterAttributes = [];
  let activeFilterFields = [];
  if (activeFilters) {
    Object.keys(activeFilters).forEach((filter) => {
      if (activeFilters[filter].module === "attributes") {
        activeFilterAttributes.push(`attributes.${filter}`);
      } else {
        activeFilterFields.push(filter);
      }
    });
  }
  const visibleColumns = (0, import_xor.default)(hiddenColumns ?? [], columns ?? []);
  const [attributes, fields] = (0, import_partition.default)(
    visibleColumns,
    (column) => column.startsWith("attribute.")
  );
  const attributesParams = attributes.map(
    (attr) => attr.replace("attribute.", "attributes.")
  );
  const mergedFields = (initialParams == null ? void 0 : initialParams.fields) ? (0, import_uniq.default)([
    ...initialParams.fields.split(","),
    ...fields,
    ...activeFilterFields
  ]) : (0, import_uniq.default)([...fields, ...activeFilterFields]);
  const mergedExtraFields = (initialParams == null ? void 0 : initialParams.extra_fields) ? (0, import_uniq.default)([
    ...initialParams.extra_fields.split(","),
    ...attributesParams,
    ...activeFilterAttributes
  ]) : (0, import_uniq.default)([...attributesParams, ...activeFilterAttributes]);
  return {
    ...mergedFields.length ? {
      fields: mergedFields == null ? void 0 : mergedFields.join(",")
    } : {},
    ...mergedExtraFields.length ? {
      extra_fields: mergedExtraFields == null ? void 0 : mergedExtraFields.join(",")
    } : {}
  };
};
var downloadXlsxDocument = (apiParams, signal, module2, onModalLoaderClose) => {
  const { endpoint, params } = apiParams;
  const urlSearchParams = new URLSearchParams({
    ...params,
    "setting[export_to_xlsx]": "true",
    "page[limit]": -1
  });
  const url = `${document.location.origin}/api/${endpoint}?${urlSearchParams}`;
  import_axios.default.get(url, {
    signal,
    responseType: "blob"
  }).then((response) => {
    const url2 = URL.createObjectURL(response.data);
    const linkElement = document.createElement("a");
    linkElement.href = url2;
    linkElement.style.display = "none";
    linkElement.download = `${module2}_list`;
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
    URL.revokeObjectURL(url2);
    setTimeout(() => {
      onModalLoaderClose == null ? void 0 : onModalLoaderClose();
    }, 2e3);
  }).catch(() => {
    return false;
  });
  return url;
};
var disableSortingColumns = (columns, disabledSortingColumns) => {
  return columns == null ? void 0 : columns.map((c) => {
    if (disabledSortingColumns.includes(c.id)) {
      c.disableSortBy = true;
    }
    return c;
  });
};
var documentStatusPositions = [
  { id: 0, value: "tworzenie" },
  { id: 1, value: "z\u0142o\u017Cone" },
  { id: 2, value: "z\u0142o\u017Cone - potwierdzone" },
  { id: 3, value: "rozpatrzone" },
  { id: 4, value: "odrzucone" },
  { id: 6, value: "zrealizowane" },
  { id: 7, value: "zrealizowane wielokrotnie" },
  { id: 8, value: "usuni\u0119te" },
  { id: 9, value: "anulowane" },
  { id: 10, value: "zamkni\u0119te" },
  { id: 14, value: "wys\u0142ane" },
  { id: 15, value: "weryfikacja" },
  { id: 16, value: "do poprawienia" },
  { id: 17, value: "cz\u0119\u015Bciowo zrealizowane" },
  { id: 18, value: "potwierdzony" },
  { id: 19, value: "autoryzacja klienta" },
  { id: 20, value: "w buforze" },
  { id: 21, value: "op\u0142acony" },
  { id: 22, value: "zrezygnowano" }
];

// src/utils/apiUtils.ts
var import_date_fns2 = require("date-fns");
var normalizeSettings = (settings) => {
  const parsedSetting = {};
  settings == null ? void 0 : settings.forEach((setting) => {
    parsedSetting[setting.name] = fixSettingValueType(setting);
  });
  return parsedSetting;
};
var fixSettingValueType = (setting) => {
  var _a2;
  switch (setting.name) {
    case "cookie_notice":
      return setting.value === "1" || setting.value === "true";
    case "enable_multilingualism":
      return setting.value === "1" || setting.value === "true";
    case "company_search_for_user_user":
      return setting.value === "1" || setting.value === "true";
    case "searchbar_account_user":
      return setting.value === "1" || setting.value === "true";
    case "company_short_name_enabled":
      return parseInt((_a2 = setting.value) == null ? void 0 : _a2.toString());
    default:
      return setting.value;
  }
};
var formatDateForApi = (date) => {
  if (!date) {
    return null;
  }
  const dateToFormat = typeof date === "string" ? new Date(date) : date;
  return (0, import_date_fns2.formatISO)(dateToFormat);
};

// src/utils/taskUtils.ts
var transformTasksForTasklist = (tasks) => {
  return tasks.map((t) => {
    var _a2, _b, _c, _d, _e;
    return {
      taskName: t.name,
      id: t.id,
      isCompleted: false,
      taskDescription: t.description,
      beginDate: t.beginDate,
      endDate: t.endDate,
      type: {
        id: t.typeId,
        typeName: t.typeName,
        isEvent: t.subtype === "event",
        icon: t.icon,
        iconColor: t.iconColor
      },
      user: {
        id: (_a2 = t == null ? void 0 : t.performer) == null ? void 0 : _a2.id,
        avatar: (_b = t == null ? void 0 : t.performer) == null ? void 0 : _b.avatar,
        fullName: ((_c = t == null ? void 0 : t.performer) == null ? void 0 : _c.firstName) && ((_d = t == null ? void 0 : t.performer) == null ? void 0 : _d.lastName) ? `${t.performer.firstName} ${t.performer.lastName}` : (_e = t.performer) == null ? void 0 : _e.name
      },
      recurrenceUuid: null,
      recurrenceParentBeginDate: null,
      recurrenceActive: t.recurrenceActive
    };
  });
};

// src/utils/documentUtils.ts
var getDocumentRelationName = (objectName) => {
  if (objectName === "campaignOpportunity") {
    return "campaignOpportunities";
  }
  return objectName + "s";
};

// src/context/ExternalMarkersContext.tsx
var import_react8 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkersContext = (0, import_react8.createContext)(null);
var ExternalMarkersProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkersContext.Provider, {
    value,
    children
  });
};
var useExternalMarkers = () => {
  const context = (0, import_react8.useContext)(ExternalMarkersContext);
  if (typeof context === "undefined") {
    throw new Error(
      "useExternalMarkers must be used inside ExternalMarkersProvider"
    );
  }
  return context;
};
var ExternalMarkersContext_default = ExternalMarkersProvider;

// src/components/ActiveFilterDisplay/FiltersDisplayItem/FiltersDisplayItem.tsx
var import_react10 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var MultiFilterDisplay = ({
  filterName,
  multiFilter,
  endpoint,
  labelField,
  extraFields,
  valueField = "id",
  removeFilter,
  positions,
  filters
}) => {
  const { data, isLoading } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    extraFields,
    valueField,
    enabled: !positions,
    filters
  });
  const { t } = (0, import_react_i18next2.useTranslation)();
  const newPositions = data ?? positions;
  if (isLoading || !newPositions) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react9.Box, {
    "data-testid": `multifilter-${filterName}`,
    children: multiFilter.value.map((val) => {
      const option = newPositions.find(
        (pos) => pos.value === val || pos.id === val || pos.id === Number(val)
      );
      if (!option) {
        logger_default.error(
          `Could not get value for MultiFilterDisplay ${filterName}: ${JSON.stringify(
            val
          )}`
        );
      }
      const optionValue = t(`${option.value}`);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
        value: optionValue,
        onFilterRemove: () => {
          removeFilter(filterName);
        }
      }, val);
    })
  });
};
var UserFilterDisplay = ({
  filterName,
  multiFilter,
  endpoint,
  labelField = "fullName",
  valueField = "id",
  removeFilter
}) => {
  const { data, isLoading } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    extraFields: ["fullName"]
  });
  if (isLoading || !data) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: multiFilter.value.map((val) => {
      const option = data.find((pos) => pos.id === val);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
        value: option.value,
        ...removeFilter ? { onFilterRemove: () => removeFilter(filterName, option.id) } : {}
      }, val);
    })
  });
};
var FiltersDisplayItem = ({
  value,
  filterName,
  filterDisplayName,
  ml,
  removeFilter,
  module: module2,
  ...props
}) => {
  var _a2, _b, _c, _d, _e;
  const { t } = (0, import_react_i18next2.useTranslation)();
  const externalMarkers = useExternalMarkers();
  if (value.type === "custom" && value.additionalData.displayComponent) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: value.additionalData.displayComponent({
        filterName,
        filterDisplayName,
        value,
        removeFilter
      })
    });
  }
  if (value.type === "custom" || value.type === "company") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: (_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.positions,
          endpoint: (_b = value == null ? void 0 : value.additionalData) == null ? void 0 : _b.endpoint,
          labelField: (_c = value == null ? void 0 : value.additionalData) == null ? void 0 : _c.labelField,
          filters: (_d = value == null ? void 0 : value.additionalData) == null ? void 0 : _d.additionalParams
        })
      ]
    });
  }
  if (value.type === "list" && filterName === "defaultPriceType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          endpoint: value.additionalData.endpoint,
          labelField: value.additionalData.labelField,
          filters: value.additionalData.filter
        })
      ]
    });
  }
  if (value.type === "list" && filterName === "vatHandling") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: value.additionalData.positions
        })
      ]
    });
  }
  if (value.type === "text" || value.type === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          value: value.value,
          onFilterRemove: () => removeFilter(filterName)
        })
      ]
    });
  }
  if (value.type === "boolean" || value.type === "bool") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          value: value.value ? `${t("Yes")}` : `${t("No")}`,
          onFilterRemove: () => removeFilter(filterName)
        })
      ]
    });
  }
  if (value.type === "integer" || value.type === "bigint" || value.type === "float" || value.type === "numeric" || value.type === "decimal") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        !(0, import_isNil2.default)(value.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_FROM"),
          value: value.value.from,
          onFilterRemove: () => removeFilter(filterName, "from")
        }) : null,
        !(0, import_isNil2.default)(value.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_TO"),
          value: value.value.to,
          onFilterRemove: () => removeFilter(filterName, "to")
        }) : null,
        !(0, import_isNil2.default)(value.value.notZero) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          value: value.value.notZero ? t("ONLY_AVAILABLE") : null,
          onFilterRemove: () => removeFilter(filterName, "notZero")
        }) : null
      ]
    });
  }
  if (value.type === "list") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: value == null ? void 0 : value.additionalData.positions
        })
      ]
    });
  }
  if (value.type === "listMulti") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: (_e = value == null ? void 0 : value.additionalData) == null ? void 0 : _e.positions
        })
      ]
    });
  }
  if (value.type === "tags") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          endpoint: "markers",
          labelField: "value",
          filters: { "filter[type][eq]": getAttributeTagTypeForModule(module2) }
        })
      ]
    });
  }
  if (value.type === "date" || value.type === "datetime" || value.type === "datetimetz") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        !(0, import_isNil2.default)(value.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_FROM"),
          value: (0, import_date_fns3.format)(
            value.value.from,
            value.type === "datetime" || value.type === "datetimetz" ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS
          ),
          onFilterRemove: () => removeFilter(filterName, "from")
        }) : null,
        !(0, import_isNil2.default)(value.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_TO"),
          value: (0, import_date_fns3.format)(
            value.value.to,
            value.type === "datetime" || value.type === "datetimetz" ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS
          ),
          onFilterRemove: () => removeFilter(filterName, "to")
        }) : null
      ]
    });
  }
  if (value.type === "relation") {
    if (value.module === "paymentType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "payment_types",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "deliveryType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "delivery_types",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "documentSeriesDefinition") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "document_series_definitions",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "commissionPhase") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "commission_phases",
            labelField: "phaseName",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "priceProductGroup") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "price_product_groups",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "defaultPriceType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "price_types",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "accountUser") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "account_users",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "userUser") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "user_users",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "externalMarker") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          value.value.map((val) => {
            const externalMarker = externalMarkers.find(
              (pos) => pos.id === val
            );
            return externalMarker && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
              value: String(
                externalMarker.label && externalMarker.label !== "" ? t(`${externalMarker.label}`) : externalMarker.symbol
              ),
              onFilterRemove: () => removeFilter(filterName, val)
            }, val);
          })
        ]
      });
    }
    if (value.module === "campaignPhase") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "campaign_phases",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "campaign") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "campaigns",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "accountCompany") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "account_companies",
            extraFields: ["displayName"],
            removeFilter
          })
        ]
      });
    }
    if (value.module === "taskType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "task_types",
            labelField: "typeName",
            removeFilter
          })
        ]
      });
    }
    if (process.env.NODE_ENV === "development") {
      logger_default.warn(
        `[ActiveFilterDisplay] no component for filter type ${value.type}${(value == null ? void 0 : value.module) ? " and module " + value.module : null}`
      );
    }
    return null;
  }
  if (process.env.NODE_ENV === "development") {
    logger_default.warn(
      `[ActiveFilterDisplay] no component for filter type ${value.type}`
    );
  }
  return null;
};
var FilterDisplayItemWrapper = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react9.Stack, {
    rowGap: 3,
    maxW: "full",
    flexWrap: "wrap",
    className: "filter-display__item",
    direction: "row",
    align: "center",
    spacing: 4,
    ...props,
    children
  });
};
var FilterName = ({ name, ...props }) => {
  const { t } = (0, import_react_i18next2.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react9.Text, {
    as: "span",
    fontSize: "md",
    fontWeight: "500",
    mr: -2,
    ...props,
    children: `${t(
      name
    )}:`
  });
};
var TagDisplay = ({
  value,
  valuePrefix,
  onFilterRemove,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagButton, {
    mr: 4,
    ...onFilterRemove ? { onClick: onFilterRemove } : {},
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react9.Stack, {
      direction: "row",
      spacing: 1,
      align: "center",
      justifyContent: "space-between",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react9.Text, {
          as: "span",
          pl: 1,
          fontSize: "sm",
          children: `${valuePrefix ? valuePrefix + ": " : ""}${value}`
        }),
        onFilterRemove && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react9.Box, {
          color: "gray.400",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react10.default, {
            path: import_js.mdiClose,
            size: "16px"
          })
        })
      ]
    })
  });
};
var TagButton = ({ onClick, children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react9.Button, {
    borderRadius: "6px",
    variant: "outline",
    size: "xs",
    px: "8px",
    py: "0",
    fontWeight: "400",
    fontSize: "13px",
    color: "blue.900",
    onClick,
    ...props,
    children
  });
};
var FiltersDisplayItem_default = FiltersDisplayItem;

// src/components/ActiveFilterDisplay/ActiveFilterDisplay.tsx
var import_react14 = __toESM(require("@mdi/react"));
var import_js2 = require("@mdi/js");

// src/components/ButtonAction/ButtonAction.tsx
var import_react11 = require("@chakra-ui/react");
var import_react12 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ButtonAction = (props) => {
  const size = (0, import_react11.useBreakpointValue)({ base: "md", md: "sm" });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react11.Button, {
    css: import_react12.css`
        & .chakra-button__icon,
        & .chakra-button__icon > svg {
          width: 20px;
          height: 20px;
        }
      `,
    fontWeight: "medium",
    size,
    fontSize: "sm",
    variant: "outline",
    px: 4,
    py: "10px",
    ...props
  });
};
var ButtonAction_default = ButtonAction;

// src/components/ActiveFilterDisplay/ActiveFilterDisplay.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ActiveFilterDisplay = ({
  filters,
  clearAllFilters,
  clearFilter,
  filterPrefix,
  module: module2,
  buttonModalFilters,
  buttonModalSorting,
  ...props
}) => {
  var _a2;
  const { t } = (0, import_react_i18next3.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react13.Flex, {
    className: "filter-display",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 3,
    ...props,
    children: [
      buttonModalFilters,
      !((0, import_isNil3.default)(filters) || (0, import_isEmpty2.default)(filters)) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonAction_default, {
            size: "md",
            leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react14.default, {
              path: import_js2.mdiFilterOffOutline,
              size: "20px"
            }),
            onClick: clearAllFilters,
            mr: 1,
            fontSize: "sm",
            lineHeight: "20px",
            letterSpacing: "0.25px",
            color: "gray.700",
            children: [
              t("KANBAN_MODAL_CLEAR_FILTERS"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react13.Text, {
                ml: 1,
                as: "span",
                fontSize: "sm",
                letterSpacing: "0.25px",
                color: "blackAlpha.500",
                children: `(${(_a2 = Object.keys(filters)) == null ? void 0 : _a2.length})`
              })
            ]
          }),
          Object.keys(filters).map((filter, index) => {
            var _a3, _b, _c, _d;
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FiltersDisplayItem_default, {
              mr: 1,
              lineHeight: "24px",
              filterName: filter,
              filterDisplayName: ((_b = (_a3 = filters[filter]) == null ? void 0 : _a3.additionalData) == null ? void 0 : _b.displayName) ? t((_d = (_c = filters[filter]) == null ? void 0 : _c.additionalData) == null ? void 0 : _d.displayName) : t(`${filterPrefix ?? "LIST_COLUMN_"}${filter}`),
              value: filters[filter],
              removeFilter: clearFilter,
              module: module2
            }, filter);
          })
        ]
      }),
      buttonModalSorting
    ]
  });
};
var ActiveFilterDisplay_default = ActiveFilterDisplay;

// src/components/ActiveFilters/ActiveFilters.tsx
var import_react29 = require("@chakra-ui/react");
var import_js3 = require("@mdi/js");
var import_react30 = __toESM(require("@mdi/react"));
var import_isEmpty5 = __toESM(require("lodash/isEmpty"));
var import_isNil5 = __toESM(require("lodash/isNil"));
var import_react_i18next5 = require("react-i18next");
var import_react_error_boundary = require("react-error-boundary");

// src/components/ActiveFilters/ActiveFilter/ActiveFilter.tsx
var import_react27 = require("@chakra-ui/react");
var import_date_fns4 = require("date-fns");
var import_isNil4 = __toESM(require("lodash/isNil"));
var import_react28 = __toESM(require("react"));
var import_react_i18next4 = require("react-i18next");

// src/hooks/useListColumnsOrdering.ts
var import_react15 = require("react");
var useListColumnsOrdering = ({ columnOrder }) => {
  const [columnOrdering, setColumnOrdering] = (0, import_react15.useState)(columnOrder);
  (0, import_react15.useEffect)(() => {
    setColumnOrdering(columnOrder);
  }, [columnOrder]);
  return { columnOrdering, setColumnOrdering };
};
var useListColumnsOrdering_default = useListColumnsOrdering;

// src/hooks/useListColumnsVisibility.ts
var import_react16 = require("react");
var useListColumnsVisibility = ({
  allColumns,
  visibleColumns
}) => {
  const [checkedColumns, setCheckedColumns] = (0, import_react16.useState)(
    visibleColumns.map((col) => col.id)
  );
  (0, import_react16.useEffect)(() => {
    setCheckedColumns(visibleColumns.map((col) => col.id));
  }, [visibleColumns]);
  const handleCheckColumn = (columnId) => {
    setCheckedColumns(
      (oldColumns) => oldColumns.includes(columnId) ? oldColumns.filter((column) => column !== columnId) : [...oldColumns, columnId]
    );
  };
  const handleCheckAllColumns = () => {
    const allIds = allColumns.map((col) => col.id);
    if (checkedColumns.length < allIds.length) {
      setCheckedColumns(allColumns.map((col) => col.id));
    } else {
      setCheckedColumns([]);
    }
  };
  return {
    checkedColumns,
    handleCheckColumn,
    handleCheckAllColumns
  };
};
var useListColumnsVisibility_default = useListColumnsVisibility;

// src/hooks/useListFiltersVisibility.ts
var import_react17 = require("react");
var import_difference = __toESM(require("lodash/difference"));
var useListFiltersVisibility = ({
  allFilters,
  hiddenFilters
}) => {
  const [checkedFilters, setCheckedFilters] = (0, import_react17.useState)(
    (0, import_difference.default)(
      allFilters.map((col) => col.id),
      hiddenFilters
    )
  );
  const handleCheckFilter = (columnId) => {
    setCheckedFilters(
      (oldColumns) => oldColumns.includes(columnId) ? oldColumns.filter((column) => column !== columnId) : [...oldColumns, columnId]
    );
  };
  const handleCheckAllFilters = () => {
    const allIds = allFilters.map((col) => col.id);
    if (checkedFilters.length < allIds.length) {
      setCheckedFilters(allFilters.map((col) => col.id));
    } else {
      setCheckedFilters([]);
    }
  };
  (0, import_react17.useEffect)(() => {
    setCheckedFilters(
      (0, import_difference.default)(
        allFilters.map((col) => col.id),
        hiddenFilters
      )
    );
  }, [allFilters]);
  return {
    checkedFilters,
    handleCheckFilter,
    handleCheckAllFilters
  };
};
var useListFiltersVisibility_default = useListFiltersVisibility;

// src/hooks/useListFilters.ts
var import_immer = __toESM(require("immer"));
var import_isEmpty3 = __toESM(require("lodash/isEmpty"));
var import_react19 = require("react");

// src/context/AuthContext.tsx
var import_react18 = __toESM(require("react"));
var import_react_query2 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var UserTypes = /* @__PURE__ */ ((UserTypes2) => {
  UserTypes2[UserTypes2["accountUser"] = 1] = "accountUser";
  UserTypes2[UserTypes2["userUser"] = 2] = "userUser";
  UserTypes2[UserTypes2["guest"] = 3] = "guest";
  UserTypes2[UserTypes2["ghost"] = 4] = "ghost";
  return UserTypes2;
})(UserTypes || {});
var AuthContext = import_react18.default.createContext(null);
AuthContext.displayName = "AuthContext";
var AuthContextProvider = ({ value, me, children }) => {
  var _a2, _b, _c, _d;
  const { data, isLoading, isError } = (0, import_react_query2.useQuery)(
    ["auth"],
    async () => {
      const response = await api_default.getMe();
      if (response.status === 401) {
        throw new Error("Unauthorized");
      }
      return response;
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      initialData: me,
      enabled: !me && !value
    }
  );
  const auth = data;
  if (process.env.NODE_ENV === "development") {
    printDebug(auth);
  }
  const checkIsUserUser = me ? ((_a2 = me == null ? void 0 : me.user) == null ? void 0 : _a2.type) === 2 /* userUser */ : ((_b = auth == null ? void 0 : auth.user) == null ? void 0 : _b.type) === 2 /* userUser */;
  const contextValue = isError ? {
    isUserUser: false,
    user: void 0
  } : me ? {
    isUserUser: checkIsUserUser,
    user: { ...me == null ? void 0 : me.user, profile: (_c = me == null ? void 0 : me.profile) == null ? void 0 : _c.id }
  } : {
    isUserUser: checkIsUserUser,
    user: { ...auth == null ? void 0 : auth.user, profile: (_d = auth == null ? void 0 : auth.profile) == null ? void 0 : _d.id }
  };
  if (isLoading) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuthContext.Provider, {
    value: value || contextValue,
    children
  });
};
var printDebug = (auth) => {
  if (!auth) {
    return;
  }
  const user = auth == null ? void 0 : auth.user;
  if (user) {
    console.log(
      `[Auth Context] Jeste\u015B zalogowany jako ${user.username} (${UserTypes[user.type]})`
    );
  } else {
    console.log("[Auth Context] Jeste\u015B niezalogowany");
  }
};

// src/hooks/useListFilters.ts
var initialState = {};
function reducer(state, action) {
  var _a2, _b;
  switch (action.type) {
    case "ADD_FILTER":
      if (typeof action.payload.value !== "boolean" && (action.payload.value === null || (0, import_isEmpty3.default)(action.payload.value)) || ((_a2 = action.payload.value) == null ? void 0 : _a2.notZero) === false) {
        const newFilters = { ...state };
        delete newFilters[action.payload.name];
        return newFilters;
      }
      return {
        ...state,
        [action.payload.name]: {
          value: action.payload.value,
          type: action.payload.type,
          module: ((_b = action.payload) == null ? void 0 : _b.relatedModule) ?? null,
          additionalData: action.payload.additionalData
        }
      };
    case "REMOVE_FILTER": {
      const newFilters = { ...state };
      delete newFilters[action.payload];
      return newFilters;
    }
    case "REMOVE_FILTER_VALUE": {
      return (0, import_immer.default)(state, (draft) => {
        const currentFilter = draft[action.payload.filterName];
        if (["from", "to", "notZero"].includes(action.payload.value)) {
          delete currentFilter.value[action.payload.value];
        } else {
          currentFilter.value = currentFilter.value.filter(
            (opt) => opt !== action.payload.value
          );
        }
        if ((0, import_isEmpty3.default)(currentFilter.value)) {
          delete draft[action.payload.filterName];
        }
      });
    }
    case "SET_FILTERS": {
      return action.payload;
    }
    case "RESET_FILTERS":
      return {};
    default:
      return state;
  }
}
var parseFiltersForApi = (filters, isUserUser) => {
  if ((0, import_isEmpty3.default)(filters)) {
    return {};
  }
  let preparedFilters = {};
  let standardFilters = {};
  let extraFilters = {};
  Object.keys(filters).forEach((f) => {
    var _a2, _b;
    if ((_b = (_a2 = filters[f]) == null ? void 0 : _a2.additionalData) == null ? void 0 : _b.isExtra) {
      extraFilters = { ...extraFilters, [f]: filters[f] };
    } else {
      standardFilters = { ...standardFilters, [f]: filters[f] };
    }
  });
  Object.keys(extraFilters).forEach((filterKey) => {
    var _a2, _b, _c;
    const currentExtraFilter = extraFilters[filterKey];
    if (currentExtraFilter.type === "float" && currentExtraFilter.additionalData.filterField === "prices") {
      const priceMin = currentExtraFilter.value.from;
      const priceMax = currentExtraFilter.value.to;
      const additionalData = currentExtraFilter.additionalData;
      if (priceMin && priceMin > -1) {
        let priceLowFilter = "";
        if (typeof additionalData.filterParam === "object") {
          priceLowFilter = getPriceFilterForUserUserLevel({
            isUserUser: additionalData.filterParam.isUserUser,
            filterType: "gte",
            priceType: filterKey === "price_netto" ? "netto" : "brutto"
          });
        } else if (typeof additionalData.filterParam === "function") {
          priceLowFilter = additionalData.filterParam({
            isUserUser: isUserUser ?? false,
            filterType: "gte"
          });
        } else {
          priceLowFilter = additionalData.filterParam;
        }
        preparedFilters[priceLowFilter] = priceMin;
      }
      if (priceMax && priceMax > -1) {
        let priceHighFilter = "";
        if (typeof additionalData.filterParam === "object") {
          priceHighFilter = getPriceFilterForUserUserLevel({
            isUserUser: additionalData.filterParam.isUserUser,
            filterType: "lte",
            priceType: filterKey === "price_netto" ? "netto" : "brutto"
          });
        } else if (typeof additionalData.filterParam === "function") {
          priceHighFilter = additionalData.filterParam({
            isUserUser: isUserUser ?? false,
            filterType: "lte"
          });
        } else {
          priceHighFilter = additionalData.filterParam;
        }
        preparedFilters[priceHighFilter] = priceMax;
      }
    }
    if (currentExtraFilter.type === "float" && currentExtraFilter.additionalData.filterField === "availabilities") {
      if ((_a2 = currentExtraFilter.value) == null ? void 0 : _a2.from) {
        preparedFilters[`${currentExtraFilter.additionalData.filterParam}[gte]`] = Number(currentExtraFilter.value.from);
      }
      if ((_b = currentExtraFilter.value) == null ? void 0 : _b.to) {
        preparedFilters[`${currentExtraFilter.additionalData.filterParam}[lte]`] = Number(currentExtraFilter.value.to);
      }
      if ((_c = currentExtraFilter.value) == null ? void 0 : _c.notZero) {
        preparedFilters[`${currentExtraFilter.additionalData.filterParam}[gt]`] = 0;
      }
    }
    if (currentExtraFilter.type === "text" && typeof currentExtraFilter.additionalData.filterParam === "string") {
      preparedFilters[currentExtraFilter.additionalData.filterParam] = currentExtraFilter.value;
    }
    if (currentExtraFilter.type === "custom" && typeof currentExtraFilter.additionalData.filterParam === "string") {
      preparedFilters[currentExtraFilter.additionalData.filterParam] = currentExtraFilter.value.join(",");
    }
    if (currentExtraFilter.type === "custom" && typeof currentExtraFilter.additionalData.getFilter === "function") {
      const filters2 = currentExtraFilter.additionalData.getFilter(currentExtraFilter);
      preparedFilters = { ...preparedFilters, ...filters2 };
    }
  });
  Object.keys(standardFilters).forEach((filterKey) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h;
    const current = standardFilters[filterKey];
    if (current.module === "attributes") {
      switch (current.type) {
        case "text":
        case "email":
        case "phone":
          preparedFilters[`filter[attributes][${filterKey}][hasText]`] = current.value;
          break;
        case "bool":
          preparedFilters[`filter[attributes][${filterKey}][eq]`] = current.value;
          break;
        case "numeric":
          if ((_a2 = current.value) == null ? void 0 : _a2.from) {
            preparedFilters[`filter[attributes][${filterKey}][gte]`] = Number(
              current.value.from
            );
          }
          if ((_b = current.value) == null ? void 0 : _b.to) {
            preparedFilters[`filter[attributes][${filterKey}][lte]`] = Number(
              current.value.to
            );
          }
          break;
        case "list":
        case "listMulti":
        case "tags":
        case "company":
          preparedFilters[`filter[attributes][${filterKey}][in]`] = String(
            current.value
          );
          break;
        case "date":
        case "datetime":
          if ((_c = current.value) == null ? void 0 : _c.from) {
            preparedFilters[`filter[attributes][${filterKey}][gte]`] = formatDateForApi(current.value.from);
          }
          if ((_d = current.value) == null ? void 0 : _d.to) {
            preparedFilters[`filter[attributes][${filterKey}][lte]`] = formatDateForApi(current.value.to);
          }
          break;
        default:
          console.warn(`Unsupported attribute of type ${current.type}`);
          break;
      }
      return;
    }
    if (current.type === "integer" || current.type === "bigint" || current.type === "decimal" || current.type === "float") {
      if ((_e = current.value) == null ? void 0 : _e.from) {
        preparedFilters[`filter[${filterKey}][gte]`] = Number(
          current.value.from
        );
      }
      if ((_f = current.value) == null ? void 0 : _f.to) {
        preparedFilters[`filter[${filterKey}][lte]`] = Number(current.value.to);
      }
      return;
    }
    if (current.type === "boolean") {
      preparedFilters[`filter[${filterKey}][eq]`] = current.value;
      return;
    }
    if (current.type === "datetime" || current.type === "date" || current.type === "datetimetz") {
      if ((_g = current.value) == null ? void 0 : _g.from) {
        preparedFilters[`filter[${filterKey}][gte]`] = formatDateForApi(
          current.value.from
        );
      }
      if ((_h = current.value) == null ? void 0 : _h.to) {
        preparedFilters[`filter[${filterKey}][lte]`] = formatDateForApi(
          current.value.to
        );
      }
      return;
    }
    if (current.type === "relation") {
      if (["products", "servicedProducts"].includes(filterKey)) {
        preparedFilters[`filter[relations][${filterKey}.id][in]`] = String(
          current.value
        );
        return;
      }
      if (filterKey === "creatorUser") {
        preparedFilters[`filterOr[${filterKey}.id][in]`] = String(
          current.value
        );
        return;
      }
      if (filterKey === "creatorAccountUser") {
        preparedFilters[`filterOr[${filterKey}.id][in]`] = String(
          current.value
        );
        return;
      }
      if (filterKey === "creator") {
        if (current.module === "userUser") {
          preparedFilters[`filter[creatorUser.id][in]`] = String(current.value);
        } else if (current.module === "accountUser") {
          preparedFilters[`filter[creatorAccountUser.id][in]`] = String(
            current.value
          );
        }
        return;
      }
      preparedFilters[`filter[${filterKey}.id][in]`] = String(current.value);
      return;
    }
    if (filterKey === "elastic") {
      preparedFilters["filter[_q][hasText]"] = filters["elastic"].value;
      return;
    }
    if ([
      "documentStatusByAu",
      "documentStatus",
      "creationType",
      "defaultPriceType",
      "currencyCode",
      "connectedEmailStatus"
    ].includes(filterKey)) {
      preparedFilters[`filter[${filterKey}][in]`] = String(
        filters[filterKey].value
      );
      return;
    }
    if (filterKey === "positions") {
      preparedFilters[`filter[${filterKey}.productName][ilike]`] = String(
        current.value
      );
      return;
    }
    preparedFilters[`filter[${filterKey}][hasText]`] = String(
      standardFilters[filterKey].value
    );
  });
  return preparedFilters;
};
var useListFilters = ({
  initialFilters = {}
} = {}) => {
  const auth = (0, import_react19.useContext)(AuthContext);
  const [filters, dispatch] = (0, import_react19.useReducer)(reducer, {
    ...initialState,
    ...initialFilters
  });
  const addFilter = (name, value, type, relatedModule, additionalData) => {
    dispatch({
      type: "ADD_FILTER",
      payload: {
        name,
        value,
        type,
        relatedModule,
        additionalData
      }
    });
  };
  const removeFilter = (name, val) => {
    if (val !== 0 && !val) {
      dispatch({
        type: "REMOVE_FILTER",
        payload: name
      });
    } else {
      dispatch({
        type: "REMOVE_FILTER_VALUE",
        payload: {
          filterName: name,
          value: val
        }
      });
    }
  };
  const resetFilters = () => {
    dispatch({ type: "RESET_FILTERS" });
  };
  const setFilters = (newFilters) => {
    dispatch({
      type: "SET_FILTERS",
      payload: newFilters
    });
  };
  const getFilterParams = () => {
    return parseFiltersForApi(filters, auth.isUserUser);
  };
  return {
    filters,
    getFilterParams,
    addFilter,
    setFilters,
    removeFilter,
    resetFilters
  };
};

// src/hooks/useListPagination.ts
var import_react20 = require("@xstate/react");

// src/stateMachines/paginationMachine.ts
var import_xstate = require("xstate");
var import_actions = require("xstate/lib/actions");
var paginationMachine = (0, import_xstate.createMachine)(
  {
    id: "pagination",
    initial: "awaitingTotalPages",
    context: {
      currentPage: 1
    },
    on: {
      UPDATE_TOTAL_PAGES: {
        cond: "newTotalPagesIsValidValue",
        actions: (0, import_actions.choose)([
          {
            cond: "currentPageIsAboveNewTotalPages",
            actions: ["assignTotalPagesToContext", "goToFirstPage"]
          },
          {
            actions: ["assignTotalPagesToContext"]
          }
        ]),
        target: "idle"
      }
    },
    states: {
      awaitingTotalPages: {},
      idle: {
        on: {
          NEXT_PAGE: {
            cond: "canGoToNextPage",
            actions: "goToNextPage"
          },
          PREV_PAGE: {
            cond: "canGoToPrevPage",
            actions: "goToPrevPage"
          },
          GO_TO_TARGET_PAGE: {
            actions: "goToTargetPage",
            cond: "targetPageIsWithinBounds"
          }
        }
      }
    }
  },
  {
    guards: {
      newTotalPagesIsValidValue: (context, event) => {
        if (event.type !== "UPDATE_TOTAL_PAGES")
          return false;
        return event.totalPages > 0;
      },
      currentPageIsAboveNewTotalPages: (context, event) => {
        if (event.type !== "UPDATE_TOTAL_PAGES")
          return false;
        return context.currentPage > event.totalPages;
      },
      canGoToNextPage: (context) => {
        return context.currentPage < context.totalPages;
      },
      canGoToPrevPage: (context) => {
        return context.currentPage > 1;
      },
      targetPageIsWithinBounds: (context, event) => {
        if (event.type !== "GO_TO_TARGET_PAGE")
          return false;
        return event.targetPage >= 1 && event.targetPage <= context.totalPages;
      }
    },
    actions: {
      goToFirstPage: (0, import_xstate.assign)({
        currentPage: 1
      }),
      goToPrevPage: (0, import_xstate.assign)({
        currentPage: (context) => context.currentPage - 1
      }),
      goToNextPage: (0, import_xstate.assign)({
        currentPage: (context) => context.currentPage + 1
      }),
      goToTargetPage: (0, import_xstate.assign)((context, event) => {
        if (event.type !== "GO_TO_TARGET_PAGE")
          return {};
        return {
          currentPage: event.targetPage
        };
      }),
      assignTotalPagesToContext: (0, import_xstate.assign)((context, event) => {
        if (event.type !== "UPDATE_TOTAL_PAGES")
          return {};
        return {
          totalPages: event.totalPages
        };
      })
    }
  }
);
var paginationMachine_default = paginationMachine;

// src/hooks/useListPagination.ts
var useListPagination = () => {
  const [current, send] = (0, import_react20.useMachine)(paginationMachine_default);
  const handleGoToNextPage = () => {
    send({ type: "NEXT_PAGE" });
  };
  const handleGoToPrevPage = () => {
    send({ type: "PREV_PAGE" });
  };
  const handleSetPage = (page) => {
    send({ type: "GO_TO_TARGET_PAGE", targetPage: page });
  };
  const setTotalPages = (totalPages) => {
    send({
      type: "UPDATE_TOTAL_PAGES",
      totalPages
    });
  };
  return {
    currentPage: current.context.currentPage,
    totalPages: current.context.totalPages,
    handleGoToNextPage,
    handleGoToPrevPage,
    handleSetPage,
    setTotalPages
  };
};
var useListPagination_default = useListPagination;

// src/hooks/useListSorting.ts
var import_react21 = require("react");
var sortingFieldMap = {
  campaign: "name",
  campaignPhase: "name",
  accountUser: "firstName",
  userUser: "firstName",
  accountCompany: "name",
  product: "name",
  products: "fullName",
  servicedProducts: "fullName"
};
var getFilterFieldForRelation = (fieldId, fieldModule) => {
  return `[${fieldId}.${(sortingFieldMap == null ? void 0 : sortingFieldMap[fieldModule]) ?? "id"}]`;
};
var getSortingField = (sortEntry, metaData) => {
  var _a2, _b;
  const field = metaData.fields[sortEntry.id];
  const extraField = metaData.extra_fields[sortEntry.id];
  if (field) {
    return field.type === "relation" ? getFilterFieldForRelation(sortEntry.id, field.relatedModule) : `[${sortEntry.id}]`;
  }
  if (extraField) {
    return `[${sortEntry.id}]`;
  }
  const [, attributeId] = sortEntry.id.split(".");
  const attribute = !Array.isArray(metaData.extra_fields) && metaData.extra_fields.attributes.items.find(
    (attr) => attr.id === Number(attributeId)
  );
  if (attribute) {
    return `[attributes][${attributeId}]`;
  }
  const relation = (_b = (_a2 = metaData.extra_fields) == null ? void 0 : _a2.relations) == null ? void 0 : _b.properties[sortEntry.id];
  if ((relation == null ? void 0 : relation.credential) > 0) {
    return "[relations]" + getFilterFieldForRelation(sortEntry.id, sortEntry.id);
  }
  return "UNKNOWN";
};
var useListSorting = (metaData) => {
  const [sorting, setSorting] = (0, import_react21.useState)([]);
  const getSortingParams = () => {
    const sortingParams = {};
    sorting.forEach(
      (sortEntry) => sortingParams[`order${getSortingField(sortEntry, metaData)}`] = sortEntry.desc ? "DESC" : "ASC"
    );
    return sortingParams;
  };
  return { sorting, setSorting, getSortingParams };
};
var useListSorting_default = useListSorting;

// src/hooks/useSetting.ts
var import_react_query3 = require("react-query");
var useSetting = (settingKey) => {
  const queryKey = ["setting", settingKey];
  const { data, isLoading } = (0, import_react_query3.useQuery)(
    queryKey,
    () => api_default.getSetting(settingKey),
    {
      staleTime: Infinity,
      enabled: Boolean(settingKey),
      refetchOnWindowFocus: false
    }
  );
  const setting = data == null ? void 0 : data.data;
  if ((setting == null ? void 0 : setting.type) === "bol" || (setting == null ? void 0 : setting.type) === "bln") {
    setting.value = (setting == null ? void 0 : setting.value) === true || (setting == null ? void 0 : setting.value) === 1 || (setting == null ? void 0 : setting.value) === "true" ? true : false;
  }
  if ((setting == null ? void 0 : setting.type) === "int") {
    setting.value = isNaN(parseInt(setting == null ? void 0 : setting.value)) ? 0 : parseInt(setting == null ? void 0 : setting.value);
  }
  return { setting, isLoading };
};
var useSetting_default = useSetting;

// src/context/SettingsContext.tsx
var import_react22 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var SettingsContext = import_react22.default.createContext({});
SettingsContext.displayName = "SettingsContext";
var SettingsProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SettingsContext.Provider, {
    value,
    children
  });
};

// src/hooks/useSettings.ts
var import_react23 = require("react");
var useSettings = () => {
  const loadedSettings = (0, import_react23.useContext)(SettingsContext);
  return loadedSettings;
};
var useSettings_default = useSettings;

// src/hooks/useUserProfiles.ts
var import_react_query4 = require("react-query");
var useUserProfiles = (enabled = true) => {
  return (0, import_react_query4.useQuery)(
    ["userProfiles"],
    () => api_default.getAutoselect("user_profiles", {
      params: {
        fields: "profileName",
        "page[limit]": -1
      }
    }),
    {
      enabled,
      refetchOnWindowFocus: false
    }
  );
};
var useUserProfiles_default = useUserProfiles;

// src/hooks/useUserSettingsWithFallback.tsx
var import_isEmpty4 = __toESM(require("lodash/isEmpty"));
var import_merge2 = __toESM(require("lodash/merge"));
var import_react24 = __toESM(require("react"));
var import_react_query5 = require("react-query");
var hasNoSettings = (settingValue) => {
  return Array.isArray(settingValue) && (0, import_isEmpty4.default)(settingValue);
};
var useUserSettingsWithFallback = (settingKeys, initialData, selectedProfileId) => {
  var _a2, _b, _c, _d;
  const [profileFallback, setProfileFallback] = (0, import_react24.useState)(
    !!selectedProfileId ? true : false
  );
  const additionalProfileParams = {
    "filter[userProfile][eq]": selectedProfileId,
    "setting[limit_to_my_settings]": false,
    "filter[name][eq]": settingKeys.join("_")
  };
  const userSettingsQueryKey = ["userSettings", ...settingKeys];
  const {
    data: userSetting,
    isLoading: isLoadingUserSetting,
    refetch: refetchUserSetting
  } = (0, import_react_query5.useQuery)(
    userSettingsQueryKey,
    () => api_default.getUserSetting(settingKeys.join("_")),
    {
      enabled: settingKeys.length > 0 && !selectedProfileId,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        if (hasNoSettings(response.data.value)) {
          setProfileFallback(true);
        }
      },
      ...initialData ? { initialData } : {}
    }
  );
  const profileSettingsQueryKey = [
    "profileSettings",
    ...settingKeys,
    selectedProfileId
  ];
  const {
    data: profileSetting,
    isLoading: isLoadingProfileSetting,
    refetch: refetchProfileSetting
  } = (0, import_react_query5.useQuery)(
    profileSettingsQueryKey,
    () => !!selectedProfileId ? api_default.getSelectedProfileSetting({
      params: additionalProfileParams
    }) : api_default.getProfileSetting(settingKeys.join("_")),
    { enabled: profileFallback }
  );
  const { mutate: updateUserSetting } = (0, import_react_query5.useMutation)(
    async (vars) => {
      const newConfig = Array.isArray(vars) ? {} : vars;
      await api_default.updateUserSetting(settingKeys.join("_"), {
        value: newConfig
      });
    },
    {
      onSuccess: () => {
        if (!selectedProfileId) {
          refetchUserSetting();
          setProfileFallback(false);
        }
      }
    }
  );
  const { mutateAsync: updateProfileSetting } = (0, import_react_query5.useMutation)(
    async ({ setting, profileId }) => {
      const newConfig = (0, import_merge2.default)(
        Array.isArray((profileSetting == null ? void 0 : profileSetting.value) ?? []) ? {} : profileSetting.value,
        setting
      );
      await api_default.updateProfileSetting(settingKeys.join("_"), profileId, {
        data: {
          value: newConfig
        },
        setting: {
          limit_to_my_settings: false
        }
      });
    },
    {
      onSuccess: () => {
        refetchProfileSetting();
      }
    }
  );
  const setUserSetting = (0, import_react24.useCallback)(
    (setting) => {
      updateUserSetting(setting);
    },
    [updateUserSetting]
  );
  const setProfileSetting = (0, import_react24.useCallback)(
    (setting, profileId) => {
      return updateProfileSetting({ setting, profileId });
    },
    [updateProfileSetting]
  );
  return import_react24.default.useMemo(
    () => {
      var _a3, _b2, _c2, _d2;
      return {
        settings: profileFallback ? ((_a3 = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _a3.value) ?? ((_c2 = (_b2 = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.value) ?? [] : ((_d2 = userSetting == null ? void 0 : userSetting.data) == null ? void 0 : _d2.value) ?? [],
        isLoading: isLoadingUserSetting || isLoadingProfileSetting,
        setUserSetting,
        setProfileSetting
      };
    },
    [
      isLoadingProfileSetting,
      isLoadingUserSetting,
      profileFallback,
      (_a2 = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _a2.value,
      (_c = (_b = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _b[0]) == null ? void 0 : _c.value,
      profileSetting,
      setUserSetting,
      (_d = userSetting == null ? void 0 : userSetting.data) == null ? void 0 : _d.value
    ]
  );
};
var useUserSettingsWithFallback_default = useUserSettingsWithFallback;

// src/hooks/useResponsive.ts
var import_react25 = require("@chakra-ui/react");
var useResponsive = () => {
  const theme = (0, import_react25.useTheme)();
  const [isSm, isMd, isLg, isXl] = (0, import_react25.useMediaQuery)([
    `(min-width: 0px)`,
    `(min-width: ${theme.breakpoints.md})`,
    `(min-width: ${theme.breakpoints.lg})`,
    `(min-width: ${theme.breakpoints.xl})`
  ]);
  return [isSm, isMd, isLg, isXl];
};
var useResponsive_default = useResponsive;

// src/hooks/useTemplates.tsx
var import_react26 = require("react");
var import_react_query6 = require("react-query");
var import_orderBy = __toESM(require("lodash/orderBy"));
var useTemplates = (type) => {
  const [hiddenDefaultTabs, setHiddenDefaultTabs] = (0, import_react26.useState)([]);
  const { data, isLoading } = (0, import_react_query6.useQuery)(
    ["product_templates", type],
    () => api_default.getEndpoint(`product_templates`, {
      params: { "filter[type][eq]": type }
    }),
    {
      select: (data2) => (data2 == null ? void 0 : data2.data) && (0, import_orderBy.default)(data2 == null ? void 0 : data2.data, ["priority"]),
      onSuccess: (data2) => {
        let hiddenIds = [];
        data2 == null ? void 0 : data2.forEach(
          (template) => {
            var _a2, _b;
            return (_b = (_a2 = template == null ? void 0 : template.options) == null ? void 0 : _a2.split(",")) == null ? void 0 : _b.forEach((id) => hiddenIds.push(Number(id)));
          }
        );
        (hiddenIds == null ? void 0 : hiddenIds.length) && setHiddenDefaultTabs(hiddenIds);
      }
    }
  );
  return { data, isLoading, hiddenDefaultTabs };
};
var useTemplates_default = useTemplates;

// src/hooks/usePersistedState.ts
var import_use_persisted_state = __toESM(require("use-persisted-state"));
var usePersistedState = (key) => {
  const useCustomPersistedState = (0, import_use_persisted_state.default)(key);
  const [persistedState, setPersistedState] = useCustomPersistedState();
  return {
    persistedState,
    setPersistedState
  };
};
var usePersistedState_default = usePersistedState;

// src/components/ActiveFilters/ActiveFilter/ActiveFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TextFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
          children: filter == null ? void 0 : filter.value
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
          ml: 1,
          onClick: () => onRemoveFilter(filterName)
        })
      ]
    })
  });
};
var DateFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  const { t } = (0, import_react_i18next4.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
              children: `${t("VALUE_FROM")}: ${(0, import_date_fns4.format)(
                filter == null ? void 0 : filter.value.from,
                DATE_FORMAT_DOTS
              )}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "from")
            })
          ]
        })
      }) : null,
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
              children: `${t("VALUE_TO")}: ${(0, import_date_fns4.format)(
                filter == null ? void 0 : filter.value.to,
                DATE_FORMAT_DOTS
              )}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "to")
            })
          ]
        })
      }) : null
    ]
  });
};
var NumericFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  const { t } = (0, import_react_i18next4.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
              children: `${t("VALUE_FROM")}: ${filter == null ? void 0 : filter.value.from}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "from")
            })
          ]
        })
      }) : null,
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
              children: `${t("VALUE_TO")}: ${filter == null ? void 0 : filter.value.to}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "to")
            })
          ]
        })
      }) : null
    ]
  });
};
var BooleanFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  const { t } = (0, import_react_i18next4.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
          children: (filter == null ? void 0 : filter.value) ? t("Yes") : t("No")
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
          ml: 1,
          onClick: () => onRemoveFilter(filterName)
        })
      ]
    })
  });
};
var getFiltersForEndpoint = (endpoint, filter) => {
  var _a2, _b;
  switch (endpoint) {
    case "markers":
      return {
        "filter[value][in]": filter.value,
        ...(_b = (_a2 = filter.additionalData) == null ? void 0 : _a2.additionalProps) == null ? void 0 : _b.filters
      };
    case "price_types":
      return {
        "filter[indexUpper][in]": filter.value
      };
    default:
      return { "filter[id][in]": filter.value };
  }
};
var ListFilterActive = ({
  filter,
  filterName,
  endpoint,
  labelField,
  valueField = "id",
  extraFields,
  onRemoveFilter
}) => {
  var _a2, _b, _c;
  const positions = (_a2 = filter.additionalData) == null ? void 0 : _a2.positions;
  const { data, isLoading, isFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    extraFields,
    enabled: !positions,
    filters: getFiltersForEndpoint(endpoint, filter)
  });
  const { t } = (0, import_react_i18next4.useTranslation)();
  const newPositions = data ?? positions;
  const handleGoToFilter = () => {
    const element = document.querySelector(`.filter-${filterName}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  if (isLoading || isFetching || !newPositions) {
    return null;
  }
  const shouldTranslateValue = ["currencyCode"].includes(filterName) ? false : true;
  if ((((_b = filter.value) == null ? void 0 : _b.length) ?? 0) > 3) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
        cursor: "pointer",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
            onClick: handleGoToFilter,
            children: `${t("SELECTED")}: ${((_c = filter.value) == null ? void 0 : _c.length) ?? 0}`
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
            ml: 1,
            onClick: () => onRemoveFilter(filterName)
          })
        ]
      })
    }, filterName);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: filter.value.map((val) => {
      const option = newPositions.find(
        (pos) => pos.value === val || pos.id === val || pos.id === Number(val)
      );
      if (!option) {
        logger_default.error(
          `Could not get value for MultiFilterDisplay ${filterName}: ${JSON.stringify(
            val
          )}`
        );
      }
      const optionValue = shouldTranslateValue ? t(`${option == null ? void 0 : option.value}`) : `${option == null ? void 0 : option.value}`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
              children: optionValue
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(
                filterName,
                endpoint === "markers" ? option.value : option.id
              )
            })
          ]
        })
      }, val);
    })
  });
};
var RelationFilterActive = ({ filterName, filter, ...props }) => {
  const baseProps = {
    filter,
    filterName,
    labelField: "name",
    ...props
  };
  if (filter.module === "accountCompany") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "account_companies",
      extraFields: ["displayName"],
      ...baseProps,
      labelField: "displayName"
    });
  }
  if (filter.module === "accountUser") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "account_users",
      extraFields: ["fullName"],
      ...baseProps,
      labelField: "fullName"
    });
  }
  if (filter.module === "campaign") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "campaigns",
      ...baseProps
    });
  }
  if (filter.module === "commissionPhase") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "commission_phases",
      ...baseProps,
      labelField: "phaseName"
    });
  }
  if (filter.module === "campaignPhase") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "campaign_phases",
      ...baseProps
    });
  }
  if (filter.module === "deliveryType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "delivery_types",
      ...baseProps
    });
  }
  if (filter.module === "documentSeriesDefinition") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "document_series_definitions",
      ...baseProps
    });
  }
  if (filter.module === "paymentType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "payment_types",
      ...baseProps
    });
  }
  if (filter.module === "priceProductGroup") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "price_product_groups",
      ...baseProps
    });
  }
  if (filter.module === "taskType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "task_types",
      ...baseProps,
      labelField: "typeName"
    });
  }
  if (filter.module === "userUser") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "user_users",
      extraFields: ["fullName"],
      ...baseProps,
      labelField: "fullName"
    });
  }
  if (filter.module === "product" || filter.module === "products") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "products",
      ...baseProps
    });
  }
  if (filter.module === "servicedProducts") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "serviced_products",
      extraFields: ["fullName"],
      ...baseProps,
      labelField: "fullName"
    });
  }
  if (filter.module === "defaultPriceType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      ...baseProps,
      endpoint: "price_types",
      labelField: "fullName",
      valueField: "indexUpper"
    });
  }
};
var CustomFilterActive = ({
  filterName,
  filter,
  onRemoveFilter,
  ...props
}) => {
  const { t } = (0, import_react_i18next4.useTranslation)();
  if (filterName === "status" && filter.additionalData) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: filter.value.map((val) => {
        const filterValue = filter.additionalData.positions.find(
          (position) => val === position.id
        ).value;
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagLabel, {
                children: t(filterValue)
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.TagCloseButton, {
                ml: 1,
                onClick: () => onRemoveFilter(filterName, val)
              })
            ]
          })
        });
      })
    });
  }
};
var filterTypeMap = {
  string: {
    component: TextFilterActive
  },
  text: {
    component: TextFilterActive
  },
  phone: {
    component: TextFilterActive
  },
  email: {
    component: TextFilterActive
  },
  date: {
    component: DateFilterActive
  },
  datetime: {
    component: DateFilterActive
  },
  datetimetz: {
    component: DateFilterActive
  },
  numeric: {
    component: NumericFilterActive
  },
  integer: {
    component: NumericFilterActive
  },
  float: {
    component: NumericFilterActive
  },
  bigint: {
    component: NumericFilterActive
  },
  decimal: {
    component: NumericFilterActive
  },
  bool: {
    component: BooleanFilterActive
  },
  boolean: {
    component: BooleanFilterActive
  },
  list: {
    component: ListFilterActive
  },
  listMulti: {
    component: ListFilterActive
  },
  company: {
    component: ListFilterActive,
    params: {
      endpoint: "account_companies",
      extraFields: ["displayName"],
      labelField: "displayName"
    }
  },
  defaultPriceType: {
    component: ListFilterActive,
    params: {
      endpoint: "price_types",
      labelField: "fullName",
      valueField: "indexUpper",
      filters: { "filter[active]": true }
    }
  },
  tags: {
    component: ListFilterActive,
    params: {
      endpoint: "markers",
      labelField: "value"
    }
  },
  relation: {
    component: RelationFilterActive
  },
  custom: {
    component: CustomFilterActive
  }
};
var ActiveFilterTag = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.Tag, {
    fontWeight: 400,
    color: "blue.900",
    bg: "none",
    border: "1px solid",
    borderColor: "gray.200",
    borderRadius: "6px",
    fontStyle: "sm",
    px: 2,
    ...props,
    children
  });
};
var ActiveFilter = ({
  filterName,
  filter,
  filterNamePrefix = "",
  valuePrefix,
  onRemoveFilter
}) => {
  var _a2, _b;
  const { t } = (0, import_react_i18next4.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react27.Text, {
          as: "span",
          fontSize: "md",
          fontWeight: 500,
          lineHeight: "24px",
          letterSpacing: "0.15px",
          children: `${((_a2 = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _a2.displayName) ? t(filter.additionalData.displayName) : t(filterNamePrefix + filterName)}:`
        })
      }),
      import_react28.default.createElement(filterTypeMap[filter.type].component, {
        filterName,
        filter,
        valuePrefix,
        onRemoveFilter,
        ...(_b = filterTypeMap[filter.type]) == null ? void 0 : _b.params
      })
    ]
  });
};
var ActiveFilter_default = ActiveFilter;

// src/components/ActiveFilters/ActiveFilters.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ActiveFilters = ({
  filters = {},
  filterNamePrefix,
  onRemoveFilter,
  onClearAllFilters,
  children,
  ...props
}) => {
  var _a2;
  const { t } = (0, import_react_i18next5.useTranslation)();
  if ((0, import_isNil5.default)(filters) || (0, import_isEmpty5.default)(filters)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.Wrap, {
      color: "gray.700",
      spacing: 4,
      align: "center",
      ...props,
      children: children ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.WrapItem, {
        children
      }) : null
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react29.Wrap, {
    className: "active-filters",
    color: "gray.700",
    spacing: 4,
    align: "center",
    mt: "8px",
    ...props,
    children: [
      children ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.WrapItem, {
        children
      }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonAction_default, {
          size: "sm",
          leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react30.default, {
            path: import_js3.mdiFilterOffOutline,
            size: "20px"
          }),
          onClick: onClearAllFilters,
          mr: 2,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.Text, {
              as: "span",
              fontSize: "sm",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "gray.700",
              children: t("FILTER_CLEAR_ALL")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.Text, {
              ml: 1,
              as: "span",
              fontSize: "sm",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "blackAlpha.500",
              children: `(${(_a2 = Object.keys(filters)) == null ? void 0 : _a2.length})`
            })
          ]
        })
      }),
      Object.keys(filters).map((filterKey) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_error_boundary.ErrorBoundary, {
        FallbackComponent: (error) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react29.Tag, {
            colorScheme: "red",
            children: [
              "Error - filterName: ",
              filterKey,
              ", filterType:",
              " ",
              filters[filterKey].type
            ]
          })
        }),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActiveFilter_default, {
          filterNamePrefix,
          filterName: filterKey,
          filter: filters[filterKey],
          onRemoveFilter
        })
      }, filterKey))
    ]
  });
};
var ActiveFilters_default = ActiveFilters;

// src/components/Information/Information.tsx
var import_react31 = require("@chakra-ui/react");
var import_react32 = __toESM(require("@mdi/react"));
var import_js4 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var Information = ({
  icon,
  label,
  link,
  iconSize
}) => {
  const displayIcon = icon ?? import_js4.mdiInformationOutline;
  const displayContent = link ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react31.Link, {
    href: link,
    color: "crmBlue",
    noOfLines: 1,
    className: "information__link",
    children: label
  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react31.Text, {
    className: "information__label",
    mb: "0",
    children: label
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react31.Flex, {
    alignItems: "center",
    textStyle: "bodyInput",
    className: "information__container",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react31.Box, {
        mr: "12px",
        color: "gray.500",
        className: "information__container__icon-box",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react32.default, {
          size: iconSize ?? "24px",
          path: displayIcon,
          className: "information__container__icon-box__icon"
        })
      }),
      displayContent
    ]
  });
};
var Information_default = Information;

// src/components/Address/Address.tsx
var import_react33 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AdditionalAddressData = ({ label }) => {
  const baseStyle = {
    textStyle: "bodyInput",
    color: "gray.500",
    ps: "33px"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react33.Box, {
    ...baseStyle,
    className: "address__additional-address",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react33.Text, {
      children: label
    })
  });
};
var Address = ({
  label,
  icon,
  link,
  addressCommunity,
  addressProvince
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react33.VStack, {
    alignItems: "start",
    spacing: "8px",
    className: "address",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
        icon,
        label,
        link
      }),
      addressCommunity && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdditionalAddressData, {
        label: addressCommunity
      }),
      addressProvince && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdditionalAddressData, {
        label: addressProvince
      })
    ]
  });
};
var Address_default = Address;

// src/components/AttributeBoolean/AttributeBoolean.tsx
var import_react34 = require("@chakra-ui/react");
var import_js5 = require("@mdi/js");
var import_react35 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeBoolean = ({
  value,
  onChange,
  isReadOnly = false,
  isInvalid = false
}) => {
  let iconSize = "100%";
  if (!value && !isInvalid)
    iconSize = "0";
  const icon = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react35.default, {
    size: iconSize,
    path: import_js5.mdiCheck
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react34.Box, {
    className: "attribute-boolean",
    children: isReadOnly ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react34.Checkbox, {
      size: "lg",
      icon,
      iconColor: "gray.500",
      isChecked: value,
      disabled: true,
      className: "attribute-boolean__checkbox-readonly"
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react34.Checkbox, {
      size: "lg",
      icon,
      isChecked: value,
      onChange,
      isInvalid,
      className: "attribute-boolean__checkbox-editable"
    })
  });
};
var AttributeBoolean_default = AttributeBoolean;

// src/components/AttributeChecklist/AttributeChecklist.tsx
var import_react44 = require("@chakra-ui/react");
var import_react45 = require("react");
var import_react_i18next6 = require("react-i18next");

// src/components/AttributeText/AttributeText.tsx
var import_react36 = require("@chakra-ui/react");
var import_react37 = require("react");
var import_react_textarea_autosize = __toESM(require("react-textarea-autosize"));
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeText = (0, import_react37.forwardRef)((props, ref) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react36.Textarea, {
    minH: "unset",
    overflow: "hidden",
    w: "100%",
    resize: "vertical",
    ref,
    minRows: 1,
    height: "unset",
    as: import_react_textarea_autosize.default,
    _readOnly: { backgroundColor: "gray.50" },
    _focus: {
      outline: "none",
      border: "1px solid",
      borderColor: "crmBlue"
    },
    ...props
  });
});
var AttributeText_default = AttributeText;

// src/components/SimpleTable/SimpleTable.tsx
var import_react40 = require("@chakra-ui/react");
var import_react41 = require("@emotion/react");
var import_js6 = require("@mdi/js");
var import_react42 = __toESM(require("@mdi/react"));
var import_react43 = require("react");

// src/hooks/useShadedScroll.ts
var import_react38 = require("@chakra-ui/react");
var import_react39 = __toESM(require("react"));
var BUTTON_SCROLL_FACTOR = 0.25;
var useShadedScroll = () => {
  const elementRef = import_react39.default.useRef(null);
  const dimensions = (0, import_react38.useDimensions)(elementRef, true);
  const elementWidth = (dimensions == null ? void 0 : dimensions.borderBox.width) ?? 0;
  const [startShade, setStartShade] = (0, import_react39.useState)(false);
  const [endShade, setEndShade] = (0, import_react39.useState)(false);
  const updateOnScroll = () => {
    const containerWidth = elementRef.current.clientWidth;
    const content = elementRef.current.firstChild;
    const contentWidth = content.clientWidth;
    if (containerWidth === contentWidth) {
      setStartShade(false);
      setEndShade(false);
      return;
    }
    const scrollLeft2 = Math.ceil(elementRef.current.scrollLeft ?? 0);
    if (contentWidth > containerWidth && scrollLeft2 === 0) {
      setStartShade(false);
      setEndShade(true);
    } else if (contentWidth > containerWidth && contentWidth - containerWidth !== scrollLeft2) {
      setStartShade(true);
      setEndShade(true);
    } else if (contentWidth > containerWidth && contentWidth - containerWidth === scrollLeft2) {
      setStartShade(true);
      setEndShade(false);
    } else {
      setStartShade(false);
      setEndShade(false);
    }
  };
  (0, import_react39.useEffect)(() => {
    updateOnScroll();
  }, [elementWidth]);
  const scrollLeft = () => {
    var _a2;
    const { current } = elementRef;
    const elementRefWidth = ((_a2 = elementRef == null ? void 0 : elementRef.current) == null ? void 0 : _a2.clientWidth) ?? 0;
    current.scroll({
      left: current.scrollLeft - elementRefWidth * BUTTON_SCROLL_FACTOR,
      behavior: "smooth"
    });
  };
  const scrollRight = () => {
    var _a2;
    const { current } = elementRef;
    const elementWidth2 = ((_a2 = elementRef == null ? void 0 : elementRef.current) == null ? void 0 : _a2.clientWidth) ?? 0;
    current.scroll({
      left: current.scrollLeft + elementWidth2 * BUTTON_SCROLL_FACTOR,
      behavior: "smooth"
    });
  };
  return {
    elementRef,
    startShade,
    endShade,
    onScroll: updateOnScroll,
    scrollLeft,
    scrollRight
  };
};
var useShadedScroll_default = useShadedScroll;

// src/components/SimpleTable/SimpleTable.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getOffsetTopHeight = (container) => {
  if (!container) {
    return 0;
  }
  const containerDetails = container == null ? void 0 : container.getBoundingClientRect();
  if (containerDetails.bottom < 0 || containerDetails.top > screen.height) {
    return 0;
  }
  const visibleTop = Math.max(containerDetails.top, 0);
  const visibleBottom = Math.min(containerDetails.bottom, screen.height);
  return (visibleTop + visibleBottom) / 2 - containerDetails.top;
};
var ScrollButtons = ({
  showLeftButton,
  showRightButton,
  onScrollLeft,
  onScrollRight
}) => {
  const containerRef = (0, import_react43.useRef)();
  const [offsetTopHeight, setOffsetTopHeight] = (0, import_react43.useState)(0);
  (0, import_react43.useEffect)(() => {
    function updateOffsetTop() {
      setOffsetTopHeight(getOffsetTopHeight(containerRef.current));
    }
    updateOffsetTop();
    window.addEventListener("scroll", updateOffsetTop);
    return () => window.removeEventListener("scroll", updateOffsetTop);
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Flex, {
    className: "simple-table-scroll-buttons__wrapper",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    pointerEvents: "none",
    ref: containerRef,
    overflow: "auto",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.Flex, {
      alignSelf: "flex-start",
      className: "simple-table-scroll-buttons__sticky-wrapper",
      position: "sticky",
      top: offsetTopHeight - 24,
      display: "inline-flex",
      height: "max-content",
      justifyContent: "space-between",
      alignItems: "center",
      pointerEvents: "none",
      w: "full",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Flex, {
          flex: 1,
          justifyContent: "flex-start",
          children: showLeftButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.IconButton, {
            className: "simple-table-scroll-buttons__left",
            size: "lg",
            rounded: "full",
            pointerEvents: "all",
            "aria-label": "",
            color: "gray.700",
            bg: "white",
            boxShadow: "md",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react42.default, {
              size: "28.8px",
              path: import_js6.mdiChevronLeft
            }),
            onClick: onScrollLeft
          }) : null
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Flex, {
          flex: 1,
          justifyContent: "flex-end",
          children: showRightButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.IconButton, {
            className: "simple-table-scroll-buttons__right",
            size: "lg",
            rounded: "full",
            pointerEvents: "all",
            "aria-label": "",
            color: "gray.700",
            bg: "white",
            boxShadow: "md",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react42.default, {
              size: "28.8px",
              path: import_js6.mdiChevronRight
            }),
            onClick: onScrollRight
          }) : null
        })
      ]
    })
  });
};
var TableContainer = ({
  children,
  ...props
}) => {
  const {
    elementRef,
    startShade,
    endShade,
    onScroll,
    scrollLeft,
    scrollRight
  } = useShadedScroll_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.Box, {
    position: "relative",
    className: "simple-table-wrapper",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.TableContainer, {
        ref: elementRef,
        border: 1,
        borderStyle: "solid",
        borderColor: "gray.200",
        borderRadius: "6px",
        onScroll,
        _before: {
          pointerEvents: "none",
          content: "''",
          position: "absolute",
          top: 0,
          right: "75%",
          bottom: 0,
          left: 0,
          backgroundImage: startShade ? `linear-gradient(to left, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
        },
        _after: {
          pointerEvents: "none",
          content: "''",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: "75%",
          backgroundImage: endShade ? `linear-gradient(to right, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
        },
        css: import_react41.css`
          & {
            -ms-overflow-style: none; /* for Internet Explorer, Edge */
            scrollbar-width: none; /* for Firefox */
          }

          &::-webkit-scrollbar {
            display: none; /* for Chrome, Safari, and Opera */
          }
        `,
        ...props,
        children
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ScrollButtons, {
        showLeftButton: startShade,
        showRightButton: endShade,
        onScrollLeft: scrollLeft,
        onScrollRight: scrollRight
      })
    ]
  });
};
var Table = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Table, {
    ...props,
    children
  });
};
var Thead = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Thead, {
    background: "gray.100",
    fontWeight: 500,
    textTransform: "none",
    ...props,
    children
  });
};
var Tbody = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Tbody, {
    ...props,
    children
  });
};
var Tfoot = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Tfoot, {
    height: 14,
    fontWeight: 400,
    ...props,
    children
  });
};
var Tr = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Tr, {
    ...props,
    children
  });
};
var Th = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Th, {
    color: "gray.600",
    fontSize: "md",
    fontWeight: "inherit",
    borderColor: "gray.200",
    background: "inherit",
    textTransform: "inherit",
    height: 12,
    ...props,
    children
  });
};
var Td = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react40.Td, {
    fontSize: "md",
    fontWeight: 400,
    color: "gray.700",
    borderColor: "gray.200",
    height: 14,
    ...props,
    children
  });
};

// src/components/AttributeChecklist/AttributeChecklist.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getSelectedValue = (row) => {
  if (row.yes === true) {
    return true;
  }
  if (row.no === true) {
    return false;
  }
  return null;
};
var exteriorBorder = {
  border: "1px solid",
  borderColor: "gray.200",
  borderRadius: "6px",
  sx: {
    "tbody > tr:last-child > td": {
      borderBottom: 0,
      borderBottomColor: "gray.200"
    }
  }
};
var AttributeChecklist = ({
  value,
  onChange,
  isReadOnly
}) => {
  const { t } = (0, import_react_i18next6.useTranslation)();
  const isSm = (0, import_react44.useBreakpointValue)({
    base: true,
    md: false
  });
  let initialCheckboxState = {};
  let initialCommentState = {};
  value == null ? void 0 : value.forEach((element) => {
    initialCheckboxState[element.id.toString()] = {
      yes: element.selected === true,
      no: element.selected === false
    };
    initialCommentState[element.id.toString()] = element.comment;
  });
  const [checkboxState, setCheckboxState] = (0, import_react45.useState)(initialCheckboxState);
  const [commentState, setCommentState] = (0, import_react45.useState)(initialCommentState);
  const handleAddComment = (positionId, newValue) => {
    const rowId = positionId.toString();
    setCommentState((prevState) => ({
      ...prevState,
      [rowId]: newValue
    }));
    onChange({
      id: positionId,
      comment: newValue ?? "",
      selected: getSelectedValue(checkboxState[rowId])
    });
  };
  const handleChangeCheckbox = (positionId, newValue, name) => {
    const rowId = positionId.toString();
    if (name === "yes" && newValue) {
      setCheckboxState((prevState) => ({
        ...prevState,
        [rowId]: { yes: true, no: false }
      }));
      onChange({
        id: positionId,
        comment: commentState[rowId] ?? "",
        selected: true
      });
    }
    if (name === "no" && newValue) {
      setCheckboxState((prevState) => ({
        ...prevState,
        [rowId]: { yes: false, no: true }
      }));
      onChange({
        id: positionId,
        comment: commentState[rowId] ?? "",
        selected: false
      });
    }
    if (!newValue) {
      setCheckboxState((prevState) => ({
        ...prevState,
        [rowId]: { yes: false, no: false }
      }));
      onChange({
        id: positionId,
        comment: commentState[rowId] ?? "",
        selected: null
      });
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Box, {
    className: "attribute-checklist",
    children: isSm ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react44.Stack, {
      className: "attribute-checklist__list",
      ...exteriorBorder,
      spacing: "0",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Box, {
          h: "44px",
          w: "full",
          bg: "gray.100"
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Accordion, {
          allowMultiple: true,
          reduceMotion: true,
          children: value == null ? void 0 : value.map((row) => {
            const rowId = row.id.toString();
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.AccordionItem, {
              className: "attribute-checklist__list-row",
              letterSpacing: "0.5px",
              children: ({ isExpanded }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react44.AccordionButton, {
                    justifyContent: "space-between",
                    p: "0",
                    _expanded: { bg: "gray.50" },
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Text, {
                        px: "24px",
                        py: "16px",
                        textAlign: "left",
                        letterSpacing: "0.5px",
                        children: t(row.value)
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.AccordionIcon, {
                        mr: "8px"
                      })
                    ]
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.AccordionPanel, {
                    p: "0",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react44.Stack, {
                      spacing: "0",
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react44.Stack, {
                          className: "attribute-checklist__list-row__yes",
                          isInline: true,
                          w: "full",
                          justifyContent: "space-between",
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Text, {
                              px: "24px",
                              py: "16px",
                              fontWeight: 500,
                              children: t("YES")
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Checkbox, {
                              "aria-label": `attribute-checklist-${row.id}-yes`,
                              size: "lg",
                              isDisabled: isReadOnly,
                              isChecked: checkboxState[rowId].yes,
                              onChange: (e) => handleChangeCheckbox(
                                row.id,
                                e.target.checked,
                                "yes"
                              ),
                              px: "24px"
                            })
                          ]
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react44.Stack, {
                          className: "attribute-checklist__list-row__no",
                          isInline: true,
                          justifyContent: "space-between",
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Text, {
                              px: "24px",
                              py: "16px",
                              fontWeight: 500,
                              children: t("NO")
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Checkbox, {
                              "aria-label": `attribute-checklist-${row.id}-no`,
                              size: "lg",
                              placeholder: t("COMMENTS"),
                              isDisabled: isReadOnly,
                              isChecked: checkboxState[rowId].no,
                              onChange: (e) => handleChangeCheckbox(
                                row.id,
                                e.target.checked,
                                "no"
                              ),
                              px: "24px"
                            })
                          ]
                        }),
                        (!isReadOnly || row.comment) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Box, {
                          className: "attribute-checklist__list-row__textarea",
                          px: "24px",
                          py: "8px",
                          children: isExpanded && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeText_default, {
                            "aria-label": `attribute-checklist-${row.id}-comment`,
                            placeholder: t("COMMENTS"),
                            isReadOnly,
                            onBlur: (event) => event.target.value !== commentState[row.id] && handleAddComment(row.id, event.target.value),
                            defaultValue: commentState[rowId],
                            letterSpacing: "0.5px"
                          })
                        })
                      ]
                    })
                  })
                ]
              })
            }, row.id);
          })
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.TableContainer, {
      className: "attribute-checklist__table",
      ...exteriorBorder,
      whiteSpace: "initial",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
        variant: "simple",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {}),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                  children: t("YES")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                  children: t("NO")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                  minW: "250px",
                  children: t("COMMENTS")
                })
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
            children: value == null ? void 0 : value.map((row) => {
              const rowId = row.id.toString();
              return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                className: "attribute-checklist__table-row",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    letterSpacing: "0.5px",
                    verticalAlign: "baseline",
                    children: t(row.value)
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    className: "attribute-checklist__table-row__yes",
                    verticalAlign: "baseline",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Checkbox, {
                      "aria-label": `attribute-checklist-${row.id}-yes`,
                      size: "lg",
                      isDisabled: isReadOnly,
                      isChecked: checkboxState[rowId].yes,
                      onChange: (e) => handleChangeCheckbox(row.id, e.target.checked, "yes")
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    className: "attribute-checklist__table-row__no",
                    verticalAlign: "baseline",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react44.Checkbox, {
                      "aria-label": `attribute-checklist-${row.id}-no`,
                      size: "lg",
                      isDisabled: isReadOnly,
                      isChecked: checkboxState[rowId].no,
                      onChange: (e) => handleChangeCheckbox(row.id, e.target.checked, "no")
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    className: "attribute-checklist__table-row__textarea",
                    py: "8px",
                    children: (!isReadOnly || row.comment) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeText_default, {
                      "aria-label": `attribute-checklist-${row.id}-comment`,
                      isReadOnly,
                      onBlur: (event) => event.target.value !== commentState[row.id] && handleAddComment(row.id, event.target.value),
                      minH: "full",
                      defaultValue: commentState[rowId],
                      letterSpacing: "0.5px"
                    })
                  })
                ]
              }, row.id);
            })
          })
        ]
      })
    })
  });
};
var AttributeChecklist_default = AttributeChecklist;

// src/components/AttributeDate/AttributeDate.tsx
var import_react54 = require("@chakra-ui/react");
var import_js7 = require("@mdi/js");
var import_react55 = __toESM(require("@mdi/react"));
var import_react56 = __toESM(require("react"));
var import_react_datepicker = __toESM(require("react-datepicker"));
var import_react_i18next7 = require("react-i18next");

// src/components/AuraInput/AuraInput.tsx
var import_react46 = require("@chakra-ui/react");
var import_react47 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var AuraInput = import_react47.default.forwardRef(
  ({ isReadOnly = false, children, ...props }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react46.Input, {
      ref,
      isReadOnly,
      isDisabled: isReadOnly,
      _readOnly: {
        bgColor: "gray.50",
        borderColor: "gray.100",
        _focus: { borderColor: "gray.100" },
        _hover: { cursor: "default" }
      },
      _disabled: {
        bgColor: "gray.50",
        borderColor: "gray.100",
        _focus: { borderColor: "gray.100" },
        _hover: { cursor: "default" }
      },
      borderRadius: "6px",
      ...props
    });
  }
);
var AuraInput_default = AuraInput;

// src/context/BasketContext.tsx
var import_react48 = __toESM(require("react"));
var import_react_query7 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var BasketContext = (0, import_react48.createContext)({
  basket: [],
  addToBasket: ({
    productId,
    quantity
  }) => {
  }
});
var BasketContextProvider = ({ children }) => {
  const queryClient = (0, import_react_query7.useQueryClient)();
  const { isUserUser } = (0, import_react48.useContext)(AuthContext);
  const { data } = (0, import_react_query7.useQuery)("basket", api_default.getBasket, { enabled: !isUserUser });
  const { mutateAsync: addToBasket } = (0, import_react_query7.useMutation)(addToBasketContent, {
    onSettled: () => {
      queryClient.invalidateQueries("basket");
    }
  });
  const basket = data == null ? void 0 : data.data;
  const value = import_react48.default.useMemo(
    () => ({ basket, addToBasket }),
    [basket, addToBasket]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BasketContext.Provider, {
    value,
    children
  });
};
var useBasketContent = () => {
  const basketContext = (0, import_react48.useContext)(BasketContext);
  if (basketContext === void 0) {
    throw new Error("useBasketContent must be used within a BasketContext");
  }
  return basketContext;
};
var addToBasketContent = ({ productId, quantity = 1 }) => {
  const payload = {
    product: productId,
    quantity
  };
  return api_default.updateBasket({ payload });
};

// src/context/CustomizerContext.tsx
var import_react49 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomizerContext = (0, import_react49.createContext)(null);
var CustomizerContextProvider = ({ value = null, moduleName = null, children, ...props }) => {
  value.moduleName = moduleName;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomizerContext.Provider, {
    value,
    children
  });
};
var CustomizerContext_default = CustomizerContextProvider;

// src/context/LanguageContext.tsx
var import_react50 = __toESM(require("react"));
var import_locale = require("date-fns/locale");
var import_jsx_runtime = require("react/jsx-runtime");
var locales = {
  pl: import_locale.pl,
  enGB: import_locale.enGB,
  de: import_locale.de,
  ru: import_locale.ru,
  cs: import_locale.cs
};
var initialLanguage = "pl";
var LanguageContext = (0, import_react50.createContext)({
  language: initialLanguage,
  changeLanguage: () => Promise.resolve(),
  currentLocale: null
});
var setUserLanguage = async (lang) => {
  await api_default.updateLanguage({ language: lang });
};
var _a;
if (typeof window !== "undefined") {
  const language = (_a = document.documentElement) == null ? void 0 : _a.lang;
  initialLanguage = language;
}
var getLocaleForLanguageCode = (languageCode) => {
  switch (languageCode) {
    case "en":
      return "en-GB";
    default:
      return languageCode;
  }
};
var LanguageProvider = ({
  language = initialLanguage,
  i18nextInstance = null,
  ...props
}) => {
  const [currentLanguage, setCurrentLanguage] = (0, import_react50.useState)(null);
  const [currentLocale, setCurrentLocale] = (0, import_react50.useState)(import_locale.pl);
  (0, import_react50.useEffect)(() => {
    setCurrentLanguage(language);
  }, [language]);
  (0, import_react50.useEffect)(() => {
    const setDefaultLocale = async () => {
      const localeName = getLocaleForLanguageCode(language);
      const defaultLocale = loadLocale(localeName);
      if (defaultLocale) {
        setCurrentLocale(defaultLocale);
      }
    };
    setDefaultLocale();
  }, [language]);
  const changeLanguage = async (lang) => {
    await setUserLanguage(lang);
    setCurrentLanguage(lang);
    if (i18nextInstance) {
      i18nextInstance.changeLanguage(lang);
    }
  };
  const loadLocale = (locale) => {
    try {
      const localeData = locales[locale];
      return localeData;
    } catch (error) {
      return void 0;
    }
  };
  const contextValue = (0, import_react50.useMemo)(
    () => ({
      language: currentLanguage,
      changeLanguage,
      currentLocale
    }),
    [currentLanguage, currentLocale]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LanguageContext.Provider, {
    value: contextValue,
    ...props
  });
};
var useLanguage = () => {
  const context = import_react50.default.useContext(LanguageContext);
  if (context === void 0) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

// src/context/ListFiltersContext.tsx
var import_react51 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ListFiltersContext = (0, import_react51.createContext)(null);
var ListFiltersContextProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFiltersContext.Provider, {
    value,
    children
  });
};
var ListFiltersContext_default = ListFiltersContextProvider;

// src/context/ModalVisibilityContext.tsx
var import_react52 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ModalVisibilityContext = (0, import_react52.createContext)(null);
var ModalVisibilityProvider = ({ isHidden, setIsHidden, children }) => {
  const hideModal = (0, import_react52.useCallback)(() => {
    setIsHidden(true);
  }, [setIsHidden]);
  const showModal = (0, import_react52.useCallback)(() => {
    setIsHidden(false);
  }, [setIsHidden]);
  const toggleModal = (0, import_react52.useCallback)(() => {
    setIsHidden((state) => !state);
  }, [setIsHidden]);
  const value = (0, import_react52.useMemo)(() => {
    return {
      isHidden,
      hideModal,
      showModal,
      toggleModal
    };
  }, [hideModal, isHidden]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalVisibilityContext.Provider, {
    value,
    children
  });
};
var useModalVisibilityContext = () => {
  const context = import_react52.default.useContext(ModalVisibilityContext);
  return context;
};

// src/context/LinkContext.tsx
var import_react53 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var LinkContext = (0, import_react53.createContext)({ Link: null });
var LinkContextProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinkContext.Provider, {
    value,
    children
  });
};
var useLink = () => {
  const context = (0, import_react53.useContext)(LinkContext);
  if (context === void 0) {
    throw new Error("useLink must be used within a LinkContextProvider");
  }
  return context;
};

// src/components/AttributeDate/AttributeDate.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getDefaultDateFormat = (withTime) => {
  return withTime ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS;
};
var AttributeDate = ({
  withTime,
  value,
  onChange,
  isLoading,
  isReadOnly,
  leftIconPlaceholder,
  ...props
}) => {
  const { t } = (0, import_react_i18next7.useTranslation)();
  const { currentLocale } = (0, import_react56.useContext)(LanguageContext);
  const dateFormatCurrent = props.dateFormat ?? getDefaultDateFormat(withTime);
  const dateValue = value ? new Date(value) : null;
  const isDisabled = props.disabled || isReadOnly || isLoading;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_datepicker.default, {
    className: "attribute-date__input",
    selected: dateValue,
    popperPlacement: "bottom",
    popperModifiers: [
      {
        name: "preventOverflow",
        options: {
          rootBoundary: "viewport",
          tether: true,
          padding: { right: withTime ? 85 : 0 }
        }
      }
    ],
    minDate: props.minDate,
    maxDate: props.maxDate,
    todayButton: t("TODAY"),
    locale: currentLocale,
    showTimeSelect: withTime,
    showYearDropdown: true,
    dateFormat: dateFormatCurrent,
    timeCaption: t("TIME"),
    onChange,
    disabled: isDisabled,
    customInput: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomInput, {
      loadingLabel: t("LOADING"),
      isDisabled,
      isLoading,
      leftIconPlaceholder: leftIconPlaceholder && t(leftIconPlaceholder)
    }),
    ...props
  });
};
var CustomInput = import_react56.default.forwardRef(
  ({
    isDisabled,
    isLoading,
    loadingLabel,
    size = "md",
    leftIconPlaceholder,
    ...props
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react54.InputGroup, {
      className: "attribute-date",
      position: "relative",
      zIndex: 0,
      size,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react54.InputLeftElement, {
          className: "attribute-date__icon",
          pointerEvents: "none",
          zIndex: 2,
          color: "gray.300",
          pl: 4,
          children: leftIconPlaceholder ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react54.Text, {
            children: leftIconPlaceholder
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react55.default, {
            path: import_js7.mdiCalendarBlankOutline,
            size: "24px"
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
          isDisabled,
          _disabled: {
            bgColor: "gray.50",
            borderColor: "gray.100"
          },
          type: "text",
          ref,
          pl: 12,
          ...props
        }),
        isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react54.InputRightElement, {
          className: "attribute-date__loader",
          title: loadingLabel,
          pointerEvents: "none",
          zIndex: 2,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react54.IconButton, {
            "aria-label": "loading",
            as: "div",
            variant: "ghost",
            isLoading: true
          })
        })
      ]
    });
  }
);
CustomInput.displayName = "CustomInput";
var AttributeDate_default = AttributeDate;

// src/components/AttributeChat/AttributeChat.tsx
var import_react59 = require("react");
var import_react60 = require("@chakra-ui/react");

// src/components/MessageItem/MessageItem.tsx
var import_react57 = require("@chakra-ui/react");
var import_date_fns5 = require("date-fns");
var import_react58 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var MessageItem = ({
  username,
  avatarUrl,
  title,
  content,
  createdDate,
  users,
  onClick,
  disableContentLimit = false,
  ...props
}) => {
  const { currentLocale } = (0, import_react58.useContext)(LanguageContext);
  const avatarBaseProps = {
    name: username,
    src: avatarUrl
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react57.Stack, {
    direction: "row",
    className: "message-item",
    spacing: 0,
    ...onClick ? { as: "button", onClick, textAlign: "left", w: "full" } : {},
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Flex, {
        display: { base: "none", lg: "flex" },
        className: "message-item__avatar-container",
        w: "60px",
        justifyContent: "flex-start",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Avatar, {
          ...avatarBaseProps,
          className: "message-item__avatar--aside",
          size: "sm",
          mt: "34px",
          ml: 4
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react57.Stack, {
        className: "message-item__content",
        minH: "104px",
        boxShadow: "0px 0.5px 4px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.06);",
        direction: "column",
        flex: 1,
        px: 4,
        py: 3,
        borderRadius: "6px",
        spacing: 2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Box, {
            lineHeight: "20px",
            maxH: "20px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Badge, {
              className: "message-item__time-badge",
              py: 0,
              px: 2,
              color: "gray.700",
              bg: "gray.100",
              fontSize: "sm",
              letterSpacing: "0.25px",
              fontWeight: 400,
              textTransform: "unset",
              borderRadius: "4px",
              children: createdDate ? (0, import_date_fns5.formatDistance)(createdDate, new Date(), {
                locale: currentLocale,
                addSuffix: true
              }) : "?"
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react57.Stack, {
            isInline: true,
            align: "center",
            spacing: 0,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Avatar, {
                ...avatarBaseProps,
                className: "message-item__avatar",
                display: { base: "flex", lg: "none" },
                size: "sm",
                mr: 4,
                ml: 2
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Text, {
                className: "message-item__users",
                as: "span",
                fontSize: "sm",
                lineHeight: "20px",
                letterSpacing: "0.25px",
                fontWeight: 400,
                color: "gray.500",
                noOfLines: 1,
                children: users
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react57.Stack, {
            direction: "column",
            spacing: 1,
            children: [
              title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Text, {
                className: "message-item__title",
                fontWeight: 400,
                fontSize: "md",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                color: "gray.800",
                noOfLines: 1,
                children: title
              }) : null,
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Text, {
                className: "message-item__text",
                fontWeight: 400,
                fontSize: "md",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                color: "gray.600",
                ...disableContentLimit ? {} : { noOfLines: 2 },
                children: content
              })
            ]
          })
        ]
      })
    ]
  });
};
var MessageItem_default = MessageItem;

// src/components/AttributeChat/AttributeChat.tsx
var import_react61 = __toESM(require("@mdi/react"));
var import_js8 = require("@mdi/js");
var import_react_i18next8 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var InputBox = ({
  messageText,
  handleMessageText,
  loadingStatus,
  handleSendAction
}) => {
  const { t } = (0, import_react_i18next8.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react60.Flex, {
    width: "100%",
    flexDir: "row",
    alignItems: "flex-end",
    className: "attribute-chat__input-box",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react60.Textarea, {
        mr: "8px",
        minH: "40px",
        rows: 1,
        value: messageText,
        onChange: handleMessageText,
        placeholder: t("ATTRIBUTE_CHAT_TYPE_MESSAGE")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react60.IconButton, {
        w: "40px",
        h: "40px",
        isLoading: loadingStatus,
        onClick: handleSendAction,
        "aria-label": "Send message",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react61.default, {
          path: import_js8.mdiSend,
          size: "20px"
        })
      })
    ]
  });
};
var AttributeChat = ({
  value,
  isEditing = false,
  maxHeight = "616px",
  onChange,
  ...props
}) => {
  const [loadingStatus, setLoadingStatus] = (0, import_react59.useState)(false);
  const [messageText, setMessageText] = (0, import_react59.useState)("");
  const handleMessageText = (e) => setMessageText(e.target.value);
  const handleSendAction = async () => {
    setLoadingStatus(true);
    await onChange(messageText);
    setLoadingStatus(false);
    setMessageText("");
  };
  const displayMessages = value.map(
    ({ username, avatarUrl, createdDate, content }, index) => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MessageItem_default, {
        username,
        avatarUrl,
        createdDate,
        content,
        users: username,
        disableContentLimit: true
      }, index);
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react60.Stack, {
    spacing: "16px",
    className: "attribute-chat",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react60.VStack, {
        maxH: maxHeight,
        overflowY: "scroll",
        spacing: "16px",
        align: "stretch",
        pe: "12px",
        py: "4px",
        className: "attribute-chat__messages",
        children: displayMessages
      }),
      isEditing && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(InputBox, {
        messageText,
        handleMessageText,
        loadingStatus,
        handleSendAction
      })
    ]
  });
};
var AttributeChat_default = AttributeChat;

// src/components/AttributeHtml/AttributeHtml.tsx
var import_react62 = require("@chakra-ui/react");
var import_ckeditor4_react = __toESM(require("ckeditor4-react"));
var import_jsx_runtime = require("react/jsx-runtime");
if (process.env.NODE_ENV === "development") {
  import_ckeditor4_react.default.editorUrl = "https://cdn.ckeditor.com/4.11.4/standard-all/ckeditor.js";
} else {
  import_ckeditor4_react.default.editorUrl = "/utils/ckeditor/ckeditor.js";
}
var AttributeHtml = ({
  value,
  isReadOnly = true,
  language,
  editorConfig = {},
  ...props
}) => {
  const config = { ...defaultEditorConfig, ...editorConfig };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react62.Box, {
    className: "attribute-html",
    children: !isReadOnly ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react62.Box, {
      className: "attribute-html__ckeditor__container",
      "data-testid": "ckeditor",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ckeditor4_react.default, {
        data: value,
        config: {
          ...config,
          defaultLanguage: "pl",
          language
        },
        ...props
      })
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react62.Box, {
      className: "attribute-html__content",
      dangerouslySetInnerHTML: {
        __html: value
      }
    })
  });
};
var AttributeHtml_default = AttributeHtml;
var defaultEditorConfig = {
  toolbar: [
    {
      name: "clipboard",
      groups: ["clipboard", "undo"],
      items: [
        "Cut",
        "Copy",
        "Paste",
        "PasteText",
        "PasteFromWord",
        "-",
        "Undo",
        "Redo"
      ]
    },
    {
      name: "editing",
      groups: ["find", "selection", "spellchecker"],
      items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"]
    },
    { name: "links", items: ["Link", "Unlink", "Anchor"] },
    {
      name: "insert",
      items: [
        "Image",
        "Table",
        "HorizontalRule",
        "Smiley",
        "SpecialChar",
        "PageBreak",
        "Iframe"
      ]
    },
    { name: "document", groups: ["mode"], items: ["Source"] },
    { name: "tools", items: ["Maximize"] },
    "/",
    { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
    {
      name: "basicstyles",
      groups: ["basicstyles"],
      items: ["Bold", "Italic", "Underline"]
    },
    {
      name: "paragraph",
      groups: ["list", "indent", "blocks", "align"],
      items: [
        "NumberedList",
        "BulletedList",
        "-",
        "Outdent",
        "Indent",
        "-",
        "Blockquote",
        "-",
        "JustifyLeft",
        "JustifyCenter",
        "JustifyRight",
        "JustifyBlock"
      ]
    },
    { name: "colors", items: ["TextColor", "BGColor"] },
    { name: "others", items: ["-"] }
  ],
  format_tags: "p;h1;h2;h3;pre",
  removeDialogTabs: "image:advanced;link:advanced",
  disableNativeSpellChecker: false,
  scayt_autoStartup: false,
  allowedContent: true,
  extraPlugins: "widget",
  heigh: 800
};

// src/components/AttributeFile/AttributeFile.tsx
var import_react65 = require("@chakra-ui/react");
var import_isEmpty6 = __toESM(require("lodash/isEmpty"));

// src/components/AttributeFile/EmptyFiles/EmptyFiles.tsx
var import_react63 = require("@chakra-ui/react");
var import_react64 = __toESM(require("@mdi/react"));
var import_js9 = require("@mdi/js");
var import_react_i18next9 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyFiles = () => {
  const { t } = (0, import_react_i18next9.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react63.Flex, {
    color: "gray.300",
    alignItems: "center",
    gap: "17px",
    p: "16px",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Box, {
        boxSize: "40px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react64.default, {
          size: "100%",
          path: import_js9.mdiFileSearch
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Text, {
        color: "gray.400",
        children: t("ATTRIBUTE_FILE_EMPTY")
      })
    ]
  });
};

// src/components/AttributeFile/AttributeFile.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeFile = ({
  children,
  onFileDelete,
  ...props
}) => {
  if (!(0, import_isEmpty6.default)(children)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react65.VStack, {
      className: "attribute-files",
      spacing: 0,
      w: "full",
      ...props,
      children
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFiles, {});
  }
};
var AttributeFile_default = AttributeFile;

// src/components/AttributeFile/AttributeFileItem/AttributeFileItem.tsx
var import_react77 = require("@chakra-ui/react");
var import_js12 = require("@mdi/js");
var import_react78 = __toESM(require("@mdi/react"));
var import_date_fns6 = require("date-fns");
var import_filesize = __toESM(require("filesize"));
var import_react79 = require("react");
var import_react_i18next10 = require("react-i18next");
var import_react_truncate_string = __toESM(require("react-truncate-string"));

// src/components/AuraDropdownMenu/AuraDropdownMenu.tsx
var import_react67 = require("@chakra-ui/react");
var import_react68 = __toESM(require("@mdi/react"));
var import_react69 = __toESM(require("react"));

// src/components/AuraMenuItem/AuraMenuItem.tsx
var import_react66 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraMenuItem = (0, import_react66.forwardRef)((props, ref) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react66.MenuItem, {
    ref,
    iconSpacing: 2,
    sx: {
      "& .chakra-menu__icon-wrapper": {
        color: "gray.500"
      }
    },
    px: 6,
    fontSize: "md",
    h: "40px",
    ...props
  });
});
var AuraMenuItem_default = AuraMenuItem;

// src/components/AuraDropdownMenu/AuraDropdownMenu.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AuraDropdownMenu = ({
  children,
  menuItems,
  ...props
}) => {
  if (!menuItems) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react67.Menu, {
    ...props,
    children: [
      children,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.MenuList, {
        py: 3,
        children: menuItems.map((item, index) => {
          const {
            className,
            customElement,
            icon,
            label,
            onClick,
            ...itemProps
          } = item;
          if (customElement) {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react69.default.Fragment, {
              children: customElement
            }, index);
          }
          if (icon) {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraMenuItem_default, {
              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react68.default, {
                path: icon,
                size: "24px"
              }),
              onClick,
              ...itemProps,
              children: label
            }, index);
          }
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraMenuItem_default, {
            onClick,
            className,
            ...itemProps,
            children: label
          }, index);
        })
      })
    ]
  });
};
var AuraDropdownMenu_default = AuraDropdownMenu;

// src/components/MoreIconButton/MoreIconButton.tsx
var import_react70 = require("@chakra-ui/react");
var import_js10 = require("@mdi/js");
var import_react71 = __toESM(require("react"));
var import_react72 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var MoreIconButton = import_react71.default.forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react70.IconButton, {
      ref,
      variant: "ghost",
      size: "md",
      fontSize: "28px",
      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react72.default, {
        path: import_js10.mdiDotsVertical,
        size: "28px"
      }),
      ...props
    });
  }
);
var MoreIconButton_default = MoreIconButton;

// src/components/AttributeFile/AttributeFileItem/FilePreview/FilePreview.tsx
var import_react73 = require("@chakra-ui/react");
var import_js11 = require("@mdi/js");
var import_react74 = __toESM(require("@mdi/react"));
var import_react75 = require("react");
var import_react76 = require("@chakra-ui/react");
var import_react_image_lightbox = __toESM(require("react-image-lightbox"));
var import_jsx_runtime = require("react/jsx-runtime");
var FilePreview = ({ file, files }) => {
  var _a2, _b;
  const [imageLoaded, setImageLoaded] = (0, import_react75.useState)(false);
  const { isOpen, onClose, onOpen } = (0, import_react73.useDisclosure)();
  const { id, mimeType, dbName, fileName, uris } = file;
  const [index, setIndex] = (0, import_react75.useState)(0);
  const imageFiles = files == null ? void 0 : files.filter(
    (file2) => file2.mimeType.startsWith("image/")
  );
  const lightBoxExtended = files && {
    prevSrc: (_a2 = imageFiles[(index + imageFiles.length - 1) % imageFiles.length]) == null ? void 0 : _a2.uris.show,
    nextSrc: (_b = imageFiles[(index + 1) % imageFiles.length]) == null ? void 0 : _b.uris.show,
    onMovePrevRequest: () => {
      setIndex((index + imageFiles.length - 1) % imageFiles.length);
    },
    onMoveNextRequest: () => {
      setIndex((index + 1) % imageFiles.length);
    }
  };
  const actualFileIndex = imageFiles == null ? void 0 : imageFiles.findIndex((file2) => (file2 == null ? void 0 : file2.id) === id);
  if (mimeType.startsWith("image/")) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react76.Image, {
          border: "1px solid",
          borderColor: "gray.200",
          borderRadius: "4px",
          src: process.env.NODE_ENV !== "production" ? getImageUrl(dbName, "thmb") : uris.show,
          alt: fileName,
          style: {
            height: "100%",
            objectFit: "cover",
            display: imageLoaded ? "block" : "none"
          },
          onLoad: () => setImageLoaded(true),
          onClick: () => {
            onOpen();
          }
        }),
        isOpen && imageLoaded ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_image_lightbox.default, {
          imageTitle: imageFiles[index].fileName,
          onCloseRequest: onClose,
          mainSrc: imageFiles[index].uris.show,
          onAfterOpen: () => setIndex(actualFileIndex),
          ...imageFiles.length > 1 && lightBoxExtended
        }) : null,
        !imageLoaded ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react74.default, {
          size: "100%",
          path: import_js11.mdiFile
        }) : null
      ]
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react74.default, {
      size: "100%",
      path: import_js11.mdiFile
    });
  }
};

// src/components/AttributeFile/AttributeFileItem/AttributeFileItem.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var gridTemplateSmall = `"date date date"
"preview details actions"`;
var gridTemplateLarge = `"preview date actions"
"preview details actions"`;
var AttributeFileItem = ({
  file,
  files,
  onDelete,
  isReadOnly = false
}) => {
  const { t } = (0, import_react_i18next10.useTranslation)();
  const { currentLocale } = (0, import_react79.useContext)(LanguageContext);
  const [, , iLg] = useResponsive_default();
  const attributeDownload = {
    customElement: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraMenuItem_default, {
      as: "a",
      download: true,
      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react78.default, {
        path: import_js12.mdiFileDownloadOutline,
        size: "24px"
      }),
      href: file.uris.get,
      children: t("ATTRIBUTE_FILE_DOWNLOAD")
    })
  };
  const attributeDelete = {
    label: t("ATTRIBUTE_FILE_DELETE"),
    icon: import_js12.mdiTrashCanOutline,
    onClick: () => onDelete == null ? void 0 : onDelete(file.id)
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react77.SimpleGrid, {
    gridTemplate: {
      base: gridTemplateSmall,
      lg: gridTemplateLarge
    },
    className: "attribute-file",
    w: "full",
    gridRowGap: { base: 3, lg: 2 },
    gridColumnGap: 4,
    gridAutoColumns: "auto 1fr auto",
    py: 3,
    px: 2,
    paddingInlineEnd: 0,
    borderBottom: "1px solid",
    borderColor: "gray.200",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.Box, {
        className: "attribute-file__date",
        gridArea: "date",
        lineHeight: "20px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.Tag, {
          size: "sm",
          borderRadius: "4px",
          fontSize: "sm",
          fontWeight: 400,
          letterSpacing: "0.25px",
          children: file.createdDate ? (0, import_date_fns6.formatDistance)(file.createdDate, new Date(), {
            locale: currentLocale,
            addSuffix: true
          }) : "?"
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.Box, {
        className: "attribute-file__preview",
        gridArea: "preview",
        color: "gray.300",
        boxSize: { base: 12, lg: 20 },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilePreview, {
          file,
          files
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react77.VStack, {
        className: "attribute-file__details",
        spacing: 1,
        gridArea: "details",
        justifyContent: "space-between",
        textAlign: "left",
        minW: 0,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.Flex, {
            className: "attribute-file__name",
            w: "full",
            h: 6,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.Link, {
              minW: 0,
              href: file.uris.show,
              color: "blue.500",
              lineHeight: "24px",
              isExternal: true,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_truncate_string.default, {
                text: file.fileName
              })
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.Box, {
            className: "attribute-file__size",
            fontSize: "sm",
            color: "gray.500",
            w: "full",
            lineHeight: "24px",
            children: (0, import_filesize.default)(file.size)
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.Flex, {
        className: "attribute-file__actions",
        gridArea: "actions",
        alignItems: "center",
        children: iLg ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react77.ButtonGroup, {
          color: "gray.700",
          spacing: 2,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.IconButton, {
              "aria-label": t("ATTRIBUTE_FILE_DOWNLOAD"),
              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react78.default, {
                size: "24px",
                path: import_js12.mdiFileDownloadOutline
              }),
              as: "a",
              download: true,
              href: file.uris.get
            }),
            !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.IconButton, {
              "aria-label": t("ATTRIBUTE_FILE_DELETE"),
              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react78.default, {
                size: "24px",
                path: import_js12.mdiTrashCanOutline
              }),
              onClick: () => onDelete == null ? void 0 : onDelete(file.id)
            })
          ]
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
          menuItems: isReadOnly ? [attributeDownload] : [attributeDownload, attributeDelete],
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.MenuButton, {
            bg: "gray.100",
            color: "gray.700",
            as: MoreIconButton_default,
            "aria-label": t("ATTRIBUTE_FILE_ACTIONS")
          })
        })
      })
    ]
  });
};
var AttributeFileItem_default = AttributeFileItem;

// src/components/AttributeFile/utils.ts
var import_api8 = require("@questy/api");
var transformApiResponse = import_api8.FileSchema.partial().transform((file) => ({
  id: file.id,
  fileName: file.fileName,
  dbName: file.dbName,
  mimeType: file.mimeType,
  size: file.fileSize,
  createdDate: new Date(file.dateCreate),
  uris: {
    get: file.uris.get,
    show: file.uris.show
  }
}));

// src/components/AttributeLabel/AttributeLabel.tsx
var import_react80 = require("@chakra-ui/react");
var import_react81 = __toESM(require("@mdi/react"));
var import_js13 = require("@mdi/js");
var import_react_i18next11 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var NumberBox = ({
  number,
  ...props
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react80.Badge, {
  backgroundColor: "crmBlue",
  borderRadius: "10px",
  fontSize: "sm",
  h: "20px",
  px: "9px",
  fontWeight: 600,
  color: "#ffffff",
  lineHeight: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  className: "attribute-label__box__number",
  ...props,
  children: number
});
var TooltipInformation = ({ content }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react80.Tooltip, {
  hasArrow: true,
  label: content,
  bg: "gray.700",
  color: "#ffffff",
  px: "12px",
  py: "8px",
  fontStyle: "caption",
  borderRadius: "4px",
  fontWeight: 500,
  maxW: "320px",
  className: "attribute-label__tooltip-content",
  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react80.Flex, {
    className: "attribute-label__tooltip-box",
    boxSize: "20px",
    justifyContent: "center",
    alignItems: "center",
    mr: "16px",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react81.default, {
      color: "#3182CE",
      size: "20px",
      path: import_js13.mdiInformation,
      className: "attribute-label__tooltip-box__icon"
    })
  })
});
var UploadFilesButton = ({ id, isLoading, onClick }) => {
  const { t } = (0, import_react_i18next11.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonAction_default, {
    height: {
      base: "40px",
      lg: "32px"
    },
    m: 0,
    mr: "16px",
    cursor: "pointer",
    as: import_react80.FormLabel,
    leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react81.default, {
      path: import_js13.mdiFilePlusOutline
    }),
    htmlFor: `attribute-label__file-input${id}`,
    isLoading,
    className: "attribute-label__file-input",
    children: [
      t(`${"ADD"}`),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react80.Input, {
        id: `attribute-label__file-input${id}`,
        type: "file",
        hidden: true,
        onChange: onClick,
        multiple: true
      })
    ]
  });
};
var AttributeLabel = ({
  id,
  text,
  numberAlerts,
  tooltipContent,
  onClick,
  buttonContent,
  isEditButton,
  isUploadFilesButton,
  isUploadFilesLoading,
  onClickUploadFiles,
  isSaving,
  isError,
  isSuccess,
  ...props
}) => {
  const baseHeight = {
    base: "40px",
    lg: "32px"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react80.Stack, {
    className: "attribute-label",
    alignItems: "center",
    flexWrap: "wrap",
    flexDir: "row",
    spacing: 0,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react80.Flex, {
        alignItems: "center",
        justifySelf: "center",
        className: "attribute-label__box",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react80.HStack, {
            spacing: "8px",
            mr: "16px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react80.Text, {
                textStyle: "subtitleLabel",
                my: "0",
                children: text
              }),
              numberAlerts && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NumberBox, {
                number: numberAlerts
              })
            ]
          }),
          tooltipContent && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TooltipInformation, {
            content: tooltipContent
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react80.Flex, {
        alignItems: "center",
        className: "attribute-label__box",
        mt: "0",
        children: [
          buttonContent && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
            height: baseHeight,
            mr: "16px",
            textStyle: "buttonSmall",
            leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react81.default, {
              path: import_js13.mdiPlus
            }),
            onClick,
            className: "attribute-label__box__button",
            children: buttonContent
          }),
          isUploadFilesButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UploadFilesButton, {
            id,
            isLoading: isUploadFilesLoading,
            onClick: onClickUploadFiles
          }),
          isEditButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react80.IconButton, {
            "aria-label": "attribute-label__box__button-edit",
            size: "xs",
            mr: "16px",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react81.default, {
              size: "20px",
              path: import_js13.mdiPencilOutline
            }),
            onClick,
            className: "attribute-label__box__button-edit"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActionBadge_default, {
            isLoading: isSaving,
            isError,
            isSuccess,
            noAnimation: true
          })
        ]
      })
    ]
  });
};
var AttributeLabel_default = AttributeLabel;

// src/components/AttributeList/AttributeList.tsx
var import_react82 = require("@chakra-ui/react");
var import_findIndex = __toESM(require("lodash/findIndex"));
var import_sortBy = __toESM(require("lodash/sortBy"));
var import_react_i18next12 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeList = ({
  value,
  options,
  onChange,
  maxVisible = 5,
  isReadOnly,
  ...props
}) => {
  const { t } = (0, import_react_i18next12.useTranslation)();
  const { isOpen, onToggle } = (0, import_react82.useDisclosure)({ defaultIsOpen: false });
  const sortedPositions = (0, import_sortBy.default)(
    options,
    (el) => -(0, import_findIndex.default)(value, (v) => v === el.id)
  );
  const visibleItems = sortedPositions.slice(
    0,
    Math.max(maxVisible, value.length)
  );
  const hiddenItems = sortedPositions.slice(Math.max(maxVisible, value.length));
  const hasHiddenItems = hiddenItems.length > 0;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react82.CheckboxGroup, {
    value,
    onChange,
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react82.Box, {
      className: "attribute-list",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react82.Stack, {
          spacing: 4,
          fontSize: "md",
          fontWeight: 400,
          lineHeight: "24px",
          sx: {
            ".attribute-list__checkbox :nth-child(2)": {
              width: "20px",
              height: "20px"
            }
          },
          children: hasHiddenItems ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              visibleItems == null ? void 0 : visibleItems.map((option) => {
                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react82.Checkbox, {
                  value: option.id,
                  isDisabled: isReadOnly,
                  className: "attribute-list__checkbox",
                  children: option.label
                }, option.id);
              }),
              isOpen ? hiddenItems == null ? void 0 : hiddenItems.map((option) => {
                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react82.Checkbox, {
                  value: option.id,
                  isDisabled: isReadOnly,
                  className: "attribute-list__checkbox",
                  children: option.label
                }, option.id);
              }) : null
            ]
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: options == null ? void 0 : options.map((option) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react82.Checkbox, {
              value: option.id,
              isDisabled: isReadOnly,
              className: "attribute-list__checkbox",
              children: option.label
            }, option.id))
          })
        }),
        hasHiddenItems && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react82.Button, {
          variant: "link",
          fontWeight: 500,
          fontSize: "sm",
          lineHeight: "20px",
          letterSpacing: "0.25px",
          color: "blue.500",
          onClick: onToggle,
          mt: 4,
          children: isOpen ? t("ATTRIBUTE_MULTI_LESS") : `${t("ATTRIBUTE_MULTI_MORE")} (+${hiddenItems.length})`
        })
      ]
    })
  });
};
var AttributeList_default = AttributeList;

// src/components/AttributeNumber/AttributeNumber.tsx
var import_react83 = require("@chakra-ui/react");
var import_num_parse = __toESM(require("num-parse"));
var import_react84 = require("react");
var import_react_query8 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var validateAttribute = (oldValue, newValue) => {
  if (+oldValue === +newValue) {
    return false;
  }
  return true;
};
var AttributeNumber = ({
  id,
  value,
  onChange,
  isReadOnly
}) => {
  const [attributeValue, setAttributeValue] = (0, import_react84.useState)("");
  const attributeId = `attribute__number-${id}`;
  (0, import_react84.useEffect)(() => {
    setAttributeValue(
      typeof value !== "undefined" && value !== null ? value : ""
    );
  }, [value]);
  const handleValueChange = ({
    target: { value: value2 }
  }) => {
    setAttributeValue(value2.replace(/[^\d.\,]/g, ""));
  };
  const handleBlur = (e) => {
    const {
      target: { value: inputValue }
    } = e;
    const parsedNumber = (0, import_num_parse.default)(inputValue.replace(",", "."));
    const finalNumber = isNaN(parsedNumber) ? "" : parsedNumber;
    if (validateAttribute(value, finalNumber)) {
      setAttributeValue(finalNumber);
      mutate(finalNumber);
    }
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query8.useMutation)((newValue) => {
    return onChange(newValue, id);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react83.InputGroup, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react83.Input, {
      isDisabled: isReadOnly,
      _disabled: {
        bgColor: "gray.50",
        borderColor: "gray.100"
      },
      pl: 2,
      value: attributeValue,
      id: attributeId,
      type: "text",
      onBlur: handleBlur,
      onChange: handleValueChange
    })
  });
};
var AttributeNumber_default = AttributeNumber;

// src/components/AuraDatePicker/AuraDatePicker.tsx
var import_react_datepicker2 = __toESM(require("react-datepicker"));
var import_jsx_runtime = require("react/jsx-runtime");
var AuraDatePicker = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_datepicker2.default, {
  ...props
});
var AuraDatePicker_default = AuraDatePicker;

// src/components/AuraDrawer/AuraDrawer.tsx
var import_react85 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraDrawer = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react85.Drawer, {
    ...props
  });
};
var AuraDrawerBody = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react85.DrawerBody, {
    py: 5,
    px: 6,
    ...props
  });
};
var AuraDrawerFooter = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react85.DrawerFooter, {
    ...props
  });
};
var AuraDrawerHeader = ({
  showCloseButton = true,
  children,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react85.DrawerHeader, {
    borderBottom: "1px solid",
    borderColor: "gray.200",
    maxH: 16,
    py: 5,
    px: 4,
    alignItems: "center",
    display: "flex",
    ...props,
    children: [
      children,
      showCloseButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDrawerCloseButton, {
        color: "gray.700",
        size: "lg",
        fontSize: "13px",
        ml: "auto"
      }) : null
    ]
  });
};
var AuraDrawerOverlay = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react85.DrawerOverlay, {
    ...props
  });
};
var AuraDrawerCloseButton = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react85.DrawerCloseButton, {
    position: "initial",
    ...props
  });
};
var AuraDrawerContent = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react85.DrawerContent, {
    ...props
  });
};

// src/components/AuraFormLabel/AuraFormLabel.tsx
var import_react86 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraFormLabel = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react86.FormLabel, {
    textStyle: "subtitleLabel",
    color: "gray.700",
    ...props,
    children
  });
};
var AuraFormLabel_default = AuraFormLabel;

// src/components/AuraTabs/AuraTabs.tsx
var import_react88 = require("@chakra-ui/react");
var import_react89 = require("react");
var import_react_i18next13 = require("react-i18next");

// src/components/ContentBox/ContentBox.tsx
var import_react87 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ContentBox = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react87.Box, {
    bg: "white",
    boxShadow: "base",
    p: {
      base: 4,
      lg: 6
    },
    borderRadius: 10,
    ...props,
    children
  });
};
var ContentBox_default = ContentBox;

// src/components/AuraTabs/AuraTabs.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AuraTabs = ({ name, data }) => {
  const { t } = (0, import_react_i18next13.useTranslation)();
  const storageName = `auraTabIndex_${name}`;
  const [tabIndex, setTabIndex] = (0, import_react89.useState)(
    localStorage.getItem(storageName) ? parseInt(localStorage.getItem(storageName)) : 0
  );
  const handleChangeTab = (index) => {
    setTabIndex(index);
    localStorage.setItem(storageName, index.toString());
  };
  const handleSelectChange = (event) => {
    handleChangeTab(parseInt(event.target.value));
  };
  const showSelector = (0, import_react88.useBreakpointValue)({
    base: true,
    lg: false
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react88.Tabs, {
      onChange: handleChangeTab,
      index: tabIndex,
      isLazy: true,
      orientation: "vertical",
      variant: "unstyled",
      alignItems: "flex-start",
      children: [
        !showSelector && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContentBox_default, {
          w: { lg: "288px", xl: "448px" },
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react88.TabList, {
            children: data.map((tab, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react88.Tab, {
              justifyContent: "flex-start",
              px: "16px",
              py: "12px",
              borderRadius: "6px",
              _selected: { bgColor: "gray.100" },
              textAlign: "left",
              children: t(tab.label)
            }, index))
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
          w: "full",
          ml: { lg: "16px" },
          children: [
            showSelector && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react88.Select, {
              onChange: handleSelectChange,
              value: tabIndex,
              w: { base: "full", md: "fit-content" },
              bg: "gray.100",
              children: data.map((tab, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                value: index,
                children: t(tab.label)
              }, index))
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react88.TabPanels, {
              children: data.map((tab, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react88.TabPanel, {
                p: 0,
                children: tab.content
              }, index))
            })
          ]
        })
      ]
    })
  });
};
var AuraTabs_default = AuraTabs;

// src/components/AuraModal/AuraModal.tsx
var import_react90 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraModal = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.Modal, {
    ...props
  });
};
var AuraModalHeader = ({
  showBorders = true,
  children,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react90.ModalHeader, {
    ...showBorders ? { borderBottom: "1px solid", borderColor: "gray.200" } : {},
    py: "20px",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    ...props,
    children: [
      children,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalCloseButton, {
        color: "gray.700",
        size: "lg",
        fontSize: "13px"
      })
    ]
  });
};
var AuraModalFooter = ({ showBorders = true, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.ModalFooter, {
    ...showBorders ? { borderTop: "1px solid", borderColor: "gray.200" } : {},
    pt: "16px",
    pb: "32px",
    px: "24px",
    ...props
  });
};
var AuraModalBody = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.ModalBody, {
    py: "16px",
    px: "24px",
    overflowY: "auto",
    ...props
  });
};
var AuraModalContent = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.ModalContent, {
    ...props
  });
};
var AuraModalOverlay = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.ModalOverlay, {
    ...props
  });
};
var AuraModalCloseButton = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.DrawerCloseButton, {
    position: "initial",
    ...props
  });
};

// src/components/AuraSelect/AuraSelect.tsx
var import_react110 = require("@chakra-ui/react");
var import_react111 = require("@emotion/react");
var import_js17 = require("@mdi/js");
var import_react112 = __toESM(require("@mdi/react"));
var import_react113 = require("react");
var import_react_i18next15 = require("react-i18next");
var import_react_select9 = __toESM(require("react-select"));

// src/components/AuraSelect/CustomSingleValue/CustomSingleValue.tsx
var import_react93 = require("@chakra-ui/react");
var import_react_select = require("react-select");

// src/components/QAvatar/QAvatar.tsx
var import_react91 = require("@chakra-ui/react");
var import_react92 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var QAvatar = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react91.Avatar, {
    css: import_react92.css`
        & > img {
          background: white;
        }
      `,
    ...props
  });
};
var QAvatar_default = QAvatar;

// src/components/AuraSelect/CustomSingleValue/CustomSingleValue.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CustomSingleValue = ({
  children,
  ...props
}) => {
  const { data, selectProps } = props;
  const { withAvatar } = selectProps;
  const preparedAvatar = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
    size: "xs",
    className: "select__single-value__avatar",
    name: data.label,
    src: getImageUrl(data.avatar, "thmb")
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select.components.SingleValue, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react93.Stack, {
      isInline: true,
      align: "center",
      children: [
        withAvatar && preparedAvatar,
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Text, {
          as: "span",
          isTruncated: true,
          whiteSpace: "nowrap",
          className: "select__single-value__label",
          children
        })
      ]
    })
  });
};
var CustomSingleValue_default = CustomSingleValue;

// src/components/AuraSelect/CustomOption/CustomOption.tsx
var import_react94 = require("@chakra-ui/react");
var import_js14 = require("@mdi/js");
var import_react95 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var CustomOption = (props) => {
  const {
    children,
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerRef,
    innerProps,
    selectProps,
    data,
    isMulti
  } = props;
  const { withAvatar, withCheckbox } = selectProps;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react94.Box, {
    className: "select__option",
    _hover: {
      bg: "gray.100"
    },
    color: "gray.700",
    fontSize: "15px",
    py: "10px",
    px: "16px",
    cursor: "pointer",
    ref: innerRef,
    ...innerProps,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react94.Stack, {
      overflowX: "hidden",
      isInline: true,
      spacing: "0",
      alignItems: "center",
      children: [
        isMulti && withCheckbox ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react94.Checkbox, {
          size: "md",
          mr: "16px",
          isChecked: isSelected,
          pointerEvents: "none"
        }) : null,
        withAvatar && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react94.Box, {
          className: "select__option__user-avatar",
          children: data.value === 0 || data.value === -1 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react94.Circle, {
            size: "32px",
            bg: "#ffffff",
            color: "gray.500",
            border: "1px solid",
            borderColor: "gray.200",
            mr: "8px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react95.default, {
              size: "20px",
              path: data.value === -1 ? import_js14.mdiAccountGroup : import_js14.mdiAccountOutline
            })
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
            mr: "8px",
            title: data.label,
            name: data.label,
            size: "sm",
            src: getImageUrl(data.avatar, "thmb")
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react94.Text, {
          className: "select__option__label",
          as: "span",
          display: "inline-block",
          lineHeight: "24px",
          whiteSpace: "normal",
          ...withAvatar ? { noOfLines: 2 } : {},
          children: data.label
        })
      ]
    })
  });
};
var CustomOption_default = CustomOption;

// src/components/AuraSelect/CustomValueContainer/AvatarValueContainer/AvatarValueContainer.tsx
var import_react96 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AvatarValueContainer = ({
  valueContainerChildren,
  maxAvatars
}) => {
  let name = null;
  try {
    if (Array.isArray(valueContainerChildren)) {
      if (Array.isArray(valueContainerChildren[0])) {
        if (valueContainerChildren[0].length === 1) {
          name = valueContainerChildren == null ? void 0 : valueContainerChildren[0][0].props.data.label;
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react96.Stack, {
    flex: 1,
    overflowX: "hidden",
    isInline: true,
    spacing: "0",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react96.AvatarGroup, {
        mr: "8px",
        max: maxAvatars,
        size: "xs",
        className: "selected__avatar-group",
        zIndex: 0,
        flexDir: "row",
        ps: "2px",
        sx: {
          "*:not(:last-child)": {
            marginEnd: "-10px"
          },
          ".chakra-avatar__excess": {
            marginStart: "2px",
            zIndex: 100,
            order: 100,
            fontSize: "13px",
            marginEnd: "0px"
          }
        },
        children: valueContainerChildren
      }),
      name && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react96.Text, {
        lineHeight: "26px",
        as: "span",
        isTruncated: true,
        whiteSpace: "nowrap",
        children: name
      })
    ]
  });
};
var AvatarValueContainer_default = AvatarValueContainer;

// src/components/AuraSelect/CustomValueContainer/CustomValueContainer.tsx
var import_react97 = require("@chakra-ui/react");
var import_react_select2 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomValueContainer = ({
  children,
  ...props
}) => {
  const { isMulti, selectProps, hasValue } = props;
  if (isMulti) {
    if (selectProps.withAvatar && hasValue) {
      const [Avatars, Input8] = children;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select2.components.ValueContainer, {
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AvatarValueContainer_default, {
            valueContainerChildren: [Avatars],
            maxAvatars: selectProps.maxAvatars
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react97.Box, {
            children: Input8
          })
        ]
      });
    } else {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select2.components.ValueContainer, {
        ...props,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react97.Flex, {
          gap: "10px",
          flexWrap: "wrap",
          pr: "8px",
          maxWidth: "100%",
          children
        })
      });
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select2.components.ValueContainer, {
    ...props,
    children
  });
};
var CustomValueContainer_default = CustomValueContainer;

// src/components/AuraSelect/CustomMultiValue/CustomMultiValue.tsx
var import_react98 = require("@chakra-ui/react");
var import_js15 = require("@mdi/js");
var import_react99 = __toESM(require("@mdi/react"));
var import_react_select3 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomMultiValue = ({
  children,
  ...props
}) => {
  var _a2;
  const { data, selectProps } = props;
  const { withAvatar } = selectProps;
  const meOption = ((_a2 = selectProps.rawOptions) == null ? void 0 : _a2.find(
    (option) => option.value === data.value
  )) ?? { avatar: void 0 };
  if (withAvatar) {
    const {
      size,
      ml,
      zIndex,
      showBorder,
      borderColor,
      marginEnd
    } = props;
    const avatarGroupProps = {
      size,
      ml,
      zIndex,
      showBorder,
      borderColor,
      marginEnd
    };
    if (data.value === -1 || data.value === 0 && !meOption.avatar) {
      return renderSpecialAvatar({
        label: data.label,
        value: data.value,
        avatarProps: { ...avatarGroupProps }
      });
    } else {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
        ...avatarGroupProps,
        size,
        className: "selected__avatar",
        name: data.label,
        src: getImageUrl(data.avatar, "thmb") || meOption.avatar,
        borderWidth: "1px",
        borderColor: "gray.200"
      });
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select3.components.MultiValue, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react98.Text, {
      isTruncated: true,
      mb: "0",
      children
    })
  });
};
var renderSpecialAvatar = ({
  value,
  label,
  avatarProps
}) => {
  if (value === 0 || value === -1) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
      ...avatarProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react98.Circle, {
        size: "24px",
        bg: "#ffffff",
        color: "gray.500",
        border: "1px solid",
        borderColor: "gray.200",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react99.default, {
          size: "15px",
          path: value === -1 ? import_js15.mdiAccountGroup : import_js15.mdiAccountOutline
        })
      })
    });
  }
  return null;
};
var CustomMultiValue_default = CustomMultiValue;

// src/components/AuraSelect/CustomMenuList/CustomMenuList.tsx
var import_react107 = require("react");
var import_react108 = require("@chakra-ui/react");
var import_react109 = __toESM(require("@mdi/react"));
var import_js16 = require("@mdi/js");
var import_react_i18next14 = require("react-i18next");
var import_react_select8 = require("react-select");

// src/components/SelectCheckbox/SelectCheckbox.tsx
var import_immer2 = __toESM(require("immer"));
var import_react106 = require("react");
var import_react_select7 = __toESM(require("react-select"));

// src/components/SelectCheckbox/CustomClearIndicator/CustomClearIndicator.tsx
var import_fa3 = require("react-icons/fa");

// src/components/SelectCheckbox/IndicatorWrapper/IndicatorWrapper.tsx
var import_react100 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var IndicatorWrapper = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react100.Box, {
    display: "flex",
    _hover: {
      color: "gray.400"
    },
    alignItems: "center",
    color: "gray.300",
    px: 2,
    ...props,
    children
  });
};
var IndicatorWrapper_default = IndicatorWrapper;

// src/components/SelectCheckbox/CustomClearIndicator/CustomClearIndicator.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CustomClearIndicator = (props) => {
  const { children, innerProps } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IndicatorWrapper_default, {
    ...innerProps,
    "aria-label": "Clear selected options",
    children: children || /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa3.FaTimes, {})
  });
};
var CustomClearIndicator_default = CustomClearIndicator;

// src/components/SelectCheckbox/CustomDropdownIndicator/CustomDropdownIndicator.tsx
var import_fa4 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomDropdownIndicator = (props) => {
  const { children, innerProps } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IndicatorWrapper_default, {
    ...innerProps,
    "aria-label": "Open dropdown",
    children: children || /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa4.FaChevronDown, {})
  });
};
var CustomDropdownIndicator_default = CustomDropdownIndicator;

// src/components/SelectCheckbox/CustomMultiValue/CustomMultiValue.tsx
var import_react_select4 = require("react-select");

// src/components/SelectCheckbox/SpecialAvatar/SpecialAvatar.tsx
var import_react101 = require("@chakra-ui/react");
var import_fa5 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var SpecialAvatar = ({
  label,
  optionType,
  optionMeValue,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react101.Flex, {
    color: "blue.500",
    w: 6,
    h: 6,
    justifyContent: "center",
    alignItems: "center",
    rounded: "full",
    border: 1,
    borderStyle: "solid",
    borderColor: "blue.200",
    bg: "white",
    ...props,
    children: optionType === "me" && optionMeValue === 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa5.FaUser, {
      "aria-hidden": "true",
      title: label
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa5.FaUsers, {
      "aria-hidden": "true",
      title: label
    })
  });
};
var SpecialAvatar_default = SpecialAvatar;

// src/components/SelectCheckbox/CustomMultiValue/CustomMultiValue.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CustomMultiValue2 = ({
  children,
  ...props
}) => {
  var _a2;
  const { data, selectProps } = props;
  const { withAvatar } = selectProps;
  const meOption = ((_a2 = selectProps.rawOptions) == null ? void 0 : _a2.find(
    (option) => option.value === data.value
  )) ?? { avatar: void 0 };
  if (withAvatar) {
    const {
      size,
      ml,
      zIndex,
      showBorder,
      borderColor,
      marginEnd
    } = props;
    const avatarGroupProps = {
      size,
      ml,
      zIndex,
      showBorder,
      borderColor,
      marginEnd
    };
    if (data.value === -1 || data.value === 0 && !meOption.avatar) {
      return renderSpecialAvatar2({
        label: data.label,
        value: data.value
      });
    } else {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
        ...avatarGroupProps,
        size,
        showBorder: true,
        className: "selected__avatar",
        name: data.label,
        src: data.avatar || meOption.avatar
      });
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select4.components.MultiValue, {
    ...props,
    children
  });
};
var renderSpecialAvatar2 = ({
  value,
  label
}) => {
  if (value === -1) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SpecialAvatar_default, {
      label
    });
  }
  if (value === 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SpecialAvatar_default, {
      optionMeValue: value,
      optionType: "me",
      label
    });
  }
  return null;
};
var CustomMultiValue_default2 = CustomMultiValue2;

// src/components/SelectCheckbox/CustomOption/CustomOption.tsx
var import_react102 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Option = (props) => {
  const {
    children,
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerRef,
    innerProps,
    selectProps,
    data
  } = props;
  const { withAvatar, rawOptions, enableOptionMe, optionMeValue } = selectProps;
  let me = null;
  if (enableOptionMe && optionMeValue && optionMeValue === data.value) {
    me = rawOptions == null ? void 0 : rawOptions.find((opt) => opt.value === optionMeValue);
  }
  const optionType = data == null ? void 0 : data.optionType;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Box, {
    _hover: {
      bg: "gray.100"
    },
    bg: isFocused ? "gray.100" : "initial",
    py: 2,
    px: 2,
    cursor: "pointer",
    ref: innerRef,
    ...innerProps,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react102.Stack, {
      color: ["all", "me"].includes(optionType) ? "blue.500" : "",
      w: "full",
      isInline: true,
      align: "center",
      justify: "space-between",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Checkbox, {
          isChecked: isSelected,
          onChange: () => {
          },
          pointerEvents: "none",
          borderColor: "blue.200"
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react102.Stack, {
          flex: 1,
          justify: "space-between",
          overflowX: "hidden",
          isInline: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Text, {
              isTruncated: true,
              as: "span",
              display: "inline-block",
              whiteSpace: "nowrap",
              children: data.label
            }),
            withAvatar && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Box, {
              className: "user-avatar",
              children: optionType === "all" || optionType === "me" && optionMeValue === 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SpecialAvatar_default, {
                optionType,
                optionMeValue,
                label: data.label
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
                title: (me == null ? void 0 : me.label) ?? data.label,
                name: (me == null ? void 0 : me.label) ?? data.label,
                size: "xs",
                src: (me == null ? void 0 : me.avatar) ?? data.avatar
              })
            })
          ]
        })
      ]
    })
  });
};
var CustomOption_default2 = Option;

// src/components/SelectCheckbox/CustomSingleValue/CustomSingleValue.tsx
var import_react103 = require("@chakra-ui/react");
var import_react_select5 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomSingleValue2 = ({
  children,
  ...props
}) => {
  var _a2;
  const { data, selectProps } = props;
  const { withAvatar } = selectProps;
  const meOption = ((_a2 = selectProps.rawOptions) == null ? void 0 : _a2.find(
    (option) => option.value === data.value
  )) ?? { avatar: void 0 };
  const renderAvatar = (label, value, avatar) => {
    if (value === -1) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SpecialAvatar_default, {
        label
      });
    }
    if (value === 0) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SpecialAvatar_default, {
        optionMeValue: value,
        optionType: "me",
        label
      });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
      showBorder: true,
      size: "xs",
      className: "selected__avatar",
      name: data.label,
      src: data.avatar || meOption.avatar
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select5.components.SingleValue, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react103.Stack, {
      isInline: true,
      align: "center",
      ml: 0.5,
      children: [
        withAvatar && renderAvatar(data.label, data.value, data.avatar),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react103.Text, {
          as: "span",
          isTruncated: true,
          whiteSpace: "nowrap",
          children
        })
      ]
    })
  });
};
var CustomSingleValue_default2 = CustomSingleValue2;

// src/components/SelectCheckbox/CustomValueContainer/AvatarValueContainer/AvatarValueContainer.tsx
var import_react104 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AvatarValueContainer2 = ({
  valueContainerChildren,
  maxAvatars
}) => {
  let name = null;
  try {
    if (Array.isArray(valueContainerChildren)) {
      if (Array.isArray(valueContainerChildren[0])) {
        if (valueContainerChildren[0].length === 1) {
          name = valueContainerChildren == null ? void 0 : valueContainerChildren[0][0].props.data.label;
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react104.Stack, {
    flex: 1,
    overflowX: "hidden",
    isInline: true,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.AvatarGroup, {
        mr: 1,
        max: maxAvatars,
        size: "xs",
        className: "selected__avatar-group",
        zIndex: 0,
        children: valueContainerChildren
      }),
      name && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.Text, {
        lineHeight: "26px",
        as: "span",
        isTruncated: true,
        whiteSpace: "nowrap",
        children: name
      })
    ]
  });
};
var AvatarValueContainer_default2 = AvatarValueContainer2;

// src/components/SelectCheckbox/CustomValueContainer/CustomValueContainer.tsx
var import_react105 = require("@chakra-ui/react");
var import_react_select6 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomValueContainer2 = ({
  children,
  ...props
}) => {
  const { isMulti, hasValue, selectProps } = props;
  if (!hasValue) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select6.components.ValueContainer, {
      ...props,
      children
    });
  }
  if (isMulti) {
    if (selectProps.withAvatar) {
      const [Avatars, Input8] = children;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select6.components.ValueContainer, {
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AvatarValueContainer_default2, {
            valueContainerChildren: [Avatars],
            maxAvatars: selectProps.maxAvatars
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react105.Box, {
            children: Input8
          })
        ]
      });
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select6.components.ValueContainer, {
    ...props,
    children
  });
};
var CustomValueContainer_default2 = CustomValueContainer2;

// src/components/SelectCheckbox/SelectCheckbox.tsx
var import_jsx_runtime = require("react/jsx-runtime");
function inputValueReducer(state, action) {
  switch (action.type) {
    case "set-value":
      return state;
    case "input-change":
      return action.payload;
    case "input-blur":
      return "";
    default:
      return state;
  }
}
var isOptionsGrouped = (opts) => {
  if (opts === void 0) {
    return false;
  }
  return opts.every((option) => {
    if (option.hasOwnProperty("options")) {
      return true;
    }
    return false;
  });
};
var isOptionsWithAvatar = (opts) => {
  if (opts === void 0) {
    return false;
  }
  return opts.every((option) => {
    if (option.hasOwnProperty("avatar")) {
      return true;
    }
    return false;
  });
};
var filterOptions = (opts, enableOptionMe, optionMeValue) => {
  if (typeof opts === void 0) {
    return opts;
  }
  if (!enableOptionMe || optionMeValue === void 0) {
    return opts;
  }
  const isGrouped = isOptionsGrouped(opts);
  if (!isGrouped) {
    const regularOptions = [...opts ?? []];
    return regularOptions == null ? void 0 : regularOptions.filter(
      (option) => option.value !== optionMeValue
    );
  } else {
    const groupedOptions = [...opts ?? []];
    const filterdGroupedOptions = [];
    groupedOptions.forEach(
      (group) => {
        const newOptions = group.options.filter((opt) => {
          return opt.value !== optionMeValue;
        });
        const newGroup = {
          label: group.label,
          options: newOptions
        };
        filterdGroupedOptions.push(newGroup);
      }
    );
    return filterdGroupedOptions;
  }
};
var SelectCheckbox = ({
  isMulti,
  enableOptionMe = false,
  enableOptionAll = false,
  optionMeLabel = "Ja",
  optionAllLabel = "Wszyscy",
  optionMeValue,
  optionAllExclusive,
  maxAvatars = 5,
  withAvatars,
  onChange,
  onInputChange,
  options,
  defaultValue,
  value,
  ...props
}) => {
  const [selectedOptions, setSelectedOptions] = (0, import_react106.useState)([]);
  const [inputValue, dispatch] = (0, import_react106.useReducer)(inputValueReducer, "");
  (0, import_react106.useEffect)(() => {
    if (!selectedOptions.length && (defaultValue == null ? void 0 : defaultValue.length) > 0) {
      setSelectedOptions(defaultValue);
    } else {
      setSelectedOptions(value ?? []);
    }
  }, [value]);
  (0, import_react106.useEffect)(() => {
    if (onInputChange) {
      onInputChange(inputValue, { action: "set-value" });
    }
  }, [inputValue]);
  const handleChange = (selectValue, actionMeta) => {
    var _a2;
    switch (actionMeta.action) {
      case "remove-value":
        if (Array.isArray(selectValue)) {
          setSelectedOptions((opts) => {
            const newValue = opts == null ? void 0 : opts.filter(
              (option) => option.value !== actionMeta.removedValue.value
            );
            handleExternalOnChange(newValue, actionMeta);
            return newValue;
          });
        } else {
          setSelectedOptions(selectValue ?? []);
          handleExternalOnChange(selectValue, actionMeta);
        }
        break;
      case "deselect-option":
        setSelectedOptions(selectValue ?? []);
        handleExternalOnChange(selectValue ?? [], actionMeta);
        break;
      case "select-option":
        if (isMulti) {
          const isAll = ((_a2 = actionMeta == null ? void 0 : actionMeta.option) == null ? void 0 : _a2.value) === -1;
          if (optionAllExclusive && isAll) {
            setSelectedOptions([actionMeta.option]);
            handleExternalOnChange([actionMeta.option], actionMeta);
            break;
          }
          const newValue = Array.isArray(selectValue) && optionAllExclusive ? selectValue == null ? void 0 : selectValue.filter((option) => option.value !== -1) : selectValue;
          setSelectedOptions(newValue ?? []);
          handleExternalOnChange(newValue, actionMeta);
        } else {
          let newValue = selectValue;
          if ((selectedOptions == null ? void 0 : selectedOptions.value) === (selectValue == null ? void 0 : selectValue.value)) {
            newValue = null;
          }
          handleExternalOnChange(newValue, actionMeta);
          setSelectedOptions(newValue);
        }
        break;
      case "clear":
        setSelectedOptions([]);
        handleExternalOnChange([], actionMeta);
        break;
      case "pop-value":
        setSelectedOptions((currentOpts) => {
          return currentOpts == null ? void 0 : currentOpts.filter(
            (option) => option.value !== actionMeta.removedValue.value
          );
        });
        handleExternalOnChange(selectValue, actionMeta);
        break;
      default:
        break;
    }
  };
  const handleExternalOnChange = (selectValue, actionMeta) => {
    if (onChange) {
      onChange(selectValue, actionMeta);
    }
  };
  const handleInputChange = (selectValue, action) => {
    dispatch({ type: action.action, payload: selectValue });
  };
  const filteredOptions = filterOptions(options, enableOptionMe, optionMeValue) ?? [];
  const sortOptions = (options2) => {
    if (!options2) {
      return [];
    }
    const sortOptions2 = (a, b) => {
      let selectedIds = [];
      if (Array.isArray(selectedOptions)) {
        selectedIds = selectedOptions.map((opt) => opt.value);
      } else {
        selectedIds = [selectedOptions == null ? void 0 : selectedOptions.value];
      }
      if (selectedIds.includes(a.value)) {
        return -1;
      }
      if (selectedIds.includes(b.value)) {
        return 1;
      }
      return 0;
    };
    let newOptions;
    if (options2.length > 0 && isOptionsGrouped(options2)) {
      newOptions = (0, import_immer2.default)(options2, (draft) => {
        draft.forEach((group) => {
          group.options.sort(sortOptions2);
        });
      });
    } else {
      newOptions = (0, import_immer2.default)(options2, (draft) => {
        draft.sort(sortOptions2);
      });
    }
    return newOptions;
  };
  const allOption = enableOptionAll && {
    value: -1,
    label: optionAllLabel,
    optionType: "all"
  };
  const meOption = enableOptionMe && optionMeValue !== void 0 && {
    value: optionMeValue,
    label: optionMeLabel,
    optionType: "me"
  };
  const sortedOptions = sortOptions(filteredOptions);
  const preparedOptions = (0, import_immer2.default)([], (draft) => {
    if (meOption) {
      draft.push(meOption);
    }
    if (allOption) {
      draft.push(allOption);
    }
    draft.push(...sortedOptions);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select7.default, {
    enableOptionMe,
    enableOptionAll,
    optionMeLabel,
    optionMeValue,
    optionAllLabel,
    inputValue,
    onInputChange: handleInputChange,
    value: selectedOptions,
    onChange: handleChange,
    closeMenuOnSelect: false,
    isMulti,
    options: preparedOptions,
    rawOptions: options,
    withAvatar: withAvatars,
    maxAvatars,
    hideSelectedOptions: false,
    components: {
      Option: CustomOption_default2,
      ValueContainer: CustomValueContainer_default2,
      MultiValue: CustomMultiValue_default2,
      SingleValue: CustomSingleValue_default2,
      DropdownIndicator: CustomDropdownIndicator_default,
      ClearIndicator: CustomClearIndicator_default
    },
    styles: {
      control: (provided) => ({
        ...provided
      }),
      indicatorSeparator: (provided) => ({
        ...provided
      })
    },
    ...props
  });
};
var SelectCheckbox_default = SelectCheckbox;

// src/components/AuraSelect/CustomMenuList/CustomMenuList.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CustomMenuList = (props) => {
  var _a2;
  const { t } = (0, import_react_i18next14.useTranslation)();
  const {
    loadDataProps: loadDataProps2,
    additionalActionProps,
    inputValue,
    loadMoreOptions,
    isSelectedAll,
    setIsSelectedAll,
    totalCount,
    isLoading,
    isMulti
  } = props.selectProps;
  const handleSetAll = () => {
    if (isOptionsGrouped(props.options)) {
      if (isSelectedAll) {
        props.setValue([], "select-option");
      } else {
        const preparedOptions = [];
        props.options.forEach((group) => {
          group.options.forEach((option) => {
            preparedOptions.push(option);
          });
        });
        props.setValue(preparedOptions, "select-option");
      }
    } else {
      if (isSelectedAll) {
        props.setValue([], "select-option");
      } else {
        props.setValue(props.options, "select-option");
      }
    }
    setIsSelectedAll((prevValue) => !prevValue);
  };
  (0, import_react107.useEffect)(() => {
    if (!props.hasValue) {
      setIsSelectedAll(false);
      return;
    }
    const value = props.getValue();
    if (value.length != props.options.length) {
      setIsSelectedAll(false);
      return;
    }
    setIsSelectedAll(true);
  }, []);
  const actionPreparedTitle = (additionalActionProps == null ? void 0 : additionalActionProps.titleLabel) ?? t("ADD_NEW");
  const actionButtonLabel = inputValue ? `${actionPreparedTitle} "${inputValue}"` : actionPreparedTitle;
  const loadDataPropsPreparedTitle = (loadDataProps2 == null ? void 0 : loadDataProps2.titleLabel) ?? t("LOAD_MORE");
  const isAdditionalActionAlwaysVisible = (additionalActionProps == null ? void 0 : additionalActionProps.alwaysVisible) ? inputValue == null ? void 0 : inputValue.length : props.children.length;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select8.components.MenuList, {
    ...props,
    children: [
      ((_a2 = props.children) == null ? void 0 : _a2.length) && isMulti ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react108.Button, {
        className: "select-all",
        variant: "unstyled",
        color: "blue.500",
        fontWeight: "400",
        letterSpacing: "0.25px",
        fontStyle: "caption",
        mx: "16px",
        onClick: () => {
          handleSetAll();
        },
        children: isSelectedAll && props.hasValue ? t("DESELECT_ALL") : t("SELECT_ALL")
      }) : null,
      props.children,
      !isLoading && loadDataProps2 && props.options.length > 0 && props.options.length < totalCount ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomButtonOption, {
        titleLabel: loadDataPropsPreparedTitle,
        icon: import_js16.mdiMagnify,
        onClickAction: loadMoreOptions
      }) : null,
      additionalActionProps && isAdditionalActionAlwaysVisible ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomButtonOption, {
        titleLabel: actionButtonLabel,
        icon: import_js16.mdiPlus,
        onClickAction: additionalActionProps.handleAction
      }) : null
    ]
  });
};
var CustomButtonOption = ({
  titleLabel,
  icon,
  onClickAction
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react108.Button, {
    width: "full",
    minH: "44px",
    fontWeight: "400",
    p: "10px 16px",
    justifyContent: "flex-start",
    borderRadius: "0s",
    backgroundColor: "transparent",
    _hover: {
      bg: "gray.100"
    },
    onClick: onClickAction,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react108.Box, {
        me: "10px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react109.default, {
          color: "#2D3748",
          size: "24px",
          path: icon
        })
      }),
      titleLabel
    ]
  });
};
var CustomMenuList_default = CustomMenuList;

// src/components/AuraSelect/AuraSelect.tsx
var import_immer3 = __toESM(require("immer"));
var import_debounce = __toESM(require("lodash/debounce"));
var import_async = __toESM(require("react-select/async"));
var import_axios2 = __toESM(require("axios"));
var import_isUndefined = __toESM(require("lodash/isUndefined"));

// src/components/AuraSelect/config.ts
var auraSelectFilterConfig = {
  ignoreCase: true,
  ignoreAccents: true,
  matchFrom: "any",
  stringify: (option) => {
    var _a2;
    return `${option.label} ${(_a2 = option.data) == null ? void 0 : _a2.additionalName}`;
  },
  trim: true
};

// src/components/AuraSelect/AuraSelect.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var fetchData = async (endpoint, config = {}) => {
  const url = `/api/${endpoint}`;
  const response = await (0, import_axios2.default)({
    method: "GET",
    url,
    ...config
  });
  return response.data;
};
var isOptionsGrouped2 = (opts) => {
  if (opts === void 0) {
    return false;
  }
  return opts.every((option) => {
    if (option.hasOwnProperty("options")) {
      return true;
    }
    return false;
  });
};
var AuraSelect = (0, import_react113.forwardRef)(
  ({
    isReadOnly,
    withAvatars,
    withCheckbox,
    optionAllEnabled,
    optionMeEnabled,
    isEnabledSelectAll,
    optionAllLabel,
    optionMeLabel,
    defaultOption,
    onChange,
    forceOnChange,
    onBlur,
    icon,
    loadDataProps: loadDataProps2,
    loadOptions: customLoadOptions,
    additionalActionProps,
    components: components11,
    ...props
  }, ref) => {
    const { t } = (0, import_react_i18next15.useTranslation)();
    const theme = (0, import_react111.useTheme)();
    const defaultLimit = 20;
    const increaseLimit = 20;
    const [selectedOptions, setSelectedOptions] = (0, import_react113.useState)([]);
    const [limitData, setLimitData] = (0, import_react113.useState)(defaultLimit);
    const [isSelectedAll, setIsSelectedAll] = (0, import_react113.useState)(false);
    const [inputValue, setInputValue] = (0, import_react113.useState)("");
    const [open, setOpen] = (0, import_react113.useState)(false);
    const [totalCount, setTotalCount] = (0, import_react113.useState)(0);
    const handleChange = (selectValue, actionMeta) => {
      var _a2;
      switch (actionMeta.action) {
        case "remove-value":
          if (Array.isArray(selectValue)) {
            setSelectedOptions((opts) => {
              const newValue = opts == null ? void 0 : opts.filter(
                (option) => option.value !== actionMeta.removedValue.value
              );
              onChange(newValue, actionMeta);
              return newValue;
            });
          } else {
            setSelectedOptions(selectValue ?? []);
            onChange(selectValue, actionMeta);
          }
          break;
        case "deselect-option":
          setSelectedOptions(selectValue ?? []);
          onChange(selectValue ?? [], actionMeta);
          break;
        case "select-option":
          if (props == null ? void 0 : props.isMulti) {
            const isAll = ((_a2 = actionMeta == null ? void 0 : actionMeta.option) == null ? void 0 : _a2.value) === -1;
            if (optionAllEnabled && isAll) {
              setSelectedOptions([actionMeta.option]);
              onChange([actionMeta.option], actionMeta);
              break;
            }
            const newValue = Array.isArray(selectValue) && optionAllEnabled ? selectValue == null ? void 0 : selectValue.filter((option) => option.value !== -1) : selectValue;
            setSelectedOptions(newValue ?? []);
            onChange(newValue, actionMeta);
          } else {
            let newValue = selectValue;
            if ((selectedOptions == null ? void 0 : selectedOptions.value) === (selectValue == null ? void 0 : selectValue.value)) {
              newValue = null;
            }
            onChange(newValue, actionMeta);
            setSelectedOptions(newValue);
          }
          break;
        case "clear":
          setSelectedOptions([]);
          onChange((props == null ? void 0 : props.isMulti) ? [] : null, actionMeta);
          break;
        case "pop-value":
          setSelectedOptions((currentOpts) => {
            return currentOpts == null ? void 0 : currentOpts.filter(
              (option) => option.value !== actionMeta.removedValue.value
            );
          });
          onChange(selectValue, actionMeta);
          break;
        default:
          break;
      }
    };
    const sortOptions = (options) => {
      if (!options) {
        return [];
      }
      const sortOptions2 = (a, b) => {
        let selectedIds = [];
        if (Array.isArray(selectedOptions)) {
          selectedIds = selectedOptions.map((opt) => opt.value);
        } else {
          selectedIds = [selectedOptions == null ? void 0 : selectedOptions.value];
        }
        if (selectedIds.includes(a.value)) {
          return -1;
        }
        if (selectedIds.includes(b.value)) {
          return 1;
        }
        return 0;
      };
      let newOptions;
      if (options.length > 0 && isOptionsGrouped2(options)) {
        newOptions = (0, import_immer3.default)(options, (draft) => {
          draft.forEach((group) => {
            group.options.sort(sortOptions2);
          });
        });
      } else {
        newOptions = (0, import_immer3.default)(options, (draft) => {
          draft.sort(sortOptions2);
        });
      }
      const optionAll = { label: optionAllLabel ?? t("ALL_USERS"), value: -1 };
      if (optionAllEnabled) {
        newOptions = [optionAll, ...newOptions];
      }
      const optionMe = { label: optionMeLabel ?? t("ME"), value: 0 };
      if (optionMeEnabled) {
        newOptions = [optionMe, ...newOptions];
      }
      return newOptions;
    };
    props.options = sortOptions(props.options);
    const handleLoadMore = () => {
      setLimitData((limit) => limit + increaseLimit);
    };
    const defaultLoadOptions = typeof customLoadOptions === "function" ? false : true;
    const loadOptions = async (query, callback) => {
      if (!query) {
        callback(null);
        return;
      }
      const endpoint = loadDataProps2 == null ? void 0 : loadDataProps2.endpoint;
      const additionalNameAccessor = loadDataProps2 == null ? void 0 : loadDataProps2.additionalNameAccessor;
      const isAutoselect = !(0, import_isUndefined.default)(loadDataProps2 == null ? void 0 : loadDataProps2.autoselect) ? loadDataProps2 == null ? void 0 : loadDataProps2.autoselect : true;
      const params = {
        fields: `${loadDataProps2 == null ? void 0 : loadDataProps2.labelField}${additionalNameAccessor ? "," + additionalNameAccessor : ""}` ?? "value",
        ...query ? { [`filter[${loadDataProps2.queryField ?? "_q"}][hasText]`]: query } : null,
        "page[limit]": limitData,
        ...(loadDataProps2 == null ? void 0 : loadDataProps2.settings) ?? {}
      };
      const url = `${endpoint}${isAutoselect ? "/autoselect" : ""}`;
      const { data, meta } = await fetchData(url, {
        params
      });
      setTotalCount(meta.page.total_count);
      let preparedData = data;
      if (additionalNameAccessor && (data == null ? void 0 : data.length)) {
        preparedData = data.map((item) => ({
          ...item,
          additionalName: item == null ? void 0 : item[additionalNameAccessor]
        }));
      }
      const readyOptions = buildOptions(
        preparedData,
        loadDataProps2.labelField,
        "id"
      );
      const translatedOptions = readyOptions == null ? void 0 : readyOptions.map((opt) => ({
        ...opt,
        label: t(opt == null ? void 0 : opt.label)
      }));
      callback(translatedOptions);
    };
    const debouncedLoadOptions = (0, import_debounce.default)(loadOptions, 500);
    (0, import_react113.useEffect)(() => {
      const defaultValue = props == null ? void 0 : props.defaultValue;
      if (!(selectedOptions == null ? void 0 : selectedOptions.length) && defaultValue) {
        setSelectedOptions(defaultValue);
      } else if (!(selectedOptions == null ? void 0 : selectedOptions.length) && (props == null ? void 0 : props.value)) {
        setSelectedOptions(props.value);
      }
    }, []);
    const colors = theme.colors;
    const placeholderText = (props == null ? void 0 : props.placeholder) ? props.placeholder : t("BEGIN_WRITING_TO_SEARCH");
    const customComponentsForSelect = {
      ValueContainer: CustomValueContainer_default,
      SingleValue: CustomSingleValue_default,
      MultiValue: CustomMultiValue_default,
      MultiValueContainer: CustomMultiValueContainer,
      MultiValueRemove: CustomMultiValueRemove,
      ClearIndicator: CustomClearIndicator2,
      DropdownIndicator: CustomDropdownIndicator2,
      Option: CustomOption_default,
      MenuList: CustomMenuList_default,
      Control: CustomControl,
      ...components11
    };
    const stylesSelect = {
      multiValue: (base) => ({
        ...base,
        backgroundColor: "initial",
        button: {
          width: "24px",
          height: "24px",
          borderRadius: "6px",
          color: "#A0AEC0"
        },
        height: "28px",
        display: "flex",
        alignItems: "center"
      }),
      multiValueLabel: (base) => ({
        ...base,
        alignItems: "center",
        color: colors.gray[700],
        display: "flex",
        fontSize: "13px"
      }),
      indicatorSeparator: () => ({
        display: "none"
      }),
      input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        lineHeight: "24px",
        fontSize: "15px"
      }),
      control: (base, { isDisabled, isFocused }) => ({
        ...base,
        backgroundColor: isDisabled ? colors.gray[50] : "initial",
        border: !props.isError ? `1px solid ${colors.gray[100]}` : `1.5px solid ${colors.red[500]}`,
        ...props.isError ? {
          boxShadow: `0 0 0 1px ${colors.red[500]}`
        } : {},
        borderRadius: "6px",
        minHeight: "40px",
        padding: "5px 11px 5px 15px",
        "&:hover .select__remove-all": {
          display: "flex"
        },
        ...isFocused ? {
          boxShadow: "none",
          border: `1px solid ${colors.blue[500]}`
        } : {
          "&:hover": {
            borderColor: colors.gray[300]
          }
        }
      }),
      valueContainer: (base) => ({
        ...base,
        padding: 0
      }),
      singleValue: (base) => ({
        ...base,
        color: colors.gray[700],
        marginLeft: 0
      }),
      groupHeading: (base) => ({
        ...base,
        letterSpacing: "0.15px",
        color: colors.gray[800],
        fontSize: "15px",
        fontWeight: "500",
        textTransform: "capitalize"
      }),
      menuList: (base) => {
        var _a2;
        return {
          ...base,
          "button.select-all": {
            display: `${!isEnabledSelectAll || !((_a2 = props.options) == null ? void 0 : _a2.length) ? "none" : "block"}  `
          }
        };
      },
      loadingIndicator: (base) => ({
        ...base,
        display: "none"
      }),
      placeholder: (base, { isFocused }) => ({
        ...base,
        position: "absolute",
        display: isFocused ? "none" : "block"
      })
    };
    return !(loadDataProps2 == null ? void 0 : loadDataProps2.endpoint) && typeof customLoadOptions !== "function" ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select9.default, {
      ref,
      isClearable: true,
      noOptionsMessage: () => t("NOTHING_FOUND"),
      loadingMessage: () => t("LOADING"),
      placeholder: null,
      value: selectedOptions,
      onChange: forceOnChange ? onChange : handleChange,
      hideSelectedOptions: !props.isMulti || !withCheckbox ? true : false,
      closeMenuOnSelect: !props.isMulti,
      loadMoreOptions: handleLoadMore,
      isSelectedAll,
      setIsSelectedAll,
      withAvatar: withAvatars,
      withCheckbox,
      icon,
      components: customComponentsForSelect,
      styles: stylesSelect,
      menuPosition: "fixed",
      filterOption: (0, import_react_select9.createFilter)(auraSelectFilterConfig),
      additionalActionProps,
      ...props,
      isDisabled: isReadOnly
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_async.default, {
      defaultOptions: defaultOption ?? true,
      autoFocus: open ?? true,
      menuIsOpen: open,
      onFocus: () => setOpen(true),
      cacheOptions: true,
      onBlur: (e) => {
        onBlur && onBlur(e);
        setOpen(false);
      },
      onMenuClose: () => setLimitData(defaultLimit),
      onInputChange: (value) => {
        setInputValue(value);
        setLimitData(defaultLimit);
      },
      totalCount,
      limitData,
      increaseLimit,
      inputValue,
      ref,
      noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? placeholderText : t("NOTHING_FOUND"),
      isClearable: true,
      loadingMessage: () => inputValue ? t("LOADING") : placeholderText,
      placeholder: null,
      value: selectedOptions,
      onChange: forceOnChange ? onChange : handleChange,
      hideSelectedOptions: !props.isMulti || !withCheckbox ? true : false,
      closeMenuOnSelect: !props.isMulti,
      loadMoreOptions: handleLoadMore,
      isSelectedAll,
      setIsSelectedAll,
      withAvatar: withAvatars,
      withCheckbox,
      icon,
      additionalActionProps,
      components: customComponentsForSelect,
      styles: stylesSelect,
      isDisabled: isReadOnly,
      ...!isReadOnly && { ...{ loadDataProps: loadDataProps2 } },
      ...!isReadOnly && {
        loadOptions: defaultLoadOptions ? debouncedLoadOptions : customLoadOptions
      },
      menuPosition: "fixed",
      filterOption: (0, import_react_select9.createFilter)(auraSelectFilterConfig),
      ...props
    }, limitData);
  }
);
var CustomControl = (props) => {
  const { icon } = props.selectProps;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select9.components.Control, {
    ...props,
    children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react110.Box, {
        me: "10px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react112.default, {
          color: "#CBD5E0",
          size: "24px",
          path: icon
        })
      }),
      props.children
    ]
  });
};
var CustomMultiValueContainer = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react110.Tag, {
    className: "select__multi-value-container",
    height: "28px",
    px: "2px",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select9.components.MultiValueContainer, {
      ...props
    })
  });
};
var customBaseProps = {
  variant: "unstyled",
  size: "xs",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "gray.700",
  cursor: "pointer"
};
var CustomMultiValueRemove = (props) => {
  if (props.selectProps.isDisabled) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react110.IconButton, {
    ...customBaseProps,
    className: "select__remove-one",
    ml: "4px",
    _hover: {
      color: "blue.400"
    },
    "aria-label": props.innerProps["aria-label"],
    ...props.innerProps,
    onClick: props.innerProps.onClick,
    onMouseDown: props.innerProps.onMouseDown,
    onTouchEnd: props.innerProps.onTouchEnd,
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react112.default, {
      size: "17.15px",
      path: import_js17.mdiClose
    })
  });
};
var CustomClearIndicator2 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react110.IconButton, {
    ...customBaseProps,
    className: "select__remove-all",
    display: { base: "flex", lg: "none" },
    _hover: {
      color: "gray.700",
      backgroundColor: "gray.100"
    },
    "aria-label": "select__remove-all",
    onClick: props.innerProps.onClick,
    onMouseDown: props.innerProps.onMouseDown,
    onTouchEnd: props.innerProps.onTouchEnd,
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react112.default, {
      size: "16px",
      path: import_js17.mdiClose
    })
  });
};
var CustomDropdownIndicator2 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react110.IconButton, {
    ...customBaseProps,
    ...props.isDisabled && { display: "none" },
    ml: "8px",
    className: "select__dropdown-button",
    _hover: {
      color: "gray.700"
    },
    "aria-label": props.innerProps["aria-label"],
    onClick: props.innerProps.onClick,
    onMouseDown: props.innerProps.onMouseDown,
    onTouchEnd: props.innerProps.onTouchEnd,
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react112.default, {
      size: "20px",
      path: import_js17.mdiChevronDown
    })
  });
};
var AuraSelect_default = AuraSelect;

// src/components/AuraSpinner/AuraSpinner.tsx
var import_react114 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraSpinner = ({ ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react114.Center, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react114.Spinner, {
      size: "xl",
      color: "blue.500",
      ...props
    })
  });
};
var AuraSpinner_default = AuraSpinner;

// src/components/BackwardNavigation/BackwardNavigation.tsx
var import_react115 = require("@chakra-ui/react");
var import_js18 = require("@mdi/js");
var import_react116 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var BackwardNavigation = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react115.Link, {
    display: "inline-block",
    _hover: {
      textDecoration: "none"
    },
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react115.HStack, {
      alignItems: "center",
      spacing: 1,
      color: "gray.500",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react116.default, {
          size: "20px",
          path: import_js18.mdiChevronLeft
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react115.Text, {
          color: "blue.500",
          fontWeight: 500,
          fontSize: "md",
          letterSpacing: "0.15px",
          as: "span",
          lineHeight: 6,
          children
        })
      ]
    })
  });
};
var BackwardNavigation_default = BackwardNavigation;

// src/components/BlockedDisabledInfo/BlockedDisabledInfo.tsx
var import_react_i18next16 = require("react-i18next");
var import_react117 = require("@chakra-ui/react");
var import_js19 = require("@mdi/js");
var import_react118 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var BlockedDisabledInfo = ({ label }) => {
  const { t } = (0, import_react_i18next16.useTranslation)();
  const showLabel = (0, import_react117.useBreakpointValue)({
    base: false,
    md: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react117.Stack, {
    color: "red.500",
    py: "2px",
    isInline: true,
    spacing: "8px",
    className: "blocked-disabled-info",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react118.default, {
        size: "20px",
        path: import_js19.mdiLockOutline,
        className: "blocked-disabled-info__icon"
      }),
      showLabel && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react117.Text, {
        textStyle: "buttonSmall",
        className: "blocked-disabled-info__label",
        children: t(label)
      })
    ]
  });
};
var BlockedDisabledInfo_default = BlockedDisabledInfo;

// src/components/BoxCollapse/BoxCollapse.tsx
var import_react119 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var BoxCollapse = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react119.Accordion, {
  allowToggle: true,
  ...props
});
var BoxCollapseItem = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react119.AccordionItem, {
  border: 0,
  ...props
});
var BoxCollapseButton = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react119.AccordionButton, {
  pl: 0,
  pr: 3,
  _hover: {
    bg: "initial"
  },
  ...props
});
var BoxCollapseContent = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react119.AccordionPanel, {
  pt: 4,
  px: 0,
  pb: 0,
  ...props
});
var BoxIcon = import_react119.AccordionIcon;

// src/components/Breadcrumbs/Breadcrumbs.tsx
var import_react120 = require("@chakra-ui/react");
var import_react121 = require("@emotion/react");
var import_react122 = __toESM(require("react"));
var import_react123 = __toESM(require("@mdi/react"));
var import_js20 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var Breadcrumbs = ({ items, ...props }) => {
  const theme = (0, import_react121.useTheme)();
  const containerRef = import_react122.default.useRef(null);
  const breadcrumbsRef = import_react122.default.useRef(null);
  const [startShade, setStartShade] = (0, import_react122.useState)(false);
  const [endShade, setEndShade] = (0, import_react122.useState)(false);
  (0, import_react122.useEffect)(() => {
    var _a2;
    if ((_a2 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a2.scroll) {
      containerRef.current.scroll({
        left: 9999,
        behavior: "smooth"
      });
    }
  }, [items]);
  const updateOnScroll = () => {
    const containerWidth = containerRef.current.offsetWidth;
    const breadcrumbsWidth = breadcrumbsRef.current.scrollWidth;
    if (breadcrumbsWidth > containerWidth && containerRef.current.scrollLeft === 0) {
      setStartShade(false);
      setEndShade(true);
    } else if (breadcrumbsWidth > containerWidth && breadcrumbsWidth - containerWidth !== containerRef.current.scrollLeft) {
      setStartShade(true);
      setEndShade(true);
    } else if (breadcrumbsWidth > containerWidth && breadcrumbsWidth - containerWidth === containerRef.current.scrollLeft) {
      setStartShade(true);
      setEndShade(false);
    } else {
      setStartShade(false);
      setEndShade(false);
    }
  };
  (0, import_react122.useLayoutEffect)(() => {
    updateOnScroll();
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react120.Box, {
    className: "breadcrumbs__container",
    position: "relative",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react120.Box, {
      ref: containerRef,
      className: "breadcrumbs__scroll-container",
      css: import_react121.css`
          & {
            -ms-overflow-style: none; /* for Internet Explorer, Edge */
            scrollbar-width: none; /* for Firefox */
            overflow-y: scroll;
          }

          &::-webkit-scrollbar {
            display: none; /* for Chrome, Safari, and Opera */
          }
        `,
      overflowX: "scroll",
      overflowY: "hidden",
      onScroll: updateOnScroll,
      _before: {
        pointerEvents: "none",
        content: "''",
        position: "absolute",
        top: 0,
        right: "75%",
        bottom: 0,
        left: 0,
        backgroundImage: startShade ? `linear-gradient(to left, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
      },
      _after: {
        pointerEvents: "none",
        content: "''",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: "75%",
        backgroundImage: endShade ? `linear-gradient(to right, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react120.Breadcrumb, {
        ref: breadcrumbsRef,
        height: "24px",
        display: "flex",
        alignItems: "center",
        className: "breadcrumbs",
        whiteSpace: "nowrap",
        color: "crmBlue",
        separator: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react123.default, {
          path: import_js20.mdiChevronRight,
          size: "20px"
        }),
        children: items.map((item, index) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react120.BreadcrumbItem, {
            className: "breadcrumbs__item",
            fontSize: "md",
            letterSpacing: "wider",
            children: [
              item.href && !item.fn ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react120.BreadcrumbLink, {
                fontWeight: "medium",
                color: "crmBlue",
                href: item.href,
                children: item.label
              }) : null,
              item.fn && !item.href ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react120.BreadcrumbLink, {
                fontWeight: "medium",
                color: "crmBlue",
                onClick: () => item.fn(item),
                children: item.label
              }) : null,
              !item.href && !item.fn ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react120.BreadcrumbLink, {
                fontWeight: "medium",
                color: "crmBlue",
                href: "#",
                children: item.label
              }) : null
            ]
          }, item.id);
        })
      })
    })
  });
};
var Breadcrumbs_default = Breadcrumbs;

// src/components/ColorPicker/ColorPicker.tsx
var import_react124 = require("react");
var import_react125 = require("@chakra-ui/react");
var import_use_debounce = require("use-debounce");
var import_react_i18next17 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ColorPicker = ({ onChange }) => {
  const initialColor = "";
  const [displayedColor, setDisplayedColor] = (0, import_react124.useState)(initialColor);
  const [color, setColor] = (0, import_react124.useState)(initialColor);
  const handleColor = (e) => {
    const value = e.target.value;
    value.length <= 9 && setColor(value);
    if (value.length === 7 || value.length === 9) {
      setDisplayedColor(value);
      onChange(value);
    }
  };
  const [isNotClicked, setIsNotClicked] = (0, import_react124.useState)(true);
  const debounced = (0, import_use_debounce.useDebouncedCallback)((e) => {
    handleColor(e);
  }, 300);
  const { t } = (0, import_react_i18next17.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react125.FormLabel, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderRadius: "6px",
    border: "1px solid",
    borderColor: "gray.200",
    height: "40px",
    px: "16px",
    className: "color-picker",
    htmlFor: "color_input",
    onClick: () => setIsNotClicked(false),
    children: [
      !isNotClicked && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          color !== "" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Box, {
            w: "24px",
            h: "24px",
            borderRadius: "4px",
            backgroundColor: displayedColor,
            cursor: "pointer",
            mr: "8px",
            className: "color-picker__box-color"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Input, {
            id: "color_input",
            onChange: (e) => debounced(e),
            display: "none",
            type: "color",
            defaultValue: initialColor,
            className: "color-picker__input-color"
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Input, {
        zIndex: color !== "" ? "0" : "-1",
        textStyle: "bodyInput",
        placeholder: t("COLOR_PICKER_CHOOSE_COLOR"),
        value: color,
        onChange: handleColor,
        color: "gray.700",
        variant: "unstyled",
        className: "color-picker__input-text"
      })
    ]
  });
};
var ColorPicker_default = ColorPicker;

// src/components/ConnectedCampaignOpportunity/ConnectedCampaignOpportunity.tsx
var import_react127 = require("react");
var import_react128 = require("@chakra-ui/react");
var import_js21 = require("@mdi/js");
var import_react129 = __toESM(require("@mdi/react"));

// src/components/ConnectedCampaignOpportunity/Milestones/Milestones.tsx
var import_react126 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Milestones = ({
  stage,
  countMilestones,
  ...props
}) => {
  const steps = [...Array(countMilestones).keys()].map((val, index) => {
    if (index <= stage) {
      return "blue.500";
    }
    return "";
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react126.Box, {
    bg: "gray.200",
    borderRadius: 4,
    overflow: "hidden",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react126.List, {
      as: "ul",
      display: "flex",
      flexWrap: "nowrap",
      overflow: "hidden",
      styleType: "none",
      fontSize: "10px",
      maxHeight: "1em",
      m: 0,
      children: steps.map((step, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react126.ListItem, {
        cursor: "pointer",
        flexGrow: 1,
        height: "1em",
        position: "relative",
        color: "white",
        bg: step,
        as: "li",
        userSelect: "none",
        _hover: {
          cursor: "default"
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react126.Box, {
          bg: steps[index !== 0 ? index - 1 : index],
          "data-testid": "single-milestone",
          _before: {
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            backgroundColor: "white",
            transform: "translate(-2px)",
            clipPath: `polygon(
                  40% 0,
                  100% 50%,
                  40% 100%,
                  0% 100%,
                  60% 50%,
                  0% 0%
                )`
          },
          _after: {
            clipPath: `polygon(0 0, 0 100%, 50% 50%)`,
            backgroundColor: "inherit",
            transform: "translateX(-2px)",
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            border: "0 solid transparent"
          },
          display: index === 0 && "none",
          position: "absolute",
          left: 0,
          top: 0,
          as: "span"
        })
      }, index))
    })
  });
};
var Milestones_default = Milestones;

// src/components/ConnectedCampaignOpportunity/ConnectedCampaignOpportunity.tsx
var import_react_i18next18 = require("react-i18next");
var import_react_query9 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var statusCampaignOpportunity = {
  O: {
    color: "gray.100",
    title: "CAMPAIGN_OPPORTUNITY_STATUS_OPEN"
  },
  W: {
    color: "green.500",
    title: "CAMPAIGN_OPPORTUNITY_STATUS_WON"
  },
  L: {
    color: "red.500",
    title: "CAMPAIGN_OPPORTUNITY_STATUS_LOST"
  }
};
var ConnectedCampaignOpportunity = ({
  id,
  index,
  status,
  title,
  company,
  progress,
  campaignId,
  onRemove,
  isReadOnly
}) => {
  var _a2, _b;
  const isMobile = (0, import_react128.useBreakpointValue)({
    base: true,
    lg: false
  });
  const { t } = (0, import_react_i18next18.useTranslation)();
  const [isLoading, setIsLoading] = (0, import_react127.useState)(false);
  const { data: countMilestones, isLoading: isLoadingCountMilestones } = (0, import_react_query9.useQuery)(
    ["campaignPhases", "countStages", campaignId],
    () => api_default.getList("campaign_phases", {
      params: {
        fields: "campaign.id",
        "setting[with_relations]": true,
        "filter[campaign.id][eq]": campaignId
      }
    }),
    {
      select: (response) => {
        var _a3;
        return (_a3 = response == null ? void 0 : response.data) == null ? void 0 : _a3.length;
      },
      enabled: !!id && !!campaignId
    }
  );
  const handleOnRemove = async () => {
    setIsLoading(true);
    await onRemove();
    setIsLoading(false);
  };
  const removeButton = () => {
    if (typeof onRemove !== "function") {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react128.IconButton, {
      onClick: handleOnRemove,
      "aria-label": "undo chance",
      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react129.default, {
        path: import_js21.mdiLinkVariantOff,
        size: "24px"
      }),
      isLoading,
      className: "connected-opportunity__remove"
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react128.Flex, {
    p: {
      base: "16px 0 16px 8px",
      lg: "24px 0 24px 16px"
    },
    gap: 3,
    flexDirection: { base: "column", lg: "row" },
    alignItems: "center",
    className: "connected-opportunity",
    borderTop: index === 0 ? 0 : 1,
    borderStyle: "solid",
    borderColor: "gray.200",
    w: "100%",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react128.Flex, {
        flexDirection: "row",
        w: "full",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react128.Flex, {
            flexDirection: "column",
            gap: 3,
            sx: {
              ".information__container": {
                fontSize: "13px"
              },
              ".information__container__icon-box": {
                mr: "8px",
                color: "gray.300"
              },
              ".information__link": {
                lineHeight: "20px"
              }
            },
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react128.Badge, {
                bgColor: "red.500",
                backgroundColor: (_a2 = statusCampaignOpportunity[status]) == null ? void 0 : _a2.color,
                px: "36px",
                color: status === "O" ? "gray.700" : "#fff",
                textTransform: "lowercase",
                letterSpacing: "0.4px",
                fontWeight: "600",
                borderRadius: "4px",
                lineHeight: "20px",
                h: "20px",
                alignItems: "center",
                w: "fit-content",
                className: "connected-opportunity__status",
                children: t((_b = statusCampaignOpportunity[status]) == null ? void 0 : _b.title)
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react128.Link, {
                href: `/campaignOpportunity/show/opportunity_id/${id}`,
                color: "crmBlue",
                letterSpacing: "0.5px",
                lineHeight: "24px",
                w: "fit-content",
                fontSize: "15px",
                className: "connected-opportunity__header",
                wordBreak: "break-word",
                children: title
              }),
              (company == null ? void 0 : company.id) && (company == null ? void 0 : company.name) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
                label: company.name,
                link: `/accountCompany/show/company_id/${company.id}`,
                icon: import_js21.mdiOfficeBuilding,
                iconSize: "20px"
              }) : null
            ]
          }),
          isMobile && !isReadOnly ? removeButton() : null
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react128.Flex, {
        h: "fit-content",
        w: "full",
        flexDirection: "row",
        justifyContent: "space-between",
        className: "connected-opportunity__stage",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react128.Flex, {
            flexDirection: "column",
            w: "full",
            gap: 3,
            pe: isMobile ? 0 : 3,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react128.Text, {
                letterSpacing: "0.5px",
                className: "connected-opportunity__stage__title",
                fontSize: "15px",
                children: t(progress.title)
              }),
              !isLoadingCountMilestones && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Milestones_default, {
                stage: progress.value,
                countMilestones,
                className: "connected-opportunity__stage__milestones"
              })
            ]
          }),
          !isMobile && !isReadOnly ? removeButton() : null
        ]
      })
    ]
  });
};
var ConnectedCampaignOpportunity_default = ConnectedCampaignOpportunity;

// src/components/ConnectedDocument/ConnectedDocument.tsx
var import_react130 = require("@chakra-ui/react");
var import_js22 = require("@mdi/js");
var import_react131 = __toESM(require("@mdi/react"));
var import_date_fns7 = require("date-fns");
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedDocument = ({
  name,
  url,
  date,
  onDisconnect
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react130.Stack, {
    className: "connected-document",
    direction: "row",
    align: "center",
    py: 2,
    pl: 4,
    borderBottom: "1px solid",
    borderColor: "gray.200",
    fontSize: "md",
    letterSpacing: "0.5px",
    fontWeight: "400",
    spacing: 1,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react130.Link, {
        className: "connected-document__link",
        flex: 1,
        color: "blue.500",
        lineHeight: "24px",
        href: url,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react130.Box, {
        w: "124px",
        display: { base: "none", md: "block" },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react130.Text, {
          className: "connected-document__date",
          lineHeight: "24px",
          children: (0, import_date_fns7.format)(date, DATE_FORMAT_DOTS)
        })
      }),
      onDisconnect ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react130.IconButton, {
        size: "md",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react131.default, {
          path: import_js22.mdiLinkVariantOff,
          size: "20px"
        }),
        "aria-label": "disconnect",
        onClick: onDisconnect
      }) : null
    ]
  });
};
var ConnectedDocument_default = ConnectedDocument;

// src/components/ConnectedProcess/ConnectedProcess.tsx
var import_react135 = require("@chakra-ui/react");
var import_js23 = require("@mdi/js");
var import_react136 = __toESM(require("@mdi/react"));
var import_react137 = require("react");
var import_react_i18next19 = require("react-i18next");

// src/components/ConnectedProcess/Milestones/Milestones.tsx
var import_react132 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Milestones2 = ({
  maxStages,
  stage,
  color,
  ...props
}) => {
  if (!maxStages) {
    return null;
  }
  const steps = [...Array(maxStages).keys()].map((val, index) => {
    if (index < stage - 1) {
      return "green.500";
    }
    if (index === stage - 1) {
      return `${color}.500`;
    }
    return "";
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react132.Box, {
    bg: "gray.200",
    borderRadius: 4,
    overflow: "hidden",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react132.List, {
      as: "ul",
      display: "flex",
      flexWrap: "nowrap",
      overflow: "hidden",
      styleType: "none",
      fontSize: "10px",
      maxHeight: "1em",
      m: 0,
      children: steps.map((step, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react132.ListItem, {
        cursor: "pointer",
        flexGrow: 1,
        height: "1em",
        position: "relative",
        color: "white",
        bg: step,
        as: "li",
        userSelect: "none",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react132.Box, {
          bg: steps[index !== 0 ? index - 1 : index],
          _before: {
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            backgroundColor: "white",
            transform: "translate(-2px)",
            clipPath: `polygon(
                  40% 0,
                  100% 50%,
                  40% 100%,
                  0% 100%,
                  60% 50%,
                  0% 0%
                )`
          },
          _after: {
            clipPath: `polygon(0 0, 0 100%, 50% 50%)`,
            backgroundColor: "inherit",
            transform: "translateX(-2px)",
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            border: "0 solid transparent"
          },
          display: index === 0 && "none",
          position: "absolute",
          left: 0,
          top: 0,
          as: "span"
        })
      }, index))
    })
  });
};
var Milestones_default2 = Milestones2;

// src/components/ConnectedProcess/TagsList/TagsList.tsx
var import_react134 = require("@chakra-ui/react");

// src/components/SmallTag/SmallTag.tsx
var import_react133 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var SmallTag = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react133.Tag, {
    fontFamily: "body",
    fontWeight: "normal",
    colorScheme: "gray",
    variant: "subtle",
    cursor: "default",
    size: "md",
    ...props
  });
};
var SmallTag_default = SmallTag;

// src/components/ConnectedProcess/TagsList/TagsList.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TagsList = ({ tags, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react134.Wrap, {
    className: "taglist",
    mt: -1,
    flexWrap: "wrap",
    gap: 2,
    ...props,
    children: tags.map((tag, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react134.WrapItem, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SmallTag_default, {
        className: "tag",
        children: tag
      })
    }, index))
  });
};
var TagsList_default = TagsList;

// src/components/ConnectedProcess/ConnectedProcess.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedProcess = ({
  commission,
  index,
  maxStages,
  commissionUserAvatars,
  onRemove
}) => {
  var _a2, _b;
  const { t } = (0, import_react_i18next19.useTranslation)();
  const {
    id,
    commissionName,
    relationName,
    relatedPhase,
    relatedSystemAttributes
  } = commission;
  const [isExpanded, setIsExpanded] = (0, import_react137.useState)(false);
  const [isLoading, setIsLoading] = (0, import_react137.useState)(false);
  const screenPhone = (0, import_react135.useBreakpointValue)({
    base: true,
    md: false
  });
  const screenPc = (0, import_react135.useBreakpointValue)({
    base: false,
    lg: true
  });
  const removeConnectedProcess = async () => {
    setIsLoading(true);
    await onRemove();
    setIsLoading(false);
  };
  const tags = relatedSystemAttributes.find(
    (attribute) => attribute.uuid === "e087dd7a-d926-405d-8511-bd88a1f341a3"
  );
  const description = relatedSystemAttributes.find(
    (attribute) => attribute.uuid === "942dd38d-8023-4efc-8c26-b0b535a241d4"
  );
  const tagsValue = tags ? tags.value : [];
  const descriptionValue = description ? description.value : null;
  const commissionWithAvatar = commissionUserAvatars == null ? void 0 : commissionUserAvatars.find(
    (c) => c.id === commission.id
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react135.Flex, {
    className: "connected-process",
    role: "group",
    wrap: "wrap",
    justify: "space-evenly",
    align: "center",
    w: "100%",
    p: "24px 12px 24px 16px",
    flexDirection: "column",
    borderTop: index === 0 ? 0 : 1,
    borderStyle: "solid",
    borderColor: "gray.200",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react135.Flex, {
        width: "100%",
        justify: "space-between",
        align: "center",
        gap: "4px",
        children: [
          ((_a2 = commissionWithAvatar == null ? void 0 : commissionWithAvatar.user) == null ? void 0 : _a2.fullName) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Tooltip, {
            label: commissionWithAvatar.user.fullName,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Avatar, {
              size: "sm",
              name: commissionWithAvatar.user.fullName,
              src: getImageUrl((_b = commissionWithAvatar == null ? void 0 : commissionWithAvatar.user) == null ? void 0 : _b.avatar, "thmb")
            })
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Avatar, {
            className: "connected-process__avatar",
            size: "sm"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react135.Flex, {
            px: "8px",
            justify: "center",
            wrap: "wrap",
            textAlign: "center",
            w: 40,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Link, {
                className: "connected-process__name",
                wordBreak: "break-word",
                color: "crmBlue",
                href: `/commission/show/commission_id/${id}`,
                children: !commissionName || commissionName.trim().length === 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react135.Text, {
                  as: "span",
                  color: "gray.600",
                  children: [
                    "[",
                    t("NO_NAME"),
                    "]"
                  ]
                }) : commissionName
              }),
              relationName && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Badge, {
                className: "connected-process__relation",
                width: "100%",
                mx: 4,
                mt: "12px",
                textTransform: "initial",
                variant: "subtle",
                colorScheme: "gray",
                whiteSpace: "normal",
                textStyle: "caption",
                fontWeight: "400",
                children: t(relationName)
              })
            ]
          }),
          screenPc && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessMilestones, {
            relatedPhase,
            maxStages
          }),
          !screenPhone && (tagsValue == null ? void 0 : tagsValue.length) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessTags, {
            tags: tagsValue
          }) : null,
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react135.Stack, {
            isInline: true,
            align: "center",
            spacing: "12px",
            children: [
              onRemove && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Box, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.IconButton, {
                  className: "connected-process__remove",
                  "aria-label": "connected-process__remove",
                  isDisabled: isLoading,
                  isLoading,
                  size: "md",
                  variant: "solid",
                  icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react136.default, {
                    path: import_js23.mdiLinkVariantOff,
                    size: "24px"
                  }),
                  onClick: () => removeConnectedProcess(),
                  px: "8px"
                })
              }),
              descriptionValue && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.IconButton, {
                className: "connected-process__description-dropdown",
                "aria-label": "connected-process__description-dropdown",
                size: "md",
                variant: "ghost",
                onClick: () => setIsExpanded(!isExpanded),
                icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react136.default, {
                  path: isExpanded ? import_js23.mdiChevronUp : import_js23.mdiChevronDown,
                  size: "20px"
                })
              })
            ]
          })
        ]
      }),
      !screenPc && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessMilestones, {
        relatedPhase,
        maxStages
      }),
      screenPhone && (tagsValue == null ? void 0 : tagsValue.length) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessTags, {
        tags: tagsValue
      }) : null,
      descriptionValue && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Box, {
        w: "full",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Collapse, {
          in: isExpanded,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react135.Stack, {
            className: "connected-process__description",
            w: "full",
            spacing: "8px",
            mt: "24px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Text, {
                fontWeight: "semibold",
                as: "p",
                children: "Opis zlecenia"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Text, {
                whiteSpace: "pre-wrap",
                as: "p",
                children: descriptionValue
              })
            ]
          })
        })
      })
    ]
  });
};
var ConnectedProcessMilestones = ({ relatedPhase, maxStages }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react135.Box, {
    className: "connected-process__milestones",
    maxW: "full",
    flex: 1,
    w: { base: "full", lg: "initial" },
    mt: { base: "24px", lg: 0 },
    px: { base: 0, lg: "8px" },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Text, {
        as: "p",
        whiteSpace: "pre-wrap",
        maxW: "full",
        children: relatedPhase.phaseName
      }),
      (relatedPhase.stage || relatedPhase.color !== "") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Milestones_default2, {
        mt: "12px",
        maxStages,
        stage: relatedPhase.stage,
        color: relatedPhase.color
      })
    ]
  });
};
var ConnectedProcessTags = ({ tags }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react135.Box, {
    className: "connected-process__tags",
    flex: 1,
    mt: { base: "24px", md: 0 },
    px: { base: 0, md: "8px" },
    w: "full",
    children: tags && tags.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagsList_default, {
      tags
    })
  });
};
var ConnectedProcess_default = ConnectedProcess;

// src/components/ConnectedServicedProduct/ConnectedServicedProduct.tsx
var import_react138 = require("@chakra-ui/react");
var import_react139 = require("react");
var import_js24 = require("@mdi/js");
var import_react140 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedServicedProduct = ({
  id,
  serialCode,
  productName,
  onRemove,
  hasDeleteCredential = true
}) => {
  const [isLoading, setIsLoading] = (0, import_react139.useState)(false);
  const removeConnectedServicedProduct = () => {
    setIsLoading(true);
    onRemove();
  };
  const baseStyleText = {
    flex: 1,
    color: "blue.500",
    isTruncated: true
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react138.Flex, {
    className: "connected-serviced-product",
    borderBottom: "1px solid",
    borderColor: "gray.200",
    ps: "16px",
    py: "8px",
    textStyle: "bodyInput",
    alignItems: "center",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react138.Text, {
        className: "connected-serviced-product__serial-code",
        mr: "16px",
        ...baseStyleText,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react138.Link, {
          href: `/servicedProduct/show/serviced_product_id/${id}`,
          children: serialCode
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react138.Text, {
        className: "connected-serviced-product__product-name",
        mr: "8px",
        ...baseStyleText,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react138.Link, {
          href: `/servicedProduct/show/serviced_product_id/${id}`,
          children: productName
        })
      }),
      hasDeleteCredential && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react138.IconButton, {
        className: "connected-serviced-product__remove",
        "aria-label": "connected-serviced-product__remove",
        variant: "solid",
        isDisabled: isLoading,
        isLoading,
        size: "md",
        onClick: removeConnectedServicedProduct,
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react140.default, {
          path: import_js24.mdiLinkVariantOff,
          size: "24px"
        })
      })
    ]
  });
};
var ConnectedServicedProduct_default = ConnectedServicedProduct;

// src/components/ConnectedTaskAndEvent/ConnectedTaskAndEvent.tsx
var import_react145 = require("react");
var import_react146 = require("@chakra-ui/react");
var import_react147 = __toESM(require("@mdi/react"));
var import_js27 = require("@mdi/js");
var import_date_fns8 = require("date-fns");

// src/components/ConnectedTaskAndEvent/TaskAndEventIcon/TaskAndEventIcon.tsx
var import_react141 = require("@chakra-ui/react");
var import_react142 = __toESM(require("@mdi/react"));
var import_js25 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var TaskAndEventIcon = ({
  icon,
  iconColor,
  typeName
}) => {
  const STANDARD_ICONS2 = {
    default: import_js25.mdiHelp,
    "glyphicon-phone-alt": import_js25.mdiPhone,
    "glyphicon-star": import_js25.mdiStar,
    "glyphicon-briefcase": import_js25.mdiBriefcase,
    "glyphicon-flag": import_js25.mdiFlagVariant,
    "glyphicon-fire": import_js25.mdiFire
  };
  const standardIconKey = !icon ? "default" : Object.keys(STANDARD_ICONS2).find((key) => icon.match(key));
  if (standardIconKey) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react141.Tooltip, {
      label: typeName,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react141.Circle, {
        size: "24px",
        bg: "transparent",
        border: "1px solid #CBD5E0",
        me: "16px",
        className: "connected-task-and-event__type-icon",
        color: iconColor ?? "#2D3748",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react142.default, {
          path: STANDARD_ICONS2[standardIconKey],
          size: "15px"
        })
      })
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react141.Box, {
      display: "inline-block",
      className: "connected-task-and-event__type-icon",
      dangerouslySetInnerHTML: {
        __html: `<span style="fill: ${iconColor}" title="${typeName}">${icon}</span>`
      },
      p: "0",
      me: "16px"
    });
  }
};
var TaskAndEventIcon_default = TaskAndEventIcon;

// src/components/ConnectedTaskAndEvent/ResponsibleUnit/ResponsibleUnit.tsx
var import_react143 = require("@chakra-ui/react");
var import_react144 = __toESM(require("@mdi/react"));
var import_js26 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var ResponsibleUnit = ({ data, type }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react143.Flex, {
    alignItems: "flex-start",
    color: "gray.300",
    mt: "8px",
    className: "connected-task-and-event__responsible-unit",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react143.Box, {
        boxSize: "20px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react144.default, {
          size: "20px",
          path: type === "company" ? import_js26.mdiOfficeBuildingOutline : import_js26.mdiAccountOutline
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react143.Flex, {
        justifyContent: "flex-start",
        flexDir: "column",
        children: data.map((el, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react143.Text, {
          fontStyle: "caption",
          fontSize: "13px",
          color: "crmBlue",
          ms: "8px",
          letterSpacing: "0.25px",
          mt: index > 0 && "8px",
          mb: "0",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react143.Link, {
            href: type === "company" ? `/accountCompany/show/company_id/${el.id}` : `/accountUser/show/user_id/${el.id}`,
            children: el.fullName
          })
        }, index))
      })
    ]
  });
};
var ResponsibleUnit_default = ResponsibleUnit;

// src/components/ConnectedTaskAndEvent/ConnectedTaskAndEvent.tsx
var import_react_i18next20 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedTaskAndEvent = ({
  isTask,
  isExecutable,
  taskName,
  taskDescription,
  user,
  contractorUsers = [],
  companies = [],
  date,
  type,
  handleEditTaskAura,
  handleCompleteTaskAura,
  ...props
}) => {
  const { currentLocale } = useLanguage();
  const { t } = (0, import_react_i18next20.useTranslation)();
  const [isTooltipActive, setTooltipActive] = (0, import_react145.useState)(true);
  const isMobileScreen = (0, import_react146.useBreakpointValue)({
    base: true,
    lg: false
  });
  const dateToDisplay = date ? (0, import_date_fns8.formatDistanceToNow)(new Date(date), {
    locale: currentLocale,
    addSuffix: true,
    includeSeconds: true
  }) : "";
  const dateTooltipDisplay = (0, import_date_fns8.format)(new Date(date), DATETIME_FORMAT_DOTS);
  const isExpired = isTask && (0, import_date_fns8.isPast)(new Date(date));
  const descriptionToDisplay = stripHtmlTags(taskDescription ?? "");
  const userName = user ? user.fullName : "";
  const ref = (0, import_react145.useRef)();
  (0, import_react146.useOutsideClick)({
    ref,
    handler: () => setTooltipActive(true)
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react146.HStack, {
    alignItems: "flex-start",
    className: "connected-task-and-event",
    position: "relative",
    py: "12px",
    ps: "16px",
    pe: { base: "16px", lg: "52px" },
    borderBottom: "solid 1px",
    borderBottomColor: "gray.200",
    ...props,
    children: [
      !isMobileScreen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Tooltip, {
        label: `${userName}`,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Avatar, {
          size: "sm",
          name: `${userName}`,
          src: getImageUrl(user == null ? void 0 : user.avatar, "thmb"),
          me: "12px",
          mt: "32px",
          className: "connected-task-and-event__avatar"
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react146.Box, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Tooltip, {
            label: dateTooltipDisplay,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Badge, {
              backgroundColor: isExpired ? "red.500" : "gray.100",
              color: isExpired ? "#ffffff" : "gray.700",
              fontWeight: "400",
              letterSpacing: "0.25px",
              lineHeight: "20px",
              textTransform: "lowercase",
              borderRadius: "4px",
              px: "8px",
              mb: { base: "8px", lg: "12px" },
              className: "connected-task-and-event__time-ago",
              children: dateToDisplay
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react146.Flex, {
            alignItems: "center",
            children: [
              isMobileScreen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Avatar, {
                size: "sm",
                name: `${userName}`,
                src: getImageUrl(user == null ? void 0 : user.avatar, "thmb"),
                me: "16px",
                className: "connected-task-and-event__avatar"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TaskAndEventIcon_default, {
                icon: type == null ? void 0 : type.icon,
                iconColor: type == null ? void 0 : type.iconColor,
                typeName: type == null ? void 0 : type.typeName
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Text, {
                fontStyle: "subtitleLabel",
                letterSpacing: "0.15px",
                className: "connected-task-and-event__task-name",
                mb: "0",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Link, {
                  onClick: () => handleEditTaskAura(),
                  children: taskName
                })
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Text, {
            mt: { base: "8px", lg: "12px" },
            className: "connected-task-and-event__task-description",
            noOfLines: 1,
            mb: "0",
            children: descriptionToDisplay
          }),
          contractorUsers.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ResponsibleUnit_default, {
            data: contractorUsers,
            type: "user"
          }),
          companies.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ResponsibleUnit_default, {
            data: companies,
            type: "company"
          })
        ]
      }),
      isTask && isExecutable ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.Tooltip, {
        label: isTooltipActive ? t("EXECUTE") : "",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.IconButton, {
          ref,
          boxSize: "40px",
          position: "absolute",
          right: "0",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "crmBlue",
          color: "#ffffff",
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react147.default, {
            path: import_js27.mdiCalendarCheckOutline,
            size: "24px"
          }),
          onClick: () => {
            handleCompleteTaskAura();
            setTooltipActive(false);
          },
          "aria-label": "connected-task-and-event__button",
          className: "connected-task-and-event__button"
        })
      }) : null
    ]
  });
};
var ConnectedTaskAndEvent_default = ConnectedTaskAndEvent;

// src/components/CookieNotice/CookieNotice.tsx
var import_react148 = require("@chakra-ui/react");
var import_react_i18next21 = require("react-i18next");
var import_react_query10 = require("react-query");
var import_js28 = require("@mdi/js");
var import_react149 = __toESM(require("@mdi/react"));
var import_react150 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var localStorageName = "AuraCookiesAccepted";
var CookieNotice = () => {
  var _a2, _b;
  const cookiesAccepted = localStorage.getItem(localStorageName);
  const [isOpen, setIsOpen] = (0, import_react150.useState)(false);
  const { data: cookieTemplateContent } = (0, import_react_query10.useQuery)(
    ["getCookieNoticeTemplate"],
    () => api_default.getTemplates({
      params: {
        fields: "name,value,type",
        "filter[type][eq]": 68,
        "page[limit]": 1
      }
    }),
    {
      enabled: Boolean(!cookiesAccepted),
      refetchOnWindowFocus: false
    }
  );
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleAcceptCookies = () => {
    localStorage.setItem(localStorageName, "true");
    handleClose();
  };
  const notificationContent = (_b = (_a2 = cookieTemplateContent == null ? void 0 : cookieTemplateContent.data) == null ? void 0 : _a2[0]) == null ? void 0 : _b.value;
  (0, import_react150.useEffect)(() => {
    setIsOpen(notificationContent ? true : false);
  }, [notificationContent]);
  if (cookiesAccepted || !notificationContent) {
    return null;
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react148.Popover, {
      returnFocusOnClose: false,
      isOpen,
      placement: "right",
      closeOnBlur: false,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.PopoverTrigger, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {})
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.Portal, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.PopoverContent, {
            position: "fixed",
            bottom: "0",
            w: "full",
            className: "cookie-notice",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NotificationBar, {
              content: notificationContent,
              acceptOnClick: handleAcceptCookies,
              onClose: handleClose
            })
          })
        })
      ]
    });
  }
};
var buttonProps = {
  fontWeight: 600,
  fontSize: "15px",
  letterSpacing: "0.15px",
  lineHeight: "24px"
};
var NotificationBar = ({
  content,
  acceptOnClick,
  onClose
}) => {
  const { t } = (0, import_react_i18next21.useTranslation)();
  const showIcon = (0, import_react148.useBreakpointValue)({
    base: false,
    md: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.Flex, {
    className: "cookie-notice__notification-bar",
    w: "100vw",
    py: "16px",
    px: "24px",
    backgroundColor: "gray.100",
    justifyContent: "center",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react148.Flex, {
      maxW: { base: "full", lg: "1530px" },
      alignItems: "center",
      gap: "16px",
      direction: { base: "column", lg: "row" },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react148.Stack, {
          spacing: "20px",
          isInline: true,
          children: [
            showIcon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react149.default, {
              className: "cookie-notice__icon",
              path: import_js28.mdiAlertCircle,
              size: "24px",
              style: {
                minWidth: "24px",
                marginTop: "4px"
              }
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.Text, {
              className: "cookie-notice__content",
              fontSize: "18px",
              fontWeight: 400,
              lineHeight: "32px",
              letterSpacing: "0.15px",
              dangerouslySetInnerHTML: { __html: content },
              sx: { p: { mb: "0" } }
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react148.Flex, {
          className: "cookie-notice__buttons",
          direction: { base: "column-reverse", md: "row" },
          alignSelf: { base: "end", lg: "center" },
          width: { base: "full", md: "initial" },
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.Button, {
              className: "cookie-notice__button-remember-later",
              onClick: () => {
                onClose();
              },
              variant: "ghost",
              ...buttonProps,
              children: t("COOKIE_NOTICE_REMEMBER_LATER")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.Button, {
              className: "cookie-notice__button-accept",
              onClick: () => {
                acceptOnClick();
              },
              variant: "solid",
              backgroundColor: "blue.500",
              color: "white",
              ...buttonProps,
              children: t("COOKIE_NOTICE_ACCEPT")
            })
          ]
        })
      ]
    })
  });
};
var CookieNotice_default = CookieNotice;

// src/components/CredentialsCompact/CredentialsCompact.tsx
var import_react151 = require("@chakra-ui/react");
var import_js29 = require("@mdi/js");
var import_react152 = __toESM(require("@mdi/react"));
var import_lib = require("@questy/lib");
var import_react153 = __toESM(require("react"));
var import_react_i18next22 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var getCredentialToSet = (profiles, profileId, credential) => {
  var _a2;
  const isAccountUserProfile = ((_a2 = profiles.find((p) => p.id === profileId)) == null ? void 0 : _a2.userType) === 2 /* AccountUser */;
  return isAccountUserProfile && credential === import_lib.FieldCredential.Edit ? import_lib.FieldCredential.Show : credential;
};
var CredentialsCompact = ({
  credentials,
  isReadOnly,
  onCredentialChange,
  profiles = [],
  ...props
}) => {
  var _a2;
  const { t } = (0, import_react_i18next22.useTranslation)();
  const [currentCredentials, setCurrentCredentials] = import_react153.default.useState(credentials);
  const [selectedProfiles, setSelectedProfiles] = import_react153.default.useState();
  const [selectedCredential, setSelectedCredential] = import_react153.default.useState(import_lib.FieldCredential.Show);
  const handleCredentialChange = (credential, profileId) => {
    const credentialToSet = getCredentialToSet(profiles, profileId, credential);
    const newCredentials = currentCredentials.map((c) => {
      if (c.profile === profileId) {
        return {
          ...c,
          credential: credentialToSet
        };
      }
      return c;
    });
    setCurrentCredentials(newCredentials);
  };
  const handleAddCredentials = (profileId, credential) => {
    setCurrentCredentials((credentials2) => {
      const newCredentials = [...credentials2];
      profileId == null ? void 0 : profileId.forEach((profileId2) => {
        const credentialToSet = getCredentialToSet(
          profiles,
          profileId2,
          credential
        );
        const credentialIndex = newCredentials.findIndex(
          (credential2) => credential2.profile === profileId2
        );
        if (credentialIndex === -1) {
          newCredentials.push({
            profile: profileId2,
            credential: credentialToSet
          });
        } else {
          newCredentials[credentialIndex].credential = credentialToSet;
        }
      });
      return newCredentials;
    });
    setSelectedCredential(import_lib.FieldCredential.Show);
  };
  const options = (0, import_react153.useMemo)(() => {
    let groupedOptions = [
      {
        label: t("CREDENTIAL_PROFILE_GROUP_USER_USER"),
        options: []
      },
      {
        label: t("CREDENTIAL_PROFILE_GROUP_ACCOUNT_USER"),
        options: []
      }
    ];
    profiles.forEach((profile) => {
      if (profile.userType === 2 /* AccountUser */) {
        groupedOptions[1].options.push({
          value: profile.id,
          label: profile.profileName
        });
      }
      if (profile.userType === 1 /* UserUser */) {
        groupedOptions[0].options.push({
          value: profile.id,
          label: profile.profileName
        });
      }
    });
    return groupedOptions;
  }, [profiles, t]);
  const value = (0, import_react153.useMemo)(() => {
    if (!selectedProfiles) {
      return [];
    }
    const selectedUserUserOptions = options[0].options.filter(
      (option) => selectedProfiles.includes(option.value)
    );
    const selectedAccountUserOptions = options[1].options.filter(
      (option) => selectedProfiles.includes(option.value)
    );
    return [...selectedUserUserOptions, ...selectedAccountUserOptions];
  }, [options, selectedProfiles]);
  (0, import_react153.useEffect)(() => {
    onCredentialChange(currentCredentials);
  }, [currentCredentials, onCredentialChange]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react151.Box, {
    maxW: "576px",
    fontSize: "md",
    ...props,
    children: [
      isReadOnly ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react151.FormControl, {
        mb: 14,
        className: "credential-add-control",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.FormLabel, {
            fontSize: "md",
            fontWeight: "medium",
            htmlFor: "credential-add-select",
            children: t("ADD_CREDENTIAL_LABEL")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react151.Wrap, {
            spacing: 4,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.WrapItem, {
                w: { base: "full", md: "unset" },
                flex: 1,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.Box, {
                  width: "full",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                    inputId: "credential-add-select",
                    className: "profile-selector",
                    isClearable: false,
                    isMulti: true,
                    options,
                    value,
                    onChange: (newValue) => {
                      setSelectedProfiles(
                        newValue.map((v) => v.value)
                      );
                    },
                    placeholder: t("CREDENTIAL_PROFILE"),
                    noOptionsMessage: () => t("NO_OPTIONS"),
                    menuPosition: "fixed"
                  })
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.WrapItem, {
                w: { base: "full", md: "unset" },
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react151.Stack, {
                  isInline: true,
                  w: "full",
                  spacing: 4,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react151.Select, {
                      value: selectedCredential,
                      className: "credential-selector",
                      w: { base: "100%", md: "160px" },
                      maxW: { base: "full", md: "160px" },
                      onChange: (e) => {
                        setSelectedCredential(
                          Number(e.target.value)
                        );
                      },
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                          value: import_lib.FieldCredential.Show,
                          children: t("CREDENTIAL_SHOW")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                          value: import_lib.FieldCredential.Edit,
                          children: t("CREDENTIAL_EDIT")
                        })
                      ]
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.IconButton, {
                      colorScheme: "blue",
                      "aria-label": t("ADD_CREDENTIAL"),
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react152.default, {
                        size: 1,
                        path: import_js29.mdiPlus
                      }),
                      onClick: () => handleAddCredentials(selectedProfiles, selectedCredential)
                    })
                  ]
                })
              })
            ]
          })
        ]
      }),
      currentCredentials ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.Stack, {
        spacing: 4,
        className: "credential-list",
        children: (_a2 = currentCredentials == null ? void 0 : currentCredentials.filter((c) => c.credential !== import_lib.FieldCredential.None)) == null ? void 0 : _a2.map((credential) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CredentialRow, {
          isReadOnly,
          profiles,
          credential,
          onCredentialChange: handleCredentialChange
        }, `${credential.profile}${credential.credential}`))
      }) : null
    ]
  });
};
var CredentialRow = ({
  profiles,
  credential,
  isReadOnly,
  onCredentialChange
}) => {
  var _a2;
  const { t } = (0, import_react_i18next22.useTranslation)();
  if (!credential) {
    return null;
  }
  const profileName = (_a2 = profiles.find(
    (profile) => profile.id === credential.profile
  )) == null ? void 0 : _a2.profileName;
  const shouldShowEditCredential = (0, import_react153.useMemo)(
    () => profiles.find((profile) => profile.id === credential.profile).userType === 1 /* UserUser */,
    [credential.profile]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.FormControl, {
    className: "credential-row",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react151.Stack, {
      isInline: true,
      spacing: 4,
      align: "center",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.FormLabel, {
          flex: 1,
          fontWeight: 400,
          htmlFor: `credential-select-${credential.profile}`,
          children: profileName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react151.Select, {
          disabled: isReadOnly,
          id: `credential-select-${credential.profile}`,
          className: "credential-selector",
          maxW: "160px",
          defaultValue: credential.credential,
          onChange: (e) => {
            const newCredential = Number(e.target.value);
            onCredentialChange(newCredential, credential.profile);
          },
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
              value: import_lib.FieldCredential.Show,
              children: t("CREDENTIAL_SHOW")
            }),
            shouldShowEditCredential ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
              value: import_lib.FieldCredential.Edit,
              children: t("CREDENTIAL_EDIT")
            }) : null
          ]
        }),
        isReadOnly ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react151.IconButton, {
          color: "gray.700",
          "aria-label": t("REMOVE_CREDENTIAL"),
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react152.default, {
            size: 1,
            path: import_js29.mdiTrashCanOutline
          }),
          onClick: () => {
            onCredentialChange(import_lib.FieldCredential.None, credential.profile);
          }
        })
      ]
    })
  });
};
var CredentialsCompact_default = CredentialsCompact;

// src/components/CustomCSSReset/CustomCSSReset.tsx
var import_react154 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var CSSReset = () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react154.Global, {
  styles: `
    @layer chakra-reset {
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }
      
      body {
        position: relative;
        min-height: 100%;
        font-feature-settings: "kern";
        margin: 0;
      }
      
        *,
        *::before,
        *::after {
          border-width: 0;
          border-style: solid;
          box-sizing: border-box;
        }
        main {
          display: block;
        }
        hr {
          border-top-width: 1px;
          box-sizing: content-box;
          height: 0;
          overflow: visible;
        }
      
        pre,
        code,
        kbd,
        samp {
          font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
          font-size: 1em;
        }
      
        a {
          background-color: transparent;
          color: inherit;
          text-decoration: inherit;
        }
      
        abbr[title] {
          border-bottom: none;
          text-decoration: underline;
          -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
        }
      
        b,
        strong {
          font-weight: bold;
        }
      
        small {
          font-size: 80%;
        }
      
        sub,
        sup {
          font-size: 75%;
          line-height: 0;
          position: relative;
          vertical-align: baseline;
        }
      
        sub {
          bottom: -0.25em;
        }
      
        sup {
          top: -0.5em;
        }
      
        img {
          border-style: none;
        }
      
        button,
        input,
        optgroup,
        select,
        textarea {
          font-family: inherit;
          font-size: 100%;
          line-height: 1.15;
          margin: 0;
        }
      
        button,
        input {
          overflow: visible;
        }
      
        button,
        select {
          text-transform: none;
        }
      
        button::-moz-focus-inner,
        [type="button"]::-moz-focus-inner,
        [type="reset"]::-moz-focus-inner,
        [type="submit"]::-moz-focus-inner {
          border-style: none;
          padding: 0;
        }
      
        fieldset {
          padding: 0.35em 0.75em 0.625em;
        }
      
        legend {
          box-sizing: border-box;
          color: inherit;
          display: table;
          max-width: 100%;
          padding: 0;
          white-space: normal;
        }
      
        progress {
          vertical-align: baseline;
        }
      
        textarea {
          overflow: auto;
        }
      
        [type="checkbox"],
        [type="radio"] {
          box-sizing: border-box;
          padding: 0;
        }
      
        [type="number"]::-webkit-inner-spin-button,
        [type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none !important;
        }
      
        input[type="number"] {
          -moz-appearance: textfield;
        }
      
        [type="search"] {
          -webkit-appearance: textfield;
          outline-offset: -2px;
        }
      
        [type="search"]::-webkit-search-decoration {
          -webkit-appearance: none !important;
        }
      
        ::-webkit-file-upload-button {
          -webkit-appearance: button;
          font: inherit;
        }
      
        details {
          display: block;
        }
      
        summary {
          display: list-item;
        }
      
        template {
          display: none;
        }
      
        [hidden] {
          display: none !important;
        }
      
        blockquote,
        dl,
        dd,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        hr,
        figure,
        p,
        pre {
          margin: 0;
        }
      
        button {
          background: transparent;
          padding: 0;
        }
      
        fieldset {
          margin: 0;
          padding: 0;
        }
      
        ol,
        ul {
          margin: 0;
          padding: 0;
        }
      
        textarea {
          resize: vertical;
        }
      
        button,
        [role="button"] {
          cursor: pointer;
        }
      
        button::-moz-focus-inner {
          border: 0 !important;
        }
      
        table {
          border-collapse: collapse;
        }
      
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          font-size: inherit;
          font-weight: inherit;
        }
      
        button,
        input,
        optgroup,
        select,
        textarea {
          padding: 0;
          line-height: inherit;
          color: inherit;
        }
      
        img,
        svg,
        video,
        canvas,
        audio,
        iframe,
        embed,
        object {
          display: block;
        }
      
        img,
        video {
          max-width: 100%;
          height: auto;
        }
      
        [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
          outline: none;
          box-shadow: none;
        }
      
        select::-ms-expand {
          display: none;
        }
    }
    `
});
var CustomCSSReset_default = CSSReset;

// src/hooks/useCustomScript.ts
var import_lib2 = require("@questy/lib");
var import_react155 = require("react");
var import_test_utils = __toESM(require("react-dom/test-utils"));
var { waitElement, waitDisappearElement } = require("@questy/wait-element");
var isomorphicUseLayoutEffect = typeof window !== "undefined" ? import_react155.useLayoutEffect : import_react155.useEffect;
var useCustomScript = () => {
  var _a2;
  const appContext = (0, import_react155.useContext)(CustomizerContext);
  const credentials = (0, import_lib2.useCredentials)();
  const auth = (0, import_react155.useContext)(AuthContext);
  const newContext = { [appContext == null ? void 0 : appContext.moduleName]: { ...appContext } };
  let gruppedContext = { ...newContext };
  if (typeof window !== "undefined" && ((_a2 = window.auraCustom) == null ? void 0 : _a2.appContext)) {
    gruppedContext = {
      ...window.auraCustom.appContext,
      ...newContext
    };
  }
  const auraCustom = (0, import_react155.useMemo)(
    () => ({
      appContext: gruppedContext,
      auth,
      credentials,
      waitElement,
      waitDisappearElement,
      trigger: import_test_utils.default.Simulate
    }),
    [gruppedContext, auth, credentials]
  );
  if (typeof window !== "undefined") {
    window.auraCustom = auraCustom;
  }
  isomorphicUseLayoutEffect(() => {
    if (!window.customScript)
      return;
    if (!window.customScriptDone) {
      window.customScript();
      window.customScriptDone = true;
    }
    return () => {
      window.customScriptDone = false;
    };
  }, []);
  isomorphicUseLayoutEffect(() => {
    if (!window.customComponent)
      return;
    if (!window.customComponentDone) {
      window.customComponent(window.customComponentData);
      window.customComponentDone = true;
    }
    return () => {
      window.customComponentDone = false;
    };
  }, []);
};
var useCustomScript_default = useCustomScript;

// src/components/CustomizerInit/CustomizerInit.tsx
var CustomizerInit = () => {
  useCustomScript_default();
  return null;
};
var CustomizerInit_default = CustomizerInit;

// src/components/CustomSelectOption/CustomSelectOption.tsx
var import_react156 = require("@chakra-ui/react");
var import_react_select10 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomSelectOption = (props) => {
  const { data } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select10.components.Option, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.Flex, {
      role: "group",
      direction: "row",
      align: "center",
      w: "100%",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react156.Flex, {
        borderStyle: "solid",
        borderColor: "gray.200",
        width: "100%",
        justify: "flex-start",
        align: "center",
        flexWrap: "nowrap",
        children: [
          (data == null ? void 0 : data.withAvatar) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
            size: "sm",
            showBorder: false,
            name: data.label,
            title: data.label,
            src: getImageUrl(data == null ? void 0 : data.avatar, "thmb") ?? void 0
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react156.Flex, {
            m: 1,
            mx: 3,
            wrap: "wrap",
            direction: "column",
            flex: "1 1 auto",
            overflow: "hidden",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.Text, {
                as: "span",
                children: data.label
              }),
              data.additionalName && data.additionalName.trim().length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.Text, {
                w: "full",
                isTruncated: true,
                color: "gray.400",
                whiteSpace: "nowrap",
                fontSize: 12,
                as: "span",
                title: data.additionalName,
                children: data.additionalName
              })
            ]
          })
        ]
      })
    })
  });
};
var CustomSelectOption_default = CustomSelectOption;

// src/components/DataSelector/DataSelector.tsx
var import_react157 = require("react");
var import_react_i18next23 = require("react-i18next");
var import_react_select11 = __toESM(require("react-select"));
var import_jsx_runtime = require("react/jsx-runtime");
var DataSelector = (0, import_react157.forwardRef)(
  ({
    endpoint,
    labelField,
    valueField,
    fields,
    extraFields,
    options,
    params = {},
    additionalOptionField,
    getFilter,
    value,
    ...props
  }, ref) => {
    const { t } = (0, import_react_i18next23.useTranslation)();
    const [inputValue, setInputValue] = (0, import_react157.useState)("");
    const { data, isLoading } = useMinimalAutoselect_default({
      endpoint,
      labelField,
      valueField,
      fields,
      extraFields,
      filters: getFilter ? getFilter(inputValue) : { [`filter[${labelField}][hasText]`]: inputValue },
      settings: {
        "page[limit]": 10,
        ...params
      },
      enabled: (inputValue == null ? void 0 : inputValue.length) > 0,
      additionalOptionField
    });
    const parsedOptions = (0, import_react157.useMemo)(
      () => buildOptions(data, "value"),
      [data]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select11.default, {
      value: value ?? [],
      ref,
      inputValue,
      options: options ?? parsedOptions,
      ...!options && {
        filterOption: () => true
      },
      isLoading,
      noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
      loadingMessage: () => t("LOADING"),
      className: "data-selector",
      styles: {
        control: (provided, state) => ({
          ...provided,
          boxShadow: state.isFocused ? "none" : provided.boxShadow
        })
      },
      ...props,
      onInputChange: (newValue, action) => {
        setInputValue(newValue);
        if (typeof (props == null ? void 0 : props.onInputChange) === "function") {
          props == null ? void 0 : props.onInputChange(newValue, action);
        }
      }
    });
  }
);
DataSelector.displayName = "DataSelector";
var DataSelector_default = DataSelector;

// src/components/DataSelectorFilter/DataSelectorFilter.tsx
var import_react158 = require("@chakra-ui/react");
var import_react159 = require("react");
var import_react_i18next24 = require("react-i18next");
var import_react_query11 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var useSelectedOptionsFetcher = ({
  endpoint,
  value,
  additionalParams,
  labelKey
}) => {
  const { t } = (0, import_react_i18next24.useTranslation)();
  return (0, import_react_query11.useQuery)(
    [endpoint, value, additionalParams, labelKey],
    () => api_default.getAutoselect(endpoint, {
      params: {
        "filter[id][in]": value,
        fields: labelKey,
        "page[limit]": -1,
        ...additionalParams
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: t(obj[labelKey]),
          value: obj.id
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? dataToReturn : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0 && !!labelKey,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
};
var DataSelectorFilter = ({
  filterName,
  name,
  onChange,
  value,
  selectProps,
  loadDataProps: loadDataProps2,
  ...props
}) => {
  const [isInitialFetching, setIsInitialFetching] = (0, import_react159.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react159.useState)([]);
  const handleSetValue = (value2) => {
    setTempValue(value2);
    const filterValues = (value2 == null ? void 0 : value2.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValues);
  };
  const validAdditionalParams = (0, import_react159.useMemo)(
    () => {
      var _a2, _b;
      return (_b = (_a2 = Object.keys(loadDataProps2.settings)) == null ? void 0 : _a2.filter((key) => key !== "order[_q]")) == null ? void 0 : _b.reduce((obj, key) => {
        obj[key] = loadDataProps2.settings[key];
        return obj;
      }, {});
    },
    [loadDataProps2]
  );
  const { data: selectedOptions, isFetching } = useSelectedOptionsFetcher({
    endpoint: loadDataProps2.endpoint,
    value,
    additionalParams: validAdditionalParams,
    labelKey: loadDataProps2.labelField
  });
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react158.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        isMulti: true,
        loadDataProps: loadDataProps2,
        isLoading: isFetching,
        ...selectProps ? selectProps : {}
      })
    ]
  });
};
var DataSelectorFilter_default = DataSelectorFilter;

// src/components/DateInput/DateInput.tsx
var import_react160 = require("@chakra-ui/react");
var import_js30 = require("@mdi/js");
var import_react161 = __toESM(require("@mdi/react"));
var import_react162 = __toESM(require("react"));
var import_react_i18next25 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var getDefaultDateFormat2 = (withTime) => {
  return withTime ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS;
};
var DateInput = ({
  id,
  value,
  lang = "pl",
  onChange,
  withTime,
  timeIntervals,
  minDate,
  maxDate,
  onBlur,
  onSelect,
  isClearable = true,
  isDisabled = false,
  dateFormat,
  onCalendarClose,
  leftIconPlaceholder,
  ...props
}) => {
  const { currentLocale } = (0, import_react162.useContext)(LanguageContext);
  const { t } = (0, import_react_i18next25.useTranslation)();
  const dateFormatCurrent = dateFormat ?? getDefaultDateFormat2(withTime);
  const clearValue = () => {
    onChange == null ? void 0 : onChange(null, null);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDatePicker_default, {
    popperPlacement: "bottom",
    popperModifiers: [
      {
        name: "preventOverflow",
        options: {
          rootBoundary: "viewport",
          tether: true,
          padding: { right: withTime ? 85 : 0 }
        }
      },
      {
        name: "flip",
        options: {
          fallbackPlacements: ["bottom"],
          allowedAutoPlacements: ["bottom"]
        }
      }
    ],
    minDate,
    maxDate,
    timeIntervals,
    todayButton: t("TODAY"),
    locale: currentLocale,
    showTimeSelect: withTime,
    showYearDropdown: true,
    id,
    selected: value,
    dateFormat: dateFormatCurrent,
    timeCaption: t("TIME"),
    onChange,
    onCalendarClose,
    onBlur,
    onSelect,
    readOnly: isDisabled,
    customInput: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomInput2, {
      loadingLabel: t("LOADING"),
      isClearable,
      clearValue,
      leftIconPlaceholder,
      isDisabled,
      ...props
    })
  });
};
var CustomInput2 = import_react162.default.forwardRef(
  ({
    isDisabled,
    isLoading,
    isClearable,
    loadingLabel,
    size = "md",
    clearValue,
    leftIconPlaceholder,
    ...props
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react160.InputGroup, {
      position: "relative",
      zIndex: 0,
      size,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react160.InputLeftElement, {
          pointerEvents: "none",
          zIndex: 2,
          color: "gray.300",
          children: leftIconPlaceholder ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react160.Text, {
            textStyle: "bodyInput",
            color: "gray.300",
            mb: "0",
            children: leftIconPlaceholder
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react161.default, {
            path: import_js30.mdiCalendarBlankOutline,
            size: "24px",
            style: { color: "gray.300" }
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
          isDisabled,
          isReadOnly: isDisabled,
          type: "text",
          ref,
          pl: "40px",
          ...props
        }),
        isClearable && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react160.InputRightElement, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react160.IconButton, {
            size: "xs",
            variant: "ghost",
            "aria-label": "clear",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react161.default, {
              path: import_js30.mdiClose,
              size: "16px"
            }),
            onClick: clearValue,
            color: "gray.300"
          })
        }),
        isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react160.InputRightElement, {
          title: loadingLabel,
          pointerEvents: "none",
          zIndex: 2,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react160.IconButton, {
            "aria-label": "loading",
            as: "div",
            variant: "ghost",
            isLoading: true
          })
        })
      ]
    });
  }
);
CustomInput2.displayName = "CustomInput";
var DateInput_default = DateInput;

// src/components/DocumentSummary/DocumentSummary.tsx
var import_react_i18next26 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var DocumentSummary = ({
  data = {},
  ...props
}) => {
  const { t } = (0, import_react_i18next26.useTranslation)();
  const preparedValuesTable = Object.entries(data).map(
    ([currency, values], index) => {
      const { valueNetto, valueVat, valueBrutto, paymentPayed } = values;
      const displayValues = [
        { isVisible: isProperty("valueNetto", data), value: valueNetto },
        { isVisible: isProperty("valueVat", data), value: valueVat },
        { isVisible: isProperty("valueBrutto", data), value: valueBrutto },
        { isVisible: isProperty("paymentPayed", data), value: paymentPayed }
      ];
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
            children: currency
          }),
          displayValues.map(
            ({ isVisible, value }, index2) => isVisible && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
              isNumeric: true,
              children: value && formatValue(value)
            }, index2)
          )
        ]
      }, index);
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
    display: "inline-block",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
      width: "auto",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {}),
              isProperty("valueNetto", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("NET_TOTAL")
              }),
              isProperty("valueVat", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("VAT_AMOUNT")
              }),
              isProperty("valueBrutto", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("GROSS_SUM")
              }),
              isProperty("paymentPayed", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("Payment payed")
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
          children: preparedValuesTable == null ? void 0 : preparedValuesTable.map((currency) => currency)
        })
      ]
    })
  });
};
var isProperty = (key, data) => Object.values(data).some((currency) => currency.hasOwnProperty(key));
var formatValue = (number) => {
  return new Intl.NumberFormat("pl-PL", {
    style: "decimal",
    minimumFractionDigits: 2
  }).format(Number(number));
};
var DocumentSummary_default = DocumentSummary;

// src/components/EmptyState/EmptyState.tsx
var import_react163 = require("@chakra-ui/react");
var import_js31 = require("@mdi/js");
var import_react164 = __toESM(require("@mdi/react"));
var import_react_i18next27 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyState = ({
  label,
  isInline,
  mdiIcon,
  ...props
}) => {
  const { t } = (0, import_react_i18next27.useTranslation)();
  const styleProps = isInline ? { spacing: "16px", isInline } : { spacing: "8px" };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react163.Stack, {
    className: "empty-state",
    alignItems: "center",
    w: "full",
    color: "gray.300",
    ...styleProps,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react164.default, {
        className: "empty-state__icon",
        size: "40px",
        path: mdiIcon ?? import_js31.mdiTextBoxSearchOutline
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react163.Text, {
        className: "empty-state__label",
        color: "gray.400",
        fontSize: "15px",
        lineHeight: "24px",
        letterSpacing: "0.5px",
        children: label ? t(label) : t("LIST_EMPTY_HEADING")
      })
    ]
  });
};
var EmptyState_default = EmptyState;

// src/components/ExternalMarker/ExternalMarkerContainer.tsx
var import_react166 = require("@chakra-ui/react");

// src/components/ExternalMarker/ExternalMarkerLabel.tsx
var import_react165 = require("@chakra-ui/react");
var import_react_i18next28 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkerLabel = ({
  externalMarker,
  ...props
}) => {
  const { t } = (0, import_react_i18next28.useTranslation)();
  const isPromoted = externalMarker == null ? void 0 : externalMarker.isPromoted;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react165.Button, {
    as: "span",
    px: "6px",
    py: "0",
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "middle",
    height: "20px",
    whiteSpace: "nowrap",
    borderRadius: "2px",
    fontSize: "xs",
    fontWeight: "600",
    alignSelf: "start",
    letterSpacing: "0.4px",
    backgroundColor: "blue.500",
    className: `product__externalMarker-${externalMarker.symbol}`,
    size: "xs",
    pointerEvents: "none",
    textTransform: "uppercase",
    bgColor: !isPromoted ? "white" : "blue.500",
    borderColor: "blue.500",
    color: isPromoted ? "white" : "blue.500",
    variant: isPromoted ? "solid" : "outline",
    ...props,
    children: externalMarker.label && externalMarker.label !== "" ? t(`${externalMarker.label}`) : externalMarker.symbol
  });
};
var ExternalMarkerLabel_default = ExternalMarkerLabel;

// src/components/ExternalMarker/ExternalMarkerContainer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkerContainer = ({
  externalMarkers,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react166.VStack, {
    minH: "20px",
    spacing: "8px",
    className: "product__externalMarkerContainer",
    w: "full",
    ...props,
    children: externalMarkers == null ? void 0 : externalMarkers.map((externalMarker, index) => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkerLabel_default, {
        externalMarker,
        className: `product__externalMarker-${externalMarker == null ? void 0 : externalMarker.symbol}`
      }, index);
    })
  });
};
var ExternalMarkerContainer_default = ExternalMarkerContainer;

// src/components/FileDetails/FileDetails.tsx
var import_react167 = require("@chakra-ui/react");
var import_js32 = require("@mdi/js");
var import_react168 = __toESM(require("@mdi/react"));
var import_date_fns9 = require("date-fns");
var import_filesize2 = __toESM(require("filesize"));
var import_react_i18next29 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var FileDetails = ({
  file,
  fullWidthPreview,
  onClose,
  ...props
}) => {
  var _a2;
  const { t } = (0, import_react_i18next29.useTranslation)();
  if (!file) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.Box, {
    fontSize: "md",
    className: "file-repository__details",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.Stack, {
        spacing: 4,
        mb: 6,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.Flex, {
            height: {
              base: "248px",
              md: "296px",
              lg: "312px",
              xl: "400px"
            },
            align: "center",
            justify: "center",
            position: "relative",
            className: "details__preview",
            children: [
              isImage(file.mimeType) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Flex, {
                mt: {
                  lg: "64px"
                },
                maxH: "264px",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Image, {
                  objectFit: "contain",
                  width: fullWidthPreview ? "full" : "auto",
                  src: getImageUrl(file.dbName, "big")
                })
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Box, {
                color: "gray.500",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react168.default, {
                  size: "128px",
                  path: import_js32.mdiFile
                })
              }),
              onClose ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.CloseButton, {
                position: "absolute",
                top: 0,
                right: 0,
                size: "lg",
                color: "gray.700",
                onClick: onClose
              }) : null
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Text, {
            fontWeight: "medium",
            children: file.fileName
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Table, {
        w: "unset",
        variant: "unstyled",
        p: 0,
        css: {
          tableLayout: "fixed"
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.Tbody, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__size-label",
                  children: `${t("FILE_REPO_FILE_SIZE")}:`
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__size",
                  children: (0, import_filesize2.default)(file.fileSize)
                })
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__date-created-label",
                  children: `${t("FILE_REPO_DATE_CREATED")}:`
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__date-created",
                  children: file.dateCreate ? (0, import_date_fns9.format)(new Date(file.dateCreate), DATE_FORMAT_DOTS) : "?"
                })
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__author-label",
                  children: `${t("FILE_REPO_AUTHOR")}:`
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__author",
                  "data-testid": "details__author",
                  children: ((_a2 = file == null ? void 0 : file.user) == null ? void 0 : _a2.name) ?? ""
                })
              ]
            })
          ]
        })
      })
    ]
  });
};
var FileDetails_default = FileDetails;

// src/components/FilterFields/TextFilter.tsx
var import_react169 = require("@chakra-ui/react");
var import_debounce2 = __toESM(require("lodash/debounce"));
var import_react170 = require("react");

// src/components/FilterTextInput/FilterTextInput.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FilterTextInput = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
    ...props
  });
};
var FilterTextInput_default = FilterTextInput;

// src/components/FilterFields/TextFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TextFilter = ({
  name,
  filterName,
  value,
  onChange,
  ...props
}) => {
  const [filterValue, setFilterValue] = (0, import_react170.useState)("");
  const handleSetValue = (e) => {
    setFilterValue(e.target.value);
  };
  const handleOnChange = (value2) => {
    onChange(filterName, value2);
  };
  const debouncedHandleOnChange = (0, import_react170.useCallback)(
    (0, import_debounce2.default)(handleOnChange, 650),
    []
  );
  (0, import_react170.useEffect)(() => {
    if (value && typeof value === "string") {
      setFilterValue(value);
    } else {
      setFilterValue("");
    }
  }, [value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react169.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterTextInput_default, {
        id: `input-${filterName}`,
        value: filterValue,
        onChange: handleSetValue,
        onKeyUp: (e) => debouncedHandleOnChange(e.target.value),
        onBlur: (e) => handleOnChange(e.target.value)
      })
    ]
  });
};
var TextFilter_default = TextFilter;

// src/components/FilterFields/NumericFilter.tsx
var import_react172 = require("@chakra-ui/react");
var import_react173 = require("react");
var import_react_i18next30 = require("react-i18next");
var import_react_number_format = __toESM(require("react-number-format"));
var import_use_debounce2 = require("use-debounce");

// src/components/FilterInputSeparator/FilterInputSeparator.tsx
var import_react171 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var FilterInputSeparator = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react171.Text, {
    color: "gray.700",
    as: "span",
    fontSize: "15px",
    lineHeight: "24px",
    fontWeight: 400,
    ...props,
    children: "\u2013"
  });
};
var FilterInputSeparator_default = FilterInputSeparator;

// src/components/FilterFields/NumericFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var commonNumberFormatProps = {
  isNumericString: true,
  decimalSeparator: ",",
  customInput: AuraInput_default,
  textAlign: "center",
  type: "text"
};
var NumericFilter = ({
  name,
  filterName,
  onChange,
  isPrice,
  value,
  ...props
}) => {
  const { t } = (0, import_react_i18next30.useTranslation)();
  const [from, setFrom] = (0, import_react173.useState)("");
  const [to, setTo] = (0, import_react173.useState)("");
  const handleSetValue = (value2, type) => {
    if (type === "from") {
      setFrom(value2);
    }
    if (type === "to") {
      setTo(value2);
    }
  };
  const handleOnChange = (from2, to2) => {
    const values = {};
    if (from2 !== "") {
      values.from = from2;
    }
    if (to2 !== "") {
      values.to = to2;
    }
    onChange(filterName, values);
  };
  (0, import_react173.useEffect)(() => {
    if (!value) {
      setFrom("");
      setTo("");
    }
  }, [value]);
  (0, import_react173.useEffect)(() => {
    if (value == null ? void 0 : value.from) {
      setFrom(value.from.toString());
    } else {
      setFrom("");
    }
  }, [value == null ? void 0 : value.from]);
  (0, import_react173.useEffect)(() => {
    if (value == null ? void 0 : value.to) {
      setTo(value.to.toString());
    } else {
      setTo("");
    }
  }, [value == null ? void 0 : value.to]);
  const debounced = (0, import_use_debounce2.useDebouncedCallback)((from2, to2) => {
    handleOnChange(from2, to2);
  }, 650);
  const showSeparator = (0, import_react172.useBreakpointValue)({
    base: false,
    xl: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react172.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react172.Stack, {
        direction: { base: "column", xl: "row" },
        align: "center",
        justifyContent: "space-evenly",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react172.InputGroup, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react172.InputLeftElement, {
                color: "blackAlpha.500",
                zIndex: "auto",
                children: t("from")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_number_format.default, {
                ...commonNumberFormatProps,
                allowNegative: !isPrice,
                id: `input-${filterName}`,
                value: from,
                onValueChange: (values) => handleSetValue(values.value, "from"),
                onKeyUp: () => debounced(from, to),
                onBlur: () => {
                  handleOnChange(from, to);
                },
                "aria-label": "number input from"
              }),
              isPrice && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CurrencyRightElement, {
                currency: "z\u0142",
                currencyCode: "PLN"
              })
            ]
          }),
          showSeparator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterInputSeparator_default, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react172.InputGroup, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react172.InputLeftElement, {
                color: "blackAlpha.500",
                zIndex: "auto",
                children: t("to")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_number_format.default, {
                ...commonNumberFormatProps,
                allowNegative: !isPrice,
                value: to,
                onValueChange: (values) => handleSetValue(values.value, "to"),
                onKeyUp: () => debounced(from, to),
                onBlur: () => handleOnChange(from, to),
                "aria-label": "number input to"
              }),
              isPrice && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CurrencyRightElement, {
                currency: "z\u0142",
                currencyCode: "PLN"
              })
            ]
          })
        ]
      })
    ]
  });
};
var CurrencyRightElement = ({
  currency,
  currencyCode = "?",
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react172.InputRightElement, {
    color: "gray.400",
    className: "filter__currency",
    "data-currency-code": currencyCode,
    ...props,
    children: currency
  });
};
var NumericFilter_default = NumericFilter;

// src/components/FilterFields/DatetimeFilter.tsx
var import_react174 = require("@chakra-ui/react");
var import_react175 = require("@emotion/react");
var import_debounce3 = __toESM(require("lodash/debounce"));
var import_isNil6 = __toESM(require("lodash/isNil"));
var import_react176 = require("react");
var import_react_i18next31 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var DatetimeFilter = ({
  name,
  filterName,
  onChange,
  value,
  withTime,
  ...props
}) => {
  const { t } = (0, import_react_i18next31.useTranslation)();
  const [from, setFrom] = (0, import_react176.useState)(null);
  const [to, setTo] = (0, import_react176.useState)(null);
  const handleSetValue = (value2, type) => {
    if (type === "from") {
      setFrom(value2);
      handleOnChange(value2, null);
    }
    if (type === "to") {
      setTo(value2);
      handleOnChange(null, value2);
    }
  };
  const handleOnChange = (fromValue, toValue) => {
    const values = {};
    if (fromValue !== null || from !== null) {
      values.from = fromValue ?? from;
    }
    if (toValue !== null || to !== null) {
      values.to = toValue ?? to;
    }
    onChange(filterName, values);
  };
  (0, import_react176.useEffect)(() => {
    if (!value) {
      setFrom(null);
      setTo(null);
    }
  }, [value]);
  (0, import_react176.useEffect)(() => {
    if (value == null ? void 0 : value.from) {
      setFrom(value.from);
    } else {
      setFrom(null);
    }
  }, [value == null ? void 0 : value.from]);
  (0, import_react176.useEffect)(() => {
    if (value == null ? void 0 : value.to) {
      setTo(value.to);
    } else {
      setTo(null);
    }
  }, [value == null ? void 0 : value.to]);
  const debouncedSetFilter = (0, import_react176.useCallback)((0, import_debounce3.default)(handleOnChange, 650), []);
  (0, import_react176.useEffect)(() => {
    debouncedSetFilter(from, to);
  }, [debouncedSetFilter, from, to]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react174.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react174.Stack, {
        direction: "column",
        css: import_react175.css`
          .react-datepicker-wrapper {
            width: 100%;
          }
        `,
        align: "center",
        justifyContent: "space-evenly",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
            value: from,
            id: `input-${filterName}`,
            onChange: (newDate) => handleSetValue(newDate, "from"),
            onSelect: (newDate) => handleSetValue(newDate, "from"),
            onKeyUp: () => debouncedSetFilter(from, to),
            onBlur: () => {
              handleOnChange(from, to);
            },
            "aria-label": "date input from",
            textAlign: "center",
            withTime: (0, import_isNil6.default)(withTime) ? true : withTime,
            leftIconPlaceholder: t("from")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
            value: to,
            onChange: (newDate) => handleSetValue(newDate, "to"),
            onSelect: (newDate) => handleSetValue(newDate, "to"),
            onKeyUp: () => debouncedSetFilter(from, to),
            onBlur: () => handleOnChange(from, to),
            "aria-label": "date input to",
            textAlign: "center",
            withTime: (0, import_isNil6.default)(withTime) ? true : withTime,
            leftIconPlaceholder: t("to")
          })
        ]
      })
    ]
  });
};
var DatetimeFilter_default = DatetimeFilter;

// src/components/FilterFields/BooleanFilter.tsx
var import_react178 = require("@chakra-ui/react");
var import_react_i18next32 = require("react-i18next");

// src/components/FilterFormLabel/FilterFormLabel.tsx
var import_react177 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var FilterFormLabel = ({ htmlFor, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react177.FormLabel, {
    htmlFor,
    color: "gray.700",
    fontWeight: "500",
    isTruncated: true,
    w: "full",
    ...props
  });
};
var FilterFormLabel_default = FilterFormLabel;

// src/components/FilterFields/BooleanFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var BooleanFilter = ({
  name,
  filterName,
  value,
  onChange,
  ...props
}) => {
  const { t } = (0, import_react_i18next32.useTranslation)();
  const handleOnChange = (changeValue) => {
    if (value === changeValue) {
      onChange == null ? void 0 : onChange(filterName, null);
      return;
    }
    onChange == null ? void 0 : onChange(filterName, changeValue);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react178.FormControl, {
    ...props,
    className: "boolean-filter",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react178.Stack, {
        spacing: 4,
        className: "boolean-filter__boolean-box",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react178.Checkbox, {
            size: "lg",
            value: "true",
            isChecked: value === true,
            onChange: () => handleOnChange(true),
            className: "boolean-filter__boolean-box__option",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react178.Text, {
              fontSize: "15px",
              lineHeight: "24px",
              mb: "0",
              children: t("Yes")
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react178.Checkbox, {
            size: "lg",
            value: "false",
            isChecked: value === false,
            onChange: () => handleOnChange(false),
            className: "boolean-filter__boolean-box__option",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react178.Text, {
              fontSize: "15px",
              lineHeight: "24px",
              mb: "0",
              children: t("No")
            })
          })
        ]
      })
    ]
  });
};
var BooleanFilter_default = BooleanFilter;

// src/components/FilterFields/AvailabilityFilter.tsx
var import_react179 = require("@chakra-ui/react");
var import_isFinite = __toESM(require("lodash/isFinite"));
var import_isNumber = __toESM(require("lodash/isNumber"));
var import_react180 = require("react");
var import_react_i18next33 = require("react-i18next");
var import_use_debounce3 = require("use-debounce");
var import_jsx_runtime = require("react/jsx-runtime");
var isValidNumber = (price) => {
  return (0, import_isNumber.default)(+price) && (0, import_isFinite.default)(price);
};
var AvailabilityFilter = ({
  name,
  filterName,
  onChange,
  value,
  ...props
}) => {
  const { t } = (0, import_react_i18next33.useTranslation)();
  const [from, setFrom] = (0, import_react180.useState)("");
  const [to, setTo] = (0, import_react180.useState)("");
  const [notZero, setNotZero] = (0, import_react180.useState)(null);
  const handleSetValue = (value2, type) => {
    if (typeof value2 === "boolean" && type === "notZero") {
      setNotZero(value2);
    }
    if (!isValidNumber(+value2)) {
      return;
    }
    if (type === "from") {
      setFrom(value2);
    }
    if (type === "to") {
      setTo(value2);
    }
  };
  const handleOnChange = (from2, to2, notZero2) => {
    const values = {};
    if (from2 !== "") {
      values.from = from2;
    }
    if (to2 !== "") {
      values.to = to2;
    }
    if (notZero2) {
      values.notZero = notZero2;
    }
    onChange(filterName, values);
  };
  (0, import_react180.useEffect)(() => {
    if (!value) {
      setFrom("");
      setTo("");
      setNotZero(false);
    }
  }, [value]);
  (0, import_react180.useEffect)(() => {
    if (value == null ? void 0 : value.from) {
      setFrom(value.from.toString());
    } else {
      setFrom("");
    }
  }, [value == null ? void 0 : value.from]);
  (0, import_react180.useEffect)(() => {
    if (value == null ? void 0 : value.to) {
      setTo(value.to.toString());
    } else {
      setTo("");
    }
  }, [value == null ? void 0 : value.to]);
  (0, import_react180.useEffect)(() => {
    if (value == null ? void 0 : value.notZero) {
      setNotZero(value.notZero);
    } else {
      setNotZero(false);
    }
  }, [value == null ? void 0 : value.notZero]);
  const debounced = (0, import_use_debounce3.useDebouncedCallback)((from2, to2, notZero2) => {
    handleOnChange(from2, to2, notZero2);
  }, 650);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react179.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react179.Stack, {
        direction: "row",
        align: "center",
        justifyContent: "space-evenly",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react179.InputGroup, {
            size: "sm",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react179.Input, {
              type: "text",
              id: `input-${filterName}`,
              value: from,
              onChange: (e) => handleSetValue(e.target.value, "from"),
              onKeyUp: () => debounced(from, to, notZero),
              onBlur: () => {
                handleOnChange(from, to, notZero);
              },
              "aria-label": "number input from",
              borderRadius: "6px",
              textAlign: "center",
              height: "40px",
              fontSize: "15px"
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterInputSeparator_default, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react179.InputGroup, {
            size: "sm",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react179.Input, {
              type: "text",
              value: to,
              onChange: (e) => handleSetValue(e.target.value, "to"),
              onKeyUp: () => debounced(from, to, notZero),
              onBlur: () => handleOnChange(from, to, notZero),
              "aria-label": "number input to",
              borderRadius: "6px",
              textAlign: "center",
              height: "40px",
              fontSize: "15px"
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react179.Checkbox, {
        mt: 2,
        size: "lg",
        isChecked: notZero,
        onChange: () => handleOnChange(from, to, !notZero),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react179.Text, {
          fontSize: "15px",
          children: t("ONLY_AVAILABLE")
        })
      })
    ]
  });
};
var AvailabilityFilter_default = AvailabilityFilter;

// src/components/FilterFields/UserFilter.tsx
var import_react181 = require("@chakra-ui/react");
var import_react182 = require("react");
var import_react_i18next34 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var UserFilter = ({
  name,
  filterName,
  value,
  onChange,
  endpoint,
  labelField = "fullName",
  valueField = "id",
  ...props
}) => {
  const { t } = (0, import_react_i18next34.useTranslation)();
  const { data } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    extraFields: ["fullName"]
  });
  const [filterValue, setFilterValue] = (0, import_react182.useState)([]);
  const handleChangeFilterValue = (newValue) => {
    const ids = newValue == null ? void 0 : newValue.map((val) => val.value);
    if (!ids) {
      onChange == null ? void 0 : onChange(filterName, null);
    } else {
      setFilterValue(ids);
      onChange == null ? void 0 : onChange(filterName, ids);
    }
  };
  const options = (0, import_react182.useMemo)(() => buildOptions(data, "value"), [data]);
  (0, import_react182.useEffect)(() => {
    const selectedOptions = options.filter(
      (opt) => value == null ? void 0 : value.includes(+opt.value)
    );
    if (selectedOptions) {
      setFilterValue(selectedOptions);
    }
  }, [options, value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react181.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react181.Box, {
        w: "full",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectCheckbox_default, {
          value: filterValue,
          onChange: handleChangeFilterValue,
          classNamePrefix: "Select",
          isMulti: true,
          options,
          placeholder: t("CHOOSE")
        })
      })
    ]
  });
};
var UserFilter_default = UserFilter;

// src/components/ListFilter/ListFilter.tsx
var import_react185 = require("@chakra-ui/react");
var import_debounce4 = __toESM(require("lodash/debounce"));
var import_isEmpty7 = __toESM(require("lodash/isEmpty"));
var import_xor2 = __toESM(require("lodash/xor"));
var import_react186 = require("react");
var import_react_i18next36 = require("react-i18next");

// src/components/FilterFields/MultiFilter/ListPositions/ListPositions.tsx
var import_react183 = require("@chakra-ui/react");
var import_findIndex2 = __toESM(require("lodash/findIndex"));
var import_sortBy2 = __toESM(require("lodash/sortBy"));
var import_react184 = require("react");
var import_react_i18next35 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ListPositions = ({ filterName, value, onChange, positions, maxVisible = 5 }) => {
  const { t } = (0, import_react_i18next35.useTranslation)();
  const [showHidden, setShowHidden] = (0, import_react184.useState)(false);
  const sortedPositions = (0, import_sortBy2.default)(
    positions,
    (el) => -(0, import_findIndex2.default)(value, (v) => v === el.id + "")
  );
  const visiblePostions = sortedPositions.slice(
    0,
    Math.max(maxVisible, value.length)
  );
  const hiddenPositions = sortedPositions.slice(
    Math.max(maxVisible, value.length)
  );
  const arrayOptions = hiddenPositions.length > 0 && !showHidden ? visiblePostions : sortedPositions;
  const shouldTranslateOptions = ["currencyCode"].includes(filterName) ? false : true;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react183.CheckboxGroup, {
      value,
      onChange: (value2) => onChange(value2.map((val) => isNaN(Number(val)) ? val : Number(val))),
      colorScheme: "blue",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react183.Stack, {
        id: `positions-${filterName}`,
        spacing: 4,
        fontSize: "md",
        fontWeight: 400,
        className: "filter-multi__select-box",
        children: [
          arrayOptions == null ? void 0 : arrayOptions.map((pos) => {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react183.Checkbox, {
              pt: "2px",
              size: "lg",
              mb: 0,
              value: "" + pos.id,
              alignItems: "flex-start",
              className: "filter-multi__select-box__option",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react183.Text, {
                fontSize: "15px",
                lineHeight: "24px",
                mt: "-2px",
                mb: "0",
                children: pos.rawValue && pos.rawValue !== "" ? pos.rawValue : shouldTranslateOptions ? t(pos.value) : pos.value
              })
            }, pos.id);
          }),
          hiddenPositions.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react183.Button, {
            w: "full",
            variant: "link",
            fontWeight: 500,
            color: "blue.500",
            fontSize: "sm",
            onClick: () => setShowHidden((state) => !state),
            justifyContent: "flex-start",
            lineHeight: "20px",
            letterSpacing: "0.25px",
            className: "filter-multi__select-box__button",
            mt: "18px !important",
            children: showHidden ? t("FILTER_HIDE_POSITIONS") : `${t("FILTER_SHOW_POSITIONS")} (+${hiddenPositions.length})`
          })
        ]
      })
    })
  });
};
var ListPositions_default = ListPositions;

// src/components/ListFilter/ListFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ListFilter = ({
  name,
  filterName,
  type,
  positions,
  value,
  onChange,
  ...props
}) => {
  const { t } = (0, import_react_i18next36.useTranslation)();
  const [filterValue, setFilterValue] = (0, import_react186.useState)(value ?? []);
  const handleChange = (val) => {
    setFilterValue((oldState) => {
      if (type === "list") {
        const diff = (0, import_xor2.default)(oldState, val);
        const newValue = diff[0] !== (oldState == null ? void 0 : oldState[0]) ? diff : val;
        handleFilterValueChange(newValue);
        return newValue;
      }
      debouncedHandleOnChange(val);
      return val;
    });
  };
  const handleFilterValueChange = (newValue) => {
    onChange(filterName, newValue);
  };
  const handleCheckAllOptions = () => {
    const allOptions = positions.map((position) => position == null ? void 0 : position.id);
    handleChange(allOptions.map((opt) => +opt));
  };
  const handleUncheckAllOptions = () => {
    handleChange([]);
  };
  const debouncedHandleOnChange = (0, import_react186.useCallback)(
    (0, import_debounce4.default)(handleFilterValueChange, 650),
    []
  );
  (0, import_react186.useEffect)(() => {
    if (value) {
      setFilterValue(value);
    } else {
      setFilterValue([]);
    }
  }, [value]);
  const checkBoxValue = (filterValue == null ? void 0 : filterValue.map((val) => "" + val)) ?? [];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react185.FormControl, {
    ...props,
    children: [
      type === "listMulti" ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        children: name
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        htmlFor: `attribute-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react185.Box, {
        color: "crmBlue",
        children: [
          (0, import_isEmpty7.default)(filterValue) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react185.Button, {
            fontWeight: "500",
            fontSize: "sm",
            variant: "link",
            onClick: handleCheckAllOptions,
            mb: "16px",
            color: "blue.500",
            children: t("ATTRIBUTE_CHECK_ALL")
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react185.Button, {
            fontWeight: "500",
            fontSize: "sm",
            variant: "link",
            onClick: handleUncheckAllOptions,
            mb: "16px",
            color: "blue.500",
            children: t("ATTRIBUTE_UNCHECK_ALL")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListPositions_default, {
            filterName,
            positions: positions ?? [],
            value: checkBoxValue,
            onChange: handleChange
          })
        ]
      })
    ]
  });
};
var ListFilter_default = ListFilter;

// src/components/FilterFields/ExternalMarkerFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkerFilter = ({ name, filterName, value, onChange }) => {
  const externalMarkers = useExternalMarkers();
  if (!externalMarkers || externalMarkers.length === 0) {
    return null;
  }
  const parsedMarkers = externalMarkers.map((marker, index) => ({
    id: marker.id,
    value: marker.label,
    rawValue: marker.label && marker.label !== "" ? null : marker.symbol,
    ordering: index
  }));
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilter_default, {
    name,
    filterName,
    value,
    onChange,
    type: "listMulti",
    positions: parsedMarkers
  });
};
var ExternalMarkerFilter_default = ExternalMarkerFilter;

// src/components/FilterFields/MultiFilter/MultiFilter.tsx
var import_react187 = require("@chakra-ui/react");
var import_debounce5 = __toESM(require("lodash/debounce"));
var import_isEmpty8 = __toESM(require("lodash/isEmpty"));
var import_react188 = require("react");
var import_react_i18next37 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var MultiFilter = ({
  name,
  filterName,
  value,
  onChange,
  endpoint,
  labelField,
  valueField = "id",
  positions,
  options,
  filters,
  labelFieldCreator,
  settings,
  relatedModule,
  ...props
}) => {
  var _a2;
  const { t } = (0, import_react_i18next37.useTranslation)();
  const [filterValue, setFilterValue] = (0, import_react188.useState)(value ?? []);
  const [tempValue, setTempValue] = (0, import_react188.useState)([]);
  const [isUpdating, setIsUpdating] = (0, import_react188.useState)(false);
  const appSettings = useSettings_default();
  const newLookListFilterAsTag = (appSettings == null ? void 0 : appSettings.new_look_list_filter_as_tag) ?? ((_a2 = appSettings == null ? void 0 : appSettings.settings) == null ? void 0 : _a2.newLookListFilterAsTag) ?? false;
  const displayAsSelect = (0, import_react188.useMemo)(() => {
    if (relatedModule === "attributes") {
      return options == null ? void 0 : options.filterAsTags;
    } else {
      return newLookListFilterAsTag || newLookListFilterAsTag === "true";
    }
  }, [newLookListFilterAsTag]);
  const { data, isError, isFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    enabled: !positions,
    filters,
    labelFieldCreator,
    settings
  });
  const prepareValueForSelect = (0, import_react188.useMemo)(
    () => {
      var _a3;
      return (_a3 = [...value ?? []]) == null ? void 0 : _a3.map(
        (val) => isNaN(Number(val)) ? val : Number(val)
      );
    },
    [value]
  );
  const { data: defaultValues, isFetching: deafultIsFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    enabled: !!endpoint,
    filters: {
      [`filter[${valueField}][in]`]: prepareValueForSelect == null ? void 0 : prepareValueForSelect.join(","),
      ...filters
    },
    labelFieldCreator,
    settings
  });
  const newPositions = data ?? positions;
  const handleChange = (val) => {
    setTempValue(val);
    setIsUpdating(true);
    setFilterValue((oldState) => {
      if (displayAsSelect) {
        debouncedHandleOnChange(val == null ? void 0 : val.map((item) => item.value));
      } else {
        debouncedHandleOnChange(val);
      }
      return val;
    });
  };
  const handleFilterValueChange = (newValue) => {
    onChange(filterName, newValue);
  };
  const handleCheckAllOptions = () => {
    const allOptions = newPositions.map((position) => position == null ? void 0 : position.id);
    handleChange(
      allOptions.map((opt) => isNaN(Number(opt)) ? opt : Number(opt))
    );
  };
  const handleUncheckAllOptions = () => {
    handleChange([]);
  };
  const debouncedHandleOnChange = (0, import_react188.useCallback)(
    (0, import_debounce5.default)(handleFilterValueChange, 650),
    []
  );
  const selectOptions = (0, import_react188.useMemo)(() => {
    const options2 = buildOptions(newPositions, "value", "id");
    return options2 == null ? void 0 : options2.map((opt) => ({
      ...opt,
      label: t(opt.label)
    }));
  }, [newPositions]);
  const selectValue = (0, import_react188.useMemo)(() => {
    const value2 = !!endpoint ? buildOptions(defaultValues, "value", "id") : selectOptions == null ? void 0 : selectOptions.filter(
      (item) => prepareValueForSelect == null ? void 0 : prepareValueForSelect.includes(item.value)
    );
    setIsUpdating(false);
    return value2 == null ? void 0 : value2.map((val) => ({
      ...val,
      label: t(val.label)
    }));
  }, [prepareValueForSelect, defaultValues]);
  const defaultCheckBoxValue = (filterValue == null ? void 0 : filterValue.map((val) => "" + val)) ?? [];
  (0, import_react188.useEffect)(() => {
    if (value == null ? void 0 : value.length) {
      if (displayAsSelect) {
        setFilterValue(selectValue);
      } else {
        setFilterValue(value);
      }
    } else {
      setFilterValue([]);
    }
  }, [value, selectValue]);
  if (isError) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react187.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        children: t(name)
      }),
      !displayAsSelect && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.Box, {
        mb: 4,
        children: (0, import_isEmpty8.default)(filterValue) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.Button, {
          className: "check-all-button",
          fontSize: "sm",
          variant: "link",
          onClick: handleCheckAllOptions,
          color: "blue.500",
          fontWeight: 500,
          lineHeight: "20px",
          children: t("ATTRIBUTE_CHECK_ALL")
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.Button, {
          className: "uncheck-all-button",
          fontSize: "sm",
          variant: "link",
          onClick: handleUncheckAllOptions,
          color: "blue.500",
          fontWeight: 500,
          lineHeight: "20px",
          children: t("ATTRIBUTE_UNCHECK_ALL")
        })
      }),
      displayAsSelect ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        value: isUpdating ? tempValue : selectValue ?? [],
        onChange: handleChange,
        classNamePrefix: "Select",
        isMulti: true,
        options: selectOptions,
        isLoading: isFetching || deafultIsFetching
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListPositions_default, {
        filterName,
        positions: newPositions ?? [],
        value: defaultCheckBoxValue,
        onChange: handleChange
      })
    ]
  });
};
var MultiFilter_default = MultiFilter;

// src/components/FilterFields/TagFilter.tsx
var import_react189 = require("@chakra-ui/react");
var import_react190 = require("react");
var import_react_i18next38 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var TagFilter = ({
  name,
  filterName,
  value,
  onChange,
  endpoint,
  labelField = "fullName",
  valueField = "id",
  filters,
  ...props
}) => {
  const { t } = (0, import_react_i18next38.useTranslation)();
  const [inputValue, setInputValue] = (0, import_react190.useState)();
  const [filterValue, setFilterValue] = (0, import_react190.useState)([]);
  const { data, isFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    settings: { "page[limit]": 20 },
    filters: {
      "filter[_q][hasText]": inputValue,
      "order[_q]": "DESC",
      ...filters
    },
    enabled: !!inputValue
  });
  const { data: defaultValues, isFetching: deafultIsFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    settings: { "page[limit]": -1 },
    filters: {
      "filter[value][in]": value == null ? void 0 : value.join(","),
      ...filters
    },
    enabled: (value == null ? void 0 : value.length) > 0 && (filterValue == null ? void 0 : filterValue.length) == 0
  });
  (0, import_react190.useEffect)(() => {
    setFilterValue(buildOptions(defaultValues, "value"));
  }, [defaultValues]);
  const handleChangeFilterValue = (newValue) => {
    const labels = newValue == null ? void 0 : newValue.map((val) => val.label);
    if (!newValue) {
      onChange == null ? void 0 : onChange(filterName, null);
    } else {
      setFilterValue(newValue);
      onChange == null ? void 0 : onChange(filterName, labels);
    }
  };
  const options = (0, import_react190.useMemo)(() => buildOptions(data, "value"), [data]);
  (0, import_react190.useEffect)(() => {
    const selectedOptions = filterValue.filter(
      (opt) => value == null ? void 0 : value.includes(opt.label)
    );
    if (selectedOptions) {
      setFilterValue(selectedOptions);
    } else {
      setFilterValue(null);
    }
  }, [value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react189.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react189.Box, {
        w: "full",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectCheckbox_default, {
          value: filterValue ?? [],
          onChange: handleChangeFilterValue,
          classNamePrefix: "Select",
          isMulti: true,
          options,
          placeholder: t("CHOOSE"),
          onInputChange: (value2) => setInputValue(value2),
          noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
          loadingMessage: () => t("LOADING"),
          isLoading: isFetching || deafultIsFetching
        })
      })
    ]
  });
};
var TagFilter_default = TagFilter;

// src/components/GalleryItem/GalleryItem.tsx
var import_react208 = require("@chakra-ui/react");
var import_framer_motion = require("framer-motion");
var import_react209 = __toESM(require("react"));

// src/components/NameDisplay/NameDisplay.tsx
var import_react191 = require("@chakra-ui/react");
var import_react192 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var NameDisplay = ({
  id,
  name,
  code,
  displayTooltip = false,
  ...props
}) => {
  const headingRef = (0, import_react192.useRef)();
  const [showTooltip, setShowTooltip] = (0, import_react192.useState)(false);
  (0, import_react192.useEffect)(() => {
    var _a2, _b;
    if (!displayTooltip)
      return;
    let tooltipTimeoutId;
    const widthHeading = headingRef == null ? void 0 : headingRef.current.offsetWidth;
    const widthContainer = (_b = (_a2 = headingRef == null ? void 0 : headingRef.current) == null ? void 0 : _a2.parentNode) == null ? void 0 : _b.offsetWidth;
    if (widthHeading === widthContainer) {
      tooltipTimeoutId = setTimeout(() => setShowTooltip(true), 500);
    }
    return () => {
      if (tooltipTimeoutId) {
        clearTimeout(tooltipTimeoutId);
      }
    };
  }, [headingRef, displayTooltip]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react191.Box, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react191.Tooltip, {
        ref: headingRef,
        label: name,
        isOpen: displayTooltip && showTooltip,
        openDelay: 500,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react191.Heading, {
          className: "product-item-heading-name",
          id: `product-heading-${id}`,
          ref: headingRef,
          display: "inline-block",
          size: "md",
          fontWeight: "normal",
          noOfLines: 1,
          width: "fit-content",
          zIndex: 5,
          children: name
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react191.Text, {
        fontSize: "sm",
        color: "gray.400",
        children: code
      })
    ]
  });
};
var NameDisplay_default = NameDisplay;

// src/components/PriceDisplay/PriceDisplay.tsx
var import_react194 = require("@chakra-ui/react");

// src/hooks/useProductPrice.ts
var import_react193 = require("react");
var getPriceBeforeRebate = (prices, salePriceType, isUserUser) => {
  if (isUserUser) {
    return void 0;
  }
  const purchasePrice = prices == null ? void 0 : prices.find(
    (price) => price.priceLevel === "purchase"
  );
  const defaultPrice = prices == null ? void 0 : prices.find((price) => price.priceLevel === "default");
  if ((defaultPrice == null ? void 0 : defaultPrice[PriceNames[salePriceType]]) > (purchasePrice == null ? void 0 : purchasePrice[PriceNames[salePriceType]])) {
    return defaultPrice == null ? void 0 : defaultPrice[PriceNames[salePriceType]];
  }
};
var getSalePriceUserUser = (prices) => {
  return (prices == null ? void 0 : prices.find((price) => price.priceLevel === "srp")) ?? (prices == null ? void 0 : prices[0]);
};
var getSalePriceAccountUser = (prices) => {
  return prices == null ? void 0 : prices.find((price) => price.priceLevel === "purchase");
};
var useProductPrice = ({ prices }) => {
  const { isUserUser } = (0, import_react193.useContext)(AuthContext);
  const { sell_by_price } = useSettings_default();
  const salePriceUserUser = getSalePriceUserUser(prices);
  const salePriceAccountUser = getSalePriceAccountUser(prices);
  const priceType = isUserUser ? "netto" : sell_by_price;
  const userUserPriceType = PriceNames[priceType];
  const accountUserPriceType = PriceNames[priceType];
  const currency = isUserUser ? salePriceUserUser == null ? void 0 : salePriceUserUser.currencyCode : salePriceAccountUser == null ? void 0 : salePriceAccountUser.currencyCode;
  const salePrice = isUserUser ? salePriceUserUser == null ? void 0 : salePriceUserUser[userUserPriceType] : salePriceAccountUser == null ? void 0 : salePriceAccountUser[accountUserPriceType];
  const beforeRebatePrice = getPriceBeforeRebate(
    prices,
    sell_by_price,
    isUserUser
  );
  return { salePrice, beforeRebatePrice, priceType, currency };
};
var useProductPrice_default = useProductPrice;

// src/components/PriceDisplay/PriceDisplay.tsx
var import_isFinite2 = __toESM(require("lodash/isFinite"));
var import_round = __toESM(require("lodash/round"));
var import_react195 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var PriceDisplay = ({
  prices,
  isGalleryItem,
  ...props
}) => {
  const { salePrice, beforeRebatePrice, priceType, currency } = useProductPrice_default(
    {
      prices
    }
  );
  const discountPercent = () => {
    if (!beforeRebatePrice || !salePrice)
      return null;
    return (0, import_round.default)(
      (beforeRebatePrice - salePrice) / beforeRebatePrice * 100,
      0
    );
  };
  const hasPricesCredential = (0, import_isFinite2.default)(salePrice);
  const beforeRebatePriceWithCurrency = priceFormatter(
    beforeRebatePrice,
    currency,
    {
      formatToParts: true
    }
  );
  const salePriceWithCurrency = priceFormatter(salePrice, currency, {
    formatToParts: true
  });
  const {
    priceValue: beforeRebatePriceValue,
    priceCurrency: beforeRebatePriceCurrency
  } = splitPriceParts(beforeRebatePriceWithCurrency);
  const { priceValue: salePriceValue, priceCurrency: salePriceCurrency } = splitPriceParts(salePriceWithCurrency);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: !isGalleryItem ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react194.Stack, {
      className: "product__price-wrapper",
      spacing: 0,
      ...props,
      children: [
        (0, import_isFinite2.default)(beforeRebatePrice) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
          price: beforeRebatePriceValue,
          currency: beforeRebatePriceCurrency,
          currencyCode: currency,
          discountPercent: discountPercent(),
          fontSize: "md",
          textDecoration: "line-through",
          color: "gray.400"
        }),
        (0, import_isFinite2.default)(salePrice) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
          price: salePriceValue,
          currency: salePriceCurrency,
          currencyCode: currency,
          fontSize: "2xl",
          lineHeight: "36px",
          fontWeight: "500"
        }) : null,
        hasPricesCredential && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Text, {
          className: "product__price-type",
          color: "gray.400",
          fontSize: "sm",
          lineHeight: "20px",
          letterSpacing: "0.25px",
          children: priceType
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react194.Stack, {
      className: `product__price-wrapper-${Math.random()}`,
      justifyContent: "flex-start",
      ...props,
      children: [
        (0, import_isFinite2.default)(beforeRebatePrice) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Flex, {
          w: "full",
          justifyContent: "flex-start",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
            price: beforeRebatePriceValue,
            currency: beforeRebatePriceCurrency,
            currencyCode: currency,
            discountPercent: discountPercent(),
            fontSize: "md",
            textDecoration: "line-through",
            color: "gray.400"
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react194.HStack, {
          alignItems: "flex-end",
          spacing: "0",
          children: [
            (0, import_isFinite2.default)(salePrice) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Box, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
                price: salePriceValue,
                currency: salePriceCurrency,
                currencyCode: currency,
                fontSize: "2xl",
                lineHeight: "36px",
                fontWeight: "500"
              })
            }),
            hasPricesCredential && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Flex, {
              alignItems: "flex-end",
              h: "36px",
              ps: "8px",
              pb: "1px",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Text, {
                className: "product__price-type",
                color: "gray.400",
                fontSize: "sm",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                children: priceType
              })
            })
          ]
        })
      ]
    })
  });
};
var PriceWithCurrency = import_react195.default.memo(
  ({
    price,
    currency,
    currencyCode,
    discountPercent,
    ...props
  }) => {
    const priceValue = price.slice(0, -1);
    const priceDivider = price.slice(-1);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react194.Box, {
      as: "span",
      display: "inline-block",
      className: "product__price-value",
      ...props,
      children: [
        discountPercent > 0 && typeof discountPercent === "number" ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react194.Tag, {
          className: "product__price-percent-discount",
          bgColor: "green.500",
          variant: "success",
          color: "#fff",
          me: "8px",
          fontSize: "md",
          borderRadius: "4px",
          children: [
            discountPercent,
            "%"
          ]
        }) : null,
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Text, {
          as: "span",
          className: "product__price",
          color: "gray.700",
          lineHeight: "24px",
          children: priceValue
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Text, {
          as: "span",
          className: "product__price-divider",
          lineHeight: "24px",
          children: priceDivider
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react194.Text, {
          as: "span",
          className: "product__currency",
          "data-currency-code": currencyCode,
          color: "gray.700",
          lineHeight: "24px",
          children: currency
        })
      ]
    });
  }
);
var PriceDisplay_default = PriceDisplay;

// src/components/ProductAvailability/ProductAvailability.tsx
var import_react196 = require("@chakra-ui/react");
var import_react_i18next39 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ProductAvailability = ({
  availabilities,
  estimatedAvailability,
  ...props
}) => {
  var _a2, _b, _c;
  const { t } = (0, import_react_i18next39.useTranslation)();
  const settings = useSettings_default();
  if (!availabilities && !estimatedAvailability) {
    return null;
  }
  const availabilityNumber = (_a2 = availabilities == null ? void 0 : availabilities.all) == null ? void 0 : _a2.available;
  const availabilityText = estimatedAvailability == null ? void 0 : estimatedAvailability.description;
  const availabilityImage = (_c = (_b = estimatedAvailability == null ? void 0 : estimatedAvailability.image) == null ? void 0 : _b.uris) == null ? void 0 : _c.show;
  const availabilityImageHeight = (settings == null ? void 0 : settings.inventory_thumbnail_height) ? `${settings.inventory_thumbnail_height}px` : "20px";
  const availabilityImageWidth = (settings == null ? void 0 : settings.inventory_thumbnail_width) ? `${settings.inventory_thumbnail_width}px` : "20px";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react196.Stack, {
    color: "gray.600",
    className: "product__availability",
    alignItems: "center",
    direction: "row",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react196.Text, {
        color: "gray.400",
        fontSize: "15px",
        letterSpacing: "mediumWide",
        lineHeight: "24px",
        children: [
          t("PRODUCT_AVAILABILITY"),
          ":"
        ]
      }),
      " ",
      availabilityImage ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react196.Flex, {
        alignItems: "flex-end",
        justifyContent: "center",
        height: availabilityImageHeight,
        width: availabilityImageWidth,
        "data-testid": "availability-image-wrapper",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react196.Image, {
          src: availabilityImage,
          alt: t(availabilityText)
        })
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react196.Text, {
        textTransform: "lowercase",
        children: availabilityText ? t(availabilityText) : availabilityNumber
      })
    ]
  });
};
var ProductAvailability_default = ProductAvailability;

// src/components/ProductEAN/ProductEAN.tsx
var import_react197 = require("@chakra-ui/react");
var import_isString = __toESM(require("lodash/isString"));
var import_react_i18next40 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ProductEAN = ({ ean }) => {
  const { t } = (0, import_react_i18next40.useTranslation)();
  if ((0, import_isString.default)(ean) && ean.length > 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react197.Text, {
      color: "gray.400",
      className: "product__ean",
      sx: {
        "&": {
          span: {
            color: "gray.700"
          }
        }
      },
      children: [
        `${t("PRODUCT_EAN")}: `,
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
          children: ean
        })
      ]
    });
  }
  return null;
};
var ProductEAN_default = ProductEAN;

// src/components/ProductImage/ProductImage.tsx
var import_react198 = require("@chakra-ui/react");
var import_react199 = require("@emotion/react");
var import_react_cool_img = __toESM(require("react-cool-img"));
var import_js33 = require("@mdi/js");
var import_react200 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ProductImage = ({
  defaultImage,
  name,
  externalMarkers = void 0,
  ...props
}) => {
  const imgMd = defaultImage ? getImageUrl(defaultImage.dbName, "md") : "";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react198.Flex, {
    w: "full",
    mx: "auto",
    overflow: "hidden",
    align: "center",
    justify: "center",
    position: "relative",
    bg: "white",
    fontSize: "4xl",
    color: "gray.400",
    css: import_react199.css`
        img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      `,
    ...props,
    children: [
      externalMarkers && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkerContainer_default, {
        externalMarkers,
        position: "absolute",
        top: "0",
        left: "0"
      }),
      defaultImage ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_cool_img.default, {
        src: imgMd,
        alt: name
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react198.Flex, {
        maxH: "98px",
        maxW: "98px",
        w: "100%",
        color: "gray.100",
        alignItems: "center",
        justifyContent: "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.default, {
          path: import_js33.mdiFileImageOutline
        })
      })
    ]
  });
};
var ProductImage_default = ProductImage;

// src/components/ProductQuantitySelector/ProductQuantitySelector.tsx
var import_react205 = require("@chakra-ui/react");
var import_react206 = require("react");
var import_react207 = __toESM(require("@mdi/react"));
var import_js35 = require("@mdi/js");
var import_react_i18next41 = require("react-i18next");

// src/components/QuantitySelector/QuantitySelector.tsx
var import_react203 = require("@chakra-ui/react");
var import_js34 = require("@mdi/js");
var import_react204 = require("react");

// src/components/QuantitySelector/ControlButton/ControlButton.tsx
var import_react201 = require("@chakra-ui/react");
var import_react202 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ControlButton = ({
  increment,
  onClick,
  icon,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react201.IconButton, {
    variant: "ghost",
    "aria-label": "control-quantity-product",
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react202.default, {
      path: icon,
      size: "20px"
    }),
    onClick: () => onClick(increment),
    bgColor: "transparent",
    m: "0",
    ...props
  });
};
var ControlButton_default = ControlButton;

// src/components/QuantitySelector/QuantitySelector.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var QuantitySelector = ({
  value,
  onChange,
  availableQuantity = 1e5,
  controlBtnSizes = "md",
  ...props
}) => {
  const [tempValue, setTempValue] = (0, import_react204.useState)(value);
  const [isInvalid, setIsInvalid] = (0, import_react204.useState)(false);
  const handleOnChange = (e) => {
    const prepareValue = e.target.value && parseInt(e.target.value);
    if (prepareValue <= availableQuantity) {
      setIsInvalid(false);
      setTempValue(prepareValue);
      onChange(prepareValue);
    } else {
      setIsInvalid(true);
    }
  };
  const handleButtonAction = (increment) => {
    let newValue;
    if (increment && tempValue < availableQuantity) {
      newValue = tempValue + 1;
    } else if (!increment && tempValue > 0) {
      newValue = tempValue - 1;
    }
    setTempValue(newValue);
    onChange(newValue);
  };
  (0, import_react204.useEffect)(() => {
    setIsInvalid(false);
  }, []);
  (0, import_react204.useEffect)(() => {
    if (value !== tempValue) {
      setTempValue(value);
    }
  }, [value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react203.HStack, {
    className: "product-quantity__selector",
    borderRadius: "6px",
    border: "1px solid",
    borderColor: "gray.200",
    w: "136px",
    spacing: 0,
    overflow: "hidden",
    width: controlBtnSizes === "lg" ? "154px" : "136px",
    ...isInvalid ? {
      borderColor: "#E53E3E",
      boxShadow: "0 0 0 1px #E53E3E"
    } : {
      borderColor: "gray.200"
    },
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ControlButton_default, {
        onClick: () => handleButtonAction(false),
        increment: false,
        icon: import_js34.mdiMinus,
        borderRight: "1px solid",
        borderColor: "gray.200",
        borderRadius: "0",
        isDisabled: [0, null].includes(tempValue),
        size: controlBtnSizes
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react203.Input, {
        type: "number",
        sx: {
          "-moz-appearance": "textfield"
        },
        border: "none",
        p: "0",
        textAlign: "center",
        value: tempValue,
        onChange: (e) => handleOnChange(e),
        onBlur: () => setIsInvalid(false),
        isDisabled: !availableQuantity
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ControlButton_default, {
        onClick: () => handleButtonAction(true),
        increment: true,
        icon: import_js34.mdiPlus,
        borderLeft: "1px solid",
        borderColor: "gray.200",
        borderRadius: "0",
        isDisabled: tempValue === availableQuantity || !availableQuantity,
        size: controlBtnSizes
      })
    ]
  });
};
var QuantitySelector_default = QuantitySelector;

// src/components/ProductQuantitySelector/ProductQuantitySelector.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ProductQuantitySelector = ({
  productId,
  availableQuantity,
  extendedButton,
  ...props
}) => {
  var _a2, _b;
  const [value, setValue] = (0, import_react206.useState)(availableQuantity > 0 ? 1 : 0);
  const { t } = (0, import_react_i18next41.useTranslation)();
  const isLimitOrderActive = ((_a2 = useSettings_default()) == null ? void 0 : _a2.block_order_with_exceeded_quantity) === "true";
  const finalAvailableQuantity = (0, import_react206.useMemo)(
    () => isLimitOrderActive ? availableQuantity : DEFAULT_LIMIT_AVAILABLE_PRODUCTS,
    [availableQuantity, isLimitOrderActive]
  );
  (0, import_react206.useEffect)(() => {
    if (!isLimitOrderActive) {
      setValue(1);
    }
  }, [isLimitOrderActive]);
  const { basket, addToBasket } = useBasketContent();
  const inBasketQuantity = (_b = basket == null ? void 0 : basket.find(
    (item) => item.product.id === productId
  )) == null ? void 0 : _b.quantity;
  const addToBasketButtonDisabled = (0, import_react206.useMemo)(
    () => isLimitOrderActive ? value < 1 || !finalAvailableQuantity : value < 1,
    [value, finalAvailableQuantity, isLimitOrderActive]
  );
  const handleAddToBasket = (quantity) => {
    addToBasket({ productId, quantity });
  };
  const handleAddButton = (quantity) => {
    if (productId) {
      handleAddToBasket(quantity);
      setValue(1);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react205.VStack, {
    w: "100%",
    justifyContent: "flex-end",
    spacing: 4,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react205.HStack, {
        spacing: extendedButton ? 4 : 2,
        className: "product-quantity",
        w: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QuantitySelector_default, {
            value,
            onChange: (value2) => setValue(value2),
            availableQuantity,
            controlBtnSizes: extendedButton ? "lg" : "md",
            sx: {
              ...extendedButton && {
                input: {
                  height: "48px"
                }
              }
            }
          }),
          extendedButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
            leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.default, {
              path: import_js35.mdiCartOutline,
              size: "20px"
            }),
            onClick: () => handleAddButton(value),
            isDisabled: addToBasketButtonDisabled,
            fontWeight: "600",
            letterSpacing: "0.15px",
            h: "48px",
            lineHeight: "32px",
            bgColor: "crmBlue",
            fontSize: "lg",
            color: "#fff",
            px: "24px",
            className: "product-quantity__button-extended",
            children: t("PRODUCT_ADD_TO_CART")
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react205.Box, {
            position: "relative",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react205.IconButton, {
                variant: "ghost",
                "aria-label": "control-quantity-product",
                icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.default, {
                  path: import_js35.mdiCartOutline,
                  size: "20px"
                }),
                onClick: () => handleAddButton(value),
                bgColor: "gray.100",
                isDisabled: addToBasketButtonDisabled,
                className: "product-quantity__button"
              }),
              inBasketQuantity && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react205.Circle, {
                bg: "blue.500",
                size: "18px",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                position: "absolute",
                top: "0",
                right: "0",
                zIndex: 3,
                "data-testId": "small-info-quantity",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react205.Text, {
                  fontWeight: "600",
                  fontSize: "xs",
                  letterSpacing: "0.4px",
                  children: inBasketQuantity
                })
              })
            ]
          })
        ]
      }),
      inBasketQuantity > 0 && extendedButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react205.Text, {
        w: "100%",
        textAlign: "right",
        letterSpacing: "mediumWide",
        lineHeight: "24px",
        fontSize: "md",
        color: "gray.400",
        children: [
          t("ADDED"),
          " " + inBasketQuantity + " ",
          t("TO_BASKET")
        ]
      }) : null
    ]
  });
};
var ProductQuantitySelector_default = ProductQuantitySelector;

// src/components/GalleryItem/GalleryItem.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var imageSizeValue = { sm: "150px", md: "250px", lg: "350px" };
var GalleryItem = import_react209.default.memo(
  ({
    product,
    hidePromotedMarkers,
    omitImageSizeSetting = false,
    showOnlyPrice,
    ...props
  }) => {
    var _a2, _b, _c, _d;
    const { Link: Link19 } = useLink();
    const { isUserUser } = (0, import_react209.useContext)(AuthContext);
    const theme = (0, import_react208.useTheme)();
    const settings = useSettings_default();
    const [displayTooltip, setDisplayTooltip] = (0, import_react209.useState)(false);
    const handleDisplayTooltip = () => setDisplayTooltip((prev) => !prev);
    const cardVariants = {
      hover: {
        boxShadow: theme.shadows.md
      }
    };
    const activeMarkers = getActiveMarkers(product.externalMarkers);
    const externalMarkers = hidePromotedMarkers ? activeMarkers == null ? void 0 : activeMarkers.filter((marker) => !marker.isPromoted) : activeMarkers;
    const imageSize = omitImageSizeSetting ? "200px" : imageSizeValue[settings["product_thumbnail_size_in_gallery"]] ?? "200px";
    const productUrl = `/product/show/productid/${product.id}`;
    const GalleryItemLink = ({ productUrl: productUrl2, product: product2 }) => {
      const memoizedLink = (0, import_react209.useMemo)(() => {
        var _a3, _b2;
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link19, {
          href: productUrl2,
          passHref: true,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.LinkOverlay, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameDisplay_default, {
              id: product2.id,
              name: (_a3 = product2 == null ? void 0 : product2.translations) == null ? void 0 : _a3.name,
              code: (_b2 = product2 == null ? void 0 : product2.translations) == null ? void 0 : _b2.code,
              flex: 1,
              displayTooltip
            })
          })
        });
      }, [productUrl2, product2, displayTooltip]);
      return memoizedLink;
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.LinkBox, {
      h: "full",
      paddingBottom: "8px",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AnimatedBox, {
        variants: cardVariants,
        whileHover: "hover",
        onAnimationComplete: (definition) => {
          if (definition === "hover")
            handleDisplayTooltip();
          else if (definition === "initial" && displayTooltip)
            handleDisplayTooltip();
        },
        animate: "initial",
        initial: "initial",
        className: "product",
        display: "flex",
        direction: "column",
        borderBottom: 1,
        borderStyle: "solid",
        borderBottomColor: "gray.100",
        cursor: "pointer",
        id: `product-${product.id}`,
        px: "24px",
        py: "16px",
        rounded: 4,
        bg: "white",
        h: "full",
        ...props,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react208.Stack, {
          spacing: showOnlyPrice ? 0 : 2,
          w: "full",
          h: "full",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductImage_default, {
              height: imageSize,
              width: imageSize,
              maxW: "calc(100vw - 48px)",
              defaultImage: product.defaultImage,
              name: product.name,
              "data-testid": "product-list-gallery-image"
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkerContainer_default, {
              externalMarkers,
              position: "absolute",
              top: "16px",
              left: "24px"
            }),
            Link19 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(GalleryItemLink, {
              productUrl,
              product
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.LinkOverlay, {
              href: productUrl,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameDisplay_default, {
                id: product.id,
                name: (_a2 = product == null ? void 0 : product.translations) == null ? void 0 : _a2.name,
                code: (_b = product == null ? void 0 : product.translations) == null ? void 0 : _b.code,
                flex: 1,
                displayTooltip
              })
            }),
            !showOnlyPrice && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductEAN_default, {
                  ean: product.ean
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductAvailability_default, {
                  availabilities: product.availabilities,
                  estimatedAvailability: product.estimatedAvailability
                })
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.Flex, {
              flexGrow: 1,
              alignItems: "flex-end",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.Box, {
                className: "product__price",
                textAlign: "right",
                justifySelf: "end",
                w: "full",
                children: isUserUser ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.Stack, {
                  justifyContent: "flex-end",
                  direction: "row",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceDisplay_default, {
                    prices: product.prices,
                    isGalleryItem: true
                  })
                }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react208.Box, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceDisplay_default, {
                      prices: product.prices,
                      isGalleryItem: true
                    }),
                    !showOnlyPrice && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.Flex, {
                      justifyContent: "flex-end",
                      mt: "16px",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductQuantitySelector_default, {
                        productId: product == null ? void 0 : product.id,
                        zIndex: 1,
                        availableQuantity: (product == null ? void 0 : product.isService) ? DEFAULT_LIMIT_AVAILABLE_PRODUCTS : (_d = (_c = product == null ? void 0 : product.availabilities) == null ? void 0 : _c.all) == null ? void 0 : _d.available
                      })
                    })
                  ]
                })
              })
            })
          ]
        })
      })
    });
  }
);
GalleryItem.displayName = "GalleryItem";
var AnimatedBox = (0, import_framer_motion.motion)(import_react208.Box);
var GalleryItem_default = GalleryItem;

// src/components/Header/Header.tsx
var import_react210 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var MainHeader = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react210.Text, {
    className: "header__main",
    as: "span",
    display: "inline",
    color: "gray.700",
    ...props,
    children
  });
};
var SecondaryHeader = ({ children, ...props }) => {
  if (typeof children !== "string" || children.trim().length < 1) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react210.Text, {
    className: "header__secondary",
    as: "span",
    display: "inline",
    color: "gray.400",
    ...props,
    children: `(${children})`
  });
};
var Header = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react210.Heading, {
    className: "header",
    as: "h2",
    fontSize: { base: "lg", sm: "xl" },
    fontWeight: "500",
    lineHeight: { base: "32px", sm: "36px" },
    color: "gray.700",
    sx: {
      "span:first-of-type": {
        marginRight: "0.75rem"
      }
    },
    ...props,
    children
  });
};
var Header_default = Header;

// src/components/InBasketInfo/InBasketInfo.tsx
var import_react211 = require("@chakra-ui/react");
var import_fa6 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var InBasketInfo = ({ quantity, ...props }) => {
  if (!quantity || !isFinite(quantity)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react211.Box, {
      "data-testid": "basket-image",
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa6.FaShoppingBasket, {
        size: 20
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react211.Box, {
    "data-testid": "basket-image-with-label",
    _after: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      bottom: "2%",
      right: "2%",
      backgroundColor: "white",
      shadow: "md",
      padding: "0.3em",
      borderRadius: "10px",
      minWidth: "15px",
      height: "15px",
      fontWeight: "600",
      fontSize: "10px",
      fontFamily: "mono",
      content: `"${quantity > 99 ? "99+" : quantity}"`
    },
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa6.FaShoppingBasket, {
      size: 20
    })
  });
};
var InBasketInfo_default = InBasketInfo;

// src/components/InBasketText/InBasketText.tsx
var import_react212 = require("@chakra-ui/react");
var import_react_i18next42 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var InBasketText = ({ count, ...props }) => {
  const { t } = (0, import_react_i18next42.useTranslation)();
  if (!count) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react212.Text, {
    as: "span",
    whiteSpace: "nowrap",
    ...props,
    children: `${t(
      "PRODUCT_IN_BASKET"
    )}: ${count}`
  });
};
var InBasketText_default = InBasketText;

// src/components/Linkify/Linkify.tsx
var import_react213 = require("@chakra-ui/react");
var import_react_linkify = __toESM(require("react-linkify"));
var import_jsx_runtime = require("react/jsx-runtime");
var Linkify = ({ children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_linkify.default, {
    componentDecorator: (decoratedHref, decoratedText, key) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react213.Link, {
      color: "blue.500",
      target: "_blank",
      rel: "noopener noreferrer nofollow",
      href: decoratedHref,
      children: decoratedText
    }, key),
    children
  });
};
var Linkify_default = Linkify;

// src/components/List/List.tsx
var import_react236 = require("@chakra-ui/react");
var import_react237 = require("@emotion/react");
var import_js37 = require("@mdi/js");
var import_react238 = __toESM(require("@mdi/react"));
var import_difference2 = __toESM(require("lodash/difference"));
var import_react239 = __toESM(require("react"));
var import_react_i18next52 = require("react-i18next");
var import_react_shadowed_double_scrollbar = __toESM(require("react-shadowed-double-scrollbar"));
var import_react_table = require("react-table");
var import_use_deep_compare_effect2 = require("use-deep-compare-effect");

// src/hooks/useQueryParams.ts
var import_react214 = require("@xstate/react");
var import_isEmpty9 = __toESM(require("lodash/isEmpty"));
var import_qs = __toESM(require("qs"));
var import_url_pattern = __toESM(require("url-pattern"));
var import_use_deep_compare_effect = require("use-deep-compare-effect");
var import_xstate2 = require("xstate");
var queryParamsMachine = (0, import_xstate2.createMachine)(
  {
    id: "queryParamsMachine",
    context: {
      currentPage: null,
      currentPerPage: null,
      orderName: null,
      orderType: null,
      filterConfig: null,
      queryParams: null,
      setFilters: null,
      setPage: null,
      setPerPage: null,
      setOrder: null
    },
    initial: "idle",
    states: {
      idle: {
        on: {
          SET_IS_READY: "readingFromUrl"
        }
      },
      readingFromUrl: {
        invoke: {
          src: "readFromUrl",
          onDone: {
            target: "writingToUrl",
            actions: (0, import_xstate2.assign)({
              queryParams: (context) => context
            })
          }
        }
      },
      writingToUrl: {
        on: {
          SET_URL_FILTERS: {
            target: "settingUrlParams"
          }
        }
      },
      settingUrlParams: {
        invoke: {
          src: "writeToUrl",
          onDone: {
            target: "writingToUrl",
            actions: (0, import_xstate2.assign)((context, event) => {
              return {
                ...event.data
              };
            })
          }
        }
      }
    }
  },
  {
    services: {
      readFromUrl: async ({ setFilters, setPerPage, setPage, setOrder, filterConfig }, event) => {
        const {
          matchedUrl,
          parsedQuery,
          perPage,
          page,
          sortField,
          sortType,
          isMatchCompanyId,
          filters
        } = parseUrlParams(filterConfig);
        if (perPage) {
          setPerPage(Number(perPage));
        }
        if (page) {
          setPage(Number(page));
        }
        if (sortField && sortType) {
          setOrder([
            {
              id: sortField,
              desc: sortType === "desc"
            }
          ]);
        }
        if (isMatchCompanyId) {
          const currentUrl = new URL(window.location.href);
          currentUrl.pathname = currentUrl.pathname.replace(
            `company_id/${matchedUrl.filterValue}`,
            ""
          );
          window.history.pushState({}, "", currentUrl.toString());
          if (!(0, import_isEmpty9.default)(filters)) {
            const query = {};
            const transformedFilters = {};
            Object.keys(filters).forEach((filterKey) => {
              transformedFilters[filterKey] = filters[filterKey].value;
            });
            query.filters = import_qs.default.stringify(transformedFilters, {
              arrayFormat: "brackets",
              indices: false
            });
            updateQueryParams(query);
          }
        }
        if (!(0, import_isEmpty9.default)(filters)) {
          setFilters(filters);
        }
        return { queryParams: parsedQuery };
      },
      writeToUrl: async ({ currentPage, currentPerPage, orderName: oN, orderType: oT }, event) => {
        const query = {};
        const pageIndex = typeof (event == null ? void 0 : event.page) === "number" ? event.page : currentPage ?? 1;
        query.page = pageIndex + 1;
        const perPage = (event == null ? void 0 : event.perPage) ? event.perPage : currentPerPage ?? 20;
        query.perPage = perPage;
        const orderName = (event == null ? void 0 : event.orderName) ?? oN;
        const orderType = (event == null ? void 0 : event.orderType) ?? oT;
        if (orderName && orderType && (event == null ? void 0 : event.orderName) !== void 0) {
          query.sortField = orderName;
          query.sortType = orderType;
        }
        const filters = (event == null ? void 0 : event.filters) ?? {};
        if (!(0, import_isEmpty9.default)(filters)) {
          const transformedFilters = {};
          Object.keys(filters).forEach((filterKey) => {
            transformedFilters[filterKey] = filters[filterKey].value;
          });
          query.filters = import_qs.default.stringify(transformedFilters, {
            arrayFormat: "brackets",
            indices: false
          });
        }
        updateQueryParams(query);
        return {
          currentPage: pageIndex,
          currentPerPage: perPage,
          orderName,
          orderType,
          filters
        };
      }
    }
  }
);
var parseUrlParams = (filterConfig) => {
  const urlPattern = new import_url_pattern.default(
    "(/index.php)/:module/:list(/:filter/:filterValue)"
  );
  const matchedUrl = urlPattern.match(window.location.pathname);
  const currentSearchParams = window.location.search.replace("?", "");
  const parsedQuery = import_qs.default.parse(currentSearchParams);
  const filters = import_qs.default.parse(parsedQuery.filters);
  const page = parsedQuery.page;
  const perPage = parsedQuery.perPage;
  const sortField = parsedQuery.sortField;
  const sortType = parsedQuery.sortType;
  const isMatchCompanyId = (matchedUrl == null ? void 0 : matchedUrl.filter) === "company_id";
  let newListFiltersValue = filters;
  if (!(0, import_isEmpty9.default)(filters) || isMatchCompanyId) {
    newListFiltersValue = getFiltersFromUrl(
      {
        ...filters,
        ...prepareCompanyFilter(isMatchCompanyId, matchedUrl)
      },
      filterConfig
    );
  }
  return {
    matchedUrl,
    parsedQuery,
    perPage,
    page,
    sortField,
    sortType,
    isMatchCompanyId,
    filters: newListFiltersValue
  };
};
var prepareCompanyFilter = (isMatchCompanyId, matchedUrl) => {
  if (!isMatchCompanyId) {
    return {};
  }
  if ((matchedUrl == null ? void 0 : matchedUrl.module) === "task") {
    return { accountCompanies: [matchedUrl.filterValue] };
  }
  return { company: [matchedUrl.filterValue] };
};
var parseValue = (filter, filterValue) => {
  switch (filter.type) {
    case "date": {
      return {
        ...(filterValue == null ? void 0 : filterValue.from) && { from: new Date(filterValue.from) },
        ...(filterValue == null ? void 0 : filterValue.to) && { to: new Date(filterValue.to) }
      };
    }
    case "datetimetz":
    case "datetime": {
      return {
        ...(filterValue == null ? void 0 : filterValue.from) && { from: new Date(filterValue.from) },
        ...(filterValue == null ? void 0 : filterValue.to) && { to: new Date(filterValue.to) }
      };
    }
    case "company": {
      return filterValue == null ? void 0 : filterValue.map((companyId) => Number(companyId));
    }
    case "relation":
    case "listMulti": {
      return filterValue.map((valueId) => Number(valueId));
    }
    case "bool": {
      return filterValue === "true";
    }
    case "list": {
      if (["connectedEmailStatus", "documentStatus"].includes(filter.id)) {
        return filterValue == null ? void 0 : filterValue.map((valueId) => Number(valueId));
      }
      return filterValue;
    }
    default: {
      return filterValue;
    }
  }
};
var getFiltersFromUrl = (filters, filterConfig) => {
  const newListFiltersValue = {};
  Object.keys(filters).forEach((filterKey) => {
    const filter = filterConfig.find((f) => f.id === filterKey);
    if (filter) {
      newListFiltersValue[filterKey] = {
        value: parseValue(filter, filters[filterKey]),
        type: filter.type,
        name: filter.name,
        module: filter.relatedModule,
        additionalData: filter.additionalData
      };
    }
  });
  return newListFiltersValue;
};
var updateQueryParams = (params) => {
  const url = new URL(document.location.pathname, document.location.origin);
  Object.entries(params).forEach((param) => {
    url.searchParams.set(param[0], param[1]);
  });
  window.history.pushState({}, "", url);
};
var useQueryParams = ({
  currentPage,
  currentPerPage,
  listFiltersConfig,
  filters,
  orderName,
  orderType,
  setOrder,
  setFilters,
  handleSetPageNumber,
  handlePageSizeChange
}) => {
  const [queryParamsState, send] = (0, import_react214.useMachine)(queryParamsMachine, {
    context: {
      currentPage,
      currentPerPage,
      orderName: orderName ?? null,
      orderType: orderType ?? null,
      filterConfig: listFiltersConfig,
      setFilters,
      setPage: handleSetPageNumber,
      setPerPage: handlePageSizeChange,
      setOrder
    }
  });
  (0, import_use_deep_compare_effect.useDeepCompareEffectNoCheck)(() => {
    send({
      type: "SET_URL_FILTERS",
      filters,
      page: currentPage,
      perPage: currentPerPage,
      orderName,
      orderType
    });
  }, [filters, currentPage, currentPerPage, orderName, orderType]);
  const setIsReady = () => {
    send({
      type: "SET_IS_READY"
    });
  };
  return {
    setIsReady
  };
};
var useQueryParams_default = useQueryParams;

// src/components/ListFilters/ListFilters.tsx
var import_react215 = require("@chakra-ui/react");
var import_react216 = __toESM(require("react"));
var import_react_i18next43 = require("react-i18next");
var import_orderBy2 = __toESM(require("lodash/orderBy"));
var import_indexOf = __toESM(require("lodash/indexOf"));
var import_jsx_runtime = require("react/jsx-runtime");
var getComponentForRelations = (filter) => {
  var _a2;
  switch (filter.relatedModule) {
    case "paymentType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "payment_types",
          labelField: "name"
        }
      };
    case "deliveryType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "delivery_types",
          labelField: "name"
        }
      };
    case "documentSeriesDefinition":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "document_series_definitions",
          labelField: "name",
          ...((_a2 = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _a2.filter) && {
            filters: filter.additionalData.filter
          }
        }
      };
    case "accountUser":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "account_users",
            labelField: "fullName",
            settings: {
              fields: "fullName,company.name",
              extra_fields: "fullName",
              "setting[with_relations]": true,
              "order[_q]": "DESC"
            }
          }
        },
        selectProps: {
          components: {
            Option: CustomSelectOption_default
          },
          additionalOptionField: [
            { field: "additionalName", source: "company.name" }
          ]
        }
      };
    case "userUser":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "user_users",
            labelField: "fullName",
            settings: {
              extra_fields: "fullName",
              "order[_q]": "DESC"
            }
          }
        }
      };
    case "priceProductGroup":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "price_product_groups",
          labelField: "name"
        }
      };
    case "externalMarker":
      return {
        component: ExternalMarkerFilter_default
      };
    case "campaignPhase":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "campaign_phases",
          labelField: ["name", "campaign.name"],
          labelFieldCreator: (item) => `${item.name} (${item.campaign.name})`,
          settings: {
            "setting[with_relations]": true
          }
        }
      };
    case "accountCompany":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "account_companies",
            labelField: "displayName",
            settings: {
              extra_fields: "displayName",
              "order[_q]": "DESC"
            }
          }
        }
      };
    case "campaign":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "campaigns",
          labelField: "name"
        }
      };
    case "taskType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "task_types",
          labelField: "typeName"
        }
      };
    case "commissionPhase":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "commission_phases",
          labelField: "phaseName"
        }
      };
    case "product":
    case "products":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "products",
            labelField: "name",
            settings: {
              "order[_q]": "DESC"
            }
          }
        }
      };
    case "servicedProducts":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "serviced_products",
            labelField: "fullName",
            settings: {
              extra_fields: "fullName",
              "order[_q]": "DESC"
            }
          }
        }
      };
    default:
      if (process.env.NODE_ENV === "development") {
        logger_default.warn(
          `No component for filter of type relation from module ${filter.relatedModule}, field: ${filter.id}`
        );
      }
      return null;
  }
};
var getComponentForFilter = (filter) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
  const additionalProps = ((_a2 = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _a2.additionalProps) ?? {};
  const baseTextFilter = {
    component: ((_b = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _b.filterComponent) ?? TextFilter_default,
    additionalProps
  };
  const baseNumericFilter = {
    component: ((_c = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _c.filterComponent) ?? NumericFilter_default,
    additionalProps
  };
  const baseBoolFilter = {
    component: ((_d = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _d.filterComponent) ?? BooleanFilter_default,
    additionalProps
  };
  const baseDatetimeFilter = {
    component: ((_e = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _e.filterComponent) ?? DatetimeFilter_default,
    additionalProps
  };
  const baseListFilter = {
    component: ((_f = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _f.filterComponent) ?? MultiFilter_default,
    additionalProps
  };
  const baseTagFilter = {
    component: ((_g = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _g.filterComponent) ?? TagFilter_default,
    additionalProps
  };
  switch (filter.type) {
    case "custom":
      return {
        component: filter.additionalData.filterComponent,
        additionalProps: {
          ...(_h = filter.additionalData) == null ? void 0 : _h.additionalProps
        }
      };
    case "text":
      return { ...baseTextFilter };
    case "string":
      return { ...baseTextFilter };
    case "email":
      return { ...baseTextFilter };
    case "phone":
      return { ...baseTextFilter };
    case "bigint":
      return { ...baseNumericFilter };
    case "integer":
      return { ...baseNumericFilter };
    case "numeric":
      return { ...baseNumericFilter };
    case "float":
      return { ...baseNumericFilter };
    case "smallint":
      return { ...baseNumericFilter };
    case "decimal":
      return { ...baseNumericFilter };
    case "boolean":
      return { ...baseBoolFilter };
    case "bool":
      return { ...baseBoolFilter };
    case "datetime":
      return { ...baseDatetimeFilter };
    case "datetimetz":
      return { ...baseDatetimeFilter };
    case "date":
      return { ...baseDatetimeFilter, additionalProps: { withTime: false } };
    case "list":
      return {
        ...baseListFilter
      };
    case "listMulti":
      return {
        ...baseListFilter
      };
    case "tags":
      return { ...baseTagFilter };
    case "company":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "account_companies",
            labelField: "displayName",
            settings: { extra_fields: "displayName" }
          }
        }
      };
    case "defaultPriceType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          ...(_i = filter.additionalData) == null ? void 0 : _i.additionalProps
        }
      };
    case "relation":
      return getComponentForRelations(filter);
    default:
      logger_default.warn(`No component for filter of type ${filter.type}`);
      return null;
  }
};
var skeletonStyle = {
  smallMargin: "10px",
  bigMargin: "24px",
  mediumWidth: "100px",
  checkboxWidth: "24px",
  height: "24px"
};
var labelSkeletonProps = {
  height: skeletonStyle.height,
  width: skeletonStyle.mediumWidth,
  mb: skeletonStyle.smallMargin
};
var checkboxSkeletonProps = {
  height: skeletonStyle.height,
  width: skeletonStyle.checkboxWidth,
  mr: skeletonStyle.bigMargin
};
var inputSkeletonProps = {
  height: skeletonStyle.height,
  mb: skeletonStyle.bigMargin
};
var checkoxLabelSkeletonProps = {
  height: skeletonStyle.height,
  width: skeletonStyle.mediumWidth
};
var ListFiltersSkeleton = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react215.Box, {
    "data-testid": "filters-skeleton",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
        ...inputSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react215.Flex, {
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            width: "45%",
            float: "left",
            ...inputSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            width: "45%",
            float: "left",
            ...inputSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
        ...inputSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react215.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react215.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react215.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react215.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      })
    ]
  });
};
var ListFilters = import_react216.default.memo(
  ({ filters, hiddenFilters, columnOrdering }) => {
    const { t } = (0, import_react_i18next43.useTranslation)();
    const { filters: filterValues, addFilter } = (0, import_react216.useContext)(ListFiltersContext);
    if (!filters) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFiltersSkeleton, {});
    }
    const preparedFiltersToSort = columnOrdering == null ? void 0 : columnOrdering.map((el) => {
      if (el.startsWith("attribute."))
        return el.slice(10);
      return el;
    });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Stack, {
      spacing: 4,
      className: "list__filters",
      children: (0, import_orderBy2.default)(
        [
          ...filters.filter(
            (filter) => preparedFiltersToSort == null ? void 0 : preparedFiltersToSort.includes(filter.id)
          )
        ],
        (item) => (0, import_indexOf.default)(preparedFiltersToSort, item.id)
      ).concat([
        ...filters.filter(
          (filter) => !(preparedFiltersToSort == null ? void 0 : preparedFiltersToSort.includes(filter.id))
        )
      ]).map((filter) => {
        var _a2, _b, _c;
        const render = getComponentForFilter(filter);
        if (!(render == null ? void 0 : render.component)) {
          return null;
        }
        if (hiddenFilters == null ? void 0 : hiddenFilters.includes(filter.id)) {
          return null;
        }
        return import_react216.default.createElement(render.component, {
          key: filter.id,
          name: t(filter.name),
          filterName: filter.id,
          value: (_a2 = filterValues[filter.id]) == null ? void 0 : _a2.value,
          positions: (_b = filter.additionalData) == null ? void 0 : _b.positions,
          options: (_c = filter.additionalData) == null ? void 0 : _c.options,
          className: `filter-${filter.id}`,
          relatedModule: filter == null ? void 0 : filter.relatedModule,
          onChange: (name, value) => addFilter(
            name,
            value,
            filter.type,
            filter.relatedModule,
            filter.additionalData
          ),
          ...(render == null ? void 0 : render.additionalProps) ? render == null ? void 0 : render.additionalProps : {},
          ...(render == null ? void 0 : render.selectProps) ? { selectProps: render == null ? void 0 : render.selectProps } : {}
        });
      })
    });
  }
);
var ListFilters_default = ListFilters;

// src/components/LoadingOverlay/LoadingOverlay.tsx
var import_react217 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react217.Flex, {
    justifyContent: "center",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "whiteAlpha.600",
    zIndex: 4,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react217.Box, {
      mt: 10,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react217.Spinner, {
        position: "sticky",
        top: "150px",
        size: "xl"
      })
    })
  });
};
var LoadingOverlay_default = LoadingOverlay;

// src/components/List/LoadingModal/LoadingModal.tsx
var import_react218 = require("@chakra-ui/react");
var import_react_i18next44 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var LoadingModal = ({ handleClose, isOpen }) => {
  const { t } = (0, import_react_i18next44.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    isOpen,
    onClose: () => handleClose(true),
    scrollBehavior: "inside",
    isCentered: true,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalContent, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
          p: 6,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react218.Stack, {
            spacing: 6,
            direction: "column",
            textAlign: "center",
            alignItems: "center",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react218.Spinner, {}),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react218.Stack, {
                spacing: 2,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react218.Text, {
                    textStyle: "h5",
                    as: "h5",
                    children: t("PLEASE_WAIT")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react218.Text, {
                    children: t("LIST_XLSX_EXPORT_LOADING_MESSAGE")
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react218.Button, {
                size: "md",
                onClick: () => handleClose(),
                children: t("CANCEL")
              })
            ]
          })
        })
      })
    ]
  });
};
var LoadingModal_default = LoadingModal;

// src/components/Pagination/Pagination.tsx
var import_react219 = require("@chakra-ui/react");
var import_react_i18next45 = require("react-i18next");
var import_fa7 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var Pagination = ({
  page,
  totalPages,
  nextPage,
  previousPage,
  setPage,
  ...props
}) => {
  const { t } = (0, import_react_i18next45.useTranslation)();
  const baseStyle = {
    size: "sm",
    variant: "ghost"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react219.Stack, {
    as: "nav",
    role: "navigation",
    className: "pagination",
    isInline: true,
    justifyContent: "flex-end",
    align: "center",
    my: 0,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_PREV_PAGE"),
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa7.FaChevronLeft, {}),
        onClick: previousPage,
        color: page > 1 ? "gray.500" : "gray.300",
        ...baseStyle
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.NumberInput, {
        backgroundColor: "white",
        value: page,
        h: "40px",
        maxW: "46px",
        min: 1,
        max: totalPages,
        onChange: (value) => setPage(Number(value)),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.NumberInputField, {
          textAlign: "center",
          paddingInline: 0,
          borderRadius: "6px"
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react219.Text, {
        as: "span",
        color: "gray.500",
        children: [
          t("OF"),
          " ",
          totalPages
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_NEXT_PAGE"),
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa7.FaChevronRight, {}),
        onClick: nextPage,
        color: page < totalPages ? "gray.500" : "gray.300",
        ...baseStyle
      })
    ]
  });
};
var ObjectsPerPageSelect = ({
  resultsPerPage,
  setTotalResult,
  paginationValues = [5, 10, 15, 30, 50]
}) => {
  const { t } = (0, import_react_i18next45.useTranslation)();
  const displayNumbersPerPage = paginationValues.map((number) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
    value: number,
    children: number
  }, number));
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react219.HStack, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.Select, {
        value: resultsPerPage,
        onChange: setTotalResult,
        textColor: "gray.700",
        w: "80px",
        h: "40px",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "gray.200",
        className: "pagination-box__select",
        children: displayNumbersPerPage
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.Text, {
        children: t("LIST_TOTAL_RESULTS")
      })
    ]
  });
};
var Pagination_default = Pagination;

// src/components/PanelHeading/PanelHeading.tsx
var import_react220 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var PanelHeading = ({ text, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react220.Heading, {
    as: "h2",
    size: "md",
    fontWeight: "500",
    mt: "0",
    ...props,
    children: text
  });
};
var PanelHeading_default = PanelHeading;

// src/components/PerPage/PerPage.tsx
var import_react221 = require("@chakra-ui/react");
var import_react_i18next46 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var PerPage = ({
  value,
  onChange,
  perPageOptions = [20, 40, 100],
  ...props
}) => {
  const { t } = (0, import_react_i18next46.useTranslation)();
  const handleChange = (e) => {
    onChange(e.target.value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react221.Stack, {
    className: "per-page",
    direction: "row",
    alignItems: "center",
    maxW: "100%",
    minW: "0%",
    flex: 1,
    ml: "16px",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react221.Select, {
        backgroundColor: "white",
        width: "auto",
        size: "sm",
        value,
        onChange: handleChange,
        rounded: "6px",
        height: "40px",
        ...props,
        children: perPageOptions.map((opt) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
          value: opt,
          children: opt
        }, opt))
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react221.Text, {
        isTruncated: true,
        maxW: "100%",
        as: "span",
        textStyle: "bodyInput",
        children: t("PAGINATION_RESULTS_PER_PAGE")
      })
    ]
  });
};
var PerPage_default = PerPage;

// src/components/SortingIndicator/SortingIndicator.tsx
var import_react222 = require("@chakra-ui/react");
var import_fa8 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var SortingIndicator = ({
  isSorted,
  isSortedDesc
}) => {
  if (!isSorted) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.Flex, {
    color: "gray.300",
    children: isSortedDesc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.Box, {
      color: "inherit",
      display: "inline-block",
      as: import_fa8.FaSortAmountDown
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.Box, {
      color: "inherit",
      display: "inline-block",
      as: import_fa8.FaSortAmountDownAlt
    })
  });
};
var SortingIndicator_default = SortingIndicator;

// src/components/Table/Table.tsx
var import_react223 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Table3 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react223.Box, {
    as: "table",
    w: "full",
    ...props
  });
};
var Table_default = Table3;

// src/components/Table/Tbody.tsx
var import_react224 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Tbody3 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react224.Box, {
    as: "tbody",
    ...props
  });
};
var Tbody_default = Tbody3;

// src/components/Table/Td.tsx
var import_react225 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Td3 = ({ children, ...props }) => {
  if (typeof children === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react225.Box, {
      dangerouslySetInnerHTML: { __html: children },
      p: 1,
      as: "td",
      ...props
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react225.Box, {
      p: 1,
      as: "td",
      ...props,
      children
    });
  }
};
var Td_default = Td3;

// src/components/Table/Th.tsx
var import_react226 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Th2 = ({ children, ...props }) => {
  if (typeof children === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react226.Box, {
      fontWeight: "inherit",
      color: "gray.600",
      dangerouslySetInnerHTML: { __html: children },
      p: 2,
      as: "th",
      ...props
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react226.Box, {
      p: 2,
      as: "th",
      ...props,
      children
    });
  }
};
var Th_default = Th2;

// src/components/Table/Thead.tsx
var import_react227 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Thead2 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react227.Box, {
    as: "thead",
    ...props
  });
};
var Thead_default = Thead2;

// src/components/Table/Tr.tsx
var import_react228 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Tr3 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react228.Box, {
    as: "tr",
    ...props
  });
};
var Tr_default = Tr3;

// src/components/List/CustomizeColumns/CustomizeColumns.tsx
var import_react229 = require("@chakra-ui/react");
var import_union = __toESM(require("lodash/union"));
var import_react_beautiful_dnd = require("react-beautiful-dnd");
var import_react_i18next47 = require("react-i18next");
var import_fa9 = require("react-icons/fa");
var import_sort_array = __toESM(require("sort-array"));
var import_jsx_runtime = require("react/jsx-runtime");
var getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  ...draggableStyle
});
var getListStyle = (isDraggingOver) => ({
  marginTop: 0
});
var reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
var baseStyleCheckboxHeader = {
  "span:nth-child(2)": {
    border: "#E2E8F0",
    backgroundColor: "#ffffff"
  }
};
var getColumnId = (column) => {
  if (column.fieldType === "attribute") {
    return column.id.slice(10);
  }
  return column.id;
};
var CustomizeColumns = ({
  allColumns,
  checkedColumns,
  handleCheckColumn,
  handleCheckAllColumns,
  columnsOrdering,
  setColumnOrdering,
  onBeforeDragStartCallback,
  onDragEndCallback,
  checkedFilters,
  handleCheckFilter,
  handleCheckAllFilters,
  countFilters,
  invisibleCheckboxFilter
}) => {
  const { t } = (0, import_react_i18next47.useTranslation)();
  const allColumnsIds = allColumns.map((col) => col.id);
  const isChecked = checkedColumns.length === allColumnsIds.length;
  const isCheckedAllFilters = checkedFilters.length === countFilters;
  const indeterminate = checkedColumns.length > 0 ? allColumnsIds.length - checkedColumns.length : false;
  const colsOrdering = columnsOrdering.length > 0 ? (0, import_union.default)(columnsOrdering, allColumnsIds) : allColumnsIds;
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const items = reorder(
      colsOrdering.filter((col) => allColumnsIds.includes(col)),
      result.source.index,
      result.destination.index
    );
    setColumnOrdering(items);
    onDragEndCallback == null ? void 0 : onDragEndCallback();
  };
  const sortedColumns = (0, import_sort_array.default)(allColumns, {
    by: "id",
    order: "id",
    customOrders: { id: colsOrdering }
  });
  const visibleCheckboxFilter = (columnId) => !["execute", ...invisibleCheckboxFilter ?? []].includes(columnId);
  const checkIsCheckedFilter = (column) => {
    const test = !!checkedFilters.find(
      (col) => col === getColumnId(column)
    );
    return test;
  };
  const handleCheckSingleFilter = (column) => {
    handleCheckFilter(getColumnId(column));
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react229.Stack, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react229.Stack, {
        direction: "row",
        backgroundColor: "gray.200",
        px: 4,
        py: 2,
        roundedTop: "4",
        border: 1,
        borderStyle: "solid",
        borderColor: "gray.200",
        justifyContent: "space-between",
        pr: "48px",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react229.Checkbox, {
            isChecked,
            isIndeterminate: !!indeterminate,
            onChange: handleCheckAllColumns,
            sx: !isChecked && baseStyleCheckboxHeader,
            children: t("KANBAN_CONFIG_COLUMNS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react229.HStack, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react229.Text, {
                mb: "0",
                children: [
                  " ",
                  t("LIST_FILTERS")
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react229.Checkbox, {
                isChecked: isCheckedAllFilters,
                isIndeterminate: !!indeterminate,
                onChange: handleCheckAllFilters,
                sx: !isCheckedAllFilters && baseStyleCheckboxHeader
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_beautiful_dnd.DragDropContext, {
        onDragEnd,
        onBeforeDragStart: onBeforeDragStartCallback,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_beautiful_dnd.Droppable, {
          droppableId: "droppable",
          children: (provided, snapshot) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
            ...provided.droppableProps,
            ref: provided.innerRef,
            style: getListStyle(snapshot.isDraggingOver),
            children: [
              sortedColumns.map((column, index) => {
                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_beautiful_dnd.Draggable, {
                  draggableId: column.id,
                  index,
                  children: (provided2, snapshot2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
                    ref: provided2.innerRef,
                    ...provided2.draggableProps,
                    style: getItemStyle(
                      snapshot2.isDragging,
                      provided2.draggableProps.style
                    ),
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react229.Stack, {
                      className: "list__column-item",
                      direction: "row",
                      px: 4,
                      py: 2,
                      borderBottom: 1,
                      borderRight: 1,
                      borderLeft: 1,
                      borderStyle: "solid",
                      borderColor: "gray.200",
                      bg: "white",
                      alignItems: "center",
                      minH: "48px",
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react229.Checkbox, {
                          flex: 1,
                          id: column.id,
                          name: column.id,
                          isTruncated: true,
                          isChecked: !!checkedColumns.find((col) => col === column.id),
                          onChange: () => handleCheckColumn(column.id),
                          children: column.fieldType === "attribute" ? t((column == null ? void 0 : column.fieldName) ?? "") : t(`LIST_COLUMN_${column.id}`)
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react229.HStack, {
                          spacing: "12px",
                          children: [
                            visibleCheckboxFilter(column.id) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react229.Checkbox, {
                              "data-testid": `checkbox-filter-${column.id}`,
                              flex: 1,
                              id: column.id,
                              name: column.id,
                              isChecked: checkIsCheckedFilter(column),
                              onChange: () => handleCheckSingleFilter(column)
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react229.Box, {
                              w: "20px",
                              ...provided2.dragHandleProps,
                              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react229.Box, {
                                as: import_fa9.FaGripLines
                              })
                            })
                          ]
                        })
                      ]
                    }, column.id)
                  })
                }, column.id);
              }),
              provided.placeholder
            ]
          })
        })
      })
    ]
  });
};
var CustomizeColumns_default = CustomizeColumns;

// src/components/List/CustomizeColumnsModal/CustomizeColumnsModal.tsx
var import_react230 = require("@chakra-ui/react");
var import_react_i18next48 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomizeColumnsModal = ({
  handleSave,
  closeOnOverlayClick,
  isOpen,
  onOpen,
  onClose,
  children,
  ...props
}) => {
  const { t } = (0, import_react_i18next48.useTranslation)();
  const handleSaveClick = () => {
    handleSave == null ? void 0 : handleSave();
    onClose();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react230.Modal, {
    isOpen,
    onClose,
    closeOnOverlayClick,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.ModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react230.ModalContent, {
        h: "100%",
        maxH: { base: "100%", md: "calc(100% - 120px)" },
        w: "100%",
        maxW: "512px",
        marginY: { base: 0, md: "60px" },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react230.ModalHeader, {
            position: "relative",
            textTransform: "capitalize",
            fontWeight: "500",
            py: "22px",
            children: [
              t("settings"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.ModalCloseButton, {
                top: "50%",
                transform: "translateY(-50%)",
                right: "24px"
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.ModalBody, {
            overflowY: "scroll",
            borderTop: "1px",
            borderColor: "gray.200",
            py: 4,
            children
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.ModalFooter, {
            pb: "32px",
            boxShadow: "dark-lg",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.ButtonGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Button, {
                textTransform: "capitalize",
                colorScheme: "blue",
                onClick: handleSaveClick,
                children: t("SAVE")
              })
            })
          })
        ]
      })
    ]
  });
};
var CustomizeColumnsModal_default = CustomizeColumnsModal;

// src/components/List/EmptyList/EmptyList.tsx
var import_react231 = require("@chakra-ui/react");
var import_react_i18next49 = require("react-i18next");
var import_fa10 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyList = ({
  isLoading,
  showHeader = true
}) => {
  const { t } = (0, import_react_i18next49.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react231.Stack, {
    spacing: 0,
    rounded: 4,
    border: 1,
    borderStyle: "solid",
    borderColor: "gray.200",
    maxH: "500px",
    children: [
      showHeader && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.Box, {
        className: "table-empty-heading",
        bg: "gray.50",
        h: 10
      }),
      isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.Flex, {
        alignItems: "center",
        justifyContent: "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.Box, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.Spinner, {
            size: "xl"
          })
        })
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react231.Stack, {
        className: "table-empty-content",
        bg: "white",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        spacing: 2,
        color: "gray.400",
        py: 20,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.Box, {
            boxSize: 10,
            as: import_fa10.FaEyeSlash
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.Heading, {
            size: "lg",
            children: t("LIST_EMPTY_HEADING")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.Text, {
            children: t("LIST_EMPTY_DESCRIPTION")
          })
        ]
      })
    ]
  });
};
var EmptyList_default = EmptyList;

// src/components/List/ProfileSaveConfigModal/ProfileSaveConfigModal.tsx
var import_react232 = require("@chakra-ui/react");
var import_react233 = require("react");
var import_react_i18next50 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ProfileSaveConfigModal = ({
  isOpen,
  onClose,
  saveSettingsForProfile
}) => {
  var _a2;
  const { t } = (0, import_react_i18next50.useTranslation)();
  const { data, isLoading } = useUserProfiles_default(isOpen);
  const [selectedProfileId, setSelectedProfileId] = (0, import_react233.useState)(void 0);
  (0, import_react233.useEffect)(() => {
    var _a3, _b;
    setSelectedProfileId((_b = (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3[0]) == null ? void 0 : _b.id);
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.Modal, {
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.ModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.ModalContent, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.ModalHeader, {
            fontSize: "xl",
            fontWeight: "500",
            lineHeight: "32px",
            letterSpacing: "0.15px",
            children: t("LIST_SETTINGS_SAVE_FOR_PROFILE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.ModalCloseButton, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.ModalBody, {
            py: "24px",
            children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Spinner, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.FormControl, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.FormLabel, {
                  fontStyle: "bodyInput",
                  letterSpacing: "mediumWide",
                  children: t("LIST_CONFIG_SAVE_FOR_PROFILE_LABEL")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.Select, {
                  onChange: (e) => setSelectedProfileId(Number(e.target.value)),
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                      disabled: true,
                      hidden: true
                    }),
                    (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.map((profile) => {
                      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                        value: profile.id,
                        children: profile.profileName
                      }, profile.id);
                    })
                  ]
                })
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.ModalFooter, {
            pt: "12px",
            pb: "32px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.ButtonGroup, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Button, {
                  onClick: onClose,
                  fontSize: "md",
                  fontWeight: "500",
                  letterSpacing: "0.15px",
                  children: t("CLOSE")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Button, {
                  textTransform: "capitalize",
                  colorScheme: "blue",
                  onClick: () => saveSettingsForProfile(selectedProfileId),
                  fontSize: "md",
                  fontWeight: "500",
                  letterSpacing: "0.15px",
                  children: t("SAVE")
                })
              ]
            })
          })
        ]
      })
    ]
  });
};
var ProfileSaveConfigModal_default = ProfileSaveConfigModal;

// src/components/List/EmptyFilters/EmptyFilters.tsx
var import_react234 = require("@chakra-ui/react");
var import_js36 = require("@mdi/js");
var import_react235 = __toESM(require("@mdi/react"));
var import_react_i18next51 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyFilters = ({ openSettings }) => {
  const { t } = (0, import_react_i18next51.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react234.VStack, {
    spacing: "20px",
    mt: "16px",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react234.VStack, {
        spacing: "10px",
        color: "gray.300",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react235.default, {
            path: import_js36.mdiFilterOffOutline,
            size: "35px"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react234.Text, {
            mb: "0",
            mt: "10px",
            color: "gray.400",
            children: t("LIST_FILTERS_NO_CONFIGURATION")
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react234.Button, {
        textTransform: "capitalize",
        onClick: openSettings,
        w: "full",
        backgroundColor: "gray.100",
        fontSize: "15px",
        letterSpacing: "0.15px",
        py: "8px",
        children: t("settings")
      })
    ]
  });
};
var EmptyFilters_default = EmptyFilters;

// src/components/List/List.tsx
var import_lib3 = require("@questy/lib");
var import_jsx_runtime = require("react/jsx-runtime");
var List3 = ({
  columns,
  data,
  summaryData,
  handleGoToNextPage,
  handleGoToPrevPage,
  handleSetPage,
  handleSetPageSize,
  isLoading,
  listFiltersConfig,
  listSorting,
  listSortingStatus,
  dependentFilters = {},
  module: module2,
  moduleName,
  pageCount: controlledPageCount,
  pageSize,
  setProfileSetting,
  setSorting,
  settings,
  setUserSetting,
  totalResults = 0,
  mainAction,
  additionalActions,
  filterContentTop = null,
  filterNamePrefix,
  apiParams,
  invisibleCheckboxFilter
}) => {
  var _a2, _b, _c;
  const { t } = (0, import_react_i18next52.useTranslation)();
  const { isUserUser } = (0, import_react239.useContext)(AuthContext);
  const defaultColumn = import_react239.default.useMemo(
    () => ({
      minWidth: 10,
      width: 150
    }),
    []
  );
  const asideFilters = (0, import_react236.useBreakpointValue)({
    base: false,
    lg: true
  });
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    visibleColumns,
    allColumns,
    setHiddenColumns,
    setColumnOrder,
    state,
    page,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setSortBy,
    resetResizing
  } = (0, import_react_table.useTable)(
    {
      columns,
      data,
      defaultColumn,
      manualSortBy: true,
      manualPagination: true,
      autoResetPage: false,
      initialState: {
        sortBy: listSorting,
        columnOrder: (settings == null ? void 0 : settings.columnOrder) ?? [],
        hiddenColumns: (settings == null ? void 0 : settings.hiddenColumns) ?? [],
        columnResizing: {
          columnWidths: (settings == null ? void 0 : settings.columnWidths) ?? {}
        }
      },
      pageCount: controlledPageCount
    },
    import_react_table.useColumnOrder,
    import_react_table.useSortBy,
    import_react_table.usePagination,
    import_react_table.useFlexLayout,
    import_react_table.useResizeColumns
  );
  const toast = (0, import_react236.useToast)();
  const { pageIndex, sortBy: sortBy4 } = state;
  const { setModuleParams, meta } = (0, import_lib3.useCredentials)();
  (0, import_react239.useEffect)(() => {
    var _a3, _b2, _c2;
    if (apiParams == null ? void 0 : apiParams.params) {
      setModuleParams({
        fields: (_a3 = apiParams == null ? void 0 : apiParams.params) == null ? void 0 : _a3.fields,
        ...((_b2 = apiParams == null ? void 0 : apiParams.params) == null ? void 0 : _b2.extra_fields) ? { extra_fields: (_c2 = apiParams == null ? void 0 : apiParams.params) == null ? void 0 : _c2.extra_fields } : {}
      });
    }
  }, [setModuleParams]);
  (0, import_react239.useEffect)(() => {
    logger_default.debug("Synchronizing sorting");
    const urlParams = new URLSearchParams(window.location.search);
    const sortField = urlParams.get("sortField");
    const sortType = urlParams.get("sortType");
    if (sortBy4 == null ? void 0 : sortBy4.length) {
      setSorting(sortBy4);
    } else {
      if (sortField) {
        setSorting([
          {
            id: sortField,
            [`desc`]: sortType === "desc" ? true : false
          }
        ]);
      } else {
        setSorting([
          {
            id: "id",
            desc: "true"
          }
        ]);
      }
    }
  }, [setSorting, sortBy4]);
  const handleSetNextPage = () => {
    nextPage();
    handleGoToNextPage();
  };
  const handleSetPrevPage = () => {
    previousPage();
    handleGoToPrevPage();
  };
  const handleSetPageNumber = (page2) => {
    logger_default.debug("handleSetPageNumber", page2);
    gotoPage(page2 - 1);
    handleSetPage(page2);
  };
  const handlePageSizeChange = (pageSize2, reset = true) => {
    setPageSize(pageSize2);
    handleSetPageSize(pageSize2);
    if (reset) {
      resetPagination();
    }
  };
  const { checkedColumns, handleCheckColumn, handleCheckAllColumns } = useListColumnsVisibility_default({
    allColumns,
    visibleColumns
  });
  const { checkedFilters, handleCheckFilter, handleCheckAllFilters } = useListFiltersVisibility_default({
    allFilters: listFiltersConfig,
    hiddenFilters: settings == null ? void 0 : settings.hiddenFilters
  });
  const { columnOrdering, setColumnOrdering } = useListColumnsOrdering_default({
    columnOrder: state.columnOrder
  });
  const getHiddenColumns = () => {
    return (0, import_difference2.default)(
      allColumns.map((col) => col.id),
      checkedColumns
    );
  };
  const dependentFiltersKeys = Object.keys(dependentFilters);
  const dependentFilterFiltersKeys = dependentFiltersKeys.map((i) => {
    return dependentFilters[i].dependents;
  }).flat();
  const getHiddenFilters = () => {
    var _a3, _b2;
    const hiddenFilters = (0, import_difference2.default)(
      listFiltersConfig.map((filter) => filter.id),
      checkedFilters
    );
    return (_b2 = (_a3 = hiddenFilters == null ? void 0 : hiddenFilters.filter((item) => !dependentFilterFiltersKeys.includes(item))) == null ? void 0 : _a3.map(
      (id) => {
        var _a4, _b3;
        return ((_b3 = (_a4 = dependentFilters == null ? void 0 : dependentFilters[id]) == null ? void 0 : _a4.dependents) == null ? void 0 : _b3.length) ? [id, ...dependentFilters[id].dependents] : id;
      }
    )) == null ? void 0 : _b2.flat();
  };
  const prepareColumnOrdering = () => {
    var _a3;
    const newColumnOrdering = (_a3 = columnOrdering == null ? void 0 : columnOrdering.filter((item) => !dependentFilterFiltersKeys.includes(item))) == null ? void 0 : _a3.map((item) => {
      if (dependentFiltersKeys.includes(item)) {
        return [item, ...dependentFilters[item].dependents];
      }
      return item;
    }).flat();
    return newColumnOrdering;
  };
  const handleSave = () => {
    const hiddenColumns = getHiddenColumns();
    setHiddenColumns(hiddenColumns);
    setColumnOrder(prepareColumnOrdering());
    const hiddenFilters = getHiddenFilters();
    setUserSetting({
      hiddenColumns,
      columnOrder: prepareColumnOrdering(),
      hiddenFilters
    });
  };
  (0, import_react239.useEffect)(() => {
    const allColumnsIds = allColumns == null ? void 0 : allColumns.map((column) => column == null ? void 0 : column.id);
    const shouldUpdate = !(allColumnsIds == null ? void 0 : allColumnsIds.every(
      (column) => {
        var _a3;
        return (_a3 = settings == null ? void 0 : settings.columnOrder) == null ? void 0 : _a3.includes(column);
      }
    ));
    if (shouldUpdate) {
      setUserSetting({
        hiddenColumns: (settings == null ? void 0 : settings.hiddenColumns) ?? [],
        columnOrder: allColumnsIds ?? (settings == null ? void 0 : settings.columnOrder) ?? [],
        columnWidths: state.columnResizing.columnWidths,
        hiddenFilters: (settings == null ? void 0 : settings.hiddenFilters) ?? []
      });
      return;
    }
    const debounceTimeout = setTimeout(() => {
      setUserSetting({
        hiddenColumns: (settings == null ? void 0 : settings.hiddenColumns) ?? [],
        columnOrder: (settings == null ? void 0 : settings.columnOrder) ?? [],
        columnWidths: state.columnResizing.columnWidths,
        hiddenFilters: (settings == null ? void 0 : settings.hiddenFilters) ?? []
      });
    }, 1e3);
    return () => clearTimeout(debounceTimeout);
  }, [state.columnResizing.columnWidths]);
  const resetColumnWidths = () => {
    resetResizing();
  };
  const resetPagination = () => {
    logger_default.debug("resetPagination");
    gotoPage(0);
    handleSetPage(1);
  };
  const listFilters = (0, import_react239.useContext)(ListFiltersContext);
  const updateSorting = (newSorting) => {
    setSortBy(newSorting);
    setSorting(newSorting);
  };
  (0, import_react239.useEffect)(() => {
    if (typeof controlledPageCount !== "undefined") {
      setIsReady();
    }
  }, [controlledPageCount]);
  const currentFilters = (listFilters == null ? void 0 : listFilters.filters) ?? null;
  const { setIsReady } = useQueryParams_default({
    currentPage: pageIndex,
    currentPerPage: pageSize,
    filters: currentFilters,
    listFiltersConfig,
    orderName: (_a2 = sortBy4[0]) == null ? void 0 : _a2.id,
    orderType: ((_b = sortBy4[0]) == null ? void 0 : _b.desc) ? "desc" : "asc",
    setOrder: updateSorting,
    handlePageSizeChange: (pageSize2) => handlePageSizeChange(pageSize2, false),
    handleSetPageNumber,
    setFilters: listFilters.setFilters
  });
  const [isInitialFilters, setIsInitialFilters] = (0, import_react239.useState)(true);
  (0, import_use_deep_compare_effect2.useDeepCompareEffectNoCheck)(() => {
    !isInitialFilters && resetPagination();
    setIsInitialFilters(false);
  }, [currentFilters]);
  const { onOpen: openProfileSettingsModal, isOpen, onClose } = (0, import_react236.useDisclosure)();
  const handleSaveForProfile = async (profileId) => {
    const hiddenColumns = getHiddenColumns();
    const hiddenFilters = getHiddenFilters();
    try {
      await setProfileSetting(
        {
          hiddenColumns,
          columnOrder: columnOrdering,
          hiddenFilters
        },
        profileId
      );
      toast({
        title: t("PROFILE_SAVE_LIST_SETTINGS_SUCCESS_TITLE"),
        description: t("PROFILE_SAVE_LIST_SETTINGS_SUCCESS_DESCRIPTION"),
        status: "success"
      });
      onClose();
    } catch (error) {
      toast({
        title: t("PROFILE_SAVE_LIST_SETTINGS_ERROR_TITLE"),
        description: t("PROFILE_SAVE_LIST_SETTINGS_ERROR_DESCRIPTION"),
        status: "error"
      });
      onClose();
    }
  };
  const [isFiltersOpen, setIsFiltersOpen] = (0, import_react239.useState)(true);
  const [isModalClosableByOverlayClick, setIsModalClosableByOverlayClick] = (0, import_react239.useState)(true);
  const {
    isOpen: customizeColumnsModalIsOpen,
    onOpen: customizeColumnsModalOnOpen,
    onClose: customizeColumnsModalOnClose
  } = (0, import_react236.useDisclosure)();
  const {
    isOpen: isModalFiltersOpen,
    onToggle: onModalFiltersToggle,
    onClose: onModalFiltersClose
  } = (0, import_react236.useDisclosure)({
    defaultIsOpen: false
  });
  const {
    isOpen: isModalLoaderOpen,
    onOpen: onModalLoaderOnOpen,
    onClose: onModalLoaderClose
  } = (0, import_react236.useDisclosure)({
    defaultIsOpen: false
  });
  const hasCredentialExportToXlsx = (_c = meta == null ? void 0 : meta.actions) == null ? void 0 : _c.xlsx_export;
  const xlsxExportAbortControllerRef = (0, import_react239.useRef)(null);
  const handleModalLoaderClose = (shouldAsk = false) => {
    const shouldClose = !shouldAsk || window.confirm(t("LIST_LOADING_MODAL_CLOSE_QUESTION"));
    if (shouldClose) {
      xlsxExportAbortControllerRef.current.abort();
      onModalLoaderClose();
    }
  };
  const handleDownloadXlsxDocument = () => {
    xlsxExportAbortControllerRef.current = new AbortController();
    onModalLoaderOnOpen();
    downloadXlsxDocument(
      apiParams,
      xlsxExportAbortControllerRef.current.signal,
      module2,
      onModalLoaderClose
    );
  };
  const menuItems = (0, import_react239.useMemo)(
    () => [
      {
        label: t("LIST_COLUMN_CONFIG"),
        onClick: customizeColumnsModalOnOpen
      },
      ...isUserUser ? [
        {
          label: t("LIST_CONFIG_SET_FOR_PROFILE"),
          onClick: openProfileSettingsModal
        }
      ] : [],
      {
        label: t("LIST_CONFIG_SET_DEFAULT_COLUMN_WIDTHS"),
        onClick: resetColumnWidths
      },
      ...hasCredentialExportToXlsx ? [
        {
          label: t("LIST_EXPORT_LIST_TO_XLSX"),
          onClick: handleDownloadXlsxDocument
        }
      ] : [],
      ...additionalActions ?? []
    ],
    [
      t,
      openProfileSettingsModal,
      resetColumnWidths,
      additionalActions,
      hasCredentialExportToXlsx
    ]
  );
  const noConfigurationFilters = (0, import_react239.useMemo)(
    () => listFiltersConfig == null ? void 0 : listFiltersConfig.every(
      (filter) => {
        var _a3;
        return (_a3 = settings == null ? void 0 : settings.hiddenFilters) == null ? void 0 : _a3.includes(filter.id);
      }
    ),
    [settings.hiddenFilters, listFiltersConfig]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Grid, {
    gridTemplateColumns: "1fr",
    w: "full",
    maxW: "breakpoint.xl",
    px: { base: 2, md: 6, lg: 10 },
    py: 4,
    m: "auto",
    gap: 4,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
        className: "list__header",
        display: "flex",
        flexDirection: { base: "column", sm: "row" },
        alignItems: { base: "flex-start", sm: "center" },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Flex, {
            flex: 1,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Heading, {
              as: "h1",
              fontSize: "2xl",
              fontWeight: "normal",
              children: moduleName
            })
          }),
          mainAction ?? null,
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
            menuItems,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.MenuButton, {
              className: "list__header__more-button",
              ml: "16px",
              as: MoreIconButton_default,
              variant: "solid",
              colorScheme: "gray"
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomizeColumnsModal_default, {
            handleSave,
            closeOnOverlayClick: isModalClosableByOverlayClick,
            isOpen: customizeColumnsModalIsOpen,
            onOpen: customizeColumnsModalOnOpen,
            onClose: customizeColumnsModalOnClose,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomizeColumns_default, {
              allColumns,
              checkedColumns,
              handleCheckColumn,
              handleCheckAllColumns,
              checkedFilters,
              handleCheckFilter,
              handleCheckAllFilters,
              countFilters: listFiltersConfig == null ? void 0 : listFiltersConfig.length,
              columnsOrdering: columnOrdering,
              setColumnOrdering,
              onBeforeDragStartCallback: () => {
                setIsModalClosableByOverlayClick(false);
              },
              onDragEndCallback: () => {
                setIsModalClosableByOverlayClick(true);
              },
              invisibleCheckboxFilter,
              dependentFilters
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProfileSaveConfigModal_default, {
            isOpen,
            onClose,
            saveSettingsForProfile: handleSaveForProfile
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Flex, {
        flexDirection: asideFilters ? "row" : "column",
        w: "full",
        minW: 0,
        children: [
          asideFilters && isFiltersOpen ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
            className: "list__filters-container",
            mb: "20rem",
            mr: "16px",
            w: { base: "full", lg: "288px", xl: "448px" },
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PanelHeading_default, {
                text: t("LIST_FILTERS"),
                mb: 4
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Flex, {
                mb: 4,
                children: filterContentTop
              }),
              noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFilters_default, {
                openSettings: customizeColumnsModalOnOpen
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilters_default, {
                filters: listFiltersConfig,
                hiddenFilters: settings == null ? void 0 : settings.hiddenFilters,
                columnOrdering: settings == null ? void 0 : settings.columnOrder
              })
            ]
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
            className: "list__filters-container",
            display: "none",
            mb: "16px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PanelHeading_default, {
                text: t("LIST_FILTERS"),
                mb: 4
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Flex, {
                mb: 4,
                children: filterContentTop
              }),
              noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFilters_default, {
                openSettings: customizeColumnsModalOnOpen
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilters_default, {
                filters: listFiltersConfig,
                hiddenFilters: settings == null ? void 0 : settings.hiddenFilters,
                columnOrdering: settings == null ? void 0 : settings.columnOrder
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
            className: "list__table-container",
            flex: 1,
            display: { base: isFiltersOpen ? "none" : "block", sm: "block" },
            position: "relative",
            minW: 0,
            mb: "auto",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Flex, {
                className: "list__table-container__top",
                mb: "16px",
                children: [
                  !asideFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActiveFilters_default, {
                        filters: listFilters.filters,
                        filterNamePrefix: filterNamePrefix ?? "LIST_COLUMN_",
                        onRemoveFilter: listFilters.removeFilter,
                        onClearAllFilters: listFilters.resetFilters,
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
                          size: "sm",
                          leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react238.default, {
                            path: import_js37.mdiFilterOutline
                          }),
                          onClick: onModalFiltersToggle,
                          children: isModalFiltersOpen ? t("KANBAN_HIDE_FILTERS") : `${t("LIST_FILTERS")}${Object.keys(listFilters.filters).length > 0 ? ` (${Object.keys(listFilters.filters).length})` : " "}`
                        })
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
                        isOpen: isModalFiltersOpen,
                        onClose: onModalFiltersClose,
                        scrollBehavior: "inside",
                        children: [
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
                          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
                            children: [
                              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
                                flex: 1,
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Text, {
                                  textStyle: "h3",
                                  as: "h3",
                                  flex: 1,
                                  children: t("LIST_FILTERS")
                                })
                              }),
                              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Stack, {
                                  spacing: 4,
                                  direction: "column",
                                  children: noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFilters_default, {
                                    openSettings: customizeColumnsModalOnOpen
                                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilters_default, {
                                    filters: listFiltersConfig,
                                    hiddenFilters: settings == null ? void 0 : settings.hiddenFilters,
                                    columnOrdering
                                  })
                                })
                              }),
                              !noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
                                children: [
                                  " ",
                                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Stack, {
                                    isInline: true,
                                    spacing: 3,
                                    maxW: "full",
                                    children: [
                                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Button, {
                                        type: "button",
                                        isTruncated: true,
                                        variant: "solid",
                                        colorScheme: "gray",
                                        onClick: () => {
                                          listFilters.resetFilters();
                                          onModalFiltersClose();
                                        },
                                        children: t("KANBAN_MODAL_CLEAR_FILTERS")
                                      }),
                                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Button, {
                                        type: "button",
                                        isTruncated: true,
                                        colorScheme: "blue",
                                        backgroundColor: "crmBlue",
                                        onClick: onModalFiltersClose,
                                        children: t("KANBAN_SHOW_RESULTS")
                                      })
                                    ]
                                  })
                                ]
                              }) : null
                            ]
                          })
                        ]
                      })
                    ]
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Box, {
                    flex: 1,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActiveFilters_default, {
                      filters: listFilters.filters,
                      filterNamePrefix: filterNamePrefix ?? "LIST_COLUMN_",
                      onRemoveFilter: listFilters.removeFilter,
                      onClearAllFilters: listFilters.resetFilters,
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
                        size: "sm",
                        leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react238.default, {
                          path: isFiltersOpen ? import_js37.mdiEyeOffOutline : import_js37.mdiEyeOutline
                        }),
                        onClick: () => setIsFiltersOpen((val) => !val),
                        children: isFiltersOpen ? t("HIDE_FILTERS") : t("SHOW_FILTERS")
                      })
                    })
                  }),
                  visibleColumns.length < 1 ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Flex, {
                    alignItems: "flex-end",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Pagination_default, {
                      page: pageIndex + 1,
                      totalPages: pageCount,
                      nextPage: handleSetNextPage,
                      previousPage: handleSetPrevPage,
                      setPage: handleSetPageNumber
                    })
                  })
                ]
              }),
              visibleColumns.length < 1 || data.length < 1 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyList_default, {
                isLoading
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Stack, {
                minW: "0%",
                sx: {
                  ".list__table th p": {
                    margin: "0"
                  },
                  "div:first-child": {
                    paddingTop: "1px"
                  }
                },
                spacing: "16px",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_shadowed_double_scrollbar.default, {
                    shadowVariant: "off",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table_default, {
                      width: "calc(100% - 10px)",
                      border: 1,
                      borderStyle: "solid",
                      borderColor: "gray.200",
                      rounded: 6,
                      bg: "white",
                      className: "list__table",
                      sx: { borderCollapse: "separate", borderSpacing: "0" },
                      ...getTableProps(),
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead_default, {
                          bg: "gray.100",
                          children: headerGroups.map((headerGroup) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr_default, {
                            ...headerGroup.getHeaderGroupProps(),
                            children: headerGroup.headers.map((column) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Th_default, {
                              ...column.getHeaderProps(),
                              textStyle: "buttonSmall",
                              color: "gray.600",
                              textAlign: "left",
                              px: "24px",
                              py: "12px",
                              whiteSpace: "nowrap",
                              borderRight: "2px solid",
                              borderColor: "gray.200",
                              children: [
                                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Stack, {
                                  ...column.getSortByToggleProps({
                                    title: t("LIST_TOGGLE_SORT_BY")
                                  }),
                                  align: "center",
                                  direction: "row",
                                  width: "full",
                                  height: "full",
                                  lineHeight: "20px",
                                  css: import_react237.css`
                                & > p,
                                & > span {
                                  text-overflow: ellipsis;
                                  overflow: hidden;
                                  white-space: nowrap;
                                }
                              `,
                                  children: [
                                    column.render("Header"),
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SortingIndicator_default, {
                                      isSorted: column.isSorted,
                                      isSortedDesc: column.isSortedDesc
                                    })
                                  ]
                                }),
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Box, {
                                  _before: {
                                    content: "''",
                                    display: "inline-block",
                                    width: "12px",
                                    transform: "translateX(-50%)",
                                    height: "100%"
                                  },
                                  display: "inline-block",
                                  bg: "gray.100",
                                  w: "2px",
                                  h: "100%",
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  transform: "translateX(50%)",
                                  className: "resizer",
                                  ...column.getResizerProps()
                                })
                              ]
                            }))
                          }))
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody_default, {
                          ...getTableBodyProps(),
                          children: page.map((row) => {
                            prepareRow(row);
                            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr_default, {
                              borderTop: "1px solid",
                              borderColor: "gray.200",
                              ...row.getRowProps(),
                              children: row.cells.map((cell) => {
                                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td_default, {
                                  h: "56px",
                                  px: "24px",
                                  py: "16px",
                                  ...cell.getCellProps(),
                                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Flex, {
                                    css: import_react237.css`
                                    & > * {
                                      text-overflow: ellipsis;
                                      overflow: hidden;
                                      white-space: nowrap;
                                    }
                                  `,
                                    alignItems: "center",
                                    whiteSpace: "nowrap",
                                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Box, {
                                      textStyle: "bodyInput",
                                      w: "full",
                                      children: cell.render("Cell")
                                    })
                                  })
                                });
                              })
                            });
                          })
                        })
                      ]
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingOverlay_default, {
                    isLoading
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingModal_default, {
                    handleClose: handleModalLoaderClose,
                    isOpen: isModalLoaderOpen
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Stack, {
                    direction: "row",
                    alignItems: "center",
                    py: "12px",
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PerPage_default, {
                        value: pageSize,
                        onChange: handlePageSizeChange
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Box, {
                        className: "list-items-count",
                        textAlign: "center",
                        flex: 1,
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Text, {
                          as: "span",
                          fontSize: "sm",
                          color: "gray.700",
                          children: [
                            totalResults,
                            " ",
                            t("LIST_TOTAL_RESULTS")
                          ]
                        })
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Box, {
                        flex: 1,
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Pagination_default, {
                          page: pageIndex + 1,
                          totalPages: pageCount,
                          nextPage: handleSetNextPage,
                          previousPage: handleSetPrevPage,
                          setPage: handleSetPageNumber
                        })
                      })
                    ]
                  }),
                  summaryData && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DocumentSummary_default, {
                    data: summaryData,
                    float: "right"
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};
var List_default = List3;

// src/components/List/sharedCells/CreatorUserCell/CreatorUserCell.tsx
var import_react240 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var CreatorUserCell = (props) => {
  var _a2, _b, _c;
  const moduleLink = ((_a2 = props == null ? void 0 : props.value) == null ? void 0 : _a2.type) === "accountUser" ? "/accountUser/show/user_id/" : "/userUser/show/userid/";
  const content = (_b = props == null ? void 0 : props.value) == null ? void 0 : _b.username;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react240.Tooltip, {
    hasArrow: true,
    px: "12px",
    py: "8px",
    label: content,
    openDelay: 500,
    placement: "bottom-start",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react240.Link, {
      textDecoration: "none",
      color: "crmBlue",
      isExternal: true,
      href: `${moduleLink}${(_c = props == null ? void 0 : props.value) == null ? void 0 : _c.id}`,
      children: content
    })
  });
};
var CreatorUserCell_default = CreatorUserCell;

// src/components/MessageBreadcrumbs/MessageBreadcrumbs.tsx
var import_react241 = require("@chakra-ui/react");
var import_js38 = require("@mdi/js");
var import_react242 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var MessageBreadcrumbs = ({
  sender,
  recipients
}) => {
  var _a2;
  const visibleCount = 3;
  const displayRecipients = recipients.slice(0, visibleCount);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react241.Breadcrumb, {
    separator: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react242.default, {
      path: import_js38.mdiChevronRight,
      size: "20px"
    }),
    spacing: "4px",
    letterSpacing: "0.25px",
    fontSize: "sm",
    color: "gray.500",
    sx: {
      ".chakra-breadcrumb__link:hover": {
        textDecoration: "none",
        cursor: "default"
      }
    },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.BreadcrumbItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.BreadcrumbLink, {
          as: import_react241.Text,
          children: sender
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react241.BreadcrumbItem, {
        flexWrap: "wrap",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.BreadcrumbLink, {
            as: import_react241.Text,
            children: displayRecipients.join(", ")
          }),
          recipients.length > 3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.Tooltip, {
            label: (_a2 = recipients.slice(visibleCount)) == null ? void 0 : _a2.join(", "),
            openDelay: 500,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.BreadcrumbLink, {
              as: import_react241.Text,
              pl: 1,
              children: `(+${recipients.length - 3})`
            })
          })
        ]
      })
    ]
  });
};
var MessageBreadcrumbs_default = MessageBreadcrumbs;

// src/components/Modal/Modal.tsx
var import_react244 = require("@chakra-ui/react");
var import_nice_modal_react = __toESM(require("@ebay/nice-modal-react"));

// src/theme.ts
var import_react243 = require("@chakra-ui/react");
var import_theme_tools = require("@chakra-ui/theme-tools");
var baseThemeExtension = {
  fonts: {
    body: 'Poppins, "Helvetica Neue", "Trebuchet MS", Helvetica, Arial, sans-serif',
    heading: 'Poppins, "Helvetica Neue", "Trebuchet MS", Helvetica, Arial, sans-serif'
  },
  components: {
    Input: {
      variants: {
        outline: {
          field: {
            "&:focus": {
              boxShadow: "none"
            }
          }
        }
      }
    }
  },
  styles: {
    global: {
      "*": {
        "--chakra-shadows-outline": "none"
      },
      body: {
        backgroundColor: "#F9F9F9",
        color: "gray.700"
      },
      ".react-datepicker": {
        fontFamily: 'Poppins, "Helvetica Neue", "Trebuchet MS", Helvetica,Arial, sans-serif !important'
      },
      ".react-datepicker__time-container--with-today-button": {
        right: "-85px !important",
        top: "-1px"
      },
      ".react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box": {
        width: "100% !important"
      },
      ".react-datepicker__year-option:first-of-type, .react-datepicker__year-option:last-child": {
        height: "20px"
      },
      ".react-datepicker__year-option:first-of-type:hover, .react-datepicker__year-option:last-child:hover": {
        backgroundColor: "transparent"
      },
      ".react-datepicker__year-option .react-datepicker__navigation.react-datepicker__navigation--years": {
        borderColor: "#ccc",
        borderStyle: "solid",
        borderWidth: "3px 3px 0 0",
        content: '""',
        height: "9px",
        top: "6px",
        width: "9px"
      },
      ".react-datepicker__navigation--years-upcoming": {
        transform: "rotate(-45deg)"
      },
      ".react-datepicker__navigation--years-previous": {
        transform: "rotate(135deg)"
      },
      ".react-datepicker__year-option .react-datepicker__navigation.react-datepicker__navigation--years:hover": {
        borderColor: "#a6a6a6"
      }
    }
  }
};
var breakpoints = (0, import_theme_tools.createBreakpoints)({
  sm: "320px",
  md: "768px",
  lg: "1280px",
  xl: "1680px",
  "2xl": "1920px"
});
var themeExtensions = {
  ...baseThemeExtension,
  breakpoints,
  colors: {
    body: "#E5E5E5",
    crmBlue: "#3182CE"
  },
  fontSizes: {
    xs: "0.723rem",
    sm: "0.823rem",
    md: "0.9375rem",
    lg: "1.138rem",
    xl: "1.383rem",
    "2xl": "1.68rem",
    "3xl": "2.041rem",
    "4xl": "2.479rem",
    "5xl": "3.012rem",
    "6xl": "3.658rem",
    "7xl": "4.444rem",
    "8xl": "5.399rem",
    "9xl": "6.558rem"
  },
  textStyles: {
    h1: {
      fontWeight: 500,
      fontSize: "3xl",
      lineHeight: "3rem",
      letterSpacing: "normal"
    },
    h2: {
      fontWeight: 500,
      fontSize: "2xl",
      lineHeight: "2.25rem",
      letterSpacing: "normal"
    },
    h3: {
      fontWeight: 500,
      fontSize: "xl",
      lineHeight: "2rem",
      letterSpacing: "normal"
    },
    h4: {
      fontWeight: 500,
      fontSize: "xl",
      lineHeight: "36px",
      letterSpacing: "normal"
    },
    h5: {
      fontSize: "lg",
      fontWeight: 500,
      lineHeight: "2rem",
      letterSpacing: "normal"
    },
    h6: {
      fontSize: "lg",
      fontWeight: 400,
      lineHeight: "32px",
      letterSpacing: "normal"
    },
    buttonLarge: {
      fontWeight: 600,
      fontSize: "lg",
      lineHeight: "1.5rem",
      letterSpacing: "normal"
    },
    subtitleLabel: {
      fontWeight: 500,
      fontSize: "md",
      lineHeight: "1.5rem",
      letterSpacing: "normal"
    },
    bodyInput: {
      fontWeight: 400,
      fontSize: "md",
      lineHeight: "1.5rem",
      letterSpacing: "wider"
    },
    buttonSmall: {
      fontWeight: 500,
      fontSize: "sm",
      lineHeight: "1.25rem",
      letterSpacing: "wide"
    },
    badgeLarge: {
      fontWeight: 600,
      fontSize: "sm",
      lineHeight: "1.25rem",
      letterSpacing: "wide"
    },
    caption: {
      fontWeight: 400,
      fontSize: "sm",
      lineHeight: "1.25rem",
      letterSpacing: "wide"
    },
    badgeSmall: {
      fontWeight: 600,
      fontSize: "xs",
      lineHeight: "1.125rem",
      letterSpacing: "wider"
    }
  },
  letterSpacings: {
    normal: "0",
    wide: "0.025em",
    mediumWide: "0.03125em",
    wider: "0.05em"
  }
};
var customTheme = (0, import_react243.extendTheme)(themeExtensions);
var theme_default = customTheme;

// src/components/Modal/Modal.tsx
var import_react245 = require("react");
var import_react_i18next53 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ManagedModal = import_nice_modal_react.default.create(
  ({ title, size = "md", afterCreate, ...props }) => {
    const [isReady, setIsReady] = (0, import_react245.useState)(false);
    const modalBodyRef = (0, import_react245.useRef)(null);
    const modalFooterRef = (0, import_react245.useRef)(null);
    const { t } = (0, import_react_i18next53.useTranslation)();
    const modal = (0, import_nice_modal_react.useModal)();
    (0, import_react245.useEffect)(() => {
      return () => {
        modal.remove();
      };
    }, []);
    (0, import_react245.useEffect)(() => {
      window.AuraModal.modalBodyRef = modalBodyRef;
      window.AuraModal.modalFooterRef = modalFooterRef;
    }, []);
    (0, import_react245.useEffect)(() => {
      if (isReady) {
        afterCreate == null ? void 0 : afterCreate({
          modal,
          modalBody: modalBodyRef,
          modalFooter: modalFooterRef
        });
      }
    }, [isReady]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react244.ChakraProvider, {
      theme: theme_default,
      resetCSS: false,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomCSSReset_default, {}),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react244.Modal, {
          isOpen: modal.visible,
          onClose: modal.remove,
          size,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react244.ModalOverlay, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react244.ModalContent, {
              borderRadius: 4,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react244.ModalHeader, {
                  children: title
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react244.ModalCloseButton, {}),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react244.ModalBody, {
                  ref: modalBodyRef,
                  className: "modal-body"
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react244.ModalFooter, {
                  ref: modalFooterRef,
                  className: "modal-footer",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react244.Button, {
                    onClick: modal.remove,
                    children: t("CLOSE")
                  })
                })
              ]
            })
          ]
        }),
        modal.visible && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ReadyCheck, {
          setIsReady
        })
      ]
    });
  }
);
var ReadyCheck = ({
  setIsReady
}) => {
  (0, import_react245.useEffect)(() => {
    setIsReady(true);
  }, []);
  return null;
};
var initModal = () => {
  logger_default.debug("Modal initializing");
  const modal = {
    show: (props) => import_nice_modal_react.default.show(ManagedModal, props),
    hide: () => import_nice_modal_react.default.hide(ManagedModal),
    modalBodyRef: { current: null },
    modalFooterRef: { current: null }
  };
  if (typeof window !== "undefined") {
    window.AuraModal = modal;
    const initializeEvent = new CustomEvent("auraModalInitialized");
    document.dispatchEvent(initializeEvent);
  }
};
var Modal_default = ManagedModal;

// src/components/ModalServicedProduct/ModalServicedProduct.tsx
var import_react248 = require("@chakra-ui/react");
var import_react249 = require("react");
var import_react_i18next55 = require("react-i18next");
var import_react_hook_form = require("react-hook-form");
var import_api11 = require("@questy/api");
var import_lib4 = require("@questy/lib");

// src/components/CustomProductOption/CustomProductOption.tsx
var import_react246 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomProductOption = (props) => {
  const { innerRef, innerProps, data } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react246.Box, {
    className: "select__option",
    _hover: {
      bg: "gray.100"
    },
    color: "gray.700",
    fontSize: "15px",
    py: "10px",
    px: "16px",
    cursor: "pointer",
    fontWeight: "400",
    ref: innerRef,
    ...innerProps,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react246.Text, {
        fontSize: "md",
        display: "block",
        letterSpacing: "mediumWide",
        lineHeight: "24px",
        children: data.label
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react246.Text, {
        mt: 1,
        fontSize: "sm",
        letterSpacing: "0.25px",
        color: "gray.500",
        lineHeight: "20px",
        children: data.additionalName
      })
    ]
  });
};
var CustomProductOption_default = CustomProductOption;

// src/components/ModalServicedProduct/CreatableValueContainer/CreatableValueContainer.tsx
var import_react247 = require("@chakra-ui/react");
var import_react_select12 = require("react-select");
var import_react_i18next54 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var CreatableValueContainer = ({
  children,
  ...props
}) => {
  var _a2;
  const { selectProps } = props;
  const isNewValue = (_a2 = selectProps.value) == null ? void 0 : _a2.__isNew__;
  const { t } = (0, import_react_i18next54.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select12.components.ValueContainer, {
    ...props,
    children: [
      children,
      isNewValue && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react247.Badge, {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        right: "0",
        borderRadius: "4px",
        bgColor: "green.500",
        color: "#fff",
        lineHeight: "20px",
        letterSpacing: "0.25px",
        me: "8px",
        px: "8px",
        children: t("NEW")
      })
    ]
  });
};
var CreatableValueContainer_default = CreatableValueContainer;

// src/components/ModalServicedProduct/ModalServicedProduct.tsx
var import_react_query12 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib4.CredentialContextProvider, {
      module: "serviced_products",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalServicedProduct = ({
  isOpen,
  onClose,
  onSubmit,
  afterSuccess,
  company,
  isCompanyFieldReadOnly = false,
  address,
  parentId,
  headerLabel
}) => {
  const { t } = (0, import_react_i18next55.useTranslation)();
  const {
    hasModuleCredential,
    isLoading: isLoadingCredentials,
    hasCredential
  } = (0, import_lib4.useCredentials)();
  const {
    register,
    control,
    formState,
    handleSubmit,
    reset,
    resetField,
    setError,
    setValue
  } = (0, import_react_hook_form.useForm)({
    defaultValues: {
      serialCode: null,
      date: new Date(),
      active: false,
      ...company && {
        company: {
          value: company.id,
          label: company.name
        }
      },
      ...address && {
        address: {
          value: address.id,
          label: address.fullName ?? address.name
        }
      }
    }
  });
  (0, import_react249.useEffect)(() => {
    reset();
  }, [isOpen, reset]);
  const handleCreateProduct = async (productName) => {
    try {
      const productResponse = await (0, import_api11.createProduct)({
        data: {
          name: productName
        }
      });
      if (productResponse.errors === null && Array.isArray(productResponse.data)) {
        return productResponse.data[0].id;
      }
    } catch (error) {
      if (error == null ? void 0 : error.response) {
        setError(
          "product",
          {
            type: "manual",
            message: "ERROR_PRODUCT_ADD_FAILED"
          },
          {
            shouldFocus: true
          }
        );
      }
    }
  };
  const handleCreateServicedProduct = async (data) => {
    var _a2, _b, _c;
    const isNewProduct = (_a2 = data == null ? void 0 : data.product) == null ? void 0 : _a2.__isNew__;
    const productId = isNewProduct ? await handleCreateProduct(data.product.value) : data.product.value;
    try {
      const servicedProductResponse = await (0, import_api11.createServicedProduct)({
        data: {
          serialCode: data.serialCode,
          ...hasCredential("date", "field", "edit") && {
            date: formatDateForApi(data == null ? void 0 : data.date)
          },
          isActive: data.active,
          product: productId,
          ...data.sold && { hasBeenSold: data.sold },
          company: ((_b = data.company) == null ? void 0 : _b.value) ?? null,
          place: ((_c = data.address) == null ? void 0 : _c.value) ?? null,
          ...parentId && { parent: parentId }
        }
      });
      if (servicedProductResponse.errors === null && Array.isArray(servicedProductResponse.data)) {
        afterSuccess(servicedProductResponse.data[0].id);
        onClose();
      }
    } catch (error) {
      if (error == null ? void 0 : error.response) {
        setError(
          "serialCode",
          {
            type: "manual",
            message: "ERROR_SERVICED_PRODUCT_SERIAL_NOT_UNIQUE"
          },
          {
            shouldFocus: true
          }
        );
      }
    }
  };
  const screenPhone = (0, import_react248.useBreakpointValue)({
    base: true,
    md: false
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        as: "form",
        onSubmit: handleSubmit(handleCreateServicedProduct),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            showBorders: false,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Text, {
              isTruncated: true,
              as: screenPhone ? "h5" : "h4",
              textStyle: { base: "h5", md: "h4" },
              children: headerLabel ? t(headerLabel) : t("NEW_SERVICED_PRODUCT")
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            overflowY: "visible",
            className: "serviced-product__crete-modal__body",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ServicedProductCreateForm, {
              control,
              register,
              resetField,
              formState,
              setValue,
              isCompanyFieldReadOnly
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
            className: "serviced-product__crete-modal__footer",
            showBorders: false,
            children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Button, {
              className: "serviced-product__crete-modal__footer-button",
              textTransform: "capitalize",
              isLoading: formState.isSubmitting,
              type: "submit",
              colorScheme: "blue",
              children: t("SAVE")
            })
          })
        ]
      })
    ]
  });
};
var ServicedProductCreateForm = ({
  register,
  control,
  resetField,
  isCompanyFieldReadOnly,
  setValue
}) => {
  var _a2, _b;
  const { language } = (0, import_react249.useContext)(LanguageContext);
  const { hasCredential } = (0, import_lib4.useCredentials)();
  const { t } = (0, import_react_i18next55.useTranslation)();
  const { errors } = (0, import_react_hook_form.useFormState)({ control });
  const currentCompany = (0, import_react_hook_form.useWatch)({ control, name: "company" });
  const { data: moduleProductsCredential } = (0, import_react_query12.useQuery)(
    ["products", "meta", "moduleCredential"],
    () => api_default.getMeta("products"),
    {
      select: (data) => {
        var _a3;
        return (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3.module.credential;
      }
    }
  );
  const handleProductName = (inputValue, action) => {
    if (moduleProductsCredential > 2) {
      if (action.action === "input-change") {
        setValue("product", {
          label: inputValue,
          value: inputValue,
          __isNew__: true
        });
      }
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.Stack, {
    spacing: 4,
    "data-testid": "create-serviced-product-form",
    className: "serviced-product__crete-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.FormControl, {
        isInvalid: !!(errors == null ? void 0 : errors.serialCode),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormLabel, {
            htmlFor: "serviced-product-serial-code",
            children: t("SERVICED_PRODUCT_SERIAL_CODE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Input, {
            id: "serviced-product-serial-code",
            className: "serviced-product__crete-modal__serial-code",
            ...register(
              "serialCode"
            )
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormErrorMessage, {
            children: t(((_a2 = errors == null ? void 0 : errors.serialCode) == null ? void 0 : _a2.message) ?? "ERROR")
          })
        ]
      }),
      hasCredential("product", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.FormControl, {
        isRequired: true,
        isInvalid: !!(errors == null ? void 0 : errors.product),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormLabel, {
            htmlFor: "serviced-product-product",
            requiredIndicator: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Text, {
              as: "span",
              ml: "12px",
              textStyle: "bodyInput",
              color: "red.500",
              children: "*"
            }),
            children: t("SERVICED_PRODUCT_PRODUCT")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "product",
            rules: {
              required: {
                value: true,
                message: "ERROR_SERVICED_PRODUCT_PRODUCT_REQUIRED"
              }
            },
            render: ({ field }) => {
              const fieldValue = field == null ? void 0 : field.value;
              const labelValue = fieldValue && `${fieldValue == null ? void 0 : fieldValue.label} ${(fieldValue == null ? void 0 : fieldValue.additionalName) ? `(${fieldValue.additionalName})` : ""} `;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DataSelector_default, {
                placeholder: t("SELECT"),
                noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
                loadingMessage: () => t("LOADING"),
                inputId: "serviced-product-product",
                className: "serviced-product__crete-modal__product",
                endpoint: "products",
                labelField: "name",
                getFilter: (inputValue) => ({
                  "filter[_q][hasText]": inputValue
                }),
                params: {
                  "order[_q]": "DESC",
                  "order[name]": "ASC"
                },
                fields: ["code"],
                valueField: "id",
                additionalOptionField: [
                  { field: "additionalName", source: "code" }
                ],
                onInputChange: (value, action) => handleProductName(value, action),
                components: {
                  Option: CustomProductOption_default,
                  ValueContainer: CreatableValueContainer_default
                },
                ...field,
                value: {
                  ...fieldValue,
                  label: labelValue
                }
              });
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormErrorMessage, {
            children: t(((_b = errors == null ? void 0 : errors.product) == null ? void 0 : _b.message) ?? "ERROR")
          })
        ]
      }),
      hasCredential("company", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormLabel, {
            htmlFor: "serviced-product-company",
            children: t("SERVICED_PRODUCT_COMPANY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "company",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DataSelector_default, {
              placeholder: t("SELECT"),
              noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
              loadingMessage: () => t("LOADING"),
              isDisabled: isCompanyFieldReadOnly,
              inputId: "serviced-product-company",
              className: "serviced-product__crete-modal__company",
              endpoint: "account_companies",
              labelField: "displayName",
              extraFields: ["displayName"],
              valueField: "id",
              ...field,
              onChange: (value, changedOption) => {
                field.onChange(value, changedOption);
                resetField("address");
              }
            })
          })
        ]
      }),
      hasCredential("place", "field", "edit") && currentCompany && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormLabel, {
            htmlFor: "serviced-product-address",
            children: t("SERVICED_PRODUCT_ADDRESS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "address",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DataSelector_default, {
              placeholder: t("SELECT"),
              noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
              loadingMessage: () => t("LOADING"),
              inputId: "serviced-product-address",
              className: "serviced-product__crete-modal__address",
              endpoint: "places",
              labelField: "fullName",
              valueField: "id",
              fields: ["company.id", "company.name"],
              extraFields: ["fullName"],
              getFilter: (value) => ({
                "filter[fullName][hasText]": value,
                "filter[company.id][eq]": currentCompany == null ? void 0 : currentCompany.value,
                "setting[with_relations]:": true
              }),
              ...field
            })
          })
        ]
      }),
      hasCredential("date", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormLabel, {
            htmlFor: "serviced-product-date",
            children: t("SERVICED_PRODUCT_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "date",
            render: ({ field: { ref, ...field } }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "serviced-product-date",
              className: "serviced-product__crete-modal__date",
              lang: language,
              isClearable: false,
              ...field
            })
          })
        ]
      }),
      hasCredential("isActive", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormControl, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.Stack, {
          className: "serviced-product__crete-modal__active",
          direction: "row",
          alignItems: "center",
          spacing: 2,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Checkbox, {
              id: "serviced-product-active",
              size: "lg",
              ...register("active")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormLabel, {
              htmlFor: "serviced-product-active",
              children: t("SERVICED_PRODUCT_ACTIVE")
            })
          ]
        })
      })
    ]
  });
};
var ModalServicedProduct_default = withCredentials(ModalServicedProduct);

// src/components/PersonInfo/PersonInfo.tsx
var import_react250 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var PersonInfo = ({
  fullName,
  position,
  accountUserId,
  userUserId
}) => {
  const baseStyle = {
    textStyle: "bodyInput"
  };
  const link = accountUserId || userUserId ? userUserId ? `/userUser/show/userid/${userUserId}` : `/accountUser/show/user_id/${accountUserId}` : "#";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react250.VStack, {
    spacing: "8px",
    alignItems: "flex-start",
    className: "person-info",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react250.Link, {
        ...baseStyle,
        color: "crmBlue",
        href: link,
        className: "person-info__link",
        children: fullName
      }),
      position && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react250.Text, {
        ...baseStyle,
        color: "gray.500",
        className: "person-info__position",
        children: position
      })
    ]
  });
};
var PersonInfo_default = PersonInfo;

// src/components/PersonItem/PersonItem.tsx
var import_react251 = require("@chakra-ui/react");
var import_js39 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var DisplayPhoneNumbers = ({ phoneNumbers }) => {
  const displayNumbers = phoneNumbers.map((number, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
    icon: import_js39.mdiPhone,
    label: number
  }, index));
  return displayNumbers;
};
var PersonItem = ({
  fullName,
  position,
  accountUserId,
  userUserId,
  emailAddress,
  link,
  phoneNumbers
}) => {
  const baseStyle = {
    width: {
      base: "100%",
      md: "50%"
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react251.Stack, {
    align: "left",
    direction: { base: "column", md: "row" },
    alignItems: "center",
    spacing: "16px",
    className: "person-item",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react251.Stack, {
        ...baseStyle,
        className: "person-item__info",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PersonInfo_default, {
          fullName,
          position,
          accountUserId,
          userUserId
        })
      }),
      (emailAddress || phoneNumbers) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react251.Stack, {
        spacing: "8px",
        ...baseStyle,
        className: "person-item__contact",
        children: [
          emailAddress && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
            link,
            label: emailAddress,
            icon: import_js39.mdiAt
          }),
          phoneNumbers && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DisplayPhoneNumbers, {
            phoneNumbers
          })
        ]
      })
    ]
  });
};
var PersonItem_default = PersonItem;

// src/components/PersonList/PersonList.tsx
var import_react252 = require("react");
var import_react_i18next56 = require("react-i18next");
var import_react253 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var DisplayList = ({
  actualPage,
  resultsPerPage,
  items,
  withPagination = true
}) => {
  const startIndex = actualPage * resultsPerPage - resultsPerPage;
  const readyList = withPagination ? items.slice(startIndex, startIndex + resultsPerPage) : items;
  const showList = readyList.map((person, index) => {
    const {
      fullName,
      position,
      accountUserId,
      userUserId,
      emailAddress,
      phoneNumbers,
      link
    } = person;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react253.Box, {
      borderTop: index > 0 ? "1px solid" : null,
      p: "16px",
      borderColor: "gray.200",
      className: "person-list__items",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PersonItem_default, {
        fullName,
        position,
        accountUserId,
        userUserId,
        emailAddress,
        phoneNumbers,
        link
      })
    }, index);
  });
  return showList;
};
var PersonList = ({
  items,
  paginationValues,
  withPagination = true
}) => {
  const [resultsPerPage, setSelectedPeoplePerPage] = (0, import_react252.useState)(5);
  const [numberOfPage, setNumberOfPage] = (0, import_react252.useState)(1);
  const totalNumberOfPages = Math.ceil(items.length / resultsPerPage);
  const handleSetSelectedPeoplePerPage = (e) => {
    const value = parseInt(e.target.value);
    setSelectedPeoplePerPage(value);
    const totalNumberOfPages2 = Math.ceil(items.length / value);
    if (numberOfPage > totalNumberOfPages2)
      setNumberOfPage(totalNumberOfPages2);
  };
  const handleNextPage = () => {
    numberOfPage < totalNumberOfPages && setNumberOfPage((prevValue) => prevValue + 1);
  };
  const handlePreviousPage = () => {
    numberOfPage > 1 && setNumberOfPage((prevValue) => prevValue - 1);
  };
  const { t } = (0, import_react_i18next56.useTranslation)();
  const perPageSelectVisible = (0, import_react253.useBreakpointValue)({ base: false, md: true });
  let actualPage = 1;
  if (numberOfPage > totalNumberOfPages)
    actualPage = totalNumberOfPages;
  else if (numberOfPage <= 0)
    actualPage = 1;
  else
    actualPage = numberOfPage;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react253.Stack, {
    spacing: "0px",
    className: "person-list",
    w: "100%",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DisplayList, {
        actualPage,
        resultsPerPage,
        items,
        withPagination
      }),
      items.length > 5 && withPagination ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react253.Flex, {
        justifyContent: { base: "center", md: "space-between" },
        alignItems: "center",
        px: "16px",
        py: "12px",
        textStyle: "bodyInput",
        className: "person-list__pagination-box",
        children: [
          perPageSelectVisible && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ObjectsPerPageSelect, {
                resultsPerPage,
                setTotalResult: handleSetSelectedPeoplePerPage,
                paginationValues
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react253.Text, {
                children: [
                  items.length,
                  " ",
                  t("LIST_TOTAL_RESULTS")
                ]
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Pagination_default, {
            page: numberOfPage,
            totalPages: totalNumberOfPages,
            nextPage: handleNextPage,
            previousPage: handlePreviousPage,
            setPage: setNumberOfPage
          })
        ]
      }) : null
    ]
  });
};
var PersonList_default = PersonList;

// src/components/ProductAvailabilityIcon/ProductAvailabilityIcon.tsx
var import_react254 = require("@chakra-ui/react");
var import_react255 = __toESM(require("@mdi/react"));
var import_js40 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var ProductAvailabilityIcon = ({
  available,
  total
}) => {
  const value = available * 100 / total;
  let icon;
  if (value <= 33 && value > 0)
    icon = import_js40.mdiSignalCellular1;
  else if (value > 33 && value <= 66)
    icon = import_js40.mdiSignalCellular2;
  else if (value > 66)
    icon = import_js40.mdiSignalCellular3;
  else
    icon = import_js40.mdiSignalCellularOutline;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react254.Box, {
    color: "gray.700",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react255.default, {
      path: icon,
      size: "24px"
    })
  });
};
var ProductAvailabilityIcon_default = ProductAvailabilityIcon;

// src/components/ProductSlider/ProductSlider.tsx
var import_react256 = require("@chakra-ui/react");
var import_react257 = require("@emotion/react");
var import_react258 = require("react");
var import_swiper = __toESM(require("swiper"));
var import_react259 = require("swiper/react");
var import_react260 = __toESM(require("@mdi/react"));
var import_js41 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
import_swiper.default.use([import_swiper.Navigation, import_swiper.Pagination, import_swiper.A11y]);
var ProductSlider = ({
  products,
  pagination,
  resolutionBreakpoints,
  swiperProps,
  galleryItemProps,
  showOnlyPrice
}) => {
  if (!products || !products.length) {
    return null;
  }
  const swiperRef = (0, import_react258.useRef)(null);
  const isSm = (0, import_react256.useBreakpointValue)({
    base: true,
    md: false
  });
  const [isPrevButtonVisible, setIsPrevButtonVisible] = (0, import_react258.useState)(true);
  const [isNextButtonVisible, setIsNextButtonVisible] = (0, import_react258.useState)(true);
  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };
  (0, import_react258.useEffect)(() => {
    const updateNavigationVisibility = () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        setIsPrevButtonVisible(swiperRef.current.swiper.activeIndex !== 0);
        setIsNextButtonVisible(!swiperRef.current.swiper.isEnd);
      }
    };
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.on("slideChange", updateNavigationVisibility);
      swiperRef.current.swiper.on("reachEnd", updateNavigationVisibility);
    }
    updateNavigationVisibility();
    return () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.off("slideChange", updateNavigationVisibility);
        swiperRef.current.swiper.off("reachEnd", updateNavigationVisibility);
      }
    };
  }, []);
  const baseStyleNavigation = {
    size: "lg",
    rounded: "full",
    color: "gray.700",
    bg: "white",
    boxShadow: "md",
    zIndex: 2,
    top: "50%",
    transform: "translateY(-50%)"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react256.Box, {
    className: "product-slider",
    "data-testid": "product-slider",
    css: import_react257.css`
        .swiper-pagination {
          bottom: 0 !important;
        }
        .swiper-button-disabled {
          display: none !important;
        }
        .swiper-slide {
          height: auto;
        }
      `,
    position: "relative",
    children: [
      isPrevButtonVisible && !isSm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react256.IconButton, {
        className: "product-slider-scroll-buttons__left",
        "aria-label": "",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.default, {
          size: "28.8px",
          path: import_js41.mdiChevronLeft
        }),
        onClick: handlePrev,
        position: "absolute",
        left: "20px",
        ...baseStyleNavigation
      }) : null,
      isNextButtonVisible && !isSm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react256.IconButton, {
        className: "product-slider-scroll-buttons__right",
        "aria-label": "",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.default, {
          size: "28.8px",
          path: import_js41.mdiChevronRight
        }),
        onClick: handleNext,
        position: "absolute",
        right: "20px",
        ...baseStyleNavigation
      }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react259.Swiper, {
        ref: swiperRef,
        navigation: { nextEl: null, prevEl: null },
        spaceBetween: 8,
        pagination: pagination ?? { clickable: false },
        autoHeight: false,
        watchOverflow: true,
        ...swiperProps,
        children: products.map((product) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react259.SwiperSlide, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(GalleryItem_default, {
            product,
            margin: 1,
            height: "full",
            hidePromotedMarkers: true,
            omitImageSizeSetting: true,
            showOnlyPrice,
            ...galleryItemProps
          })
        }, product.id))
      })
    ]
  });
};
var ProductSlider_default = ProductSlider;

// src/components/RepositoryFile/RepositoryFile.tsx
var import_react261 = require("@chakra-ui/react");
var import_js42 = require("@mdi/js");
var import_react262 = __toESM(require("@mdi/react"));
var import_date_fns10 = require("date-fns");
var import_filesize3 = __toESM(require("filesize"));
var import_react263 = require("react");
var import_react_i18next57 = require("react-i18next");
var import_react_truncate_string2 = __toESM(require("react-truncate-string"));
var import_jsx_runtime = require("react/jsx-runtime");
var isFile = (file) => {
  return file.type !== void 0;
};
var RepositoryFile = ({
  file,
  onClickFile,
  onClickDirectory,
  onCredentialsChange,
  onDelete,
  onDownload,
  onMove,
  onRename,
  selectedFiles,
  onSelectFile,
  selectedDirectories,
  onSelectDirectory,
  hasEditCredential = true,
  ...props
}) => {
  const { t } = (0, import_react_i18next57.useTranslation)();
  const [, isMd] = useResponsive_default();
  const fileIsFile = isFile(file);
  const menuItems = (0, import_react263.useMemo)(
    () => [
      ...fileIsFile ? [
        {
          icon: import_js42.mdiTrayArrowDown,
          label: t("FILE_REPO_DOWNLOAD"),
          onClick: () => onDownload(file)
        }
      ] : [],
      ...hasEditCredential ? [
        {
          icon: import_js42.mdiFolderArrowRightOutline,
          label: t("FILE_REPO_MOVE"),
          onClick: () => onMove(file)
        }
      ] : [],
      ...fileIsFile ? [] : hasEditCredential ? [
        {
          icon: import_js42.mdiAccountCheckOutline,
          label: t("FILE_REPO_CREDENTIALS"),
          onClick: () => onCredentialsChange(file)
        }
      ] : [],
      ...hasEditCredential ? [
        {
          icon: import_js42.mdiPencilOutline,
          label: t("FILE_REPO_RENAME"),
          onClick: () => onRename(file)
        },
        {
          icon: import_js42.mdiTrashCanOutline,
          label: t("FILE_REPO_DELETE"),
          onClick: () => onDelete(file)
        }
      ] : []
    ],
    [
      t,
      onDownload,
      onMove,
      onCredentialsChange,
      onRename,
      onDelete,
      file,
      hasEditCredential
    ]
  );
  const hasImageThumbnail = (0, import_react263.useMemo)(
    () => fileIsFile ? isImage(file.mimeType) : false,
    [fileIsFile, file]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react261.Stack, {
    isInline: true,
    height: "72px",
    align: "center",
    spacing: 3,
    minW: 0,
    borderBottom: "1px solid",
    borderColor: "gray.200",
    className: `file-repository__item${fileIsFile ? " file-repository__item-file" : " file-repository__item-directory"}`,
    ...props,
    children: [
      fileIsFile ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Checkbox, {
        disabled: !hasEditCredential,
        size: "lg",
        checked: selectedFiles == null ? void 0 : selectedFiles.includes(file.id),
        onChange: () => onSelectFile(file.id)
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Checkbox, {
        disabled: !hasEditCredential,
        size: "lg",
        checked: selectedDirectories == null ? void 0 : selectedDirectories.includes(file.id),
        onChange: () => onSelectDirectory(file.id)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Flex, {
        boxSize: "40px",
        align: "center",
        justify: "center",
        color: "gray.300",
        children: fileIsFile ? hasImageThumbnail ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Img, {
          boxSize: "40px",
          objectFit: "contain",
          src: getImageUrl(file.dbName, "thmb")
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react262.default, {
          path: import_js42.mdiFile,
          size: "40px"
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react262.default, {
          path: import_js42.mdiFolder,
          size: "40px"
        })
      }),
      fileIsFile ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Link, {
        flex: 1,
        fontSize: "md",
        minW: 0,
        title: file.fileName,
        onClick: (e) => onClickFile(file),
        "data-file-id": file.id,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_truncate_string2.default, {
          text: file.fileName ?? ""
        })
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Link, {
        flex: 1,
        fontSize: "md",
        href: "#",
        minW: 0,
        title: file.name,
        onClick: () => onClickDirectory(file),
        isTruncated: true,
        "data-dir-id": file.id,
        children: file.name ?? ""
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react261.Stack, {
        spacing: 4,
        isInline: true,
        align: "center",
        children: [
          isMd && fileIsFile ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Text, {
            as: "span",
            className: "file-size",
            textStyle: "bodyInput",
            children: (0, import_filesize3.default)((file == null ? void 0 : file.fileSize) ?? 0)
          }) : null,
          isMd && fileIsFile && (file == null ? void 0 : file.dateCreate) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.Text, {
            as: "span",
            className: "file-date-created",
            textStyle: "bodyInput",
            children: (0, import_date_fns10.format)(new Date(file.dateCreate), DATE_FORMAT_DOTS)
          }) : null,
          menuItems.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
            menuItems,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.MenuButton, {
              as: MoreIconButton_default
            })
          })
        ]
      })
    ]
  });
};
var RepositoryFile_default = RepositoryFile;

// src/components/RepositoryFileList/RepositoryFileList.tsx
var import_react264 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var RepositoryFileList = ({
  files,
  onClickFile,
  onClickDirectory,
  onCredentialsChange,
  onDelete,
  onDownload,
  onMove,
  onRename,
  selectedFiles,
  onSelectFile,
  selectedDirectories,
  onSelectDirectory,
  hasEditCredential = true,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react264.Stack, {
    className: "file-repository__list",
    ...props,
    children: files.map((file) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RepositoryFile_default, {
      selectedFiles,
      onSelectFile,
      selectedDirectories,
      onSelectDirectory,
      file,
      onCredentialsChange,
      onDelete,
      onDownload,
      onMove,
      onRename,
      onClickFile,
      onClickDirectory,
      hasEditCredential
    }, isFile(file) ? `file-${file.id}` : `directory-${file.id}`))
  });
};
var RepositoryFileList_default = RepositoryFileList;

// src/components/ResultsPagination/ResultsPagination.tsx
var import_react265 = require("@chakra-ui/react");
var import_react_i18next58 = require("react-i18next");
var import_react266 = __toESM(require("@mdi/react"));
var import_js43 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var Pagination3 = ({
  page,
  totalPages,
  nextPage,
  previousPage,
  setPage,
  ...props
}) => {
  const { t } = (0, import_react_i18next58.useTranslation)();
  const canNextPage = page < totalPages;
  const canPreviousPage = page > 1;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react265.Stack, {
    as: "nav",
    role: "navigation",
    className: "pagination",
    isInline: true,
    justifyContent: "flex-end",
    align: "center",
    my: 0,
    spacing: 3,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react265.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_PREV_PAGE"),
        size: "md",
        opacity: canPreviousPage ? 1 : 0.5,
        color: "gray.700",
        variant: "ghost",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react266.default, {
          path: import_js43.mdiChevronLeft,
          size: "16px"
        }),
        onClick: previousPage
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react265.NumberInput, {
        backgroundColor: "white",
        size: "md",
        value: page,
        maxW: "40px",
        minW: "46px",
        min: 1,
        max: totalPages + 1,
        onChange: (value) => setPage(Number(value)),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react265.NumberInputField, {
          textAlign: "center",
          paddingInline: 0
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react265.Text, {
        as: "span",
        color: "gray.500",
        children: [
          t("OF"),
          " ",
          totalPages
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react265.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_NEXT_PAGE"),
        size: "md",
        opacity: canNextPage ? 1 : 0.5,
        color: "gray.700",
        variant: "ghost",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react266.default, {
          path: import_js43.mdiChevronRight,
          size: "16px"
        }),
        onClick: nextPage
      })
    ]
  });
};
var ResultsPagination_default = Pagination3;

// src/components/ResultsPerPage/ResultsPerPage.tsx
var import_react267 = require("@chakra-ui/react");
var import_react_i18next59 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ResultsPerPage = ({
  value,
  onChange,
  perPageOptions = [20, 40, 100],
  ...props
}) => {
  const { t } = (0, import_react_i18next59.useTranslation)();
  const handleChange = (e) => {
    onChange(e.target.value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react267.Stack, {
    className: "per-page",
    direction: "row",
    alignItems: "center",
    maxW: "100%",
    minW: "0%",
    flex: 1,
    fontSize: "md",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react267.Select, {
        borderRadius: 6,
        backgroundColor: "white",
        width: "80px",
        value,
        onChange: handleChange,
        children: perPageOptions.map((opt) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
          value: opt,
          children: opt
        }, opt))
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react267.Text, {
        isTruncated: true,
        maxW: "100%",
        as: "span",
        color: "gray.700",
        children: t("PAGINATION_RESULTS_PER_PAGE")
      })
    ]
  });
};
var ResultsPerPage_default = ResultsPerPage;

// src/components/RoundIcon/RoundIcon.tsx
var import_react268 = require("@chakra-ui/react");
var import_react269 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var RoundIcon = import_react269.default.forwardRef(
  ({ icon, ...props }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react268.Flex, {
      ref,
      position: "relative",
      as: "span",
      minW: "33px",
      minH: "33px",
      maxW: "33px",
      maxH: "33px",
      justify: "center",
      align: "center",
      fontSize: 20,
      borderRadius: "9999px",
      rounded: "full",
      bg: "cyan.400",
      color: "white",
      ...props,
      children: (0, import_react269.createElement)(icon)
    });
  }
);
var RoundIcon_default = RoundIcon;

// src/components/SubordinatesCheckbox/SubordinatesCheckbox.tsx
var import_react270 = require("@chakra-ui/react");
var import_react_i18next60 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var SubordinatesCheckbox = ({
  isChecked = false,
  onChange = () => {
  },
  ...props
}) => {
  const { t } = (0, import_react_i18next60.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react270.FormControl, {
    display: "flex",
    gap: "12px",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react270.Switch, {
        id: "with-subordinates",
        isChecked,
        onChange: () => onChange(!isChecked)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react270.FormLabel, {
        htmlFor: "with-subordinates",
        fontWeight: "400",
        mb: "0",
        children: t("WITH_SUBORDINATES_SWITCH")
      })
    ]
  });
};
var SubordinatesCheckbox_default = SubordinatesCheckbox;

// src/components/TaskItem/TaskItem.tsx
var import_react271 = require("@chakra-ui/react");
var import_react272 = require("@emotion/react");
var import_lib5 = require("@questy/lib");
var import_date_fns11 = require("date-fns");
var import_react273 = require("react");
var import_react_i18next61 = require("react-i18next");
var import_fa11 = require("react-icons/fa");
var import_react_query13 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var STANDARD_ICONS = {
  default: import_fa11.FaQuestion,
  "glyphicon-phone-alt": import_fa11.FaPhone,
  "glyphicon-star": import_fa11.FaStar,
  "glyphicon-briefcase": import_fa11.FaBriefcase,
  "glyphicon-flag": import_fa11.FaFlag,
  "glyphicon-fire": import_fa11.FaFire
};
var getTaskTypeIcon = (icon, iconColor, typeName) => {
  const standardIconKey = !icon ? "default" : Object.keys(STANDARD_ICONS).find((key) => icon.match(key));
  if (standardIconKey) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RoundIcon_default, {
      className: "task__icon",
      maxW: 6,
      maxH: 6,
      minW: 6,
      minH: 6,
      fontSize: 12,
      icon: STANDARD_ICONS[standardIconKey],
      color: iconColor,
      bg: "none",
      border: 1,
      borderStyle: "solid",
      borderColor: "gray.200",
      title: typeName,
      display: "inline-flex"
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Box, {
      display: "inline-block",
      className: "task__icon",
      dangerouslySetInnerHTML: {
        __html: `<span style="fill: ${iconColor}" title="${typeName}">${icon}</span>`
      }
    });
  }
};
var TaskItem = ({
  task,
  index,
  isLoading = false,
  handleEditTaskAura,
  handleCompleteTaskAura,
  showCompany = true,
  showUserAvatar = true
}) => {
  var _a2, _b;
  const { t } = (0, import_react_i18next61.useTranslation)();
  const { language, currentLocale } = (0, import_react273.useContext)(LanguageContext);
  const { id, user, taskName, taskDescription, beginDate, type } = task;
  const typeName = type.typeName;
  const icon = type.icon;
  const iconColor = type.iconColor;
  const taskBeginDate = new Date(beginDate);
  const dateBadge = (0, import_date_fns11.formatDistanceToNow)(taskBeginDate, {
    locale: currentLocale,
    addSuffix: true
  });
  const isEvent = type.isEvent;
  const isOverdue = !isEvent && (0, import_date_fns11.isPast)(taskBeginDate);
  const isRecurring = task.recurrenceUuid !== null;
  const isVirtualTask = task.id === null && task.recurrenceUuid && task.recurrenceParentBeginDate;
  const isExecutable = (task.id || isVirtualTask) && !isEvent && !task.isCompleted;
  const { data: moduleCredential } = (0, import_react_query13.useQuery)(
    ["tasks", "meta", "moduleCredential", { forType: task.type.id }],
    () => api_default.getMeta("tasks", {
      params: {
        "for[type]": task.type.id
      }
    }),
    {
      staleTime: Infinity,
      select: (data) => {
        var _a3;
        return (_a3 = data.data) == null ? void 0 : _a3.module.credential;
      },
      enabled: typeof ((_a2 = task == null ? void 0 : task.type) == null ? void 0 : _a2.id) !== "undefined" && isExecutable === true
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Flex, {
    role: "group",
    direction: "row",
    align: "center",
    w: "100%",
    className: "task",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react271.Flex, {
      borderTop: index === 0 ? 0 : 1,
      borderStyle: "solid",
      borderColor: "gray.200",
      p: 4,
      width: "100%",
      justify: "flex-start",
      align: "center",
      flexWrap: "nowrap",
      children: [
        showUserAvatar && ((user == null ? void 0 : user.fullName) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Avatar, {
          css: import_react272.css`
                & > img {
                  background: white;
                }
              `,
          size: "sm",
          showBorder: true,
          name: user.fullName,
          title: user.fullName,
          src: getImageUrl(user == null ? void 0 : user.avatar, "thmb") ?? void 0
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Avatar, {
          size: "sm",
          showBorder: true
        })),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react271.Stack, {
          m: 1,
          mx: 4,
          spacing: 1,
          direction: "column",
          flex: "1 1 auto",
          overflow: "hidden",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react271.Stack, {
              className: "task__main-info",
              isInline: true,
              align: "center",
              w: "full",
              children: [
                getTaskTypeIcon(icon, iconColor, typeName),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Box, {
                  className: "task__time",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Tooltip, {
                    "aria-label": "Task time",
                    placement: "top",
                    label: (0, import_date_fns11.format)(new Date(beginDate), DATETIME_FORMAT_DOTS),
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Badge, {
                      textTransform: "initial",
                      variant: isOverdue ? "solid" : "subtle",
                      colorScheme: isOverdue ? "red" : "gray",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      verticalAlign: "middle",
                      py: "0.15rem",
                      children: dateBadge
                    })
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Link, {
                  className: "task__link",
                  wordBreak: "break-word",
                  onClick: () => handleEditTaskAura(task),
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Text, {
                    as: "span",
                    color: "gray.800",
                    fontWeight: "bold",
                    children: !taskName || taskName.trim().length === 0 ? t("NO_NAME") : taskName
                  })
                }),
                isRecurring && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Tooltip, {
                  placement: "top",
                  "aria-label": "Recurring task",
                  label: t("TASK_RECURRING"),
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Box, {
                    className: "task__recurring",
                    "data-testid": "recurring task icon",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Box, {
                      as: import_fa11.FaRedoAlt,
                      color: "gray.400"
                    })
                  })
                })
              ]
            }),
            taskDescription && taskDescription.trim().length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Text, {
              w: "full",
              isTruncated: true,
              className: "task__description",
              mt: 1,
              color: "gray.600",
              whiteSpace: "nowrap",
              children: stripHtmlTags(taskDescription)
            }),
            showCompany && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Text, {
              fontSize: "sm",
              children: (_b = task.relations) == null ? void 0 : _b.accountCompanies.map(
                (company, index2, acArray) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.Link, {
                      href: `/accountCompany/show/company_id/${company.id}`,
                      children: company.value
                    }, company.id),
                    index2 === acArray.length - 1 ? "" : ", "
                  ]
                })
              )
            })
          ]
        }),
        isExecutable && moduleCredential > import_lib5.ModuleCredential.Show ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react271.IconButton, {
          isLoading,
          isDisabled: isLoading,
          "aria-label": "Execute task",
          ml: 2,
          title: t("EXECUTE"),
          variant: "solid",
          colorScheme: "green",
          size: "xs",
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa11.FaCalendarCheck, {}),
          onClick: () => handleCompleteTaskAura(task)
        }) : null
      ]
    })
  });
};
TaskItem.displayName = "TaskItem";
var TaskItem_default = TaskItem;

// src/components/TaskList/TaskList.tsx
var import_react274 = require("@chakra-ui/react");
var import_sortBy3 = __toESM(require("lodash/sortBy"));
var import_reverse = __toESM(require("lodash/reverse"));
var import_slice = __toESM(require("lodash/slice"));
var import_jsx_runtime = require("react/jsx-runtime");
var sortTasks = (tasks, isEvent) => {
  const sortedTasks = (0, import_sortBy3.default)(tasks, ["beginDate", "id"]);
  return isEvent ? (0, import_reverse.default)(sortedTasks) : sortedTasks;
};
var TaskList = ({
  data: tasks,
  loadingTasks = [],
  handleCompleteTask,
  handleEditTask,
  isEvent = false,
  limit = 500,
  showCompany,
  showUserAvatar,
  ...props
}) => {
  const theme = (0, import_react274.useTheme)();
  if (!tasks) {
    return null;
  }
  const sortedTasks = sortTasks(tasks, isEvent);
  const limitedTasks = (0, import_slice.default)(sortedTasks, 0, limit);
  if (limitedTasks.length === 0) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react274.Box, {
    className: "task-list",
    border: 1,
    borderStyle: "solid",
    borderColor: "gray.200",
    borderRadius: 4,
    my: 2,
    css: import_react274.css`
        & > .task ~ .task {
          border-top: 1px solid
            ${theme.colors.gray[200]};
        }
      `,
    ...props,
    children: limitedTasks.map((task, index) => {
      const isLoading = loadingTasks.find(
        (loadingTask) => loadingTask.recurrenceUuid === task.recurrenceUuid && loadingTask.recurrenceParentBeginDate === task.recurrenceParentBeginDate
      );
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TaskItem_default, {
        task,
        index,
        isLoading: !!isLoading,
        handleEditTaskAura: handleEditTask,
        handleCompleteTaskAura: handleCompleteTask,
        showCompany,
        showUserAvatar,
        isEvent
      }, `${task.id}${task.recurrenceUuid}${task.beginDate}`);
    })
  });
};
var TaskList_default = TaskList;

// src/components/TextScroll/TextScroll.tsx
var import_react275 = require("react");
var import_react276 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TextScroll = ({ children, ...props }) => {
  const scrollContentRef = (0, import_react275.useRef)(null);
  const [isScrollableToLeft, setIsScrollableToLeft] = (0, import_react275.useState)(false);
  const [isScrollableToRight, setIsScrollableToRight] = (0, import_react275.useState)(false);
  (0, import_react275.useEffect)(() => {
    const scrollContent = scrollContentRef.current;
    const handleScroll = () => {
      if (scrollContent) {
        setIsScrollableToLeft(scrollContent.scrollLeft > 0);
        setIsScrollableToRight(
          scrollContent.scrollLeft < scrollContent.scrollWidth - scrollContent.clientWidth
        );
      }
    };
    if (scrollContent) {
      scrollContent.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContent) {
        scrollContent.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react276.Box, {
    h: "fit-content",
    position: "relative",
    ...props,
    children: [
      isScrollableToLeft && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ShadowBox, {
        type: "left"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react276.HStack, {
        ref: scrollContentRef,
        className: "text-scroll",
        overflowX: "auto",
        width: "100%",
        whiteSpace: "nowrap",
        sx: {
          "&::-webkit-scrollbar": {
            display: "none"
          },
          "scrollbar-width": "none",
          "::-webkit-scrollbar": {
            display: "none"
          }
        },
        children
      }),
      (isScrollableToRight || !(scrollContentRef == null ? void 0 : scrollContentRef.current)) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ShadowBox, {
        type: "right"
      })
    ]
  });
};
var TextScroll_default = TextScroll;
var ShadowBox = ({ type, ...props }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react276.Box, {
  h: "100%",
  w: "32px",
  position: "absolute",
  top: "0",
  ...type === "left" ? { left: "0" } : { right: "0" },
  ...props,
  sx: {
    "&": {
      "background-color": "rgba(255, 255, 255, 0)",
      "background-image": `linear-gradient(${type === "left" ? "270deg" : "90deg"}, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)`
    }
  }
});

// src/components/TileList/TileItem/TileItem.tsx
var import_react277 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TileItem = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react277.Link, {
    color: "blue.500",
    fontSize: "sm",
    fontWeight: 400,
    lineHeight: "20px",
    isExternal: true,
    ...props
  });
};
var TileItem_default = TileItem;

// src/components/TileList/TileItemList/TileItemList.tsx
var import_react278 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TileItemList = ({ children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react278.Stack, {
    children
  });
};
var TileItemList_default = TileItemList;

// src/components/TileList/TileList.tsx
var import_react279 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TileList = ({ icon, children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react279.HStack, {
    className: "tile-list",
    alignItems: "flex-start",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react279.Box, {
        className: "tile-list__icon",
        color: "gray.300",
        children: icon
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react279.Flex, {
        className: "tile-list__items",
        children
      })
    ]
  });
};
var TileList_default = TileList;

// src/components/Timeline/Timeline.tsx
var import_react280 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Timeline = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react280.VStack, {
    className: "timeline",
    position: "relative",
    bg: "white",
    spacing: 0,
    ...props,
    children
  });
};
var Timeline_default = Timeline;

// src/components/Timeline/TimelineItem/TimelineItem.tsx
var import_react281 = require("@chakra-ui/react");
var import_js44 = require("@mdi/js");
var import_react282 = __toESM(require("@mdi/react"));
var import_date_fns12 = require("date-fns");
var import_jsx_runtime = require("react/jsx-runtime");
var TimelineItem = ({
  children,
  date,
  user,
  title,
  ...props
}) => {
  const { isOpen, onToggle } = (0, import_react281.useDisclosure)();
  const { currentLocale } = useLanguage();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.VStack, {
    className: "timeline-item",
    _before: {
      width: "1px",
      content: "''",
      position: "absolute",
      left: "32px",
      top: 0,
      bottom: 0,
      background: "gray.200"
    },
    alignItems: "flex-start",
    w: "full",
    pl: "60px",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react281.HStack, {
      spacing: 0,
      align: "flex-start",
      justify: "flex-start",
      w: "full",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react281.Flex, {
          direction: "column",
          zIndex: 1,
          alignItems: "flex-start",
          py: 4,
          flex: 1,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Badge, {
              className: "timeline-item__time-badge",
              borderRadius: 1,
              px: 1,
              py: 0,
              fontSize: "sm",
              fontWeight: 400,
              textTransform: "unset",
              color: "gray.700",
              children: date ? (0, import_date_fns12.formatDistanceToNow)(date, {
                locale: currentLocale,
                addSuffix: true,
                includeSeconds: true
              }) : ""
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Stack, {
              isInline: true,
              align: "center",
              spacing: "12px",
              mb: "2px",
              mt: "8px",
              className: "timeline-item__author",
              children: user ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Avatar, {
                    showBorder: true,
                    borderColor: "gray.200",
                    borderWidth: "1px",
                    size: "sm",
                    ml: "-44px",
                    name: user.fullName
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Text, {
                    fontSize: "sm",
                    color: "gray.500",
                    fontWeight: 400,
                    lineHeight: "20px",
                    letterSpacing: "0.25px",
                    children: user.fullName
                  })
                ]
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Avatar, {
                showBorder: true,
                borderColor: "gray.200",
                borderWidth: "1px",
                size: "sm",
                ml: "-44px"
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Text, {
              className: "timeline-item__title",
              fontSize: "md",
              color: "gray.700",
              mb: 2,
              lineHeight: "24px",
              fontWeight: 500,
              letterSpacing: "0.15px",
              children: title
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Collapse, {
              className: "timeline-item__content",
              in: isOpen,
              animateOpacity: true,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Text, {
                fontSize: "md",
                color: "gray.600",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                children
              })
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.Box, {
          pt: "42px",
          px: 3,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react281.IconButton, {
            className: "timeline-item__toggle-content-button",
            "aria-label": "expand",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react282.default, {
              path: isOpen ? import_js44.mdiChevronUp : import_js44.mdiChevronDown
            }),
            minW: "unset",
            variant: "ghost",
            boxSize: "20px",
            onClick: onToggle
          })
        })
      ]
    })
  });
};
var TimelineItem_default = TimelineItem;

// src/components/UsedMaterials/UsedMaterials.tsx
var import_react288 = require("@chakra-ui/react");
var import_react289 = require("react");
var import_react290 = require("@chakra-ui/react");
var import_react_i18next63 = require("react-i18next");
var import_react291 = require("@mdi/react");
var import_js46 = require("@mdi/js");

// src/components/UsedMaterials/TdExtended/TdExtended.tsx
var import_react283 = require("@chakra-ui/react");
var import_js45 = require("@mdi/js");
var import_react284 = __toESM(require("@mdi/react"));
var import_react285 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var TdExtended = ({
  handleOnChange,
  handleDelete,
  handleAdd,
  product,
  isReadOnly,
  defaultOptions
}) => {
  const [quantity, setQuantity] = (0, import_react285.useState)((product == null ? void 0 : product.quantity) ?? "");
  const handleQuantity = (e) => {
    const newValue = e.target.value ? parseFloat(e.target.value) : null;
    setQuantity(newValue);
    onChange("quantity", newValue);
  };
  const [price, setPrice] = (0, import_react285.useState)((product == null ? void 0 : product.price) ?? "");
  (0, import_react285.useEffect)(() => {
    const newPrice = (product == null ? void 0 : product.price) ? Number(formatPriceToTwoDecimalPlaces(product == null ? void 0 : product.price)) : 0;
    newPrice != price && setPrice(newPrice);
  }, [product]);
  const handlePrice = (e) => {
    const newValue = e.target.value ? Number(formatPriceToTwoDecimalPlaces(e.target.value)) : null;
    setPrice(newValue);
    onChange("price", newValue);
  };
  const onChange = (key, value) => handleOnChange({
    id: product == null ? void 0 : product.id,
    quantity,
    price,
    ...key && { [key]: value }
  });
  const [selectedValue, setSelectedValue] = (0, import_react285.useState)();
  const onAdd = (value) => {
    value && setSelectedValue(value);
    handleAdd(value ?? selectedValue);
  };
  const labelValue = `${product == null ? void 0 : product.productName} ${(product == null ? void 0 : product.productCode) ? `(${product.productCode})` : ""}`;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: !isReadOnly ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Td, {
          w: "50%",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react283.HStack, {
            spacing: "8px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.FormControl, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                  value: {
                    label: labelValue,
                    value: product == null ? void 0 : product.id
                  },
                  controlShouldRenderValue: product ? true : false,
                  blurInputOnSelect: true,
                  onChange: (data) => {
                    typeof handleAdd === "function" ? onAdd(data == null ? void 0 : data.value) : onChange("changedProductId", data == null ? void 0 : data.value);
                  },
                  isClearable: false,
                  hideSelectedOptions: false,
                  options: defaultOptions,
                  components: {
                    Option: CustomProductOption_default
                  },
                  loadDataProps: {
                    endpoint: "products",
                    labelField: "name",
                    autoselect: true,
                    additionalNameAccessor: "code",
                    settings: {
                      "order[_q]": "DESC",
                      "order[name]": "ASC"
                    }
                  }
                })
              }),
              product && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Link, {
                    href: product == null ? void 0 : product.link,
                    isExternal: true,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.IconButton, {
                      w: "40px",
                      h: "40px",
                      "aria-label": "Open",
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react284.default, {
                        path: import_js45.mdiOpenInNew,
                        size: "20px"
                      })
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.IconButton, {
                    w: "40px",
                    h: "40px",
                    "aria-label": "Open",
                    onClick: () => handleDelete(product == null ? void 0 : product.id),
                    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react284.default, {
                      path: import_js45.mdiTrashCanOutline,
                      size: "20px"
                    })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Td, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
            isDisabled: !product,
            type: "number",
            value: quantity,
            onChange: (e) => handleQuantity(e),
            borderColor: "gray.200"
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Td, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
            isDisabled: !product,
            type: "number",
            value: price,
            onChange: (e) => handlePrice(e),
            borderColor: "gray.200"
          })
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Td, {
          w: "50%",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Link, {
            href: product == null ? void 0 : product.link,
            color: "crmBlue",
            isTruncated: true,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Text, {
              isTruncated: true,
              children: `${product == null ? void 0 : product.productName} (${product == null ? void 0 : product.productCode})`
            })
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Td, {
          children: product == null ? void 0 : product.quantity
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react283.Td, {
          textAlign: "right",
          children: priceFormatter(price, "none", { formatToParts: true }, 2)
        })
      ]
    })
  });
};
var TdExtended_default = TdExtended;
var formatPriceToTwoDecimalPlaces = (input) => {
  const number = parseFloat(input);
  if (isNaN(number)) {
    return;
  }
  if (Number.isInteger(number)) {
    return number.toString();
  }
  const formattedValue = number.toFixed(2).replace(/\.?0+$/, "").replace(/[^\d.\,]/g, "");
  return formattedValue;
};

// src/components/UsedMaterials/Modal/ModalUsedMaterials.tsx
var import_react286 = require("@chakra-ui/react");
var import_react287 = require("react");
var import_react_i18next62 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var getProduct = async ({
  id,
  companyId
}) => {
  var _a2;
  const product = await api_default.getAutoselect("products", {
    params: {
      fields: "id,name,code",
      extra_fields: "prices",
      "setting[with_relations]": true,
      ...companyId && { "for[company.id]": companyId },
      ...id && { "filter[id][eq]": id }
    }
  });
  return (_a2 = product == null ? void 0 : product.data) == null ? void 0 : _a2[0];
};
var ModalUsedMaterials = ({
  isOpen,
  onClose,
  editedProduct: product,
  companyId,
  handleAdd,
  handleOnChange,
  handleDelete
}) => {
  const { t } = (0, import_react_i18next62.useTranslation)();
  const [quantity, setQuantity] = (0, import_react287.useState)();
  const handleQuantity = (e) => {
    const newValue = parseFloat(e.target.value) ?? null;
    setQuantity(newValue);
  };
  const [price, setPrice] = (0, import_react287.useState)();
  const handlePrice = (e) => {
    const newValue = e.target.value ? formatPriceToTwoDecimalPlaces(e.target.value) : null;
    setPrice(newValue);
  };
  const [selectedProduct, setSelectedProduct] = (0, import_react287.useState)();
  const isSm = (0, import_react286.useBreakpointValue)({
    base: true,
    md: false
  });
  const mobileStyle = {
    height: "100%",
    mt: 0,
    borderRadius: 0
  };
  const handleProductChange = async (productId) => {
    const fetchedProduct = await getProduct({ id: productId, companyId });
    setSelectedProduct(fetchedProduct);
    setQuantity(1);
    const companyPrice = getUserPrice(fetchedProduct == null ? void 0 : fetchedProduct.prices);
    const newPrice = (companyPrice == null ? void 0 : companyPrice.priceNetto) ? formatPriceToTwoDecimalPlaces(companyPrice.priceNetto) : 0;
    setPrice(newPrice);
  };
  const onSave = () => {
    if (!(selectedProduct == null ? void 0 : selectedProduct.id))
      return;
    handleOnChange({
      id: product == null ? void 0 : product.id,
      quantity,
      price,
      ...(selectedProduct == null ? void 0 : selectedProduct.id) ? { changedProductId: selectedProduct.id } : null
    });
    onClose();
  };
  const onAdd = () => {
    if (!(selectedProduct == null ? void 0 : selectedProduct.id))
      return;
    handleAdd(selectedProduct.id, price, quantity);
    onClose();
  };
  (0, import_react287.useEffect)(() => {
    setPrice((product == null ? void 0 : product.price) ?? "");
    setQuantity((product == null ? void 0 : product.quantity) ?? "");
    setSelectedProduct(product ?? {});
  }, [product, isOpen]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
      isOpen,
      onClose,
      size: `${isSm ? "full" : "lg"}`,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
          ...isSm && mobileStyle,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
              fontWeight: "500",
              lineHeight: "36px",
              showBorders: false,
              children: t(`${!product ? "Add product" : "USED_MATERIALS_EDIT_PRODUCT"}`)
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react286.VStack, {
                spacing: "16px",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react286.FormControl, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react286.FormLabel, {
                        htmlFor: "product-name",
                        children: t("Product name")
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                        value: {
                          label: getLabelValue(selectedProduct),
                          value: selectedProduct == null ? void 0 : selectedProduct.id
                        },
                        onChange: ({ value }) => handleProductChange(value),
                        isClearable: false,
                        loadDataProps: {
                          endpoint: "products",
                          labelField: "name",
                          autoselect: false,
                          additionalNameAccessor: "code",
                          settings: {
                            "order[_q]": "DESC",
                            "order[name]": "ASC"
                          }
                        },
                        components: {
                          Option: CustomProductOption_default
                        },
                        closeMenuOnSelect: true
                      })
                    ]
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react286.FormControl, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react286.FormLabel, {
                        htmlFor: "product-quantity",
                        children: t("Quantity")
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                        type: "number",
                        value: quantity,
                        onChange: (e) => handleQuantity(e),
                        id: "product-quantity"
                      })
                    ]
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react286.FormControl, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react286.FormLabel, {
                        htmlFor: "product-price",
                        children: t("Price netto")
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                        type: "number",
                        value: price,
                        onChange: (e) => handlePrice(e),
                        id: "product-price"
                      })
                    ]
                  })
                ]
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
              showBorders: false,
              children: [
                product && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react286.Button, {
                  variant: "ghost",
                  onClick: () => handleDelete(product == null ? void 0 : product.id),
                  children: [
                    " ",
                    t("Delete")
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react286.Button, {
                  backgroundColor: "crmBlue",
                  color: "#fff",
                  ml: 3,
                  onClick: () => product ? onSave() : onAdd(),
                  children: product ? t("TASK_CONFIRM_EDIT") : t("GANTT_CONFIG_ADD")
                })
              ]
            })
          ]
        })
      ]
    })
  });
};
var ModalUsedMaterials_default = ModalUsedMaterials;
var getLabelValue = (selectedProduct) => {
  return `${(selectedProduct == null ? void 0 : selectedProduct.name) ?? (selectedProduct == null ? void 0 : selectedProduct.productName) ?? ""} ${(selectedProduct == null ? void 0 : selectedProduct.code) || (selectedProduct == null ? void 0 : selectedProduct.productCode) ? `(${selectedProduct.code ?? selectedProduct.productCode})` : ""}`;
};

// src/components/UsedMaterials/UsedMaterials.tsx
var import_debounce6 = __toESM(require("lodash/debounce"));
var import_fa12 = require("react-icons/fa");
var import_react_query14 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var UsedMaterials = ({
  usedMaterials,
  companyId,
  handleDelete,
  handleOnChange,
  handleAdd,
  isReadOnly
}) => {
  const { data: defaultOptions, isLoading } = (0, import_react_query14.useQuery)(
    ["products"],
    async () => {
      var _a2;
      const response = await api_default.getEndpoint("products", {
        params: {
          "page[limit]": 20,
          fields: "name,code"
        }
      });
      const preparedData = (_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((product) => ({
        ...product,
        additionalName: product == null ? void 0 : product.code
      }));
      return buildOptions(preparedData, "name", "id");
    },
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  );
  const { t } = (0, import_react_i18next63.useTranslation)();
  const isDesktop = (0, import_react288.useBreakpointValue)({
    base: false,
    lg: true
  });
  const [editedProduct, setEditedProduct] = (0, import_react289.useState)();
  const { isOpen: isOpenModal, onOpen, onClose } = (0, import_react288.useDisclosure)();
  const closeModalForm = () => {
    setEditedProduct(null);
    onClose();
  };
  const onChange = (0, import_debounce6.default)(handleOnChange, 300);
  const rowsBase = usedMaterials == null ? void 0 : usedMaterials.map((product, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
    className: "used-materials__table__row-base",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
      p: 0,
      maxW: "0px",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BoxCollapse, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BoxCollapseItem, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BoxCollapseButton, {
              minH: "56px",
              py: "16px",
              pl: "24px",
              pr: "8px",
              justifyContent: "space-between",
              _expanded: { bg: "gray.50" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.Link, {
                  color: "crmBlue",
                  target: "_blank",
                  isTruncated: true,
                  mr: "24px",
                  href: product == null ? void 0 : product.link,
                  isExternal: true,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.Text, {
                    letterSpacing: "0.5px",
                    isTruncated: true,
                    children: `${product == null ? void 0 : product.productName} (${product == null ? void 0 : product.productCode})`
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react288.AccordionIcon, {})
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BoxCollapseContent, {
              px: "24px",
              py: "0",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react288.Flex, {
                  justifyContent: "space-between",
                  py: "16px",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.Text, {
                      fontStyle: "bodyInput",
                      fontWeight: "500",
                      letterSpacing: "0.5px",
                      children: t("Quantity")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.Text, {
                      fontStyle: "bodyInput",
                      letterSpacing: "0.5px",
                      children: product == null ? void 0 : product.quantity
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react288.Flex, {
                  justifyContent: "space-between",
                  py: "16px",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.Text, {
                      fontStyle: "bodyInput",
                      fontWeight: "500",
                      letterSpacing: "0.5px",
                      children: t("Price netto")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.Text, {
                      fontStyle: "bodyInput",
                      letterSpacing: "0.5px",
                      children: priceFormatter(
                        product == null ? void 0 : product.price,
                        "none",
                        { formatToParts: true },
                        2
                      )
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react288.Flex, {
                  gap: "8px",
                  py: "8px",
                  justifyContent: "flex-end",
                  children: [
                    !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react288.IconButton, {
                      w: "40px",
                      h: "40px",
                      "aria-label": "Edit",
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react291.Icon, {
                        path: import_js46.mdiPencilOutline,
                        size: "20px"
                      }),
                      onClick: () => {
                        setEditedProduct(product);
                        onOpen();
                      },
                      "data-testid": "btn-edit"
                    }),
                    !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react288.IconButton, {
                      w: "40px",
                      h: "40px",
                      "aria-label": "Delete",
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react291.Icon, {
                        path: import_js46.mdiTrashCanOutline,
                        size: "20px"
                      }),
                      onClick: () => handleDelete(product == null ? void 0 : product.id),
                      "data-testid": "btn-delete"
                    })
                  ]
                })
              ]
            })
          ]
        })
      })
    })
  }, index));
  const rowsXl = (0, import_react289.useMemo)(() => {
    return usedMaterials == null ? void 0 : usedMaterials.map((product, index) => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
        className: "used-materials__table__row-extended",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TdExtended_default, {
          handleOnChange: onChange,
          handleDelete,
          product,
          isReadOnly,
          defaultOptions
        })
      }, index);
    });
  }, [usedMaterials, defaultOptions, isReadOnly]);
  if (isLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react288.Center, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react288.Spinner, {
        color: "blue.500",
        size: "xl"
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react288.Box, {
      className: "used-materials",
      children: [
        !isDesktop && !isReadOnly ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react288.Button, {
          variant: "outline",
          mt: 2,
          size: "sm",
          leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa12.FaPlus, {}),
          className: "used-materials__button-add-new",
          textTransform: "capitalize",
          onClick: () => {
            onOpen();
          },
          children: t("ADD")
        }) : null,
        (usedMaterials == null ? void 0 : usedMaterials.length) || isDesktop && (isReadOnly && (usedMaterials == null ? void 0 : usedMaterials.length) || !isReadOnly) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.TableContainer, {
          border: "1px solid",
          borderColor: "gray.200",
          borderRadius: "6px",
          mt: "16px",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react290.Table, {
            className: "used-materials__table",
            children: [
              (usedMaterials == null ? void 0 : usedMaterials.length) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react290.Thead, {
                backgroundColor: "gray.100",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                  children: [
                    !isDesktop ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                      children: t("Product name")
                    }) : null,
                    isDesktop && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("Product name")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("Quantity")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          textAlign: isReadOnly ? "right" : "left",
                          children: t("Price netto")
                        })
                      ]
                    })
                  ]
                })
              }) : "",
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react290.Tbody, {
                children: [
                  isDesktop ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                    children: [
                      rowsXl,
                      !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
                        className: "used-materials__table__add-new",
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TdExtended_default, {
                          product: null,
                          handleOnChange: onChange,
                          handleAdd,
                          defaultOptions
                        })
                      })
                    ]
                  }) : rowsBase,
                  " "
                ]
              })
            ]
          })
        }) : "",
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalUsedMaterials_default, {
          isOpen: isOpenModal,
          onClose: () => {
            closeModalForm();
          },
          editedProduct,
          companyId,
          handleAdd,
          handleOnChange,
          handleDelete
        })
      ]
    })
  });
};
var UsedMaterials_default = UsedMaterials;

// src/components/Widget/Widget.tsx
var import_react292 = require("@chakra-ui/react");
var import_react293 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Widget = ({ widgetUUID, children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react292.Box, {
    className: "widget__container",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react293.Global, {
        styles: import_react293.css`
          /* Ukrycie starych panelu kontrolek */
          .widgetElementOptions[uid="${widgetUUID}"] {
            display: none !important;
          }
        `
      }),
      children
    ]
  });
};
var Widget_default = Widget;

// src/components/Widget/WidgetBody/WidgetBody.tsx
var import_react294 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetBody = ({
  isOpen = true,
  children,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react294.Box, {
    className: "widget__body",
    mt: 4,
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react294.Collapse, {
      in: isOpen,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react294.Box, {
        children
      })
    })
  });
};
var WidgetBody_default = WidgetBody;

// src/components/Widget/WidgetControls/WidgetControls.tsx
var import_react295 = require("@chakra-ui/react");
var import_js47 = require("@mdi/js");
var import_react296 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetControls = ({
  isLoading,
  isOpen,
  onOpenSettings,
  onRefresh,
  onToggleOpen
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react295.ButtonGroup, {
    spacing: 2,
    variant: "ghost",
    children: [
      onRefresh ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react295.IconButton, {
        isLoading,
        "aria-label": "refresh",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react296.default, {
          path: import_js47.mdiRefresh,
          size: "24px"
        }),
        onClick: onRefresh
      }) : null,
      onOpenSettings ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react295.IconButton, {
        "aria-label": "settings",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react296.default, {
          path: import_js47.mdiCogOutline,
          size: "24px"
        }),
        onClick: onOpenSettings
      }) : null,
      onToggleOpen ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react295.IconButton, {
        "aria-label": "minimize",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react296.default, {
          path: isOpen ? import_js47.mdiChevronUp : import_js47.mdiChevronDown,
          size: "24px"
        }),
        onClick: onToggleOpen
      }) : null
    ]
  });
};
var WidgetControls_default = WidgetControls;

// src/components/Widget/WidgetHeader/WidgetHeader.tsx
var import_react297 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetHeader = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react297.Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    ...props,
    children
  });
};
var WidgetHeader_default = WidgetHeader;

// src/components/Widget/WidgetName/WidgetName.tsx
var import_react298 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetName = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react298.Heading, {
    as: "h5",
    fontSize: "lg",
    fontWeight: 500,
    ...props,
    children
  });
};
var WidgetName_default = WidgetName;

// src/components/Widget/WidgetSettingsModal/WidgetSettingsModal.tsx
var import_react299 = require("@chakra-ui/react");
var import_react_i18next64 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetSettingsModal = ({
  onClose,
  onRemove,
  initialFocusRef,
  children,
  ...props
}) => {
  const { t } = (0, import_react_i18next64.useTranslation)();
  const handleSave = () => {
    onClose();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react299.Modal, {
    initialFocusRef,
    closeOnOverlayClick: false,
    onClose,
    scrollBehavior: "inside",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react299.ModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react299.ModalContent, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react299.ModalHeader, {
            borderBottom: "1px",
            borderColor: "gray.200",
            py: "20px",
            px: "24px",
            position: "relative",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react299.Text, {
                textStyle: "h4",
                as: "h4",
                children: t("WIDGET_SETTINGS")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react299.ModalCloseButton, {
                boxSize: "40px",
                top: "50%",
                right: "24px ",
                transform: "translateY(-50%)"
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react299.ModalBody, {
            py: "16px",
            px: "24px",
            children
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react299.ModalFooter, {
            boxShadow: "0px -10px 15px -3px rgba(0, 0, 0, 0.06), 0px -4px 6px -2px rgba(0, 0, 0, 0.05)",
            p: "16px 24px 32px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react299.ButtonGroup, {
              spacing: "12px",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react299.Button, {
                  variant: "ghost",
                  onClick: onRemove,
                  children: t("WIDGET_SETTINGS_DELETE")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react299.Button, {
                  type: "submit",
                  colorScheme: "blue",
                  form: "widget-config",
                  onClick: handleSave,
                  children: t("WIDGET_SETTINGS_SAVE")
                })
              ]
            })
          })
        ]
      })
    ]
  });
};
var WidgetSettingsModal_default = WidgetSettingsModal;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ACCOUNT_COMPANY_CREATION_TYPE,
  ACCOUNT_COMPANY_VAT_HANDLING,
  ActionBadge,
  ActiveFilterDisplay,
  ActiveFilters,
  Address,
  AttributeBoolean,
  AttributeChat,
  AttributeChecklist,
  AttributeDate,
  AttributeFile,
  AttributeFileItem,
  AttributeHtml,
  AttributeLabel,
  AttributeList,
  AttributeNumber,
  AttributeText,
  AuraDatePicker,
  AuraDrawer,
  AuraDrawerBody,
  AuraDrawerCloseButton,
  AuraDrawerContent,
  AuraDrawerFooter,
  AuraDrawerHeader,
  AuraDrawerOverlay,
  AuraDropdownMenu,
  AuraFormLabel,
  AuraInput,
  AuraMenuItem,
  AuraModal,
  AuraModalBody,
  AuraModalCloseButton,
  AuraModalContent,
  AuraModalFooter,
  AuraModalHeader,
  AuraModalOverlay,
  AuraSelect,
  AuraSpinner,
  AuraTabs,
  AuthContext,
  AuthContextProvider,
  AvailabilityFilter,
  BackwardNavigation,
  BasketContext,
  BasketContextProvider,
  BlockedDisabledInfo,
  BooleanFilter,
  BoxCollapse,
  BoxCollapseButton,
  BoxCollapseContent,
  BoxCollapseItem,
  BoxIcon,
  Breadcrumbs,
  ButtonAction,
  CSSReset,
  CellWrapper,
  ColorPicker,
  ConnectedCampaignOpportunity,
  ConnectedDocument,
  ConnectedProcess,
  ConnectedServicedProduct,
  ConnectedTaskAndEvent,
  ContentBox,
  CookieNotice,
  CreatorUserCell,
  CredentialsCompact,
  CustomCSSReset,
  CustomMultiValueContainer,
  CustomProductOption,
  CustomSelectOption,
  CustomizeColumns,
  CustomizeColumnsModal,
  CustomizerContext,
  CustomizerContextProvider,
  CustomizerInit,
  DATETIME_FORMAT_DOTS,
  DATE_FORMAT_DOTS,
  DEFAULT_LIMIT_AVAILABLE_PRODUCTS,
  DataSelector,
  DataSelectorFilter,
  DateInput,
  DatetimeFilter,
  DefaultEventDates,
  DocumentSummary,
  EmptyFilters,
  EmptyList,
  EmptyState,
  ExternalMarkerContainer,
  ExternalMarkerFilter,
  ExternalMarkerLabel,
  ExternalMarkersContext,
  ExternalMarkersProvider,
  FileDetails,
  FilePreview,
  FilterFormLabel,
  FilterInputSeparator,
  FilterName,
  FilterTextInput,
  FiltersDisplayItem,
  GalleryItem,
  Header,
  InBasketInfo,
  InBasketText,
  Information,
  LANGUAGES,
  LanguageContext,
  LanguageProvider,
  LinkContext,
  LinkContextProvider,
  Linkify,
  List,
  ListFilter,
  ListFilters,
  ListFiltersContext,
  ListFiltersContextProvider,
  LoadingOverlay,
  MODULE_MAP,
  MainHeader,
  MessageBreadcrumbs,
  MessageItem,
  Modal,
  ModalServicedProduct,
  ModalVisibilityProvider,
  ModuleLink,
  MoreIconButton,
  MultiFilter,
  NameDisplay,
  NotificationBar,
  NumberBox,
  NumericFilter,
  ObjectsPerPageSelect,
  Pagination,
  PanelHeading,
  PerPage,
  PersonInfo,
  PersonItem,
  PersonList,
  PriceDisplay,
  PriceWithCurrency,
  ProductAvailability,
  ProductAvailabilityIcon,
  ProductEAN,
  ProductImage,
  ProductQuantitySelector,
  ProductSlider,
  ProfileSaveConfigModal,
  QAvatar,
  QuantitySelector,
  RepositoryFile,
  RepositoryFileList,
  ResultsPagination,
  ResultsPerPage,
  RoundIcon,
  STable,
  STableContainer,
  STbody,
  STd,
  STfoot,
  STh,
  SThead,
  STr,
  SecondaryHeader,
  SelectCheckbox,
  SettingsContext,
  SettingsProvider,
  SmallTag,
  SortingIndicator,
  SubordinatesCheckbox,
  Table,
  TagButton,
  TagDisplay,
  TagFilter,
  TaskItem,
  TaskList,
  Tbody,
  Td,
  TextFilter,
  TextScroll,
  Th,
  Thead,
  TileItem,
  TileItemList,
  TileList,
  Timeline,
  TimelineItem,
  Tr,
  UNRESET_SCSS,
  USED_SETTINGS,
  UsedMaterials,
  UserFilter,
  UserTypes,
  Widget,
  WidgetBody,
  WidgetControls,
  WidgetHeader,
  WidgetName,
  WidgetSettingsModal,
  auraSelectFilterConfig,
  baseApi,
  buildOptions,
  disableSortingColumns,
  documentStatusPositions,
  downloadXlsxDocument,
  formatAttributeCell,
  formatAttributeHeader,
  formatDateForApi,
  formatFieldCell,
  formatHeader,
  formatPlaceField,
  formatRelationFieldCell,
  formatRelationHeader,
  formatValue,
  getActiveMarkers,
  getAttributeTagTypeForModule,
  getBasePriceFilter,
  getCommonI18nConfig,
  getDocumentRelationName,
  getImageUrl,
  getListFiltersConfig,
  getModuleHref,
  getPriceFilterForUserUserLevel,
  getUserPrice,
  getVisibleColumnsParams,
  imageSizeValue,
  initModal,
  inputValueReducer,
  isFile,
  isImage,
  isOptionsGrouped,
  isOptionsWithAvatar,
  log,
  normalizeSettings,
  parseFiltersForApi,
  parseMetaToColumns,
  parseUrlParams,
  priceFormatter,
  sortTasks,
  splitPriceParts,
  statusCampaignOpportunity,
  stripHtmlTags,
  theme,
  transformApiResponse,
  transformTasksForTasklist,
  useBasketContent,
  useCustomScript,
  useExternalMarkers,
  useLanguage,
  useLink,
  useListColumnsOrdering,
  useListColumnsVisibility,
  useListFilters,
  useListFiltersVisibility,
  useListPagination,
  useListSorting,
  useMinimalAutoselect,
  useModalVisibilityContext,
  usePersistedState,
  useProductPrice,
  useQueryParams,
  useResponsive,
  useSetting,
  useSettings,
  useTemplates,
  useUserProfiles,
  useUserSettingsWithFallback,
  validateAttribute
});
